export function bootTabwheel(){
  "use strict";

  /* ================= card types ================= */
  var REPEATS = ["Every day","Every weekday","Every week","Every 2 weeks","Every month"];
  /* repeating tasks (c.rpt) get three longer rules meetings don't offer; meetings keep the plain
     REPEATS list above so their own field editor is unchanged */
  var TASK_REPEATS = REPEATS.concat(["Every 3 months","Every 6 months","Every year"]);
  var TYPES = {
    server:  {label:"Server", plural:"Servers", short:"SRV", statuses:["Online","Degraded","Maintenance","Offline"],
      fields:[{k:"host",l:"Host / IP",mono:1},{k:"os",l:"OS"},{k:"location",l:"Location"},{k:"role",l:"Role"},{k:"start",l:"Maintenance start",t:"date"},{k:"end",l:"Maintenance end",t:"date"}]},
    storage: {label:"Storage", plural:"Storage & assets", short:"STO", statuses:["Healthy","Near capacity","Degraded","Retired"],
      fields:[{k:"kind",l:"Kind"},{k:"capacity",l:"Capacity",mono:1},{k:"used",l:"Used",mono:1},{k:"location",l:"Location"},{k:"serial",l:"Serial / asset tag",mono:1},{k:"due",l:"Warranty ends",t:"date"}]},
    issue:   {label:"Issue", plural:"Issues", short:"ISS", statuses:["Open","In progress","Blocked","Resolved"],
      fields:[{k:"severity",l:"Severity",t:"select",opts:["Low","Medium","High","Critical"]},{k:"assignee",l:"Assignee"},{k:"related",l:"Affects"},{k:"ticket",l:"Ticket",mono:1},{k:"due",l:"Due",t:"date"}]},
    person:  {label:"Person", plural:"People", short:"PPL", statuses:["Active","Away","Former"],
      fields:[{k:"role",l:"Role"},{k:"company",l:"Company / team"},{k:"email",l:"Email",t:"email",mono:1},{k:"phone",l:"Phone",t:"tel",mono:1},{k:"location",l:"Location"}]},
    event:   {label:"Upcoming", plural:"Upcoming", short:"UPC", statuses:["Scheduled","Tentative","Done","Cancelled"],
      fields:[{k:"due",l:"Date",t:"date"},{k:"time",l:"Time",mono:1},{k:"where",l:"Where"},{k:"with",l:"With"}]},
    meeting: {label:"Meeting", plural:"Meetings", short:"MTG", statuses:["Scheduled","Done","Cancelled"],
      fields:[{k:"due",l:"Date",t:"date"},{k:"time",l:"Starts",t:"time",mono:1},{k:"endtime",l:"Ends",t:"time",mono:1},{k:"repeat",l:"Repeats",t:"select",opts:REPEATS},{k:"join",l:"Join link",t:"url"},{k:"organiser",l:"Organiser"},{k:"where",l:"Room / location"},{k:"with",l:"Attendees"}]},
    project: {label:"Project", plural:"Projects", short:"PRJ", statuses:["Planned","Active","At risk","Done"],
      fields:[{k:"owner",l:"Owner"},{k:"start",l:"Start",t:"date"},{k:"end",l:"End",t:"date"},{k:"progress",l:"Progress %",t:"number",mono:1}]}
  };
  Object.keys(TYPES).forEach(function(k){ TYPES[k].color = "var(--t-" + k + ")"; TYPES[k].builtin = true; });
  var BUILTIN = TYPES, BUILTIN_ORDER = ["server","storage","issue","person","meeting","event","project"];
  var TYPE_ORDER = BUILTIN_ORDER.slice();
  var OTHER = {label:"Other", plural:"Other", short:"OTH", statuses:["Open","Done"], fields:[], color:"var(--muted)", other:true};
  var PALETTE = ["c1","c2","c3","c4","c5","c6","c7","c8"];
  var FIELD_KINDS = {text:"Text", date:"Date", number:"Number", select:"Choice list", email:"Email", tel:"Phone", url:"Web address"};
  var typeCfg = {custom:[], extra:{}, style:{}, builtinOrder:BUILTIN_ORDER.slice()};
  var TAB_POS = {left:"3%", centre:"35%", right:"67%"};
  var PAPERS = {lined:"Lined", plain:"Plain", grid:"Squared"};
  function td(k){ return TYPES[k] || OTHER; }
  function typeIsHome(key){ var ct = typeCfg.custom.filter(function(x){ return x.key === key; })[0]; return !!(ct && ct.home); }
  /* a built-in type hidden for this workspace (typeCfg.off) — unless a live (non-deleted) card of it still exists */
  function typeHidden(key){
    if((typeCfg.off || []).indexOf(key) < 0) return false;
    return !Array.from(S.cards.values()).some(function(c){ return c.type === key; });
  }
  /* the types that belong to the current Work/Home space, in menu order (sidebar, "+ New", empty state, calendar "+ Add") */
  function spaceTypes(){ return TYPE_ORDER.filter(function(k){ return (S.space === "home" ? typeIsHome(k) : !typeIsHome(k)) && !typeHidden(k); }); }
  /* "new card of this type" buttons; with a date, the new card's main date field is set to it (see createCard) */
  function newTypeBtns(keys, date){ return keys.map(function(k){ return '<button class="btn small" type="button" data-new="' + k + '"' + (date ? ' data-date="' + esc(date) + '"' : "") + ' style="' + typeVar(k) + '"><span class="t-chip">' + esc(td(k).label) + '</span></button>'; }).join(""); }
  function normTypeCfg(raw){
    var out = {custom:[], extra:{}, style:{}, builtinOrder:BUILTIN_ORDER.slice(), off:[], pack:"", packs:[], tour:false};
    raw = raw && typeof raw === "object" ? raw : {};
    if(Array.isArray(raw.off)) out.off = raw.off.filter(function(k){ return typeof k === "string" && BUILTIN[k]; }).slice(0, 40);
    if(typeof raw.pack === "string") out.pack = str(raw.pack, 40);
    if(Array.isArray(raw.packs)) out.packs = raw.packs.filter(function(k){ return typeof k === "string"; }).map(function(k){ return str(k, 40); }).slice(0, 20);
    if(raw.tour) out.tour = true;
    if(Array.isArray(raw.builtinOrder)){
      var seen = {}, ord = raw.builtinOrder.filter(function(k){ return BUILTIN[k] && !seen[k] && (seen[k] = 1); });
      BUILTIN_ORDER.forEach(function(k){ if(!seen[k]) ord.push(k); });
      out.builtinOrder = ord;
    }
    var normField = function(fd){
      if(!fd || typeof fd.k !== "string" || !/^[A-Za-z][A-Za-z0-9_]{0,40}$/.test(fd.k)) return null;
      var t = FIELD_KINDS[fd.t] ? fd.t : "text";
      var o = {k:fd.k, l:str(fd.l, 60) || "Field", t:t};
      if(t === "select") o.opts = (Array.isArray(fd.opts) ? fd.opts : []).map(function(x){ return str(x, 60).trim(); }).filter(Boolean).slice(0, 30);
      if(t === "tel" || t === "email" || t === "number") o.mono = 1;
      return o;
    };
    (Array.isArray(raw.custom) ? raw.custom : []).slice(0, 1000).forEach(function(ct){
      if(!ct || typeof ct.key !== "string" || !/^[a-z][a-z0-9_]{0,40}$/.test(ct.key) || BUILTIN[ct.key] || ct.key === "other") return;
      var statuses = (Array.isArray(ct.statuses) ? ct.statuses : []).map(function(x){ return str(x, 40).trim(); }).filter(Boolean).slice(0, 12);
      out.custom.push({key:ct.key, label:str(ct.label, 40) || "Custom", plural:str(ct.plural, 40) || (str(ct.label, 40) || "Custom") + "s",
        short:(str(ct.short, 4) || str(ct.label, 3) || "CUS").toUpperCase(), color:PALETTE.indexOf(ct.color) >= 0 ? ct.color : "c1",
        sheet:str(ct.sheet, 160), statuses:statuses.length ? statuses : ["Active","Inactive"], fields:(Array.isArray(ct.fields) ? ct.fields : []).slice(0, 500).map(normField).filter(Boolean),
        home:!!ct.home});
    });
    Object.keys(raw.extra && typeof raw.extra === "object" ? raw.extra : {}).forEach(function(k){
      if(!BUILTIN[k] || !Array.isArray(raw.extra[k])) return;
      out.extra[k] = raw.extra[k].slice(0, 500).map(normField).filter(Boolean).filter(function(fd){ return !BUILTIN[k].fields.some(function(b){ return b.k === fd.k; }); });
    });
    var st = raw.style && typeof raw.style === "object" ? raw.style : {};
    Object.keys(st).slice(0, 60).forEach(function(k){
      var v = st[k];
      if(!/^[a-z][a-z0-9_]{0,40}$/.test(k) || !v || typeof v !== "object") return;
      var o = {};
      if(PALETTE.indexOf(v.color) >= 0 || BUILTIN_ORDER.indexOf(v.color) >= 0) o.color = v.color;
      if(typeof v.short === "string" && v.short.trim()) o.short = str(v.short, 4).trim().toUpperCase();
      if(TAB_POS[v.tab]) o.tab = v.tab;
      if(PAPERS[v.paper]) o.paper = v.paper;
      if(Array.isArray(v.face)) o.face = v.face.filter(function(x){ return typeof x === "string" && /^[A-Za-z][A-Za-z0-9_]{0,40}$/.test(x); }).slice(0, 8);
      if(Object.keys(o).length) out.style[k] = o;
    });
    return out;
  }
  function rebuildTypes(){
    var t = {};
    BUILTIN_ORDER.forEach(function(k){
      var b = BUILTIN[k];
      t[k] = Object.assign({}, b, {fields:b.fields.concat(typeCfg.extra[k] || [])});
    });
    var order = (typeCfg.builtinOrder || BUILTIN_ORDER).slice();
    typeCfg.custom.forEach(function(ct){
      t[ct.key] = {label:ct.label, plural:ct.plural, short:ct.short, statuses:ct.statuses, fields:ct.fields, color:"var(--t-" + ct.color + ")", custom:true};
      order.push(ct.key);
    });
    /* one style per card type: every card of that type (e.g. every row of an imported sheet) follows it */
    Object.keys(typeCfg.style || {}).forEach(function(k){
      var st = typeCfg.style[k], T = t[k]; if(!T) return;
      if(st.color) T.color = "var(--t-" + st.color + ")";
      if(st.short) T.short = st.short;
      if(st.tab) T.tab = st.tab;
      if(st.paper) T.paper = st.paper;
      if(st.face) T.face = st.face;
    });
    TYPES = t; TYPE_ORDER = order;
  }
  var TONE = {Online:"good",Healthy:"good",Resolved:"good",Active:"good",Done:"good",
    Scheduled:"info",Planned:"info","In progress":"info",
    Open:"warn",Degraded:"warn","Near capacity":"warn",Maintenance:"warn",Tentative:"warn",Away:"warn",
    "At risk":"bad",Blocked:"bad",Offline:"bad"};
  var CLOSED = {Resolved:1, Done:1, Cancelled:1, Retired:1, Former:1, Paid:1, Completed:1, Delivered:1};
  var TAB_SLOTS = ["3%","35%","67%"];
  var LOCAL_KEY = "work-rolodex/cards-v1";
  var FOLDER_KEY = "work-rolodex/folders-v1";
  var TYPES_KEY = "work-rolodex/types-v1";
  var PREF_KEY = "work-rolodex/prefs-v1";
  var LASTBACKUP_KEY = "work-rolodex/last-backup-v1";
  var ID_RE = /^[A-Za-z0-9_.~:@+-]{1,60}$/;

  /* ================= state ================= */
  var S = {
    cards:new Map(), trash:new Map(), revs:new Map(), mode:"loading", db:null, assets:null, readOnly:false,
    deck:[], cur:0, curId:null, open:false, nav:"all", query:"", pq:null,
    sort:"az", view:"rolodex", calMonth:null, calDay:null, calView:"month", calAdd:false, dirty:new Set(),
    folders:[], foldersDirty:false, editFolders:false, collapsed:{}, space:"work"
  };

  /* ================= helpers ================= */
  function $(id){ return document.getElementById(id); }
  function esc(s){ return String(s == null ? "" : s).replace(/[&<>"']/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]; }); }
  /* rich text on notes pages: only this small set of tags survives, with no inline styles or scripts.
     Colours are classes (fc-1..5 text, hl-1..5 highlight) so they follow the light/dark theme. */
  var RT_TAGS = {B:"b", STRONG:"b", I:"i", EM:"i", U:"u", S:"s", STRIKE:"s", DEL:"s", H1:"h1", H2:"h2", H3:"h2", UL:"ul", OL:"ol", LI:"li",
    BR:"br", DIV:"div", P:"div", BLOCKQUOTE:"blockquote", CODE:"code", PRE:"code", A:"a", MARK:"mark", SPAN:"span", FONT:"span"};
  var RT_DROP = {SCRIPT:1, STYLE:1, TEMPLATE:1, IFRAME:1, OBJECT:1, EMBED:1, SVG:1, MATH:1, HEAD:1, TITLE:1, META:1, LINK:1, IMG:1, VIDEO:1, AUDIO:1, INPUT:1, BUTTON:1, SELECT:1, TEXTAREA:1, FORM:1, NOSCRIPT:1};
  function rtColorClass(el){
    /* map a colour on a span/font (from the toolbar's marker colours) to a class */
    var cls = (el.getAttribute("class") || "").split(/\s+/).filter(function(c){ return /^(fc|hl|sz)-[1-5]$/.test(c); });
    var st = el.getAttribute("style") || "", m;
    if((m = /(?:^|;)\s*color:\s*rgb\(\s*1,\s*1,\s*([1-5])\s*\)/i.exec(st))) cls.push("fc-" + m[1]);
    if((m = /background(?:-color)?:\s*rgb\(\s*2,\s*2,\s*([1-5])\s*\)/i.exec(st))) cls.push("hl-" + m[1]);
    var fc = el.getAttribute("color"); if(fc && (m = /^#0101(0[1-5])$/i.exec(fc))) cls.push("fc-" + (+m[1]));
    return cls.join(" ");
  }
  function cleanHTML(html){
    var tpl = document.createElement("template");
    tpl.innerHTML = String(html || "");
    var walk = function(src, dst){
      Array.from(src.childNodes).forEach(function(n){
        if(n.nodeType === 3){ dst.appendChild(document.createTextNode(n.nodeValue)); return; }
        if(n.nodeType !== 1 || RT_DROP[n.nodeName]) return;
        var tag = RT_TAGS[n.nodeName];
        if(!tag){ walk(n, dst); return; }
        var out;
        if(tag === "span" || tag === "mark"){
          var cls = rtColorClass(n);
          if(tag === "mark" && !/hl-/.test(cls)) cls = (cls + " hl-1").trim();
          if(!cls){ walk(n, dst); return; }
          out = document.createElement(tag === "mark" ? "mark" : "span"); out.className = cls;
        } else {
          out = document.createElement(tag);
          if(tag === "a"){
            var href = n.getAttribute("href") || "";
            if(!/^(https?:|mailto:)/i.test(href.trim())){ walk(n, dst); return; }
            out.setAttribute("href", href.trim()); out.setAttribute("target", "_blank"); out.setAttribute("rel", "noopener noreferrer");
          }
          if(tag === "ul" && /(^|\s)todo(\s|$)/.test(n.getAttribute("class") || "")) out.className = "todo";
          if(tag === "li" && n.getAttribute("data-done") === "1") out.setAttribute("data-done", "1");
        }
        if(tag !== "br") walk(n, out);
        if(tag === "div" && !out.childNodes.length) return;
        dst.appendChild(out);
      });
    };
    var box = document.createElement("div");
    walk(tpl.content, box);
    return box.innerHTML;
  }
  /* plain text of a rich block, with to-dos written as ☐/☑ so search and Ask see them */
  function richText(el){
    var c = el.cloneNode(true);
    c.querySelectorAll("ul.todo > li").forEach(function(li){ li.insertBefore(document.createTextNode(li.getAttribute("data-done") === "1" ? "☑ " : "☐ "), li.firstChild); });
    c.querySelectorAll("li, div, h1, h2, blockquote, br").forEach(function(x){ if(x.nodeName === "BR") x.replaceWith("\n"); else x.appendChild(document.createTextNode("\n")); });
    return c.textContent.replace(/\n{3,}/g, "\n\n").replace(/\s+$/, "");
  }
  function uid(){ return Date.now().toString(36) + Math.random().toString(36).slice(2, 9); }
  function pad(n){ return (n < 10 ? "0" : "") + n; }
  function iso(d){ return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate()); }
  function parseISO(s){ var p = s.split("-"); return new Date(+p[0], +p[1] - 1, +p[2]); }
  function validDate(s){ return typeof s === "string" && /^\d{4}-\d{2}-\d{2}$/.test(s); }
  function today(){ return iso(new Date()); }
  function addDays(s, n){ var d = parseISO(s); d.setDate(d.getDate() + n); return iso(d); }
  function dayDiff(a, b){ return Math.round((parseISO(b) - parseISO(a)) / 864e5); }
  function fmtDate(s, withDay){
    if(!validDate(s)) return "";
    var d = parseISO(s), o = {day:"numeric", month:"short"};
    if(withDay) o.weekday = "short";
    if(d.getFullYear() !== new Date().getFullYear()) o.year = "numeric";
    return d.toLocaleDateString(undefined, o);
  }
  /* "Today"/"Tomorrow" instead of a bare date, for the common near-term cases — same convention as the dashboard's next-meeting row */
  function relDate(s){
    if(!validDate(s)) return "";
    var n = dayDiff(today(), s);
    return n === 0 ? "Today" : n === 1 ? "Tomorrow" : fmtDate(s, true);
  }
  /* reminders are one local "YYYY-MM-DDTHH:MM" string (c.remind), so plain string order is time order */
  function stamp(d){ return iso(d) + "T" + pad(d.getHours()) + ":" + pad(d.getMinutes()); }
  function nowStamp(){ return stamp(new Date()); }
  function nextMonday(s){ var d = parseISO(s); do d.setDate(d.getDate() + 1); while(d.getDay() !== 1); return iso(d); }
  function laterStamp(h){ var d = new Date(Date.now() + h * 36e5); d.setSeconds(0, 0); d.setMinutes(Math.ceil(d.getMinutes() / 5) * 5); return stamp(d); }
  function fmtRemind(s){ if(!s) return ""; var p = s.split("T"); return relDate(p[0]) + ", " + p[1]; }
  function remindDue(c){ return !!c.remind && c.remind <= nowStamp(); }
  function rev(id){ return S.revs.get(id) || 0; }
  function bump(id){ S.revs.set(id, rev(id) + 1); }
  function lsGet(k){ try{ return localStorage.getItem(k); }catch(e){ return null; } }
  function lsSet(k, v){ try{ localStorage.setItem(k, v); return true; }catch(e){ return false; } }
  function typeVar(t){ return "--tc:" + td(t).color; }

  var toastTimer = null;
  var toastAction = null;
  /* toast("Deleted X.", {label:"Undo", fn:...}) shows a button and stays up a little longer */
  function toast(msg, action){
    var t = $("toast");
    toastAction = action || null;
    t.innerHTML = '<span>' + esc(msg) + '</span>' + (action ? '<button type="button" class="toast-btn">' + esc(action.label) + '</button>' : "");
    t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function(){ t.hidden = true; toastAction = null; }, action ? 8000 : 4200);
  }

  /* plain-English save/sync states, keyed by setStatus(s, msg)'s s (or "error:"+msg for the several error cases) */
  var SAVE_INFO = {
    loading:{ic:"", label:"Connecting…", explain:"Connecting to your workspace…"},
    saving:{ic:"↻", label:"Saving", explain:"Saving your latest changes."},
    online:{ic:"✓", label:"Saved", explain:"Your cards are saved online and sync across your devices."},
    local:{ic:"✓", label:"Saved locally", explain:"Saved in this browser only. Open this page on claude.ai to save online and sync across your devices."},
    "error:Card too large":{ic:"⚠", label:"Too large to save", explain:"This card is too large to save online. Move some notes or images to another card."},
    "error:View only":{ic:"⚠", label:"View only", explain:"You have view-only access to this workspace, so changes aren't saved."},
    "error:Storage full":{ic:"⚠", label:"Storage full", explain:"Online storage is full (5,000 records max). Empty the Trash or delete some cards."},
    "error:Disconnected":{ic:"⚠", label:"Not synced", explain:"Lost the connection to online storage. Any change made since is only kept in this tab, so don't close it — reload the page to reconnect and finish saving."},
    "error:Not saved":{ic:"↻", label:"Retrying…", explain:"Having trouble saving right now. Your change is kept in this tab and is retried automatically — just leave it open."},
    "error:Device storage full":{ic:"⚠", label:"Storage full", explain:"This browser has no room left, so your last change wasn't saved. Open this page on claude.ai to save online instead."}
  };
  function setStatus(s, msg){
    var el = $("saveState");
    el.dataset.s = s;
    var info = SAVE_INFO[s === "error" ? "error:" + msg : s] || {ic:"⚠", label:msg || "Not synced", explain:""};
    el.innerHTML = (info.ic ? '<span class="save-ic" aria-hidden="true">' + info.ic + '</span>' : "") + esc(info.label);
    el.dataset.explain = info.explain;
    var pop = $("savePop");
    if(!pop.hidden) pop.textContent = info.explain;
    var note = $("storeNote");
    if(S.mode === "online") note.textContent = S.readOnly ? "You have view-only access. Changes won't be saved." : "Cards save online and sync across your devices. Images upload to this page's storage.";
    else if(S.mode === "local") note.textContent = "Offline copy: cards save only in this browser. Export a backup to move them.";
  }
  function toggleSaveInfo(show){
    var pop = $("savePop");
    pop.hidden = !show;
    $("saveState").setAttribute("aria-expanded", show ? "true" : "false");
    if(show){
      pop.textContent = $("saveState").dataset.explain || "";
      pop.style.transform = "";
      /* the button can sit anywhere along the top bar (it reflows to the middle on narrow phones);
         nudge the popover right if right:0 would run it off the left edge of the viewport */
      var over = 8 - pop.getBoundingClientRect().left;
      if(over > 0) pop.style.transform = "translateX(" + over + "px)";
    }
  }

  /* two-step confirm for destructive buttons (the viewer blocks confirm()) */
  function armed(btn, label){
    if(btn.classList.contains("armed")) return true;
    var orig = btn.textContent;
    btn.classList.add("armed"); btn.textContent = label;
    /* the button's own text just changed (e.g. to "Click again to delete") — make sure that's
       actually visible instead of leaving the user to hunt for it in a long, scrolled panel */
    if(btn.scrollIntoView) btn.scrollIntoView({block:"nearest", behavior:"smooth"});
    setTimeout(function(){ if(btn.isConnected){ btn.classList.remove("armed"); btn.textContent = orig; } }, 3500);
    return false;
  }

  /* ================= card model ================= */
  function str(v, max){ return typeof v === "string" ? v.slice(0, max || 400) : (typeof v === "number" ? String(v) : ""); }
  function norm(c){
    c = c && typeof c === "object" ? c : {};
    var type = (typeof c.type === "string" && /^[a-z][a-z0-9_]{0,40}$/.test(c.type)) ? c.type : "issue";
    var T = td(type);
    var f = {};
    var src = c.f && typeof c.f === "object" ? c.f : {};
    Object.keys(src).slice(0, 200).forEach(function(k){ if(/^[A-Za-z][A-Za-z0-9_]{0,40}$/.test(k)){ var v = str(src[k], 5000); if(v) f[k] = v; } });
    var check = Array.isArray(c.check) ? c.check.filter(function(x){ return x && typeof x.t === "string"; }).map(function(x){ return {id:(typeof x.id === "string" && ID_RE.test(x.id)) ? x.id : uid(), t:str(x.t, 1000), done:!!x.done}; }) : [];
    var hist = Array.isArray(c.hist) ? c.hist.filter(function(x){ return x && typeof x.w === "string"; }).slice(-300).map(function(x){ return {at:str(x.at, 40), w:str(x.w, 300)}; }) : [];
    var tags = Array.isArray(c.tags) ? c.tags.map(function(t){ return str(t, 40).toLowerCase().replace(/^#/, "").trim(); }).filter(Boolean).slice(0, 100) : [];
    var links = Array.isArray(c.links) ? c.links.filter(function(l){ return l && safeUrl(l.url); }).map(function(l){ return {label:str(l.label, 120), url:safeUrl(l.url)}; }) : [];
    /* an uploaded file's id is either claude.ai's 32-hex asset id, or (this hosted
       Supabase app) a storage path like "<workspaceId>/<randomId>-<name>.png" —
       accept either shape, since rejecting the latter silently dropped every
       image block on the notes page on the very next normalize */
    var FILE_ID_RE = /^[A-Za-z0-9_.\-\/]{1,300}$/;
    var files = Array.isArray(c.files) ? c.files.filter(function(x){ return x && ((typeof x.id === "string" && FILE_ID_RE.test(x.id)) || (typeof x.data === "string" && /^data:(image\/(png|jpeg|gif|webp)|application\/pdf);/.test(x.data))); })
      .map(function(x){ var o = {name:str(x.name, 160), type:str(x.type, 60)}; if(x.id) o.id = x.id; else o.data = x.data; return o; }) : [];
    var normFile = function(x){ var o = {name:str(x.name, 160), type:str(x.type, 60)}; if(x.id) o.id = x.id; else o.data = x.data; return o; };
    var okFile = function(x){ return x && ((typeof x.id === "string" && FILE_ID_RE.test(x.id)) || (typeof x.data === "string" && /^data:(image\/(png|jpeg|gif|webp)|application\/pdf);/.test(x.data))); };
    /* a notes page: blocks placed freely, {id, k:"t"|"i", x, y, w, t (text) | f (file)} */
    var num = function(v, lo, hi, d){ v = Math.round(+v); return isFinite(v) ? Math.max(lo, Math.min(hi, v)) : d; };
    var normBlocks = function(list){
      if(!Array.isArray(list)) return null;
      return list.filter(function(b){ return b && (b.k === "t" ? typeof b.t === "string" : b.k === "i" && okFile(b.f)); }).map(function(b){
        var o = {id:(typeof b.id === "string" && ID_RE.test(b.id)) ? b.id : uid(), k:b.k, x:num(b.x, 0, 20000, 16), y:num(b.y, 0, 200000, 16), w:num(b.w, 40, 4000, b.k === "t" ? 360 : 280)};
        if(b.k === "t"){ o.t = str(b.t, 200000); if(typeof b.h === "string" && b.h) o.h = cleanHTML(b.h); } else o.f = normFile(b.f);
        return o;
      });
    };
    var sess = Array.isArray(c.sess) ? c.sess.filter(function(x){ return x && validDate(x.date); }).map(function(x){
      var o = {id:(typeof x.id === "string" && ID_RE.test(x.id)) ? x.id : uid(), date:x.date, text:str(x.text, 200000), files:(Array.isArray(x.files) ? x.files.filter(okFile).map(normFile) : [])};
      var bl = normBlocks(x.blocks); if(bl) o.blocks = bl;
      return o;
    }) : [];
    var page = normBlocks(c.page);
    var id = str(c.id, 60);
    var rel = [];
    if(Array.isArray(c.rel)) c.rel.forEach(function(r){ if(typeof r === "string" && ID_RE.test(r) && r !== id && rel.indexOf(r) < 0) rel.push(r); });
    /* a repeating task: {every, until, times, n}. Dropped entirely if "every" isn't a known rule. */
    var rpt = null;
    if(c.rpt && typeof c.rpt === "object" && TASK_REPEATS.indexOf(c.rpt.every) >= 0){
      var rptNum = function(v){ v = Math.round(+v); return isFinite(v) && v > 0 ? Math.min(v, 9999) : 0; };
      rpt = {every:c.rpt.every, until:validDate(c.rpt.until) ? c.rpt.until : "", times:rptNum(c.rpt.times), n:rptNum(c.rpt.n)};
    }
    return {
      id:id, type:type, title:str(c.title, 160) || ("Untitled " + T.label.toLowerCase()),
      subtitle:str(c.subtitle, 200), status:(T.statuses.indexOf(c.status) >= 0 || (T.other && typeof c.status === "string")) ? str(c.status, 60) : T.statuses[0],
      check:check, hist:hist, sess:sess, src:str(c.src, 300),
      f:f, tags:tags, links:links, files:files, notes:str(c.notes, 200000), page:page,
      fav:!!c.fav, folder:(typeof c.folder === "string" && ID_RE.test(c.folder)) ? c.folder : "", rel:rel,
      example:!!c.example, updated:str(c.updated, 40), deleted:str(c.deleted, 40), archived:str(c.archived, 40), template:!!c.template, home:!!c.home,
      remind:(typeof c.remind === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(c.remind)) ? c.remind : "",
      rpt:rpt
    };
  }
  function normFolders(list){
    var out = [], ids = {};
    (Array.isArray(list) ? list : []).slice(0, 5000).forEach(function(x){
      if(!x || typeof x.id !== "string" || !ID_RE.test(x.id) || ids[x.id]) return;
      ids[x.id] = 1;
      out.push({id:x.id, name:str(x.name, 80) || "Untitled folder", parent:typeof x.parent === "string" ? x.parent : null, example:!!x.example, home:!!x.home});
    });
    out.forEach(function(f){ if(f.parent && (!ids[f.parent] || f.parent === f.id)) f.parent = null; });
    /* break any cycles */
    out.forEach(function(f){
      var seen = {}, p = f;
      while(p && p.parent){ if(seen[p.id]){ f.parent = null; break; } seen[p.id] = 1; p = folderById(p.parent, out); }
    });
    return out;
  }
  function folderById(id, list){ list = list || S.folders; for(var i = 0; i < list.length; i++) if(list[i].id === id) return list[i]; return null; }
  function folderChildren(id){ return S.folders.filter(function(f){ return (f.parent || null) === (id || null) && !!f.home === (S.space === "home"); }).sort(function(a, b){ return a.name.localeCompare(b.name, undefined, {numeric:true, sensitivity:"base"}); }); }
  function folderDescendants(id){
    var out = [id], i = 0;
    while(i < out.length){ folderChildren(out[i]).forEach(function(c){ out.push(c.id); }); i++; }
    return out;
  }
  function folderPath(id){
    var names = [], f = folderById(id), guard = 0;
    while(f && guard++ < 20){ names.unshift(f.name); f = f.parent ? folderById(f.parent) : null; }
    return names.join(" / ");
  }
  function linkedIds(c){
    var ids = c.rel.slice();
    S.cards.forEach(function(o){ if(o.id !== c.id && o.rel.indexOf(c.id) >= 0 && ids.indexOf(o.id) < 0) ids.push(o.id); });
    return ids.filter(function(id){ var o = S.cards.get(id); return o && (!o.template || c.template); });
  }
  function safeUrl(u){
    u = str(u, 2000).trim();
    if(!u) return "";
    if(!/^[a-z][a-z0-9+.-]*:/i.test(u)) u = "https://" + u;
    try{ var p = new URL(u); return (p.protocol === "http:" || p.protocol === "https:") ? p.href : ""; }catch(e){ return ""; }
  }
  /* claude.ai serves uploaded files at /_blob/<id>; the Supabase-backed shim instead exposes a
     synchronous S.assets.url(id) (a Storage public URL), since fileSrc must return a src string
     immediately, not a promise. This is the one core-logic line touched to support server mode. */
  function fileSrc(x){ if(!x.id) return x.data; if(S.assets && typeof S.assets.url === "function") return S.assets.url(x.id); return "/_blob/" + x.id; }
  function isImage(x){ return /^image\//.test(x.type) || /^data:image/.test(x.data || ""); }

  /* ---- recurring meetings ---- */
  function stepDate(d, rule){
    var x = parseISO(d);
    if(rule === "Every day") x.setDate(x.getDate() + 1);
    else if(rule === "Every weekday"){ do { x.setDate(x.getDate() + 1); } while(x.getDay() === 0 || x.getDay() === 6); }
    else if(rule === "Every week") x.setDate(x.getDate() + 7);
    else if(rule === "Every 2 weeks") x.setDate(x.getDate() + 14);
    else if(rule === "Every month"){ var day = parseISO(d).getDate(); x.setDate(1); x.setMonth(x.getMonth() + 1); x.setDate(Math.min(day, new Date(x.getFullYear(), x.getMonth() + 1, 0).getDate())); }
    else if(rule === "Every 3 months" || rule === "Every 6 months" || rule === "Every year"){
      var months = rule === "Every year" ? 12 : (rule === "Every 6 months" ? 6 : 3);
      var day2 = parseISO(d).getDate(); x.setDate(1); x.setMonth(x.getMonth() + months); x.setDate(Math.min(day2, new Date(x.getFullYear(), x.getMonth() + 1, 0).getDate()));
    }
    else return null;
    return iso(x);
  }
  /* every date a meeting happens on between two days (inclusive) */
  function meetingDates(c, from, to){
    var start = c.f.due; if(!validDate(start)) return [];
    var rule = REPEATS.indexOf(c.f.repeat) >= 0 ? c.f.repeat : "";
    if(!rule) return (start >= from && start <= to) ? [start] : [];
    var out = [], d = start, guard = 0;
    if(rule === "Every day" || rule === "Every weekday"){ if(d < from){ var gap = dayDiff(d, from); if(rule === "Every day") d = from; else { d = addDays(d, Math.max(0, gap - 3)); } } }
    while(d && d <= to && guard++ < 1500){ if(d >= from) out.push(d); d = stepDate(d, rule); }
    return out;
  }
  function nextMeeting(c, from){
    var r = meetingDates(c, from, addDays(from, 400));
    return r.length ? r[0] : null;
  }
  function joinInfo(url){
    if(!url) return null;
    var u = safeUrl(url); if(!u) return null;
    var h = ""; try{ h = new URL(u).hostname; }catch(e){}
    var name = /teams\.(microsoft|live)\.com$/.test(h) ? "Teams" : /zoom\.us$/.test(h) ? "Zoom" : /meet\.google\.com$/.test(h) ? "Meet" : /webex\.com$/.test(h) ? "Webex" : "meeting";
    return {url:u, label:"Join " + name};
  }
  function cardDates(c){
    var out = [], T = td(c.type);
    if(c.type === "meeting" && c.f.repeat && validDate(c.f.due)){
      var nx = nextMeeting(c, today());
      if(nx) out.push({date:nx, kind:"due", what:"Meeting" + (c.f.time ? " at " + c.f.time : ""), card:c, key:"due", rep:true});
      return out;
    }
    T.fields.forEach(function(fd){
      if(fd.t !== "date" || !validDate(c.f[fd.k])) return;
      var kind = fd.k === "start" ? "start" : fd.k === "end" ? "end" : "due";
      var what = c.type === "server" && kind !== "due" ? (kind === "start" ? "Maintenance starts" : "Maintenance ends")
        : kind === "start" ? "Starts" : kind === "end" ? "Ends" : c.type === "meeting" ? "Meeting" + (c.f.time ? " at " + c.f.time : "") : fd.l;
      out.push({date:c.f[fd.k], kind:kind, what:what, card:c, key:fd.k});
    });
    return out;
  }
  /* a type's main date field (the first date field; "due" for meetings): what "+ Add" on a calendar day fills in */
  function dateKey(type){ var fd = td(type).fields.filter(function(x){ return x.t === "date"; })[0]; return fd ? fd.k : ""; }

  /* ---- repeating tasks (any non-meeting card with a date field; c.rpt) ---- */
  function isRepeating(c){ return !!(c.rpt && c.rpt.every) || (c.type === "meeting" && !!c.f.repeat); }
  /* the label a repeat's main date carries, e.g. "Maintenance ends" for a server's end date */
  function mainDateWhat(c){
    var key = dateKey(c.type), fd = td(c.type).fields.filter(function(x){ return x.k === key; })[0];
    if(!fd) return "";
    var kind = key === "start" ? "start" : key === "end" ? "end" : "due";
    return c.type === "server" && kind !== "due" ? (kind === "start" ? "Maintenance starts" : "Maintenance ends")
      : kind === "start" ? "Starts" : kind === "end" ? "Ends" : fd.l;
  }
  /* every future occurrence of a task repeat between two days (inclusive), calendar-preview only —
     the current occurrence itself already comes through cardDates()/occurrences() like any other date,
     so this starts counting from the date *after* it */
  function taskRepeatDates(c, from, to){
    var key = dateKey(c.type);
    if(c.type === "meeting" || !c.rpt || !c.rpt.every || !key || !validDate(c.f[key])) return [];
    var out = [], d = c.f[key], n = c.rpt.n || 0, guard = 0;
    d = stepDate(d, c.rpt.every);
    while(d && d <= to && guard++ < 500){
      if(c.rpt.until && d > c.rpt.until) break;
      n++;
      if(c.rpt.times && n > c.rpt.times) break;
      if(d >= from) out.push(d);
      d = stepDate(d, c.rpt.every);
    }
    return out;
  }
  /* called right after c.status has just been set to a CLOSED, non-Cancelled status: rolls a
     repeating card's SAME card forward instead of leaving it closed — advances the main date (skipping
     over any missed occurrences so it lands on today or later), shifts any reminder by the same
     number of days, unticks the checklist and reopens it at the type's first status. Returns
     {rolled:true, next} when it moved on, {ended:true} when the repeat just finished (card stays
     closed, c.rpt is cleared), or null when there was nothing to roll. */
  function rollCard(c){
    if(!c.rpt || !c.rpt.every || c.status === "Cancelled") return null;
    var key = dateKey(c.type), from = key && c.f[key];
    if(!validDate(from)) return null;
    var nd = stepDate(from, c.rpt.every);
    if(!nd) return null;
    var t = today(), guard = 0;
    while(nd < t && guard++ < 2000){ var s = stepDate(nd, c.rpt.every); if(!s) break; nd = s; }
    var n = (c.rpt.n || 0) + 1;
    var ended = (c.rpt.until && nd > c.rpt.until) || (c.rpt.times && n >= c.rpt.times);
    if(ended){
      logHist(c, "Repeat finished");
      c.rpt = null;
      return {ended:true};
    }
    c.f[key] = nd;
    if(c.remind){ var days = dayDiff(from, nd), p = c.remind.split("T"); c.remind = addDays(p[0], days) + "T" + p[1]; }
    c.check.forEach(function(x){ x.done = false; });
    c.status = td(c.type).statuses[0];
    c.rpt.n = n;
    logHist(c, "Done for " + fmtDate(from) + " — next due " + fmtDate(nd));
    return {rolled:true, next:nd};
  }
  function nextDate(c){
    var t = today(), best = null;
    cardDates(c).forEach(function(d){ if(d.date >= t && (!best || d.date < best)) best = d.date; });
    return best || "9999";
  }

  /* ================= sample data ================= */
  function sampleFolders(){
    return [
      {id:"fx-infra", name:"Infrastructure", parent:null},
      {id:"fx-dc", name:"Dublin DC", parent:"fx-infra"},
      {id:"fx-room", name:"Office server room", parent:"fx-infra"},
      {id:"fx-cloud", name:"Cloud", parent:"fx-infra"},
      {id:"fx-aws", name:"AWS", parent:"fx-cloud"},
      {id:"fx-people", name:"People", parent:null},
      {id:"fx-team", name:"Team", parent:"fx-people"},
      {id:"fx-vendors", name:"Vendors", parent:"fx-people"},
      {id:"fx-q4", name:"Q4 plans", parent:null}
    ].map(function(f){ f.example = true; return f; });
  }
  function examples(){
    var t = today(), d = function(n){ return addDays(t, n); };
    var lastMon = addDays(t, -((new Date().getDay() + 6) % 7));
    var list = [
      {id:"ex01", type:"server", title:"db-prod-02", subtitle:"Primary PostgreSQL", status:"Online", fav:true, folder:"fx-dc", f:{host:"10.0.4.22", os:"Ubuntu 24.04 LTS", location:"Rack B3, Dublin DC", role:"Database", start:d(12), end:d(12)}, tags:["prod","database"], links:[{label:"db-prod-02 admin login", url:"https://vault.bitwarden.eu/#/vault?itemId=3f2b9c1e-0000-4000-8000-000000000001&action=view"},{label:"Grafana dashboard", url:"https://grafana.example.com/d/db-prod-02"}], notes:"Replica is db-prod-03. Failover runbook linked above.", rel:["ex19"]},
      {id:"ex02", type:"server", title:"web-edge-01", subtitle:"Nginx reverse proxy", status:"Degraded", folder:"fx-aws", f:{host:"203.0.113.18", os:"Debian 12", location:"AWS eu-west-1", role:"Edge / TLS"}, tags:["prod","web"], notes:"High latency since the last kernel update."},
      {id:"ex03", type:"server", title:"build-runner-03", subtitle:"CI runner", status:"Maintenance", folder:"fx-room", f:{host:"10.0.6.41", os:"Ubuntu 22.04", location:"Office server room", role:"CI / builds", start:d(-1), end:d(2)}, tags:["ci"]},
      {id:"ex04", type:"storage", title:"NAS-01", subtitle:"Team file shares (Synology)", status:"Near capacity", folder:"fx-room", f:{kind:"NAS", capacity:"48 TB", used:"41.2 TB", location:"Office server room", serial:"SYN-DS1821-0447", due:d(40)}, tags:["files","backup"]},
      {id:"ex05", type:"storage", title:"Offsite backups bucket", subtitle:"Nightly backups", status:"Healthy", folder:"fx-aws", f:{kind:"S3 bucket", capacity:"20 TB", used:"6.8 TB", location:"AWS eu-west-2"}, tags:["backup"]},
      {id:"ex06", type:"storage", title:"Loaner laptops", subtitle:"6 × ThinkPad T14", status:"Healthy", folder:"fx-infra", f:{kind:"Hardware", location:"IT cupboard, Level 2", serial:"LP-001 to LP-006", due:d(210)}, tags:["hardware"]},
      {id:"ex07", type:"issue", title:"SSL cert expiring on web-edge-01", subtitle:"Renew before the expiry date", status:"Open", folder:"fx-aws", f:{severity:"High", assignee:"Maya Chen", related:"web-edge-01", ticket:"INC-2291", due:d(5)}, tags:["prod","web"], rel:["ex02","ex10"]},
      {id:"ex08", type:"issue", title:"NAS-01 over 85% full", subtitle:"Archive old project shares", status:"In progress", folder:"fx-room", f:{severity:"Medium", assignee:"Maya Chen", related:"NAS-01", ticket:"INC-2284", due:d(10)}, tags:["files"], rel:["ex04","ex18","ex10"]},
      {id:"ex09", type:"issue", title:"VPN drops for remote staff", subtitle:"Disconnects every ~40 min", status:"Blocked", fav:true, folder:"fx-infra", f:{severity:"High", assignee:"Raj Patel", related:"Firewall / VPN", ticket:"INC-2270", due:d(-2)}, tags:["network"], notes:"Waiting on a firmware fix from the vendor.", rel:["ex11","ex16","ex20"]},
      {id:"ex10", type:"person", title:"Maya Chen", subtitle:"Systems engineer", status:"Active", fav:true, folder:"fx-team", f:{role:"Systems engineer", company:"Infrastructure", email:"maya.chen@example.com", phone:"+353 1 555 0142", location:"Dublin"}, tags:["team"]},
      {id:"ex11", type:"person", title:"Raj Patel", subtitle:"Network lead", status:"Active", folder:"fx-team", f:{role:"Network lead", company:"Infrastructure", email:"raj.patel@example.com", phone:"+353 1 555 0178", location:"Cork"}, tags:["team","network"]},
      {id:"ex12", type:"person", title:"Siobhan Byrne", subtitle:"Account manager, Northwind Hosting", status:"Active", folder:"fx-vendors", f:{role:"Account manager", company:"Northwind Hosting", email:"s.byrne@northwind.example", phone:"+353 1 555 0199"}, tags:["vendor"]},
      {id:"ex13", type:"event", title:"Quarterly DR test", subtitle:"Fail over db-prod-02 to the replica", status:"Scheduled", folder:"fx-dc", f:{due:d(7), time:"09:00–12:00", where:"Dublin DC", with:"Maya Chen, Raj Patel"}, tags:["prod"], rel:["ex01","ex10","ex11","ex19"]},
      {id:"ex14", type:"event", title:"Northwind renewal call", subtitle:"Hosting contract renewal", status:"Scheduled", folder:"fx-vendors", f:{due:d(3), time:"14:30", where:"Teams", with:"Siobhan Byrne"}, tags:["vendor"], rel:["ex12","ex02"]},
      {id:"ex15", type:"event", title:"Budget review", subtitle:"Q4 hardware budget", status:"Tentative", folder:"fx-q4", f:{due:d(12), time:"10:00", where:"Room 2.04"}, rel:["ex06","ex16"]},
      {id:"ex16", type:"project", title:"Office network refresh", subtitle:"New switches and Wi-Fi", status:"Active", fav:true, folder:"fx-q4", f:{owner:"Raj Patel", start:d(-20), end:d(35), progress:"45"}, tags:["network"], rel:["ex11","ex20"]},
      {id:"ex17", type:"project", title:"Mail migration", subtitle:"Move mailboxes to the new tenant", status:"Planned", folder:"fx-q4", f:{owner:"Maya Chen", start:d(10), end:d(60), progress:"0"}, rel:["ex10"]},
      {id:"ex18", type:"project", title:"Backup policy rewrite", subtitle:"Retention, testing, ownership", status:"At risk", folder:"fx-q4", f:{owner:"D. O'Leary", start:d(-30), end:d(6), progress:"70"}, tags:["backup"], rel:["ex05","ex04"]},
      {id:"ex19", type:"server", title:"db-prod-03", subtitle:"PostgreSQL replica", status:"Online", folder:"fx-dc", f:{host:"10.0.4.23", os:"Ubuntu 24.04 LTS", location:"Rack B4, Dublin DC", role:"Database replica"}, tags:["prod","database"]},
      {id:"ex20", type:"person", title:"Liam Walsh", subtitle:"Support engineer, Fortigate reseller", status:"Active", folder:"fx-vendors", f:{role:"Support engineer", company:"NetSecure Ltd", email:"liam.walsh@netsecure.example", phone:"+353 21 555 0110"}, tags:["vendor","network"]},
      {id:"ex21", type:"issue", title:"Printer queue stuck on Level 2", subtitle:"Spooler restarts fixed it", status:"Resolved", folder:"fx-room", f:{severity:"Low", assignee:"Tom Alvarez", ticket:"INC-2262", due:d(-6)}, tags:["printing"]},
      {id:"ex22", type:"person", title:"Tom Alvarez", subtitle:"IT support (contract)", status:"Away", folder:"fx-team", f:{role:"IT support", company:"Contract", email:"tom.alvarez@example.com", location:"Dublin"}, tags:["team"], rel:["ex21"]},
      {id:"ex23", type:"event", title:"Patch Tuesday", subtitle:"Monthly OS and app updates", status:"Scheduled", folder:"fx-infra", f:{due:d(18), time:"18:00", where:"All servers"}, tags:["patching"], rel:["ex01","ex19","ex02","ex03"]},
      {id:"ex25", type:"meeting", title:"Weekly infrastructure stand-up", subtitle:"Every Monday with the infra team", status:"Scheduled", fav:true, folder:"fx-team",
        f:{due:addDays(lastMon, -28), time:"09:30", endtime:"09:45", repeat:"Every week", join:"https://teams.microsoft.com/l/meetup-join/19%3ameeting_example%40thread.v2/0", organiser:"D. O'Leary", where:"Teams", "with":"Maya Chen, Raj Patel, Tom Alvarez"},
        tags:["team"], rel:["ex10","ex11","ex22"],
        sess:[{id:"exs1", date:addDays(lastMon, -14), text:"Backups: two failed jobs on NAS-01, Maya looking into it.\nVPN: vendor ticket raised with NetSecure.\nActions: Raj to chase firmware date.", files:[]},
              {id:"exs2", date:addDays(lastMon, -7), text:"NAS-01 at 86%, archive plan agreed.\nDR test booked.\nActions: Maya to send the DR run sheet by Friday.", files:[]}]},
      {id:"ex26", type:"meeting", title:"Northwind quarterly review", subtitle:"Hosting contract and service levels", status:"Scheduled", folder:"fx-vendors",
        f:{due:d(4), time:"15:00", endtime:"16:00", join:"https://zoom.us/j/5550100200", organiser:"Siobhan Byrne", where:"Zoom", "with":"Siobhan Byrne, D. O'Leary"},
        tags:["vendor"], rel:["ex12","ex14"], notes:"Bring the uptime figures for web-edge-01."},
      {id:"ex24", type:"storage", title:"Tape library", subtitle:"LTO-9 archive, 24 slots", status:"Degraded", folder:"fx-dc", f:{kind:"Tape", capacity:"432 TB", used:"188 TB", location:"Dublin DC, Rack B6", serial:"TL-2400-0091", due:d(-3)}, tags:["backup","archive"], notes:"Drive 2 reports cleaning errors. Warranty just lapsed; renewal quote requested.", rel:["ex18"]}
    ];
    var byId = {};
    list.forEach(function(c){ byId[c.id] = c; c.rel = c.rel || []; });
    list.forEach(function(c){ c.rel.forEach(function(r){ var o = byId[r]; if(o && o.rel.indexOf(c.id) < 0) o.rel.push(c.id); }); });
    return list.map(function(c){ c.example = true; c.updated = new Date().toISOString(); return norm(c); });
  }

  /* ================= starter sets ================= */
  /* Types shared by key across packs: adding a second pack only adds keys that don't exist yet.
     Shape matches a typeCfg.custom entry (fields pass straight through normField in normTypeCfg). */
  var STARTER_SHARED = {
    customer: {key:"customer", label:"Customer", plural:"Customers", short:"CUS", color:"c1", statuses:["Active","Lead","Past"],
      fields:[{k:"phone",l:"Phone",t:"tel"},{k:"email",l:"Email",t:"email"},{k:"address",l:"Address",t:"text"},{k:"source",l:"Found us via",t:"select",opts:["Referral","Website","Repeat customer","Social media","Other"]}]},
    supplier: {key:"supplier", label:"Supplier", plural:"Suppliers", short:"SUP", color:"c5", statuses:["Active","Inactive"],
      fields:[{k:"contact",l:"Contact name",t:"text"},{k:"phone",l:"Phone",t:"tel"},{k:"email",l:"Email",t:"email"},{k:"account",l:"Account no.",t:"text"},{k:"website",l:"Website",t:"url"}]},
    invoice: {key:"invoice", label:"Invoice", plural:"Invoices", short:"INV", color:"c6", statuses:["Sent","Overdue","Paid"],
      fields:[{k:"due",l:"Payment due",t:"date"},{k:"amount",l:"Amount",t:"text"},{k:"customer",l:"Billed to",t:"text"},{k:"number",l:"Invoice no.",t:"text"}]},
    task: {key:"task", label:"Task", plural:"Tasks", short:"TSK", color:"c3", statuses:["To do","Doing","Done"],
      fields:[{k:"due",l:"Due",t:"date"},{k:"owner",l:"Who",t:"text"},{k:"priority",l:"Priority",t:"select",opts:["Low","Normal","High"]}]},
    job: {key:"job", label:"Job", plural:"Jobs", short:"JOB", color:"c3", statuses:["Booked","In progress","On hold","Done"],
      fields:[{k:"due",l:"Booked for",t:"date"},{k:"customer",l:"Customer",t:"text"},{k:"address",l:"Site address",t:"text"},{k:"price",l:"Price",t:"text"},{k:"assigned",l:"Who's on it",t:"text"}]},
    quote: {key:"quote", label:"Quote", plural:"Quotes", short:"QUO", color:"c4", statuses:["Draft","Sent","Accepted","Declined"],
      fields:[{k:"due",l:"Follow up by",t:"date"},{k:"customer",l:"Customer",t:"text"},{k:"amount",l:"Amount",t:"text"},{k:"valid",l:"Valid until",t:"date"}]},
    kit: {key:"kit", label:"Van & kit", plural:"Vans & kit", short:"KIT", color:"c7", statuses:["In use","Needs attention","Retired"],
      fields:[{k:"due",l:"Service / MOT due",t:"date"},{k:"reg",l:"Reg / serial",t:"text"},{k:"insurance",l:"Insurance renewal",t:"date"}]},
    client: {key:"client", label:"Client", plural:"Clients", short:"CLI", color:"c1", statuses:["Active","Prospect","Past"],
      fields:[{k:"contact",l:"Main contact",t:"text"},{k:"email",l:"Email",t:"email"},{k:"phone",l:"Phone",t:"tel"},{k:"website",l:"Website",t:"url"},{k:"renewal",l:"Contract renewal",t:"date"}]},
    stock: {key:"stock", label:"Stock item", plural:"Stock", short:"STK", color:"c2", statuses:["In stock","Running low","Out of stock","Discontinued"],
      fields:[{k:"sku",l:"Code / SKU",t:"text"},{k:"supplier",l:"Supplier",t:"text"},{k:"qty",l:"In stock",t:"number"},{k:"reorder",l:"Reorder at",t:"number"},{k:"price",l:"Sell price",t:"text"}]},
    order: {key:"order", label:"Order", plural:"Orders", short:"ORD", color:"c4", statuses:["Ordered","Part delivered","Delivered"],
      fields:[{k:"due",l:"Expected",t:"date"},{k:"supplier",l:"Supplier",t:"text"},{k:"total",l:"Total",t:"text"},{k:"ref",l:"Order ref",t:"text"}]},
    booking: {key:"booking", label:"Booking", plural:"Bookings", short:"BKG", color:"c6", statuses:["Confirmed","Tentative","Completed","Cancelled"],
      fields:[{k:"due",l:"Date",t:"date"},{k:"time",l:"Time",t:"text"},{k:"guests",l:"People",t:"number"},{k:"phone",l:"Phone",t:"tel"},{k:"notes2",l:"Requests",t:"text"}]},
    check: {key:"check", label:"Check", plural:"Checks & compliance", short:"CHK", color:"c8", statuses:["Due","Done"],
      fields:[{k:"due",l:"Next due",t:"date"},{k:"area",l:"Area",t:"text"},{k:"who",l:"Who does it",t:"text"}]},
    property: {key:"property", label:"Property", plural:"Properties", short:"PRP", color:"c2", statuses:["Let","Vacant","Under offer","Off market"],
      fields:[{k:"address",l:"Address",t:"text"},{k:"beds",l:"Bedrooms",t:"number"},{k:"rent",l:"Rent (pcm)",t:"text"},{k:"landlord",l:"Landlord",t:"text"}]},
    tenancy: {key:"tenancy", label:"Tenancy", plural:"Tenancies", short:"TEN", color:"c1", statuses:["Active","Ending","Ended"],
      fields:[{k:"due",l:"Renewal / end",t:"date"},{k:"tenant",l:"Tenant(s)",t:"text"},{k:"property",l:"Property",t:"text"},{k:"rent",l:"Rent (pcm)",t:"text"},{k:"deposit",l:"Deposit scheme ref",t:"text"},{k:"start",l:"Started",t:"date"}]},
    landlord: {key:"landlord", label:"Landlord", plural:"Landlords", short:"LLD", color:"c5", statuses:["Active","Former"],
      fields:[{k:"phone",l:"Phone",t:"tel"},{k:"email",l:"Email",t:"email"},{k:"address",l:"Correspondence address",t:"text"}]},
    repair: {key:"repair", label:"Repair", plural:"Repairs", short:"REP", color:"c3", statuses:["Reported","Booked","Done"],
      fields:[{k:"due",l:"Booked for",t:"date"},{k:"property",l:"Property",t:"text"},{k:"contractor",l:"Contractor",t:"text"},{k:"priority",l:"Priority",t:"select",opts:["Routine","Urgent","Emergency"]}]},
    viewing: {key:"viewing", label:"Viewing", plural:"Viewings", short:"VWG", color:"c4", statuses:["Booked","Done","Cancelled"],
      fields:[{k:"due",l:"Date",t:"date"},{k:"time",l:"Time",t:"text"},{k:"property",l:"Property",t:"text"},{k:"applicant",l:"Applicant",t:"text"},{k:"phone",l:"Phone",t:"tel"}]},
    cert: {key:"cert", label:"Certificate", plural:"Certificates", short:"CRT", color:"c7", statuses:["Valid","Renewal due","Expired"],
      fields:[{k:"due",l:"Expires",t:"date"},{k:"property",l:"Property",t:"text"},{k:"kind",l:"Type",t:"select",opts:["Gas safety","EICR","EPC","Fire risk","Licence","Other"]}]}
  };
  /* one pack's example cards, built fresh each time so ids/dates are current; `today` is a date fn(n) */
  function starterPackExamples(id, d){
    if(id === "trades") return [
      {id:"sx_tr1", type:"customer", title:"Sarah Price", subtitle:"Kitchen refit, repeat customer", status:"Active", fav:true, f:{phone:"07700 900123", email:"sarah.price@example.com", address:"14 Elm Road, Bristol", source:"Referral"}, rel:["sx_tr2","sx_tr3"]},
      {id:"sx_tr2", type:"job", title:"Kitchen refit – 14 Elm Road", subtitle:"Units, worktops and tiling", status:"In progress", f:{due:d(2), customer:"Sarah Price", address:"14 Elm Road, Bristol", price:"£6,850", assigned:"Dan & Luke"}, check:[{t:"Strip out old units",done:true},{t:"First-fix plumbing",done:true},{t:"Fit units",done:false},{t:"Worktops templated",done:false},{t:"Tiling",done:false}], rel:["sx_tr1"]},
      {id:"sx_tr3", type:"quote", title:"Bathroom – £4,200", subtitle:"Walk-in shower conversion", status:"Sent", f:{due:d(3), customer:"Sarah Price", amount:"£4,200", valid:d(27)}, rel:["sx_tr1"]},
      {id:"sx_tr4", type:"job", title:"Boiler service – 7 Mill Lane", subtitle:"Annual service, Worcester combi", status:"Booked", f:{due:d(5), customer:"Mr & Mrs Okafor", address:"7 Mill Lane", price:"£95"}, rpt:{every:"Every year", until:"", times:0, n:0}},
      {id:"sx_tr5", type:"invoice", title:"INV-1042 – Okafor", subtitle:"Radiator replacement", status:"Sent", f:{due:d(-3), amount:"£380", customer:"Mr & Mrs Okafor", number:"INV-1042"}},
      {id:"sx_tr6", type:"supplier", title:"City Plumbing Supplies", subtitle:"Trade counter, account holder", status:"Active", f:{contact:"Gary", phone:"0117 496 0000", account:"CPS-55821", website:"https://www.example.com"}},
      {id:"sx_tr7", type:"kit", title:"Van – Ford Transit", subtitle:"WX21 ABC", status:"In use", f:{due:d(40), reg:"WX21 ABC", insurance:d(120)}, rpt:{every:"Every year", until:"", times:0, n:0}}
    ];
    if(id === "office") return [
      {id:"sx_of1", type:"client", title:"Harbour & Co", subtitle:"Retainer: brand and website", status:"Active", fav:true, f:{contact:"Priya Shah", email:"priya@harbour.example", phone:"020 7946 0000", renewal:d(60)}, rel:["sx_of2","sx_of4"]},
      {id:"sx_of2", type:"project", title:"Harbour website refresh", subtitle:"New pages and booking form", status:"Active", f:{owner:"Alex", start:d(-20), end:d(25), progress:"45"}, rel:["sx_of1"]},
      {id:"sx_of3", type:"task", title:"Send monthly report to clients", subtitle:"Analytics summary + next steps", status:"To do", f:{due:d(4), owner:"Alex", priority:"Normal"}, rpt:{every:"Every month", until:"", times:0, n:0}},
      {id:"sx_of4", type:"meeting", title:"Harbour weekly check-in", subtitle:"30 minutes, video call", status:"Scheduled", f:{due:d(1), time:"10:00", endtime:"10:30", repeat:"Every week", where:"Video call", "with":"Priya Shah, Alex"}, rel:["sx_of1"]},
      {id:"sx_of5", type:"invoice", title:"INV-2031 – Harbour & Co", subtitle:"September retainer", status:"Sent", f:{due:d(9), amount:"£2,400", customer:"Harbour & Co", number:"INV-2031"}},
      {id:"sx_of6", type:"person", title:"Alex Morgan", subtitle:"Project lead", status:"Active", f:{role:"Project lead", company:"Our team", email:"alex@example.com"}},
      {id:"sx_of7", type:"task", title:"Renew professional indemnity insurance", status:"To do", f:{due:d(18), owner:"You", priority:"High"}, rpt:{every:"Every year", until:"", times:0, n:0}}
    ];
    if(id === "shop") return [
      {id:"sx_sh1", type:"stock", title:"House coffee beans 1kg", subtitle:"Best seller", status:"Running low", fav:true, f:{sku:"COF-001", supplier:"Roast & Co", qty:"6", reorder:"8", price:"£14.50"}, rel:["sx_sh2","sx_sh3"]},
      {id:"sx_sh2", type:"supplier", title:"Roast & Co", subtitle:"Coffee, weekly delivery", status:"Active", f:{contact:"Jo", phone:"0161 496 0000", email:"orders@roast.example", account:"RC-3310"}},
      {id:"sx_sh3", type:"order", title:"Weekly coffee order", subtitle:"12 × house beans, 4 × decaf", status:"Ordered", f:{due:d(2), supplier:"Roast & Co", total:"£168", ref:"PO-0457"}},
      {id:"sx_sh4", type:"booking", title:"Birthday lunch – Taylor, 12 people", subtitle:"Long table by the window", status:"Confirmed", f:{due:d(6), time:"13:00", guests:"12", phone:"07700 900456", notes2:"One vegan, one nut allergy"}},
      {id:"sx_sh5", type:"check", title:"Fridge temperatures", subtitle:"Log both fridges, below 5°C", status:"Due", f:{due:d(0), area:"Kitchen", who:"Opening shift"}, rpt:{every:"Every day", until:"", times:0, n:0}, check:[{t:"Fridge 1",done:false},{t:"Fridge 2",done:false}]},
      {id:"sx_sh6", type:"check", title:"Fire alarm test", subtitle:"Test a different call point each week", status:"Due", f:{due:d(3), area:"Whole building", who:"Manager"}, rpt:{every:"Every week", until:"", times:0, n:0}},
      {id:"sx_sh7", type:"task", title:"Update the autumn menu boards", status:"To do", f:{due:d(10), owner:"Sam", priority:"Normal"}}
    ];
    if(id === "property") return [
      {id:"sx_pr1", type:"property", title:"Flat 3, 21 Queen Street", subtitle:"2-bed first-floor flat", status:"Let", fav:true, f:{address:"Flat 3, 21 Queen Street, Leeds", beds:"2", rent:"£950", landlord:"Mrs H. Patel"}, rel:["sx_pr2","sx_pr3","sx_pr4","sx_pr5"]},
      {id:"sx_pr2", type:"tenancy", title:"Flat 3 – J. & K. Evans", subtitle:"12-month AST", status:"Active", f:{due:d(45), tenant:"James & Kate Evans", property:"Flat 3, 21 Queen Street", rent:"£950", deposit:"DPS 1234-5678", start:d(-320)}, rel:["sx_pr1"]},
      {id:"sx_pr3", type:"landlord", title:"Mrs H. Patel", subtitle:"2 properties", status:"Active", f:{phone:"07700 900789", email:"h.patel@example.com"}, rel:["sx_pr1"]},
      {id:"sx_pr4", type:"cert", title:"Gas safety – Flat 3", subtitle:"CP12", status:"Valid", f:{due:d(21), property:"Flat 3, 21 Queen Street", kind:"Gas safety"}, rpt:{every:"Every year", until:"", times:0, n:0}, rel:["sx_pr1"]},
      {id:"sx_pr5", type:"repair", title:"Dripping kitchen tap – Flat 3", subtitle:"Reported by tenant", status:"Booked", f:{due:d(1), property:"Flat 3, 21 Queen Street", contractor:"A1 Plumbing", priority:"Routine"}, rel:["sx_pr1"]},
      {id:"sx_pr6", type:"viewing", title:"Viewing – 8 Park Row", subtitle:"Couple, relocating for work", status:"Booked", f:{due:d(2), time:"17:30", property:"8 Park Row", applicant:"Tom Reid", phone:"07700 900321"}},
      {id:"sx_pr7", type:"property", title:"8 Park Row", subtitle:"3-bed terrace", status:"Vacant", f:{address:"8 Park Row, Leeds", beds:"3", rent:"£1,150", landlord:"Mr D. Kerr"}},
      {id:"sx_pr8", type:"supplier", title:"A1 Plumbing", subtitle:"Approved contractor", status:"Active", f:{contact:"Mike", phone:"0113 496 0000"}}
    ];
    return [];
  }
  var STARTER_PACKS = [
    {id:"trades", name:"Trades & services", blurb:"Customers, jobs, quotes and invoices — for plumbers, electricians, builders, cleaners and the like.",
     types:["customer","job","quote","invoice","supplier","kit"], off:["server","storage","issue","project"]},
    {id:"office", name:"Office & agency", blurb:"Clients, projects, tasks and meetings — for consultancies, agencies and small offices.",
     types:["client","task","invoice","supplier"], off:["server","storage","issue"]},
    {id:"shop", name:"Shop & hospitality", blurb:"Stock, suppliers, orders, bookings and daily checks — for shops, cafés, salons and venues.",
     types:["stock","supplier","order","booking","check","task"], off:["server","storage","issue","project"]},
    {id:"property", name:"Property & lettings", blurb:"Properties, tenancies, landlords, repairs and certificates — for letting agents and landlords.",
     types:["property","tenancy","landlord","repair","viewing","cert","supplier"], off:["server","storage","issue","project"]},
    {id:"it", name:"IT & infrastructure", blurb:"Servers, storage, issues, people and projects — the original Tabwheel set.", types:[], off:[]}
  ];
  function starterPack(id){ return STARTER_PACKS.filter(function(p){ return p.id === id; })[0] || null; }
  /* fresh ids for a batch of example cards whose ids are already taken (so applying the same pack twice, or
     applying it after cards with those ids already exist, never collides), remapping their rel[] together */
  function freshenExampleIds(list){
    var remap = {};
    list.forEach(function(c){ remap[c.id] = (S.cards.has(c.id) || S.trash.has(c.id)) ? ("sx" + uid()) : c.id; });
    return list.map(function(c){
      var o = JSON.parse(JSON.stringify(c));
      o.id = remap[c.id];
      if(Array.isArray(o.rel)) o.rel = o.rel.map(function(r){ return remap[r] || r; });
      return o;
    });
  }
  /* adds a pack's types (skipping any key already present, shared or custom) and, optionally, its example
     cards; used by both the setup chooser and "Add a starter set" in Card types. */
  /* Bulk-seeding a batch of cards still ends up through the normal storage path (flush() for online,
     saveLocal() for local), but not through touch()'s per-card debounce timer: dozens of cards at once
     would otherwise leave localTimer/S.dirty churning for the better part of a second right as the
     workspace first opens, and a tab closed in that window could still lose the very data it just got. */
  function seedCards(list){
    list.forEach(function(c){ S.cards.set(c.id, c); if(S.mode === "online") touch(c.id); else bump(c.id); });
    if(S.mode !== "online") saveLocal();
  }
  function applyStarterPack(id, withExamples){
    var pack = starterPack(id); if(!pack) return;
    if(id === "it"){
      sampleFolders().forEach(function(f){ if(!folderById(f.id)) S.folders.push(f); });
      if(withExamples){ seedCards(examples()); foldersChanged(); }
    } else {
      var have = {}; typeCfg.custom.forEach(function(c){ have[c.key] = 1; });
      pack.types.forEach(function(k){
        if(have[k] || BUILTIN[k]) return;
        var def = STARTER_SHARED[k]; if(!def) return;
        typeCfg.custom.push(JSON.parse(JSON.stringify(def)));
        have[k] = 1;
      });
      var off = (typeCfg.off || []).slice();
      pack.off.forEach(function(k){ if(BUILTIN[k] && off.indexOf(k) < 0) off.push(k); });
      typeCfg.off = off;
      typeCfg = normTypeCfg(typeCfg);
      rebuildTypes(); saveTypes();
      if(withExamples){
        var t = today(), d = function(n){ return addDays(t, n); };
        var list = freshenExampleIds(starterPackExamples(id, d)).map(function(c){ c.example = true; c.updated = new Date().toISOString(); return norm(c); });
        seedCards(list);
      }
    }
    if((typeCfg.packs || []).indexOf(id) < 0) typeCfg.packs = (typeCfg.packs || []).concat([id]);
    if(!typeCfg.pack) typeCfg.pack = id;
    typeCfg = normTypeCfg(typeCfg); rebuildTypes(); saveTypes();
  }
  /* the setup chooser: shown once, only for a brand-new Work space with no real cards yet */
  var chooserOffered = false, chooserDecided = false;
  function openSetupChooser(){
    if(S.readOnly || modalKind){ return; }
    chooserDecided = false;
    openModal("chooser");
    var packHtml = function(p){
      var chips = p.id === "it" ? ["server","storage","issue","person","meeting","event","project"].map(function(k){ return {l:BUILTIN[k].label, c:"var(--t-" + k + ")"}; }) : p.types.map(function(k){ var t = STARTER_SHARED[k] || {}; return {l:t.label || k, c:"var(--t-" + (t.color || "c1") + ")"}; });
      return '<button type="button" class="setup-card" data-pack="' + p.id + '"><h3>' + esc(p.name) + '</h3><p>' + esc(p.blurb) + '</p><div class="setup-chips">' + chips.map(function(c){ return '<span class="pill" style="--tc:' + c.c + '">' + esc(c.l) + '</span>'; }).join("") + '</div></button>';
    };
    $("modalBox").innerHTML = '<div class="modal-head"><h2 id="modalTitle">What’s this workspace for?</h2></div>' +
      '<div class="modal-body"><p class="d-note setup-intro">Pick the closest match — it sets up a few card types and example cards to get you going. You can add, remove or change any of it afterwards.</p>' +
      '<div class="setup-grid">' + STARTER_PACKS.map(packHtml).join("") + '</div></div>' +
      '<div class="modal-foot"><span class="note">Nothing here suits you?</span><button type="button" class="btn" data-pack="__blank">Start blank</button></div>';
  }
  $("modalBox").addEventListener("click", function(e){
    if(modalKind !== "chooser") return;
    var b = e.target.closest("[data-pack]"); if(!b) return;
    chooserDecided = true;
    if(b.dataset.pack !== "__blank") applyStarterPack(b.dataset.pack, true);
    else { typeCfg.pack = "blank"; typeCfg = normTypeCfg(typeCfg); saveTypes(); }
    closeModal();
    S.nav = "all"; setView("rolodex");
    refresh();
    maybeOfferTour();
  });
  /* dismissed (Esc / backdrop / no choice made): today's long-standing behaviour — seed the IT examples */
  function chooserDismissed(){
    if(chooserDecided) return;
    chooserDecided = true;
    applyStarterPack("it", true);
    S.nav = "all";
    refresh();
    maybeOfferTour();
  }
  /* offered once per new Work space: no real (non-example) cards yet, and no pack decision recorded */
  function checkStarterChooser(){
    if(chooserOffered || S.readOnly || typeCfg.pack || S.space !== "work") return false;
    var hasReal = Array.from(S.cards.values()).concat(Array.from(S.trash.values())).some(function(c){ return !c.example; });
    if(hasReal) return false;
    chooserOffered = true;
    /* browser checks pass ?skipsetup=1 to get today's deterministic IT seed without the chooser UI in the way */
    if(/[?&]skipsetup=1\b/.test(location.search)){ applyStarterPack("it", true); return false; }
    openSetupChooser();
    return true;
  }

  /* ================= storage ================= */
  /* Online layout: cards/<id> holds the card WITHOUT its meeting notes; each meeting-notes page is its own
     doc sess/<cardId>~<sessId> {card, id, date, text, files}, so a long-running meeting never outgrows the
     256 KB document limit. Deleted cards stay in cards/<id> with `deleted` set (the Trash) until purged. */
  var localTimer = null;
  var saveTimers = {}, writing = {}, again = {}, activeWrites = 0, writeQueue = [], MAX_WRITES = 6;
  var serverCard = new Map();   /* id -> JSON of the card body last seen on / written to the server */
  var serverSess = new Map();   /* sess doc id -> JSON last seen on / written to the server */
  var sessByCard = new Map();   /* card id -> [sess] from the sess collection */
  var serverPage = new Map();   /* card id -> JSON of pages/<id> last seen on / written to the server */
  var pageByCard = new Map();   /* card id -> [blocks] from the pages collection */
  var legacySess = new Set();   /* cards whose doc still carries sess inline (migrated on first save) */
  var DOC_LIMIT = 250000;

  function cardOf(id){ return S.cards.get(id) || S.trash.get(id); }
  function putCard(c){
    if(c.deleted){ S.trash.set(c.id, c); S.cards.delete(c.id); }
    else { S.cards.set(c.id, c); S.trash.delete(c.id); }
  }
  function dropCard(id){ S.cards.delete(id); S.trash.delete(id); S.revs.delete(id); }

  function touch(id){
    /* a real edit (anything past the one touch createCard() itself makes) means this card is no
       longer an untouched blank — see S.pendingBlank in createCard()/refresh(). */
    if(S.pendingBlank === id) S.pendingBlank = null;
    var c = cardOf(id);
    if(c) c.updated = new Date().toISOString();
    bump(id);
    S.dirty.add(id);
    clearTimeout(saveTimers[id]);
    saveTimers[id] = setTimeout(function(){ flush(id); }, 500);
    if(S.mode === "online") setStatus("saving");
    scheduleRefresh();
  }

  function cardBody(c){ var o = JSON.parse(JSON.stringify(c)); delete o.sess; delete o.page; return o; }
  function sessDocId(cardId, sid){ return cardId + "~" + sid; }
  /* only the fields that changed since the server copy; nested `f` is merged key by key ("" clears) */
  function cardPatch(body, base){
    var p = {}, n = 0;
    Object.keys(body).forEach(function(k){
      if(k === "f"){
        var bf = base.f || {}, fp = {}, fn = 0;
        Object.keys(body.f).forEach(function(x){ if(body.f[x] !== bf[x]){ fp[x] = body.f[x]; fn++; } });
        Object.keys(bf).forEach(function(x){ if(!(x in body.f)){ fp[x] = ""; fn++; } });
        if(fn){ p.f = fp; n++; }
      } else if(JSON.stringify(body[k]) !== JSON.stringify(base[k])){ p[k] = body[k]; n++; }
    });
    return n ? p : null;
  }

  function flush(id){
    if(S.mode !== "online"){ S.dirty.delete(id); clearTimeout(localTimer); localTimer = setTimeout(saveLocal, 250); return; }
    if(S.readOnly){ S.dirty.delete(id); return; }
    if(writing[id]){ again[id] = true; return; }
    if(activeWrites >= MAX_WRITES){ if(writeQueue.indexOf(id) < 0) writeQueue.push(id); return; }
    writing[id] = true; activeWrites++;
    var c = cardOf(id);
    var ref = S.db.doc("cards/" + id);
    var job;
    if(!c){
      /* purged: remove the card and every notes page it had */
      var gone = Array.from(serverSess.keys()).filter(function(k){ return k.indexOf(id + "~") === 0; });
      if(serverPage.has(id)) gone.push("__page");
      job = Promise.all(gone.map(function(k){
        if(k === "__page") return S.db.doc("pages/" + id).delete().then(function(){ serverPage.delete(id); });
        return S.db.doc("sess/" + k).delete().then(function(){ serverSess.delete(k); });
      })).then(function(){ return ref.delete(); }).then(function(){ serverCard.delete(id); });
    } else {
      /* 1: notes pages that changed or went away */
      var want = {};
      c.sess.forEach(function(x){ want[sessDocId(id, x.id)] = JSON.stringify({card:id, id:x.id, date:x.date, text:x.text, files:x.files, blocks:x.blocks}); });
      var writes = [];
      Object.keys(want).forEach(function(k){
        if(serverSess.get(k) === want[k]) return;
        if(want[k].length > DOC_LIMIT){ writes.push(Promise.reject({code:"too_big"})); return; }
        writes.push(S.db.doc("sess/" + k).set(JSON.parse(want[k])).then(function(){ serverSess.set(k, want[k]); }));
      });
      Array.from(serverSess.keys()).forEach(function(k){
        if(k.indexOf(id + "~") === 0 && !want[k]) writes.push(S.db.doc("sess/" + k).delete().then(function(){ serverSess.delete(k); }));
      });
      if(c.page){
        var pj = JSON.stringify({card:id, blocks:c.page});
        if(serverPage.get(id) !== pj){
          if(pj.length > DOC_LIMIT) writes.push(Promise.reject({code:"too_big"}));
          else writes.push(S.db.doc("pages/" + id).set(JSON.parse(pj)).then(function(){ serverPage.set(id, pj); }));
        }
      }
      /* 2: the card itself, as a patch when the server already has it */
      var body = cardBody(c), json = JSON.stringify(body);
      job = Promise.all(writes).then(function(){
        if(json.length > DOC_LIMIT) return Promise.reject({code:"too_big"});
        var base = serverCard.get(id);
        var patch = base && !legacySess.has(id) ? cardPatch(body, JSON.parse(base)) : body;
        if(!patch) return;
        var w = patch === body ? ref.set(body) : ref.update(patch).catch(function(e){
          /* the doc vanished under us (deleted elsewhere): write it whole */
          if(e && e.code === "invalid_argument") return ref.set(body);
          throw e;
        });
        return w.then(function(){ serverCard.set(id, json); legacySess.delete(id); });
      });
    }
    job.then(function(){ setStatus("online"); delete invalidRetries[id]; return false; }, function(e){ return dbError(e, id); })
     .then(function(retrying){
       writing[id] = false; activeWrites--;
       if(again[id]){ again[id] = false; flush(id); }
       else if(!retrying) S.dirty.delete(id);
       if(writeQueue.length) flush(writeQueue.shift());
     });
  }

  var invalidRetries = {};
  function dbError(e, id){
    var code = e && e.code;
    if(code === "too_big"){ setStatus("error", "Card too large"); var c = cardOf(id); toast("“" + (c ? c.title : "This card") + "” is too large to save online. Move some notes or images to another card."); }
    else if(code === "invalid_argument"){
      /* a permission denial can also be a bulk-operation timing race (e.g. clearing several
         cards touches others' link/rel fields while the deletes are still landing) — retry a
         few times before latching the whole workspace read-only over what may be transient */
      var n = (invalidRetries[id] || 0) + 1; invalidRetries[id] = n;
      if(n <= 3){ setStatus("error", "Not saved"); setTimeout(function(){ flush(id); }, 800 * n); return true; }
      S.readOnly = true; setStatus("error", "View only"); toast("You have view-only access to this workspace, so changes aren't saved.");
    }
    else if(code === "quota_exceeded"){ setStatus("error", "Storage full"); toast("Online storage is full (5,000 records max). Empty the Trash or delete some cards."); }
    else if(code === "revoked"){ setStatus("error", "Disconnected"); toast("Access to online storage ended. Reload the page."); }
    else {
      setStatus("error", "Not saved");
      if(!again["retry:" + id]){ again["retry:" + id] = true; setTimeout(function(){ again["retry:" + id] = false; if(id === "__folders") writeFolders(); else if(id === "__types") saveTypes(); else flush(id); }, 1500 + Math.random() * 1000); }
    }
  }

  /* On this device, cards live in the browser's database (IndexedDB), which holds far more than
     localStorage's ~5 MB, so full-size screenshots fit. localStorage is only the fallback. */
  var idbP = null;
  function idb(){
    if(idbP) return idbP;
    idbP = new Promise(function(res, rej){
      try{
        var rq = indexedDB.open("tabwheel", 1);
        rq.onupgradeneeded = function(){ rq.result.createObjectStore("kv"); };
        rq.onsuccess = function(){ var db = rq.result; db.onversionchange = function(){ db.close(); idbP = null; }; res(db); };
        rq.onerror = function(){ rej(rq.error); };
      }catch(e){ rej(e); }
    });
    return idbP;
  }
  function idbGet(k){ return idb().then(function(db){ return new Promise(function(res, rej){ var r = db.transaction("kv").objectStore("kv").get(k); r.onsuccess = function(){ res(r.result); }; r.onerror = function(){ rej(r.error); }; }); }); }
  function idbSet(k, v){ return idb().then(function(db){ return new Promise(function(res, rej){ var tx = db.transaction("kv", "readwrite"); tx.objectStore("kv").put(v, k); tx.oncomplete = function(){ res(); }; tx.onerror = function(){ rej(tx.error); }; tx.onabort = function(){ rej(tx.error); }; }); }); }
  var useIdb = true, localSaving = false, localAgain = false;
  function saveLocal(){
    var data = JSON.stringify(Array.from(S.cards.values()).concat(Array.from(S.trash.values())));
    var fallback = function(){
      if(lsSet(LOCAL_KEY, data)) setStatus("local");
      else { setStatus("error", "Device storage full"); toast("This browser has no room left, so the last change wasn't saved. Open the page on claude.ai to save online."); }
    };
    if(!useIdb){ fallback(); return; }
    if(localSaving){ localAgain = true; return; }
    localSaving = true;
    idbSet(LOCAL_KEY, data).then(function(){ setStatus("local"); try{ localStorage.removeItem(LOCAL_KEY); if(!localAgain) localStorage.removeItem(PENDING_KEY); }catch(e){} }, function(){ useIdb = false; fallback(); })
      .then(function(){ localSaving = false; if(localAgain){ localAgain = false; saveLocal(); } });
  }

  /* the browser database writes asynchronously, so when the tab closes the latest state is also copied
     synchronously to localStorage (when it fits); the next load prefers that copy and clears it */
  var PENDING_KEY = "work-rolodex/cards-pending";
  function saveLocalNow(){
    var data = JSON.stringify(Array.from(S.cards.values()).concat(Array.from(S.trash.values())));
    lsSet(PENDING_KEY, data);
    if(useIdb) idbSet(LOCAL_KEY, data).catch(function(){}); else lsSet(LOCAL_KEY, data);
  }
  function startLocal(){
    S.mode = "local";
    var pending = lsGet(PENDING_KEY);
    idbGet(LOCAL_KEY).then(function(v){ finishLocal(pending || v || lsGet(LOCAL_KEY)); if(pending) saveLocal(); }, function(){ useIdb = false; finishLocal(pending || lsGet(LOCAL_KEY)); });
  }
  function finishLocal(raw){
    var loaded = false;
    try{ typeCfg = normTypeCfg(JSON.parse(lsGet(TYPES_KEY) || "{}")); rebuildTypes(); }catch(e){}
    if(raw){ try{ JSON.parse(raw).forEach(function(c){ c = norm(c); if(c.id){ putCard(c); bump(c.id); } }); loaded = true; }catch(e){} }
    var fraw = lsGet(FOLDER_KEY);
    if(fraw){ try{ S.folders = normFolders(JSON.parse(fraw)); }catch(e){} }
    purgeOldTrash();
    setStatus("local");
    refresh();
    /* a brand-new Work space (nothing stored, no starter pack decided) gets the setup chooser instead of
       today's silent IT seeding — dismissing it without a choice still falls back to the IT examples,
       see chooserDismissed(). An existing workspace goes straight to the one-time tour offer. */
    if(!checkStarterChooser()) maybeOfferTour();
  }

  /* folders live in one document: meta/folders {list:[...]} */
  var folderTimer = null, folderWriting = false, folderAgain = false;
  function saveFolders(){
    if(S.mode !== "online"){ lsSet(FOLDER_KEY, JSON.stringify(S.folders)); return; }
    if(S.readOnly) return;
    S.foldersDirty = true;
    clearTimeout(folderTimer);
    folderTimer = setTimeout(writeFolders, 350);
  }
  function writeFolders(){
    if(folderWriting){ folderAgain = true; return; }
    folderWriting = true;
    S.db.doc("meta/folders").set({list:JSON.parse(JSON.stringify(S.folders))})
      .then(function(){ setStatus("online"); }, function(e){ dbError(e, "__folders"); })
      .then(function(){
        folderWriting = false;
        if(folderAgain){ folderAgain = false; writeFolders(); } else S.foldersDirty = false;
      });
  }
  function foldersChanged(){ saveFolders(); scheduleRefresh(); }
  var typesWriting = false, typesAgain = false;
  function saveTypes(){
    if(S.mode !== "online"){ lsSet(TYPES_KEY, JSON.stringify(typeCfg)); return; }
    if(S.readOnly) return;
    S.typesDirty = true;
    if(typesWriting){ typesAgain = true; return; }
    typesWriting = true;
    S.db.doc("meta/types").set(JSON.parse(JSON.stringify(typeCfg)))
      .then(function(){ setStatus("online"); }, function(e){ dbError(e, "__types"); })
      .then(function(){ typesWriting = false; if(typesAgain){ typesAgain = false; saveTypes(); } else S.typesDirty = false; });
  }

  function startOnline(db){
    S.db = db; S.mode = "online"; setStatus("online");
    var cardsReady = false, sessReady = false, typesReady = false, cleaned = false;
    var afterFirstLoad = function(){
      if(cleaned || !cardsReady || !sessReady || !typesReady) return;
      cleaned = true;
      /* move notes still stored inside card docs out into their own docs */
      legacySess.forEach(function(id){ if(cardOf(id)) touch(id); });
      purgeOldTrash();
      if(!checkStarterChooser()) maybeOfferTour();
    };
    db.collection("cards").onSnapshot(function(snap){
      var seen = new Set(), openChanged = false;
      snap.docs.forEach(function(d){
        seen.add(d.id);
        var body = d.data() || {};
        var c = norm(Object.assign({}, body, {id:d.id}));
        var inline = Array.isArray(body.sess) && body.sess.length > 0;
        if(inline) legacySess.add(d.id); else c.sess = (sessByCard.get(d.id) || []).slice();
        c.page = pageByCard.has(d.id) ? pageByCard.get(d.id).slice() : null;
        serverCard.set(d.id, JSON.stringify(cardBody(c)));
        if(S.dirty.has(d.id)) return;
        var old = cardOf(d.id);
        if(!old || JSON.stringify(old) !== JSON.stringify(c)){
          putCard(c); bump(d.id);
          if(S.open && d.id === S.curId) openChanged = true;
        }
      });
      Array.from(S.cards.keys()).concat(Array.from(S.trash.keys())).forEach(function(id){ if(!seen.has(id) && !S.dirty.has(id)){ dropCard(id); serverCard.delete(id); } });
      if(!snap.metadata.fromCache){ cardsReady = true; afterFirstLoad(); }
      if(openChanged){ var el = els.get(S.curId); if(el && !el.contains(document.activeElement)) el._detailFor = null; }
      refresh();
    }, function(){
      setStatus("error", "Disconnected");
      toast("Lost the connection to online storage. Reload the page to reconnect.");
    });
    db.collection("sess").onSnapshot(function(snap){
      var by = new Map(), ids = new Set();
      snap.docs.forEach(function(d){
        ids.add(d.id);
        var b = d.data() || {};
        if(typeof b.card !== "string") return;
        serverSess.set(d.id, JSON.stringify({card:b.card, id:b.id, date:b.date, text:b.text, files:b.files, blocks:b.blocks || undefined}));
        if(!by.has(b.card)) by.set(b.card, []);
        by.get(b.card).push(b);
      });
      Array.from(serverSess.keys()).forEach(function(k){ if(!ids.has(k)) serverSess.delete(k); });
      sessByCard = new Map();
      by.forEach(function(list, cid){ sessByCard.set(cid, norm({id:cid, sess:list}).sess); });
      var openChanged = false;
      S.cards.forEach(function(c, id){
        if(S.dirty.has(id) || legacySess.has(id)) return;
        var next = sessByCard.get(id) || [];
        if(JSON.stringify(next) !== JSON.stringify(c.sess)){ c.sess = next.slice(); bump(id); if(S.open && id === S.curId) openChanged = true; }
      });
      if(!snap.metadata.fromCache){ sessReady = true; afterFirstLoad(); }
      if(openChanged){ var el = els.get(S.curId); if(el && !el.contains(document.activeElement)) el._detailFor = null; }
      refresh();
    }, function(){});
    db.collection("pages").onSnapshot(function(snap){
      pageByCard = new Map(); serverPage = new Map();
      snap.docs.forEach(function(d){
        var b = d.data() || {};
        serverPage.set(d.id, JSON.stringify({card:b.card, blocks:b.blocks}));
        pageByCard.set(d.id, norm({id:d.id, page:b.blocks}).page || []);
      });
      var openChanged = false;
      S.cards.forEach(function(c, id){
        if(S.dirty.has(id)) return;
        var next = pageByCard.has(id) ? pageByCard.get(id) : null;
        if(!next) return;
        if(JSON.stringify(next) !== JSON.stringify(c.page)){ c.page = next.slice(); bump(id); if(S.open && id === S.curId) openChanged = true; }
      });
      if(openChanged){ var el = els.get(S.curId); if(el && !el.contains(document.activeElement)) el._detailFor = null; }
      refresh();
    }, function(){});
    db.doc("meta/types").onSnapshot(function(snap){
      if(!S.typesDirty){
        var cfg = normTypeCfg(snap.exists ? snap.data() : {});
        if(JSON.stringify(cfg) !== JSON.stringify(typeCfg)){ typeCfg = cfg; rebuildTypes(); Array.from(S.cards.keys()).forEach(bump); if(!$("modal").hidden && (modalKind === "types" || modalKind === "style")) return; refresh(); }
      }
      typesReady = true; afterFirstLoad();
    }, function(){});
    db.doc("meta/folders").onSnapshot(function(snap){
      if(S.foldersDirty) return;
      var list = normFolders(snap.exists ? (snap.data() || {}).list : []);
      if(JSON.stringify(list) !== JSON.stringify(S.folders)){
        S.folders = list;
        var a = document.activeElement;
        if(!(a && a.classList && a.classList.contains("folder-edit"))) refresh();
      }
    }, function(){});
  }

  function connect(){
    if(!window.claude || typeof window.claude.use !== "function"){ startLocal(); return; }
    window.claude.use("sample").then(function(fn){ S.sample = fn || null; $("askBtn").hidden = !fn; }, function(){ S.sample = null; });
    window.claude.use("db").then(function(db){
      if(!db){ startLocal(); return; }
      startOnline(db);
      window.claude.use("assets").then(function(a){ S.assets = a || null; if(S.open) rebuildDetail(); }, function(){ S.assets = null; });
    }, function(){ startLocal(); });
  }

  /* ================= search ================= */
  function parseQuery(q){
    var pq = {terms:[], types:[], tags:[], is:[], has:[]};
    q.toLowerCase().split(/\s+/).filter(Boolean).forEach(function(tok){
      var m;
      if((m = /^type:(.+)$/.exec(tok))){
        var want = m[1];
        TYPE_ORDER.forEach(function(k){ var T = td(k); if(k.indexOf(want) === 0 || T.label.toLowerCase().indexOf(want) === 0 || T.plural.toLowerCase().indexOf(want) === 0) pq.types.push(k); });
        if(!pq.types.length) pq.types.push("__none");
      }
      else if((m = /^is:(.+)$/.exec(tok))) pq.is.push(m[1]);
      else if((m = /^has:(.+)$/.exec(tok))) pq.has.push(m[1]);
      else if(tok.charAt(0) === "#" && tok.length > 1) pq.tags.push(tok.slice(1));
      else pq.terms.push(tok);
    });
    pq.empty = !pq.terms.length && !pq.types.length && !pq.tags.length && !pq.is.length && !pq.has.length;
    return pq;
  }
  function textParts(c){
    var T = td(c.type), parts = [["Title", c.title]];
    if(c.subtitle) parts.push(["Subtitle", c.subtitle]);
    parts.push(["Status", c.status]);
    T.fields.forEach(function(fd){ var v = c.f[fd.k]; if(v) parts.push([fd.l, fd.t === "date" ? v + " " + fmtDate(v) : v]); });
    if(c.tags.length) parts.push(["Tags", c.tags.map(function(t){ return "#" + t; }).join(" ")]);
    c.links.forEach(function(l){ parts.push(["Link", (l.label ? l.label + " " : "") + l.url]); });
    c.files.forEach(function(x){ if(x.name) parts.push(["File", x.name]); });
    if(c.notes) parts.push(["Notes", c.notes]);
    c.sess.forEach(function(x){ if(x.text) parts.push(["Notes " + fmtDate(x.date), x.text]); });
    if(c.check.length) parts.push(["Checklist", c.check.map(function(x){ return x.t; }).join(" · ")]);
    if(c.folder && folderById(c.folder)) parts.push(["Folder", folderPath(c.folder)]);
    var linked = linkedIds(c).map(function(id){ return S.cards.get(id).title; });
    if(linked.length) parts.push(["Linked", linked.join(", ")]);
    c.hist.forEach(function(h){ if(h.w) parts.push(["History", h.w]); });
    parts.push(["Type", T.label + " " + T.plural]);
    return parts;
  }
  function matches(c, pq){
    if(!pq || pq.empty) return true;
    if(pq.types.length && pq.types.indexOf(c.type) < 0) return false;
    for(var i = 0; i < pq.tags.length; i++){ var tg = pq.tags[i]; if(!c.tags.some(function(t){ return t.indexOf(tg) === 0; })) return false; }
    for(var j = 0; j < pq.is.length; j++){
      var w = pq.is[j];
      if(w === "fav" || w === "favorite" || w === "favourite" || w === "starred"){ if(!c.fav) return false; }
      else if(w === "overdue"){ if(!cardDates(c).some(isOverdue)) return false; }
      else if(w === "stale"){ if(!isStale(c)) return false; }
      else if(w === "reminder" || w === "remind"){ if(!c.remind) return false; }
      else if(w === "repeating" || w === "repeats"){ if(!isRepeating(c)) return false; }
      else if(w === "today" || w === "tomorrow" || w === "week" || w === "nextweek"){
        var t = today(), lo = w === "today" ? 0 : w === "tomorrow" ? 1 : w === "week" ? 0 : 7, hi = w === "today" ? 0 : w === "tomorrow" ? 1 : w === "week" ? 6 : 13;
        if(CLOSED[c.status] || !cardDates(c).some(function(o){ var d = dayDiff(t, o.date); return d >= lo && d <= hi; })) return false;
      }
      else if(c.status.toLowerCase().indexOf(w) !== 0) return false;
    }
    for(var k = 0; k < pq.has.length; k++){
      var hw = pq.has[k];
      if(hw === "notes"){ if(!((c.notes && c.notes.trim()) || c.sess.some(function(s){ return s.text && s.text.trim(); }))) return false; }
      else if(hw === "file"){ if(!(c.files.length || c.sess.some(function(s){ return s.files && s.files.length; }))) return false; }
      else if(hw === "link"){ if(!c.links.length) return false; }
      else if(hw === "checklist"){ if(!c.check.length) return false; }
    }
    if(!pq.terms.length) return true;
    var hay = textParts(c).map(function(p){ return p[1]; }).join(" \n ").toLowerCase();
    return pq.terms.every(function(t){ return hay.indexOf(t) >= 0; });
  }
  /* rank matches: roughly exact title > title starts with > title contains > subtitle > important
     fields (status, type fields, folder, links, files, checklist) > tags > notes (card + sessions) >
     linked-card titles > history. Tiers are spaced far enough apart that the small favourite tie-break
     below can never let a weak-tier match outrank a stronger one. */
  function partTier(label){
    if(label === "Subtitle") return 18;
    if(label === "Tags") return 10;
    if(label === "Notes" || label.indexOf("Notes ") === 0) return 6;
    if(label === "Linked") return 4;
    if(label === "History") return 2;
    return 12; /* important fields: Status, type fields, Link, File, Checklist, Folder, Type */
  }
  function score(c, pq){
    var terms = pq.terms || [], titleLower = c.title.toLowerCase(), n = 0;
    if(terms.length && terms.join(" ") === titleLower) n += 100; /* exact full-title match */
    if(terms.length){
      var parts = textParts(c);
      terms.forEach(function(w){
        var best = titleLower.indexOf(w) === 0 ? 50 : titleLower.indexOf(w) >= 0 ? 30 : 0;
        if(!best){
          for(var i = 1; i < parts.length; i++){
            var val = parts[i][1];
            if(!val || String(val).toLowerCase().indexOf(w) < 0) continue;
            var tier = partTier(parts[i][0]);
            if(tier > best) best = tier;
          }
        }
        n += best;
      });
    }
    return n + (c.fav ? .5 : 0);
  }
  function ranked(list, pq){
    return list.slice().sort(function(a, b){ return score(b, pq) - score(a, pq) || a.title.localeCompare(b.title, undefined, {numeric:true, sensitivity:"base"}); });
  }
  function highlight(text, terms){
    if(!terms.length) return esc(text);
    var re = new RegExp("(" + terms.map(function(t){ return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }).join("|") + ")", "ig");
    var out = "", last = 0, m;
    while((m = re.exec(text))){ out += esc(text.slice(last, m.index)) + "<mark>" + esc(m[0]) + "</mark>"; last = m.index + m[0].length; if(!m[0].length) re.lastIndex++; }
    return out + esc(text.slice(last));
  }
  function snippet(c, pq){
    var terms = pq ? pq.terms : [];
    if(!terms.length) return esc(c.subtitle || td(c.type).label);
    var parts = textParts(c);
    for(var i = 1; i < parts.length; i++){
      var low = parts[i][1].toLowerCase();
      for(var j = 0; j < terms.length; j++){
        var at = low.indexOf(terms[j]);
        if(at >= 0){
          var txt = parts[i][1].replace(/\s+/g, " ");
          var start = Math.max(0, at - 28);
          var cut = (start ? "…" : "") + txt.slice(start, start + 90);
          return "<span>" + esc(parts[i][0]) + ":</span> " + highlight(cut, terms);
        }
      }
    }
    return esc(c.subtitle || td(c.type).label);
  }

  /* ================= deck ================= */
  function navMatch(c){
    var n = S.nav;
    if(!!c.home !== (S.space === "home")) return false;
    /* templates live outside every view, count, search and dashboard; only the Templates nav shows them */
    if(c.template || n === "templates") return !!c.template && n === "templates";
    if(n === "archived") return !!c.archived;
    if(c.archived && !(S.pq && !S.pq.empty)) return false;
    if(n === "fav") return c.fav;
    if(n === "unfiled") return !c.folder || !folderById(c.folder);
    if(n.indexOf("t:") === 0) return c.type === n.slice(2);
    if(n.indexOf("f:") === 0) return S._navFolders.has(c.folder);
    return true;
  }
  function navLabel(){
    var n = S.nav;
    if(n === "fav") return "Favourites";
    if(n === "archived") return "Archived";
    if(n === "templates") return "Templates";
    if(n === "unfiled") return "Not in a folder";
    if(n.indexOf("t:") === 0) return td(n.slice(2)).plural;
    if(n.indexOf("f:") === 0){ var f = folderById(n.slice(2)); return f ? f.name : "Folder"; }
    return "All cards";
  }
  function computeDeck(){
    if(S.nav.indexOf("f:") === 0 && !folderById(S.nav.slice(2))) S.nav = "all";
    if(S.nav.indexOf("t:") === 0 && !TYPES[S.nav.slice(2)]) S.nav = "all";
    S._navFolders = S.nav.indexOf("f:") === 0 ? new Set(folderDescendants(S.nav.slice(2))) : null;
    var list = Array.from(S.cards.values()).filter(function(c){ return navMatch(c) && matches(c, S.pq); });
    var byTitle = function(a, b){ return a.title.localeCompare(b.title, undefined, {sensitivity:"base", numeric:true}); };
    if(S.sort === "az") list.sort(byTitle);
    else if(S.sort === "fav") list.sort(function(a, b){ return (b.fav - a.fav) || byTitle(a, b); });
    else if(S.sort === "type") list.sort(function(a, b){ return TYPE_ORDER.indexOf(a.type) - TYPE_ORDER.indexOf(b.type) || byTitle(a, b); });
    else if(S.sort === "recent") list.sort(function(a, b){ return (b.updated || "").localeCompare(a.updated || "") || byTitle(a, b); });
    else if(S.sort === "date") list.sort(function(a, b){ return nextDate(a).localeCompare(nextDate(b)) || byTitle(a, b); });
    S.deck = list;
    var idx = S.curId ? list.findIndex(function(c){ return c.id === S.curId; }) : -1;
    if(idx < 0){ idx = Math.min(S.cur, list.length - 1); if(S.open) S.open = false; }
    S.cur = Math.max(0, idx);
    S.curId = list[S.cur] ? list[S.cur].id : null;
  }

  var refreshQueued = false, checkedOnce = false;
  function scheduleRefresh(){
    if(refreshQueued) return;
    refreshQueued = true;
    requestAnimationFrame(function(){ refreshQueued = false; refresh(); });
  }
  function refresh(){
    /* a card just created and never edited, closed (or navigated away from) without anything
       typed into it: drop it instead of leaving an empty "New Issue" etc. behind. */
    if(S.pendingBlank && (!S.open || S.curId !== S.pendingBlank)){
      var pendingId = S.pendingBlank; S.pendingBlank = null;
      if(isBlankNewCard(pendingId)) purgeCards([pendingId]);
    }
    computeDeck();
    renderNav();
    renderDeckList();
    renderSearchCount();
    var all = Array.from(S.cards.values()).filter(function(c){ return !c.template; });
    var hasSample = all.some(function(c){ return c.example; }) || S.folders.some(function(f){ return f.example; });
    $("clearSample").disabled = S.readOnly || !hasSample;
    $("clearAll").disabled = S.readOnly || !all.length;
    $("loadSample").disabled = S.readOnly || S.mode === "loading" || hasSample;
    renderSampleBar(hasSample);
    renderNewMenu();
    if(S.view !== "rolodex") renderTrail();
    if(!checkedOnce && S.mode !== "loading"){ checkedOnce = true; setTimeout(checkMeetings, 400); }
    if(S.view === "rolodex") renderRolodex();
    else if(S.view === "today") renderToday();
    else if(S.view === "board") renderBoard();
    else if(S.view === "calendar") renderCalendar();
    else if(S.view === "timeline") renderTimeline();
    else renderUpcoming();
    checkReminders();
  }

  /* ================= left menu ================= */
  function navItem(nav, icon, label, count, style){
    return '<button type="button" class="nav-item' + (S.nav === nav ? " on" : "") + '" data-nav="' + esc(nav) + '"' + (style ? ' style="' + style + '"' : "") + '>' + icon + '<span class="nm">' + label + '</span><span class="n">' + count + '</span></button>';
  }
  function renderNav(){
    var nav = $("nav"), a = document.activeElement;
    if(a && nav.contains(a) && a.classList.contains("folder-edit")) return;
    var all = Array.from(S.cards.values()).filter(function(c){ return !!c.home === (S.space === "home") && !c.template; });
    var tc = {}, fc = {}, fav = 0, unfiled = 0, archivedN = 0;
    all.forEach(function(c){
      if(c.archived){ archivedN++; return; }
      tc[c.type] = (tc[c.type] || 0) + 1;
      if(c.fav) fav++;
      if(c.folder && folderById(c.folder)) fc[c.folder] = (fc[c.folder] || 0) + 1; else unfiled++;
    });
    var trashN = Array.from(S.trash.values()).filter(function(c){ return !!c.home === (S.space === "home"); }).length;
    var total = function(id){ return folderDescendants(id).reduce(function(n, x){ return n + (fc[x] || 0); }, 0); };
    var html = '<div class="side-h nav-group-lbl">My data</div>' +
      navItem("fav", '<span class="star-ico">★</span>', "Favourites", fav) +
      navItem("all", '<span class="dot"></span>', "All cards", all.length - archivedN) +
      navItem("archived", '<span class="dot"></span>', "Archived", archivedN) +
      (S.nav === "templates" ? navItem("templates", '<span class="dot"></span>', "Templates", templatesInSpace().length) : "") +
      navItem("trash", '<span class="dot"></span>', "Trash", trashN);
    html += '<div class="nav-sep"></div><div class="nav-head"><button type="button" class="side-h" data-collapse="types"><span class="caret' + (S.collapsed.types ? " shut" : "") + '"></span>Card types</button>' + (S.readOnly ? "" : '<button type="button" class="text-btn" data-edittypes="1">Edit</button>') + '</div>';
    if(!S.collapsed.types){
      var shown = spaceTypes().filter(function(k){ return tc[k] || S.nav === "t:" + k; });
      if(!shown.length) html += '<p class="nav-hint">Cards you add will show up here by type.</p>';
      else shown.forEach(function(k){ html += navItem("t:" + k, '<span class="dot"></span>', esc(td(k).plural), tc[k] || 0, typeVar(k)); });
    }
    html += '<div class="nav-sep"></div><div class="nav-head" data-droproot="1"><button type="button" class="side-h" data-collapse="folders"><span class="caret' + (S.collapsed.folders ? " shut" : "") + '"></span>Folders</button>' +
      (S.readOnly ? "" : '<button type="button" class="icon-btn" data-addfolder="" title="New folder" aria-label="New folder">+</button><button type="button" class="text-btn" data-editfolders="1">' + (S.editFolders ? "Done" : "Edit") + '</button>') + '</div>';
    if(!S.collapsed.folders){
      var row = function(f, depth){
        var kids = folderChildren(f.id), shut = !!S.collapsed["f:" + f.id];
        var caret = '<button type="button" class="caret' + (kids.length ? (shut ? " shut" : "") : " none") + '" data-caret="' + esc(f.id) + '" aria-label="' + (shut ? "Expand " : "Collapse ") + esc(f.name) + '"></button>';
        var out;
        if(S.editFolders){
          out = '<div class="folder-row editing" draggable="true" data-folder="' + esc(f.id) + '" style="padding-left:' + (depth * 14) + 'px">' + caret + '<span class="fold-ico"></span>' +
            '<input class="folder-edit" id="fe-' + esc(f.id) + '" data-rename="' + esc(f.id) + '" value="' + esc(f.name) + '" aria-label="Folder name">' +
            '<select class="folder-parent" data-reparent="' + esc(f.id) + '" aria-label="Move ' + esc(f.name) + ' to">' + folderParentOptions(f) + '</select>' +
            '<button type="button" class="icon-btn" data-addfolder="' + esc(f.id) + '" title="Add subfolder" aria-label="Add subfolder to ' + esc(f.name) + '">+</button>' +
            '<button type="button" class="icon-btn" data-delfolder="' + esc(f.id) + '" title="Delete folder" aria-label="Delete ' + esc(f.name) + '">✕</button></div>';
        } else {
          out = '<div class="folder-row" data-folder="' + esc(f.id) + '" style="padding-left:' + (depth * 14) + 'px">' + caret +
            '<button type="button" class="nav-item' + (S.nav === "f:" + f.id ? " on" : "") + '" data-nav="f:' + esc(f.id) + '"><span class="fold-ico"></span><span class="nm">' + esc(f.name) + '</span><span class="n">' + total(f.id) + '</span></button></div>';
        }
        if(!shut) kids.forEach(function(k){ out += row(k, depth + 1); });
        return out;
      };
      var roots = folderChildren(null);
      roots.forEach(function(f){ html += row(f, 0); });
      if(!roots.length) html += '<p class="nav-hint">No folders yet. Use + to make one.</p>';
      else if(unfiled && !S.editFolders) html += navItem("unfiled", '<span class="fold-ico" style="border-style:dashed"></span>', "Not in a folder", unfiled);
      if(S.editFolders) html += '<p class="nav-hint">Rename folders here. Drag a folder onto another to nest it, or onto the Folders heading to move it to the top.</p>';
      else if(roots.length) html += '<p class="nav-hint">Drag cards from the list onto a folder to file them.</p>';
    }
    if(nav._html !== html){ nav.innerHTML = html; nav._html = html; }
  }

  function addFolder(parent){
    if(S.readOnly) return;
    var f = {id:"f" + uid(), name:"New folder", parent:parent || null, home:S.space === "home"};
    S.folders.push(f);
    if(parent) delete S.collapsed["f:" + parent];
    S.collapsed.folders = false;
    S.editFolders = true;
    savePrefs(); foldersChanged();
    setTimeout(function(){ var inp = $("fe-" + f.id); if(inp){ inp.focus(); inp.select(); } }, 30);
  }
  function deleteFolder(id){
    var f = folderById(id); if(!f) return;
    S.folders.forEach(function(x){ if(x.parent === id) x.parent = f.parent; });
    S.cards.forEach(function(c){ if(c.folder === id){ c.folder = f.parent || ""; touch(c.id); } });
    S.folders = S.folders.filter(function(x){ return x.id !== id; });
    if(S.nav === "f:" + id) S.nav = f.parent ? "f:" + f.parent : "all";
    toast("Deleted folder “" + f.name + "”. Its cards and subfolders moved up a level.");
    foldersChanged();
  }
  function moveFolder(id, parent){
    if(id === parent) return;
    if(parent && folderDescendants(id).indexOf(parent) >= 0){ toast("A folder can't go inside its own subfolder."); return; }
    var f = folderById(id); if(!f || (f.parent || null) === (parent || null)) return;
    f.parent = parent || null;
    if(parent) delete S.collapsed["f:" + parent];
    foldersChanged();
  }
  function fileCard(id, folder){
    var c = S.cards.get(id); if(!c || S.readOnly) return;
    if(c.folder === (folder || "")) return;
    c.folder = folder || "";
    logHist(c, folder ? "Moved to " + folderPath(folder) : "Taken out of its folder");
    touch(id);
    toast(folder ? "Moved “" + c.title + "” to " + folderPath(folder) + "." : "Took “" + c.title + "” out of its folder.");
    if(S.open && S.curId === id) rebuildDetail();
  }

  var lastListKey = "";
  function renderDeckList(){
    var box = $("deckList");
    $("listHead").textContent = navLabel() + (S.pq && !S.pq.empty ? " · matches" : "");
    var key = S.mode + "|" + S.nav + "|" + S.space + "|" + S.query + "|" + S.deck.map(function(c){ return c.id + ":" + rev(c.id); }).join(",");
    if(key !== lastListKey){
      lastListKey = key;
      if(!S.deck.length){
        var msg;
        if(S.mode === "loading") msg = "Loading…";
        else if(S.pq && !S.pq.empty) msg = "No cards match your search.";
        else if(S.nav !== "all") msg = "Nothing here yet — drag a card here or create a new one.";
        else msg = "Your workspace is ready. <button type=\"button\" class=\"text-btn\" data-act=\"open-import\">Import</button>" + (S.space === "home" ? "" : " or <button type=\"button\" class=\"text-btn\" data-act=\"load-examples\">load sample data</button>") + " to get started.";
        box.innerHTML = '<p class="side-note">' + msg + '</p>';
      }
      else box.innerHTML = S.deck.map(function(c){
        return '<button type="button" draggable="true" data-id="' + esc(c.id) + '" style="' + typeVar(c.type) + '"><span class="dot"></span><span class="nm">' + highlight(c.title, S.pq ? S.pq.terms : []) + (c.fav ? '<span class="fav" aria-label="Favourite">★</span>' : "") + '</span><span class="sb">' + snippet(c, S.pq) + '</span></button>';
      }).join("");
    }
    box.querySelectorAll("button[data-id]").forEach(function(b){
      var on = b.dataset.id === S.curId;
      if(b.classList.contains("on") !== on){ b.classList.toggle("on", on); if(on && S.view === "rolodex"){ var top = b.offsetTop, bot = top + b.offsetHeight; if(top < box.scrollTop) box.scrollTop = top - 4; else if(bot > box.scrollTop + box.clientHeight) box.scrollTop = bot - box.clientHeight + 4; } }
    });
  }

  /* ================= rolodex ================= */
  var els = new Map();
  var deckEl = $("deck"), stage = $("stage");

  function makeCard(c){
    var el = document.createElement("div");
    el.className = "card";
    el.dataset.id = c.id;
    el.innerHTML = '<button class="card-tab" type="button"></button><div class="card-body"><div class="face"></div><div class="detail"></div><span class="notch l"></span><span class="notch r"></span></div><div class="card-shade"></div>';
    el.addEventListener("click", onCardClick);
    return el;
  }

  function onCardClick(e){
    var el = e.currentTarget;
    if(el._justDragged) return;
    if(e.target.closest("a[href]")) return;
    var id = el.dataset.id, k = +el.dataset.k;
    var star = e.target.closest(".star");
    if(star && k === 0){ toggleFav(id); return; }
    if(k !== 0){ jumpTo(id); return; }
    if(S.open){
      if(e.target.closest(".card-tab, .face-head")) closeCard();
      return;
    }
    openCard();
  }

  function ago(isoTime){
    var ms = Date.now() - new Date(isoTime).getTime();
    if(!(ms >= 0)) return "just now";
    var m = Math.round(ms / 6e4);
    if(m < 1) return "just now";
    if(m < 60) return m + " min ago";
    var h = Math.round(m / 60);
    if(h < 24) return h + (h === 1 ? " hour ago" : " hours ago");
    var d = Math.round(h / 24);
    if(d < 30) return d + (d === 1 ? " day ago" : " days ago");
    return fmtDate(iso(new Date(isoTime)));
  }
  /* the most useful date on a card, as a short badge */
  /* the {diff, overdue, what, date} behind dueBadge's text — kept separate so the quick-action
     buttons (Mark done / Snooze) can get at the raw date without changing dueBadge's own
     string-returning signature, which Board and the face already rely on. */
  function dueBadgeBest(c){
    var t = today(), best = null;
    cardDates(c).forEach(function(d){
      var diff = dayDiff(t, d.date);
      var overdue = diff < 0 && !CLOSED[c.status] && (d.kind !== "start") && (c.type === "issue" || c.type === "project");
      if(diff < 0 && !overdue) return;
      if(!best || (overdue && !best.overdue) || (!best.overdue && !overdue && diff < best.diff)) best = {diff:diff, overdue:overdue, what:d.what, date:d.date};
    });
    return best;
  }
  function dueBadge(c){
    var best = dueBadgeBest(c);
    if(!best) return "";
    var d = best.diff, txt, tone;
    if(best.overdue){ txt = "Overdue " + (-d) + (d === -1 ? " day" : " days"); tone = "bad"; }
    else if(d === 0){ txt = best.what + " today"; tone = "warn"; }
    else if(d === 1){ txt = best.what + " tomorrow"; tone = "warn"; }
    else if(d <= 7){ txt = best.what + " in " + d + " days"; tone = "warn"; }
    else { txt = best.what + " " + fmtDate(addDays(today(), d)); tone = "info"; }
    return '<span class="due tone-' + tone + '">' + esc(txt) + '</span>';
  }

  function fillFace(el, c){
    var T = td(c.type);
    el.style.setProperty("--tc", td(c.type).color);
    el.querySelector(".card-tab").innerHTML = '<span class="tab-type">' + T.short + '</span>' + (c.fav ? '<span class="tab-star" aria-hidden="true">★</span>' : "") + '<span class="tab-title">' + esc(c.title) + '</span><i class="tab-shade" aria-hidden="true"></i>';
    el.querySelector(".card-tab").setAttribute("aria-label", T.label + ": " + c.title);
    el.classList.toggle("paper-plain", T.paper === "plain");
    el.classList.toggle("paper-grid", T.paper === "grid");
    var fields = T.face ? T.face.map(function(k){ return T.fields.filter(function(fd){ return fd.k === k; })[0]; }).filter(function(fd){ return fd && c.f[fd.k]; })
      : T.fields.filter(function(fd){ return c.f[fd.k] && fd.k !== "progress" && !(c.type === "meeting" && fd.k === "join"); }).slice(0, 8);
    var fh = fields.map(function(fd, i){
      var v = fd.t === "date" ? fmtDate(c.f[fd.k]) : c.f[fd.k];
      var lead = i === 0 ? "face-field-lead" : i === 1 ? "face-field-lead2" : "face-field-sub";
      return '<div class="' + lead + '"><dt>' + esc(fd.l) + '</dt><dd class="' + (fd.mono || fd.t === "date" ? "mono" : "") + '">' + esc(v) + '</dd></div>';
    }).join("");
    if(!fh) fh = '<div><dt>No details yet</dt><dd></dd></div>';
    var imgs = c.files.filter(isImage);
    /* the Files gallery isn't the only place a card can have an image — screenshots pasted
       straight onto the notes canvas (c.page) never land in c.files, so without this a card
       whose only image lives on the canvas would never show a tab thumbnail at all */
    var pageImgs = imgs.length ? [] : (c.page || []).filter(function(b){ return b.k === "i"; }).sort(function(a, b){ return a.y - b.y || a.x - b.x; });
    var thumbFile = imgs[0] || (pageImgs[0] && pageImgs[0].f);
    var thumbCount = imgs.length || pageImgs.length;
    var thumb = thumbFile ? '<div class="face-thumb"><img src="' + esc(fileSrc(thumbFile)) + '" alt="" loading="lazy">' + (thumbCount > 1 ? '<span>+' + (thumbCount - 1) + '</span>' : "") + '</div>' : "";
    /* meeting cards get their "short note preview" from the latest session excerpt below (histHtml);
       showing the plain c.notes preview too would be redundant (it's almost always empty for meetings,
       whose real notes live in per-date sessions) so it's skipped for that type only */
    var notes = c.type === "meeting" ? "" : (c.notes ? '<p class="face-notes">' + esc(c.notes.replace(/\n{2,}/g, " · ").replace(/\s+/g, " ").slice(0, 360)) + '</p>' : '<p class="face-notes empty">No notes yet. Open the card to add notes, images and links.</p>');
    var rel = linkedIds(c), relHtml = "";
    if(rel.length){
      relHtml = '<div class="face-rel"><span class="lbl">Linked</span>' + rel.slice(0, 3).map(function(id){
        var o = S.cards.get(id);
        return '<span class="mini-chip" style="' + typeVar(o.type) + '"><span class="dot"></span><span>' + esc(o.title) + '</span></span>';
      }).join("") + (rel.length > 3 ? '<span class="mini-more">+' + (rel.length - 3) + ' more</span>' : "") + '</div>';
    }
    /* the mini checklist and the plain change-log teaser both have a proper home in the expanded card
       (d-check, d-hist) — the face keeps only the meeting session excerpt, a genuinely useful
       "what happened last time" preview that the change log doesn't offer */
    var histHtml = "";
    var ji = c.type === "meeting" ? joinInfo(c.f.join) : null;
    var joinHtml = ji ? '<a class="join-btn" href="' + esc(ji.url) + '" target="_blank" rel="noopener noreferrer" title="' + esc(ji.url) + '">' + esc(ji.label) + '</a>' : "";
    if(c.sess.length){
      var ls = c.sess.slice().sort(function(a, b){ return b.date.localeCompare(a.date); })[0];
      var first = (ls.text || "").replace(/\s+/g, " ").trim();
      histHtml = '<div class="face-hist"><span class="lbl">Notes ' + esc(fmtDate(ls.date)) + '</span><span>' + esc(first || (ls.files.length ? ls.files.length + " screenshot" + (ls.files.length === 1 ? "" : "s") : "No notes written yet")) + '</span></div>';
    }
    var dueBest = dueBadgeBest(c), dueLine = dueBadge(c), dueActs = "";
    if(dueLine && dueBest && !S.readOnly){
      var doneSt = T.statuses.filter(function(st){ return CLOSED[st]; })[0];
      var isRec = c.type === "meeting" && c.f.repeat;
      var a = "";
      if(doneSt && !CLOSED[c.status]) a += '<button type="button" class="q-btn" data-qdone="' + esc(c.id) + '" title="Mark ' + esc(doneSt.toLowerCase()) + '">Mark done</button>';
      if(!isRec) a += '<button type="button" class="q-btn" data-qsnooze="' + esc(c.id) + '" data-qdate="' + esc(dueBest.date) + '" title="Move this date later" aria-haspopup="true">Snooze</button>';
      if(a) dueActs = '<span class="due-acts">' + a + '</span>';
    }
    var dueHtml = dueLine ? '<div class="face-due-line">' + dueLine + dueActs + '</div>' : "";
    var bellHtml = c.remind ? '<span class="remind-badge' + (remindDue(c) ? " due" : "") + '" title="Reminder: ' + esc(fmtRemind(c.remind)) + '"><span aria-hidden="true">🔔</span><span class="rb-t">' + esc(fmtRemind(c.remind)) + '</span></span>' : "";
    var repHtml = isRepeating(c) ? '<span class="rep-badge" title="Repeats ' + esc(((c.rpt && c.rpt.every) || c.f.repeat).toLowerCase()) + '" aria-hidden="true">↻</span>' : "";
    var tagsFoldHtml = "";
    if(c.tags.length || (c.folder && folderById(c.folder))){
      tagsFoldHtml = '<div class="face-tagsfold">';
      if(c.tags.length) tagsFoldHtml += '<div class="tags">' + c.tags.slice(0, 3).map(function(t){ return '<span class="tag">#' + esc(t) + '</span>'; }).join("") + '</div>';
      if(c.folder && folderById(c.folder)) tagsFoldHtml += '<span class="face-crumb" title="' + esc(folderPath(c.folder)) + '"><span class="fold-ico"></span>' + esc(folderById(c.folder).name) + '</span>';
      tagsFoldHtml += '</div>';
    }
    var foot = meterFor(c);
    if(c.check.length){ var cd = c.check.filter(function(x){ return x.done; }).length; foot += '<span class="check-sum" title="Checklist">☑ <b>' + cd + '</b>/' + c.check.length + '</span>'; }
    var docs = c.files.length - imgs.length, bits = [];
    if(imgs.length) bits.push(imgs.length + (imgs.length === 1 ? " image" : " images"));
    if(docs) bits.push(docs + (docs === 1 ? " file" : " files"));
    var vl = c.links.filter(function(l){ return vaultLink(l.url); });
    if(vl.length) foot = '<a class="vault-chip" href="' + esc(vl[0].url) + '" target="_blank" rel="noopener noreferrer" title="Open the password in ' + esc(vaultLink(vl[0].url).label) + '">🔒 ' + esc(vl.length > 1 ? vl.length + " passwords" : vl[0].label || vaultLink(vl[0].url).short) + '</a>' + foot;
    if(c.links.length > vl.length) bits.push((c.links.length - vl.length) + (c.links.length - vl.length === 1 ? " web link" : " web links"));
    if(c.updated) bits.push("edited " + ago(c.updated));
    foot += '<span class="meta">' + esc(bits.join(" · ")) + '</span>';
    if(c.example) foot += '<span class="ex-badge">Example</span>';
    if(c.archived) foot += '<span class="ex-badge">Archived</span>';
    if(c.template) foot += '<span class="ex-badge">Template</span>';
    el.querySelector(".face").innerHTML =
      '<div class="face-head"><div class="face-titles"><h3 class="face-title">' + esc(c.title) + '</h3><p class="face-sub">' + esc(c.subtitle || T.label) + '</p></div>' +
      '<div class="face-side">' + joinHtml + repHtml + bellHtml + '<button type="button" class="star" aria-pressed="' + (c.fav ? "true" : "false") + '" aria-label="' + (c.fav ? "Remove from favourites" : "Add to favourites") + '" title="' + (c.fav ? "Remove from favourites" : "Add to favourites") + '">' + (c.fav ? "★" : "☆") + '</button><span class="pill tone-' + (TONE[c.status] || "muted") + '">' + esc(c.status) + '</span><button class="btn small close-btn" type="button">Close</button></div></div>' +
      dueHtml +
      '<div class="face-mid"><div class="face-main"><dl class="face-fields">' + fh + '</dl>' + thumb + '</div>' + relHtml + tagsFoldHtml + notes + histHtml + '</div><div class="face-foot">' + foot + '</div>';
    el._rev = rev(c.id);
  }

  function meterFor(c){
    var pct = null, label = "";
    if(c.type === "project" && c.f.progress !== undefined && c.f.progress !== ""){
      pct = Math.max(0, Math.min(100, parseFloat(c.f.progress) || 0)); label = Math.round(pct) + "%";
    } else if(c.type === "storage" && c.f.used && c.f.capacity){
      var u = /([\d.]+)\s*([a-z]+)/i.exec(c.f.used), cap = /([\d.]+)\s*([a-z]+)/i.exec(c.f.capacity);
      if(u && cap && u[2].toLowerCase() === cap[2].toLowerCase() && +cap[1] > 0){ pct = Math.min(100, +u[1] / +cap[1] * 100); label = Math.round(pct) + "% used"; }
    }
    if(pct === null) return "";
    var hot = c.type === "storage" && pct >= 85;
    return '<div class="meter"><div class="meter-track"><div class="meter-fill' + (hot ? " hot" : "") + '" style="width:' + pct.toFixed(1) + '%"></div></div><span class="mono">' + label + '</span></div>';
  }

  /* ---- the wheel: cards hang on a rod and share one viewpoint ----
     Offset d is a float: 0 = front, + = behind (leaning back), − = flipped past (falling toward you).
     Depth comes from the 3D sort (.deck is preserve-3d), so there are no z-index writes. */
  var W = {pos:0, vel:0, target:0, raf:0, last:0, drag:null, ids:[], shown:"", slot:null, said:"", openAfter:null, snapT:0,
    fade:1, fadeAll:false, fadeT0:0, fadeFrom:1, fadeDur:0, dragEnd:0, fine:false, wheelAcc:0};
  var WHEEL = {
    lean:1.36,     /* degrees each card behind leans further back: from the high viewpoint that lifts each tab row ~12px */
    gap:.55,       /* a little extra between the front card and the first card behind it */
    fall:100,      /* degrees a card turns toward you as it flips past */
    fadeFrom:5.6, fadeTo:7.1,   /* cards further back fade out, so the stack never ends abruptly */
    back:3, win:12 /* pre-mounted window: offsets -3 … +8, nodes recycled */
  };
  function tilt(d){
    if(d >= 0) return d * WHEEL.lean + WHEEL.gap * Math.min(d, 1);
    return -(Math.min(-d, 1) * WHEEL.fall + Math.max(0, -d - 1) * 16);
  }
  function place(el, d, i){
    var k = Math.round(d);
    if(el._k !== k){
      el._k = k; el.dataset.k = k;
      el.classList.toggle("front", k === 0);
      el._tab.tabIndex = (k >= 0 && k <= 6 && !(S.open && k > 0)) ? 0 : -1;
    }
    var open = k === 0 && S.open;
    if(el._open !== open){ el._open = open; el.classList.toggle("open", open); }
    var a = tilt(d);
    var tr = Math.abs(d) < 4e-4 ? "none" : "rotateX(" + a.toFixed(3) + "deg)";
    if(el._tr !== tr){ el._tr = tr; el.style.transform = tr; }
    var op = d < 0 ? Math.max(0, 1 + d * 1.05) : d > WHEEL.fadeFrom ? Math.max(0, (WHEEL.fadeTo - d) / (WHEEL.fadeTo - WHEEL.fadeFrom)) : 1;
    if(W.fadeAll || Math.abs(d) >= .5) op *= W.fade;
    op = op < .004 ? 0 : Math.round(op * 1000) / 1000;
    if(el._op !== op){
      el._op = op; el.style.opacity = op;
      el.style.visibility = op ? "" : "hidden";
    }
    /* the front card takes clicks; behind it only the tabs do (hit-testing a nearly parallel 3D stack is unreliable) */
    var pe = op > .3 && d > -.5 ? (k === 0 ? "" : "tab") : "none";
    if(el._pe !== pe){ el._pe = pe; el.style.pointerEvents = pe === "" ? "" : "none"; el._tab.style.pointerEvents = pe === "none" ? "none" : "auto"; }
    /* light falls from above: cards darken as they lean back, and as they tip toward you */
    var sh = d > 0 ? Math.min(.3, d * .05) : Math.min(.4, -d * .5);
    sh = Math.round(sh * 500) / 500;
    if(el._sh !== sh){ el._sh = sh; el._shade.style.opacity = sh; if(el._tabShade) el._tabShade.style.opacity = Math.min(.2, sh * .8); }
  }

  /* the deck is a wheel: after the last card comes the first again */
  function ringOffset(i, cur, n){
    if(n < 3) return i - cur;
    var k = ((i - cur) % n + n) % n;
    return k > n - 3 ? k - n : k;
  }
  function mod(a, n){ return ((a % n) + n) % n; }
  /* the short way round from one index to another */
  function ringDelta(from, to, n){ var d = mod(to - from, n); return n > 2 && d > n / 2 ? d - n : d; }

  /* card nodes: a bounded window keyed by id; nodes that leave the window are re-used for cards that enter it */
  var spare = [], drawStamp = 0, need = [];
  function releaseCard(el, id){
    els.delete(id);
    el.style.visibility = "hidden"; el.style.opacity = 0; el._op = 0;
    el.style.pointerEvents = "none"; el._tab.style.pointerEvents = "none"; el._pe = "none";
    el.classList.remove("front", "open"); el._k = null; el._open = false;
    if(el._detailFor){ el._detailFor = null; el.querySelector(".detail").innerHTML = ""; }
    if(spare.length < WHEEL.win) spare.push(el); else el.remove();
  }
  function cardNode(c){
    var el = els.get(c.id);
    if(el) return el;
    el = spare.pop();
    if(el){ el.dataset.id = c.id; el._rev = -1; el._tr = null; }
    else {
      el = makeCard(c); el._rev = -1;
      el._tab = el.querySelector(".card-tab"); el._shade = el.querySelector(".card-shade");
      el.style.visibility = "hidden"; el.style.opacity = 0; el._op = 0;
      deckEl.appendChild(el);
    }
    els.set(c.id, el);
    return el;
  }
  /* position every card in the window for the current (float) wheel position; no layout reads */
  function draw(){
    var deck = S.deck, n = deck.length;
    if(!n) return;
    var p = W.pos, span = Math.min(n, WHEEL.win);
    var back = n >= WHEEL.win ? WHEEL.back : Math.max(1, Math.floor((span - 1) / 3));
    var m0 = Math.floor(p - back) + 1, j, m, i, c, el;
    drawStamp++;
    need.length = 0;
    for(j = 0; j < span; j++){
      m = m0 + j; i = mod(m, n); c = deck[i];
      need.push(m);
      el = els.get(c.id); if(el) el._stamp = drawStamp;
    }
    els.forEach(function(el, id){ if(el._stamp !== drawStamp) releaseCard(el, id); });
    for(j = 0; j < need.length; j++){
      m = need[j]; i = mod(m, n); c = deck[i];
      el = cardNode(c); el._stamp = drawStamp;
      if(el._rev !== rev(c.id)){ fillFace(el, c); el._tabShade = el._tab.querySelector(".tab-shade"); el._sh = null; }
      /* staggered cut-tab positions, unless the card's type fixes one */
      var TT = td(c.type), tx = TT.tab && TAB_POS[TT.tab] ? TAB_POS[TT.tab] : TAB_SLOTS[i % 3];
      if(el._tx !== tx){ el._tx = tx; el.style.setProperty("--tab-x", tx); }
      place(el, m - p, i);
    }
    var ci = mod(Math.round(p), n);
    if(W.shown !== ci + "/" + n){ W.shown = ci + "/" + n; $("counter").textContent = (ci + 1) + " / " + n; }
  }

  /* the wheel's deck may have changed under us (filter, sort, new or deleted card): keep the wheel on the same card */
  function syncDeck(){
    var d = S.deck, n = d.length, old = W.ids, same = old.length === n, i;
    if(same) for(i = 0; i < n; i++){ if(old[i] !== d[i].id){ same = false; break; } }
    if(!same){
      W.ids = d.map(function(c){ return c.id; });
      if(!n){ W.pos = W.target = W.vel = 0; return; }
      var frontId = old.length ? old[mod(Math.round(W.pos), old.length)] : null;
      var at = frontId ? W.ids.indexOf(frontId) : -1;
      if(at < 0 || W.drag){ W.pos = W.target = S.cur; W.vel = 0; if(W.drag) W.drag = null; return; }
      W.pos = at + (W.pos - Math.round(W.pos));
      W.target = at + ringDelta(at, S.cur, n);
      if(Math.abs(W.target - W.pos) > 1e-3 || Math.abs(W.vel) > 1e-3) kick();
      return;
    }
    if(n && !W.drag && mod(Math.round(W.target), n) !== S.cur){
      aimAt(Math.round(W.target) + ringDelta(mod(Math.round(W.target), n), S.cur, n));
    }
  }

  /* size the wheel so the whole stage, prev/next and counter included, fits the window without scrolling */
  function fitStage(){
    var wrap = stage.parentNode, side = document.querySelector(".side"), root = document.documentElement.style;
    if(side && getComputedStyle(side).position === "sticky") root.setProperty("--side-top", Math.round(side.getBoundingClientRect().top + scrollY + 16) + "px");
    if(wrap.classList.contains("expanded") || S.view !== "rolodex") return;
    var top = wrap.getBoundingClientRect().top + scrollY;
    var h = Math.round(Math.max(200, Math.min(700, innerHeight - top - 182 - 30)));
    if(root.getPropertyValue("--card-h") !== h + "px") root.setProperty("--card-h", h + "px");
  }
  window.addEventListener("resize", function(){ fitStage(); if(S.open) detailHost.querySelectorAll(".page").forEach(sizePage); });

  function renderRolodex(){
    if(!S.open) fitStage();
    var openEl = deckEl.querySelector(".card.open"), wasOpen = stage.classList.contains("is-open");
    var flipFrom = null, flipEl = null;
    if(wasOpen !== S.open && S.view === "rolodex" && !reduceMotion){
      flipEl = wasOpen ? openEl : els.get(S.curId);
      if(flipEl && flipEl.isConnected) flipFrom = flipEl.querySelector(".card-body").getBoundingClientRect();
      if(S.open && W.raf){ W.pos = W.target = Math.round(W.target); W.vel = 0; }
    }
    /* the expanded card leaves the page flow; hold the wheel's place so the page behind doesn't jump */
    var wrap = stage.parentNode;
    if(S.open && !wasOpen) wrap.parentNode.style.minHeight = wrap.parentNode.offsetHeight + "px";
    else if(!S.open && wasOpen) wrap.parentNode.style.minHeight = "";
    stage.classList.toggle("is-open", S.open);
    wrap.classList.toggle("expanded", S.open);
    document.body.classList.toggle("card-open", S.open && S.view === "rolodex");
    var deck = S.deck, n = deck.length;
    stage.classList.toggle("no-cards", !n);
    var emptyEl = stage.querySelector(":scope > .empty");
    syncDeck();
    if(!n){
      els.forEach(function(el, id){ releaseCard(el, id); });
      if(!emptyEl){ emptyEl = document.createElement("div"); emptyEl.className = "empty"; stage.appendChild(emptyEl); }
      emptyEl.innerHTML = emptyHTML();
      $("counter").textContent = "0 / 0"; W.shown = "";
      renderAZ(); renderTrail();
      return;
    }
    if(emptyEl) emptyEl.remove();
    if(S.open){ W.pos = W.target = Math.round(W.target); W.vel = 0; }
    els.forEach(function(el){ el._k = null; el._open = null; });   /* re-apply front/open/tab focus */
    draw();
    var front = els.get(S.curId);
    if(S.open && front && front._detailFor !== S.curId) buildDetail(front, S.cards.get(S.curId));
    els.forEach(function(el, id){ if(el._detailFor && (!S.open || id !== S.curId)){ el._detailFor = null; el.querySelector(".detail").innerHTML = ""; } });
    renderAZ(); renderTrail();
    if(flipFrom && flipEl.isConnected && (S.open || !W.raf)) flipCard(flipEl, flipFrom, S.open);
    if(wasOpen && !S.open) fadeBackIn();
  }

  /* open / close: the card is pulled out of the wheel and grows into the editor (FLIP: transform and opacity only) */
  function flipCard(el, from, opening){
    /* the whole card moves (tab included); the wheel is still while this runs, so nothing else writes its transform */
    var body = el, to = el.querySelector(".card-body").getBoundingClientRect();
    if(!to.width || !to.height || !body.animate) return;
    var sx = from.width / to.width, sy = from.height / to.height, dx = from.left - to.left, dy = from.top - to.top;
    if(Math.abs(dx) < 1 && Math.abs(dy) < 1 && Math.abs(sx - 1) < .01 && Math.abs(sy - 1) < .01) return;
    var start = "translate(" + dx.toFixed(1) + "px," + dy.toFixed(1) + "px) scale(" + sx.toFixed(4) + "," + sy.toFixed(4) + ")";
    if(opening){
      /* lift first (a small rise out of the slot), then grow */
      var lift = "translate(" + (dx * .72).toFixed(1) + "px," + (dy * .72 - 18).toFixed(1) + "px) scale(" + (1 + (sx - 1) * .72).toFixed(4) + "," + (1 + (sy - 1) * .72).toFixed(4) + ")";
      body.animate([{transform:start, transformOrigin:"0 0"}, {transform:lift, transformOrigin:"0 0", offset:.3}, {transform:"none", transformOrigin:"0 0"}],
        {duration:420, easing:"cubic-bezier(.3,.7,.2,1)"});
      var det = el.querySelector(".detail");
      if(det) det.animate([{opacity:0}, {opacity:0, offset:.35}, {opacity:1}], {duration:420, easing:"ease-out"});
      var head = el.querySelector(".face");
      if(head) head.animate([{opacity:.6}, {opacity:1}], {duration:260, easing:"ease-out"});
    } else {
      /* drop back into the slot with a small settle */
      /* the stage clips falling cards; let the big card overhang it while it shrinks back */
      stage.classList.add("flipping");
      var anim = body.animate([{transform:start, transformOrigin:"0 0"}, {transform:"translate(0,4px)", transformOrigin:"0 0", offset:.78}, {transform:"none", transformOrigin:"0 0"}],
        {duration:360, easing:"cubic-bezier(.35,.1,.25,1)"});
      anim.onfinish = anim.oncancel = function(){ stage.classList.remove("flipping"); };
    }
  }

  function emptyHTML(){
    if(S.mode === "loading") return '<h3>Opening your workspace…</h3>';
    if(S.pq && !S.pq.empty) return '<h3>No cards match your search</h3><p>Try different words, or clear the search.</p><div class="empty-actions"><button class="btn" type="button" data-act="clear-filters">Clear search and filters</button></div>';
    if(S.nav !== "all") return '<h3>Nothing here yet</h3><p>Drag a card here, or create a new one — or go back to All cards.</p><div class="empty-actions"><button class="btn" type="button" data-act="clear-filters">All cards</button></div>';
    var b = newTypeBtns(spaceTypes());
    /* sample cards are always Work data (see loadSamples()), so offering "Load sample data" while
       viewing Home would visibly do nothing — Home only ever gets starter types, never sample cards */
    return '<h3>Welcome to Tabwheel</h3><p>Your cards, meetings, notes and work information in one place. Add your first card, import what you already have' + (S.space === "home" ? "" : ", or load example cards to try it out") + '.</p><div class="empty-actions">' + b + '</div>' +
      (S.readOnly ? "" : '<div class="empty-actions">' + '<button class="btn" type="button" data-act="open-import">Import…</button>' + (S.space === "home" ? "" : '<button class="btn" type="button" data-act="load-examples">Load sample data</button>') + '</div>');
  }

  function renderAZ(){
    var az = $("az"), have = {};
    S.deck.forEach(function(c){ var ch = c.title.charAt(0).toUpperCase(); have[/[A-Z]/.test(ch) ? ch : "#"] = true; });
    var curCh = S.deck[S.cur] ? S.deck[S.cur].title.charAt(0).toUpperCase() : "";
    if(!/[A-Z]/.test(curCh)) curCh = "#";
    var html = "ABCDEFGHIJKLMNOPQRSTUVWXYZ#".split("").map(function(ch){
      return '<button type="button" data-l="' + ch + '"' + (have[ch] ? "" : " disabled") + (S.deck.length && ch === curCh ? ' class="on"' : "") + '>' + ch + '</button>';
    }).join("");
    if(az._html !== html){ az.innerHTML = html; az._html = html; }
  }

  /* ---- where you've been: back / forward like a browser ---- */
  S.back = []; S.fwd = [];
  function remember(){
    if(!S.curId) return;
    var top = S.back[S.back.length - 1];
    if(top && top.id === S.curId) top.open = S.open;
    else S.back.push({id:S.curId, open:S.open});
    if(S.back.length > 40) S.back.shift();
  }
  function jumpTo(id, open, fromTrail){
    var idx = S.deck.findIndex(function(c){ return c.id === id; });
    if(idx < 0){ var jc = S.cards.get(id); S.nav = jc && jc.template ? "templates" : "all"; setQuery(""); computeDeck(); idx = S.deck.findIndex(function(c){ return c.id === id; }); }
    if(idx < 0) return;
    if(!fromTrail && S.curId && S.curId !== id){ remember(); S.fwd = []; }
    if(S.view !== "rolodex"){
      S.open = false;
      setView("rolodex");
      requestAnimationFrame(function(){ spinTo(id, open); });
      return;
    }
    spinTo(id, open);
  }
  function liveEntry(list){
    while(list.length){ var e = list.pop(); if(S.cards.has(e.id)) return e; }
    return null;
  }
  function goBack(){
    var e = liveEntry(S.back); if(!e) return;
    if(S.curId) S.fwd.push({id:S.curId, open:S.open});
    jumpTo(e.id, e.open, true);
  }
  function goForward(){
    var e = liveEntry(S.fwd); if(!e) return;
    if(S.curId) S.back.push({id:S.curId, open:S.open});
    jumpTo(e.id, e.open, true);
  }
  function goCrumb(i){
    var e = S.back[i]; if(!e) return;
    var later = S.back.splice(i).slice(1);
    if(S.curId) later.push({id:S.curId, open:S.open});
    S.fwd = S.fwd.concat(later.reverse());
    jumpTo(e.id, e.open, true);
  }
  function renderTrail(){
    var bar = $("trail");
    S.back = S.back.filter(function(e){ return S.cards.has(e.id); });
    S.fwd = S.fwd.filter(function(e){ return S.cards.has(e.id); });
    if(!S.back.length && !S.fwd.length){ bar.hidden = true; return; }
    bar.hidden = false;
    var start = Math.max(0, S.back.length - 4);
    var crumbs = S.back.slice(start).map(function(e, j){
      var c = S.cards.get(e.id);
      return '<button type="button" class="crumb" data-crumb="' + (start + j) + '" style="' + typeVar(c.type) + '" title="Go back to ' + esc(c.title) + '"><span class="dot"></span>' + esc(c.title) + '</button><span class="sep" aria-hidden="true">›</span>';
    }).join("");
    var cur = S.cards.get(S.curId);
    var prev = S.back.length ? S.cards.get(S.back[S.back.length - 1].id) : null;
    var html = '<button type="button" class="btn small" data-trail="back"' + (S.back.length ? "" : " disabled") + ' title="Back (Alt+←)">← ' + (prev ? "Back to " + esc(prev.title.length > 28 ? prev.title.slice(0, 26) + "…" : prev.title) : "Back") + '</button>' +
      '<button type="button" class="btn small" data-trail="fwd"' + (S.fwd.length ? "" : " disabled") + ' title="Forward (Alt+→)" aria-label="Forward">→</button>' +
      '<nav class="crumbs" aria-label="Where you have been">' + (start > 0 ? '<span class="sep">…</span>' : "") + crumbs + (cur ? '<span class="crumb here" style="' + typeVar(cur.type) + '"><span class="dot"></span>' + esc(cur.title) + '</span>' : "") + '</nav>' +
      '<button type="button" class="text-btn" data-trail="clear">Clear</button>';
    if(bar._html !== html){ bar.innerHTML = html; bar._html = html; }
  }

  /* ---- wheel motion: one spring, one requestAnimationFrame loop ----
     pos is where the wheel is (float, unbounded), target is where it's going. A critically damped spring pulls
     pos toward target; wheel, drag, keys, buttons and jumps only ever change target (or pos, while dragging). */
  var SPRING = {K:220, D:26, long:25, capTo:12, maxDrag:45};
  var mqReduce = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
  var reduceMotion = !!(mqReduce && mqReduce.matches);
  if(mqReduce){
    var onReduce = function(e){ reduceMotion = e.matches; if(reduceMotion && (W.raf || W.pos !== W.target)){ W.pos = W.target = Math.round(W.target); W.vel = 0; W.fade = 1; W.fadeT0 = 0; } };
    if(mqReduce.addEventListener) mqReduce.addEventListener("change", onReduce); else if(mqReduce.addListener) mqReduce.addListener(onReduce);
  }
  function frame(t){
    W.raf = 0;
    var n = S.deck.length;
    if(!n || S.view !== "rolodex"){ W.pos = W.target = Math.round(W.target); W.vel = 0; W.last = 0; stage.classList.remove("moving"); return; }
    var dt = W.last ? Math.min((t - W.last) / 1000, 1 / 30) : 1 / 60;
    W.last = t;
    if(!W.drag){
      /* fixed small sub-steps keep the spring stable and identical at 60 Hz and 120 Hz */
      var steps = Math.max(1, Math.ceil(dt * 240)), h = dt / steps;
      for(var s = 0; s < steps; s++){
        var acc = -SPRING.K * (W.pos - W.target) - SPRING.D * W.vel;
        W.vel += acc * h; W.pos += W.vel * h;
      }
    }
    if(W.fadeT0){
      var u = Math.min(1, (t - W.fadeT0) / W.fadeDur);
      W.fade = W.fadeFrom + (1 - W.fadeFrom) * (1 - Math.pow(1 - u, 3));
      if(u >= 1){ W.fade = 1; W.fadeT0 = 0; W.fadeAll = false; }
    }
    draw();
    var slot = Math.floor(W.pos + .5);
    if(slot !== W.slot){ if(W.slot !== null) tick(); W.slot = slot; }
    if(W.drag || W.fadeT0 || Math.abs(W.vel) > .01 || Math.abs(W.pos - W.target) > 1e-3) W.raf = requestAnimationFrame(frame);
    else settle();
  }
  function settle(){
    W.pos = W.target; W.vel = 0; W.last = 0;
    var n = S.deck.length;
    if(n && W.target === Math.round(W.target)){ W.pos = W.target = mod(W.target, n); W.slot = W.pos; }
    draw();
    stage.classList.remove("moving");
    if(!n || W.target !== Math.round(W.target)) return;
    var c = S.deck[W.target];
    if(c && W.said !== c.id){
      W.said = c.id;
      $("wheelLive").textContent = c.title;
      /* move keyboard focus with the wheel, but never steal it from typing or an about-to-open card */
      if(!W.openAfter && !S.open){
        var a = document.activeElement;
        var typing = a && (a.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName));
        var wasWheelFocus = !a || a === document.body || (a.classList && a.classList.contains("card-tab")) ||
          a === $("prevBtn") || a === $("nextBtn") || (a.closest && a.closest("#deckList, #az"));
        if(!typing && wasWheelFocus){ var el = els.get(c.id); if(el && el._tab && el._tab !== a) el._tab.focus({preventScroll:true}); }
      }
    }
    if(W.openAfter){ var id = W.openAfter; W.openAfter = null; if(id === S.curId && !S.open && S.view === "rolodex"){ S.open = true; refresh(); } }
  }
  function kick(){
    if(reduceMotion || S.view !== "rolodex"){
      if(W.raf){ cancelAnimationFrame(W.raf); W.raf = 0; }
      W.pos = W.target; W.vel = 0; W.fade = 1; W.fadeT0 = 0; W.fadeAll = false;
      settle(); return;
    }
    if(!W.raf){ W.last = 0; stage.classList.add("moving"); W.raf = requestAnimationFrame(frame); }
  }
  /* send the wheel somewhere; very long trips skip the far part with a quick fade so a jump never drags on */
  function aimAt(t){
    W.target = t;
    var dist = t - W.pos;
    if(reduceMotion){
      if(Math.abs(dist) >= 1 && deckEl.animate) crossFade();
    } else if(Math.abs(dist) > SPRING.long){
      var dir = dist > 0 ? 1 : -1;
      W.pos = t - dir * SPRING.capTo;
      W.vel = dir * Math.max(Math.abs(W.vel), 34);
      W.fade = .25; W.fadeFrom = .25; W.fadeT0 = performance.now(); W.fadeDur = 260; W.fadeAll = true;
    }
    kick();
  }
  function fadeBackIn(){
    if(reduceMotion) return;
    W.fade = 0; W.fadeFrom = 0; W.fadeT0 = performance.now(); W.fadeDur = 320; W.fadeAll = false;
    kick();
  }
  /* reduced motion: nothing turns; the new card simply cross-fades in */
  function crossFade(){
    var el = els.get(S.curId);
    if(el && el.animate) el.animate([{opacity:.2}, {opacity:1}], {duration:180, easing:"ease-out"});
  }
  /* keep S.cur / S.curId on the card the wheel is heading for (cheap: no full refresh) */
  function syncCur(){
    var n = S.deck.length; if(!n) return;
    var i = mod(Math.round(W.target), n);
    if(i === S.cur && S.deck[i].id === S.curId) return;
    S.cur = i; S.curId = S.deck[i].id;
    renderDeckList(); renderAZ(); renderTrail();
  }

  /* spin the short way round to a card; long jumps spin fast through the middle and settle gently */
  function spinTo(id, open){
    syncDeck();
    var n = S.deck.length;
    var idx = S.deck.findIndex(function(c){ return c.id === id; });
    if(idx < 0) return;
    var base = Math.round(W.target), d = ringDelta(mod(base, n), idx, n);
    S.cur = idx; S.curId = id;
    W.openAfter = null;
    if(d === 0 && !W.raf){ S.open = !!open; W.pos = W.target = idx; refresh(); return; }
    S.open = false;
    W.openAfter = open ? id : null;
    aimAt(base + d);
    refresh();
  }
  function toggleFav(id){
    var c = S.cards.get(id); if(!c || S.readOnly) return;
    c.fav = !c.fav; touch(id);
  }
  function step(d, absolute){
    var N = S.deck.length;
    if(!N) return;
    syncDeck();
    clearTimeout(W.snapT);
    var base = Math.round(W.target), cur = mod(base, N);
    var n = absolute ? Math.max(0, Math.min(N - 1, cur + d)) : mod(cur + d, N);
    var delta = absolute ? n - cur : d;
    if(!delta && W.target === base) return;
    var wasOpen = S.open;
    S.open = false; W.openAfter = null;
    S.cur = n; S.curId = S.deck[n].id;
    aimAt(base + delta);
    /* a closed wheel only needs the list highlight, A–Z and trail updated; the loop draws the cards */
    if(wasOpen || S.view !== "rolodex") refresh(); else { renderDeckList(); renderAZ(); renderTrail(); }
  }
  function openCard(){
    if(!S.curId) return;
    if(W.raf || W.pos !== W.target){ W.target = Math.round(W.target); syncCur(); W.pos = W.target; W.vel = 0; }
    S.open = true; refresh();
  }
  function closeCard(){ S.open = false; refresh(); }

  /* drag: 1:1 while held (mouse: pull down to flip toward you; touch: swipe sideways), a flick carries on */
  var PX_PER_CARD = {y:150, x:150}, FRICTION = 90;   /* px of drag per card; flick deceleration in cards/s² */
  function attachDrag(host){
    var g = null;
    function move(e){
      if(!g || e.pointerId !== g.id) return;
      var dx = e.clientX - g.x, dy = e.clientY - g.y;
      if(!g.on){
        if(Math.abs(dx) < 7 && Math.abs(dy) < 7) return;
        g.axis = g.touch ? "x" : (Math.abs(dy) >= Math.abs(dx) ? "y" : "x");
        if(g.touch && Math.abs(dy) > Math.abs(dx)){ end(); return; }   /* vertical on touch = page scroll */
        g.on = true; clearTimeout(W.snapT);
        g.p0 = W.pos; g.samples = [];
        W.drag = g; W.vel = 0; W.openAfter = null;
        g.x = e.clientX; g.y = e.clientY; dx = dy = 0;
        stage.classList.add("dragging");
        kick();
      }
      var p = g.p0 + (g.axis === "y" ? dy / PX_PER_CARD.y : -dx / PX_PER_CARD.x);
      g.samples.push([e.timeStamp, p]);
      while(g.samples.length > 2 && e.timeStamp - g.samples[0][0] > 90) g.samples.shift();
      if(!reduceMotion) W.pos = p;
      g.last = p;
    }
    function end(){
      document.removeEventListener("pointermove", move);
      document.removeEventListener("pointerup", up);
      document.removeEventListener("pointercancel", up);
      g = null;
    }
    function up(e){
      if(!g || (e && e.pointerId !== g.id)) return;
      var was = g; end();
      if(!was.on) return;
      stage.classList.remove("dragging");
      W.dragEnd = performance.now();
      if(was.card){ was.card._justDragged = true; setTimeout(function(){ was.card._justDragged = false; }, 0); }
      var sm = was.samples, v = 0;
      if(sm.length > 1){ var a = sm[0], b = sm[sm.length - 1], dt = (b[0] - a[0]) / 1000; if(dt > .004) v = (b[1] - a[1]) / dt; }
      if(e && e.timeStamp - sm[sm.length - 1][0] > 120) v = 0;   /* held still before letting go */
      v = Math.max(-SPRING.maxDrag, Math.min(SPRING.maxDrag, v));
      W.drag = null;
      if(reduceMotion){
        var moved = was.last - was.p0, k = Math.abs(moved) > .35 ? Math.round(moved) || Math.sign(moved) : 0;
        if(k) step(k); else draw();
        return;
      }
      W.vel = v;
      /* where the flick coasts to under friction (v²/2a: gentle flicks barely coast, hard ones spin), then snap to a card */
      W.target = Math.round(W.pos + v * Math.abs(v) / (2 * FRICTION));
      syncCur(); kick();
    }
    host.addEventListener("pointerdown", function(e){
      if(S.open || S.view !== "rolodex" || e.button > 0 || !S.deck.length || g) return;
      if(e.target.closest("button, a, input, select, textarea, [contenteditable], .stage-foot, .stage > .empty")) return;
      g = {id:e.pointerId, x:e.clientX, y:e.clientY, on:false, touch:e.pointerType === "touch", card:e.target.closest(".card"), samples:[]};
      document.addEventListener("pointermove", move);
      document.addEventListener("pointerup", up);
      document.addEventListener("pointercancel", up);
    });
    /* the click that ends a drag must not open or jump */
    host.addEventListener("click", function(e){
      if(W.dragEnd && performance.now() - W.dragEnd < 60){ e.stopPropagation(); e.preventDefault(); }
    }, true);
  }
  attachDrag(stage);
  /* read-only peek for the browser checks (tests/checks/wheel-motion.js) */
  window.__wheel = function(){ return {pos:W.pos, target:W.target, vel:W.vel, moving:!!W.raf, reduced:reduceMotion}; };

  /* scroll wheel / trackpad: deltas nudge the target fractionally so the wheel follows your fingers, then snaps */
  stage.addEventListener("wheel", function(e){
    if(S.open || S.view !== "rolodex" || !S.deck.length) return;
    e.preventDefault();
    var dy = Math.abs(e.deltaY) >= Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
    if(e.deltaMode === 1) dy *= 33; else if(e.deltaMode === 2) dy *= 400;
    if(!dy) return;
    clearTimeout(W.snapT);
    if(reduceMotion){
      W.wheelAcc = (W.wheelAcc || 0) + dy;
      if(Math.abs(W.wheelAcc) >= 60){ step(W.wheelAcc > 0 ? 1 : -1); W.wheelAcc = 0; }
      W.snapT = setTimeout(function(){ W.wheelAcc = 0; }, 200);
      return;
    }
    W.openAfter = null;
    if(Math.abs(dy) >= 60 && !W.fine){
      /* a mouse wheel notch: one card per notch */
      W.target = Math.round(W.target) + (dy > 0 ? 1 : -1);
    } else {
      if(Math.abs(dy) < 60) W.fine = true;
      W.target += Math.max(-1.5, Math.min(1.5, dy / 115));
      W.snapT = setTimeout(function(){ W.fine = false; W.target = Math.round(W.target); syncCur(); kick(); }, 130);
    }
    /* don't let the target run far ahead of the wheel */
    if(W.target - W.pos > 14) W.target = W.pos + 14; else if(W.pos - W.target > 14) W.target = W.pos - 14;
    syncCur(); kick();
  }, {passive:false});

  /* optional soft "tick" as each card passes (off by default; Settings in the workspace menu) */
  var audioCtx = null, lastTick = 0;
  function tick(){
    if(!S.wheelSound || reduceMotion) return;
    var now = performance.now();
    if(now - lastTick < 34) return;
    lastTick = now;
    try{
      if(!audioCtx){ var AC = window.AudioContext || window.webkitAudioContext; if(!AC) return; audioCtx = new AC(); }
      if(audioCtx.state === "suspended") audioCtx.resume();
      var t = audioCtx.currentTime, len = Math.floor(audioCtx.sampleRate * .018);
      if(!tick.buf){
        tick.buf = audioCtx.createBuffer(1, len, audioCtx.sampleRate);
        var ch = tick.buf.getChannelData(0);
        for(var i = 0; i < len; i++) ch[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 4);
      }
      var src = audioCtx.createBufferSource(), bp = audioCtx.createBiquadFilter(), gn = audioCtx.createGain();
      src.buffer = tick.buf; bp.type = "bandpass"; bp.frequency.value = 2400 + Math.random() * 500; bp.Q.value = 1.4;
      gn.gain.setValueAtTime(.16, t);
      src.connect(bp); bp.connect(gn); gn.connect(audioCtx.destination);
      src.start(t);
    }catch(err){}
  }

  /* ================= expanded card (detail editor) ================= */
  function fieldInput(id, label, value, opts){
    opts = opts || {};
    var input;
    if(opts.select){
      input = '<select id="' + id + '" data-f="' + opts.key + '">' + (opts.blank ? '<option value="">' + (opts.key === "f.repeat" ? "Doesn't repeat" : "") + '</option>' : "") + opts.select.map(function(o){ return '<option' + (o === value ? " selected" : "") + '>' + esc(o) + '</option>'; }).join("") + '</select>';
    } else {
      input = '<input id="' + id + '" data-f="' + opts.key + '" type="' + (opts.type || "text") + '" value="' + esc(value) + '"' + (opts.mono ? ' class="mono"' : "") + (opts.type === "number" ? ' min="0" max="100" step="5"' : "") + '>';
    }
    return '<div class="fld' + (opts.wide ? " wide" : "") + '"><label for="' + id + '">' + esc(label) + '</label>' + input + '</div>';
  }
  /* the compact "Repeats" control shown next to a card's main date field (any type but meeting) */
  function repeatFieldHtml(c){
    var rpt = c.rpt, ro = S.readOnly ? " disabled" : "";
    var everySel = '<select id="d-rpt-every" data-f="rpt.every"' + ro + '><option value="">' + "Doesn't repeat" + '</option>' +
      TASK_REPEATS.map(function(r){ return '<option' + (rpt && rpt.every === r ? " selected" : "") + '>' + esc(r) + '</option>'; }).join("") + '</select>';
    var extra = "";
    if(rpt && rpt.every){
      extra = '<div class="rpt-extra">' +
        '<label class="rpt-mini">until <input type="date" id="d-rpt-until" data-f="rpt.until" value="' + esc(rpt.until || "") + '"' + ro + '></label>' +
        '<label class="rpt-mini">or after <input type="number" id="d-rpt-times" data-f="rpt.times" min="0" max="999" value="' + (rpt.times || "") + '"' + ro + '> times</label>' +
        '</div><p class="rpt-sum">Repeats ' + esc(rpt.every.charAt(0).toLowerCase() + rpt.every.slice(1)) + (rpt.n ? " · " + rpt.n + " done" : "") + '</p>';
    }
    return '<div class="fld rpt-fld"><label for="d-rpt-every">Repeats</label>' + everySel + '</div>' + extra;
  }

  /* cards imported together from one sheet share a card type: that type is the "set" */
  function setSiblings(c){
    var T = td(c.type); if(!T.custom) return null;
    var list = Array.from(S.cards.values()).filter(function(o){ return o.type === c.type && !o.template === !c.template; }).sort(function(a, b){ return a.title.localeCompare(b.title, undefined, {numeric:true, sensitivity:"base"}); });
    if(list.length < 2) return null;
    var i = list.findIndex(function(o){ return o.id === c.id; });
    return {list:list, pos:i + 1, prev:list[(i - 1 + list.length) % list.length], next:list[(i + 1) % list.length]};
  }
  function buildDetail(el, c){
    if(!c) return;
    var T = td(c.type);
    var from = S.back.length ? S.cards.get(S.back[S.back.length - 1].id) : null;
    var sib = setSiblings(c);
    /* big card: the working stuff (notes, meeting pages, checklist, files) on the left; details on the right.
       Meeting cards get a "cockpit" layout: date/time + Join, today's notes, open actions, related cards. */
    var relSectionHtml = '<section class="d-sec"><h4>' + (c.type === "meeting" ? "Related cards" : "Linked cards") + '</h4><div class="rel-list" id="d-rel"></div>' +
        (S.readOnly ? "" : '<div class="rel-pick"><input class="inline-input" id="d-relq" autocomplete="off" placeholder="Link a card: type a name, IP, person…" aria-label="Find a card to link"><div class="rel-pop" id="d-relpop" hidden></div></div>') +
      '</section>';
    var meetHead = "";
    if(c.type === "meeting"){
      var ji = joinInfo(c.f.join), mtime = c.f.time ? (c.f.time + (c.f.endtime ? "–" + c.f.endtime : "")) : "";
      var mwhen = relDate(sessDefaultDate(c)) + (mtime ? " · " + mtime : "") + (c.f.where ? " · " + c.f.where : "");
      meetHead = '<section class="d-sec meet-cockpit-head"><span class="meet-when">' + esc(mwhen) + '</span>' +
        (ji ? '<a class="join-btn" href="' + esc(ji.url) + '" target="_blank" rel="noopener">' + esc(ji.label) + '</a>' : "") + '</section>';
    }
    /* session timeline holds every dated meeting page (past/today/upcoming), not just today's — "Meeting notes"
       says so plainly; the "+ Notes for today/for 3 Oct" button next door still gives the day-to-day scope */
    var sessSection = c.type === "meeting" ? '<section class="d-sec" id="d-sesssec"><div class="sess-head"><h4 style="margin:0">Meeting notes</h4>' +
        (S.readOnly ? "" : '<button type="button" class="btn small" data-addsess="1">+ Notes for ' + esc(sessDefaultLabel(c)) + '</button>') + '</div><div class="sess-list" id="d-sess"></div></section>' : "";
    var notesSection = '<section class="d-sec"><h4>' + (c.type === "meeting" ? "Other notes" : "Notes") + '</h4><div class="page-host" id="d-page"></div></section>';
    var checkSection = '<section class="d-sec"><h4>' + (c.type === "meeting" ? "Open actions" : "Checklist") + '<span class="sum" id="d-checksum"></span></h4><div class="check-bar" id="d-checkbar" hidden><i></i></div><ul class="check-list" id="d-check"></ul>' +
        (S.readOnly ? "" : '<input class="inline-input" id="d-checkin" placeholder="Add a checklist item, press Enter" aria-label="Add a checklist item">') +
      '</section>';
    var filesSection = '<section class="d-sec" id="d-filesec"><h4>Images &amp; files</h4><div class="file-grid" id="d-files"></div><p class="d-note" id="d-filenote"></p></section>';
    /* meeting cockpit order: header, session timeline, open actions, related cards, then the quieter
       free-text notes and files — everything else (non-meeting types) keeps the original order */
    var main = c.type === "meeting"
      ? meetHead + sessSection + checkSection + relSectionHtml + notesSection + filesSection
      : notesSection + checkSection + filesSection;
    var mainDK = dateKey(c.type);
    var fields = T.fields.map(function(fd){
      var h = fieldInput("d-f-" + fd.k, fd.l, c.f[fd.k] || "", {key:"f." + fd.k, type:fd.t === "select" ? null : fd.t, select:fd.t === "select" ? fd.opts : null, blank:true, mono:fd.mono});
      if(fd.k === mainDK && c.type !== "meeting") h += repeatFieldHtml(c);
      return h;
    }).join("");
    var side = (sib ? '<section class="d-sec set-strip"><h4>' + esc(T.plural) + ' <span class="sum">' + sib.pos + ' of ' + sib.list.length + '</span></h4><div class="set-nav">' +
        '<button type="button" class="btn small" data-setgo="' + esc(sib.prev.id) + '" title="' + esc(sib.prev.title) + '">‹ Previous</button>' +
        '<button type="button" class="btn small" data-setgo="' + esc(sib.next.id) + '" title="' + esc(sib.next.title) + '">Next ›</button>' +
        '<button type="button" class="text-btn" data-setall="' + esc(c.type) + '">Show all ' + sib.list.length + '</button></div></section>' : "") +
      /* DETAILS group: status, type fields, folder, tags, web links, related cards — the things you look up */
      '<div class="d-group d-group-details">' +
      '<section class="d-sec"><div class="side-head"><h4>Details</h4>' + (S.readOnly ? "" : '<button type="button" class="text-btn" data-style="' + esc(c.type) + '" title="Change how every ' + esc(T.label.toLowerCase()) + ' card looks">Style all ' + esc(T.plural.toLowerCase()) + '</button>') + '</div>' +
        '<div class="d-grid one">' +
          fieldInput("d-title", "Title", c.title, {key:"title"}) +
          fieldInput("d-status", "Status", c.status, {key:"status", select:T.statuses}) +
          '<div class="fld"><label for="d-folder">Folder</label><select id="d-folder" data-f="folder">' + folderOptions(c.folder) + '</select></div>' +
          fields + '</div></section>' +
      /* Remind me: one date + time per card (c.remind), filled by renderRemind */
      '<section class="d-sec d-remind"><h4>Remind me</h4><div id="d-remind"></div></section>' +
      /* Related: the "look this up" trio (tags, web links, linked cards) reads as one cluster,
         set apart from the fields-editing Details section above by a divider rather than by
         merging their markup — renderTagEdit/renderLinks/renderRel keep targeting their own ids */
      '<div class="d-related">' +
      '<section class="d-sec"><h4>Tags</h4><div class="tag-edit" id="d-tags"></div></section>' +
      '<section class="d-sec"><div style="display:flex; align-items:center; justify-content:space-between; gap:8px; margin-bottom:8px;"><h4 style="margin:0">Web links</h4><button type="button" class="text-btn" data-bwfind="1" title="Copy this card’s title and open Bitwarden to search for it">🔒 Find in Bitwarden</button></div><ul class="link-list" id="d-links"></ul>' +
        (S.readOnly ? "" : '<form class="link-add" id="d-linkform"><input class="inline-input" id="d-linklabel" placeholder="Label (optional)" aria-label="Link label"><input class="inline-input mono" id="d-linkurl" placeholder="https://…" aria-label="Link address"><button class="btn small" type="submit">Add link</button></form>') +
      '</section>' +
      (c.type === "meeting" ? "" : relSectionHtml) +
      '</div>' +
      '</div>' +
      /* SECONDARY group: quieter, looked at less often */
      '<div class="d-group d-group-secondary">' +
      '<details class="d-sec d-fold"><summary>History</summary><ol class="hist" id="d-hist"></ol></details>' +
      '<details class="d-sec d-fold"><summary>Subtitle and card type</summary><div class="d-grid one">' +
        fieldInput("d-subtitle", "Subtitle", c.subtitle, {key:"subtitle"}) +
        '<div class="fld"><label for="d-type">Card type</label><select id="d-type" data-f="type">' + TYPE_ORDER.map(function(k){ return '<option value="' + esc(k) + '"' + (k === c.type ? " selected" : "") + '>' + esc(td(k).label) + '</option>'; }).join("") + (TYPES[c.type] ? "" : '<option value="' + esc(c.type) + '" selected>Other</option>') + '</select></div>' +
      '</div></details>' +
      '<div class="d-foot"><span id="d-updated"></span>' + (S.readOnly ? "" : '<span class="d-foot-acts">' + (c.template
        ? '<button class="btn small" id="d-usetpl" type="button">New card from template</button><button class="btn small danger" id="d-delete" type="button">Delete template</button>'
        : '<button class="btn small" id="d-dup" type="button">Duplicate</button><button class="btn small" id="d-savetpl" type="button">Save as template</button><button class="btn small" id="d-archive" type="button">' + (c.archived ? "Unarchive" : "Archive") + '</button><button class="btn small danger" id="d-delete" type="button">Delete card</button>') + '</span>') + '</div>' +
      '</div>';
    var html = (from ? '<button type="button" class="came-from" data-trail="back">← Back to <b>' + esc(from.title) + '</b></button>' : "") +
      (c.template ? '<p class="tpl-note"><b>Template.</b> Edit it like any card; new cards made from it start as a copy. It stays out of the wheel, search and dashboards. <button type="button" class="text-btn" data-alltpl="1">All templates…</button></p>' : "") +
      '<div class="d-cols"><div class="d-main">' + main + '</div><aside class="d-side">' + side + '</aside></div>';
    histAll = false;
    var box = el.querySelector(".detail");
    box.innerHTML = html;
    box.scrollTop = 0;
    el._detailFor = c.id;
    renderPage($("d-page"), c, null); renderSess(c); renderTagEdit(c); renderRel(c); renderCheck(c); renderLinks(c); renderFiles(c); renderUpdated(c); renderHist(c); renderRemind(c);
    if(S.readOnly) box.querySelectorAll("input, select, textarea").forEach(function(x){ x.disabled = true; });
  }
  /* ---- meeting notes: one entry per meeting date ---- */
  function sessDefaultDate(c){
    var t = today();
    if(c.f.repeat){ var nx = nextMeeting(c, t); return nx || t; }
    return validDate(c.f.due) && c.f.due >= t ? c.f.due : t;
  }
  function sessDefaultLabel(c){ var d = sessDefaultDate(c); return d === today() ? "today" : fmtDate(d, true); }
  function ensureSess(c, date){
    var s0 = c.sess.filter(function(x){ return x.date === date; })[0];
    if(s0) return s0;
    s0 = {id:uid(), date:date, text:"", files:[]};
    c.sess.push(s0);
    logHist(c, "Started notes for " + fmtDate(date, true));
    touch(c.id);
    return s0;
  }
  function renderSess(c){
    var box = $("d-sess"); if(!box) return;
    var t = today();
    var list = c.sess.slice().sort(function(a, b){ return b.date.localeCompare(a.date); });
    box.innerHTML = list.length ? list.map(function(x){
      return '<div class="sess' + (x.date === t ? " today" : "") + '" data-sess="' + esc(x.id) + '"><div class="sess-top"><b>' + esc(fmtDate(x.date, true)) + '</b><span class="when">' + (x.date === t ? "Today" : x.date > t ? "Upcoming" : esc(ago(x.date + "T12:00:00"))) + '</span>' +
        (S.readOnly ? "" : '<label class="text-btn sess-add" style="cursor:pointer">Add images<input type="file" data-sessfile="' + esc(x.id) + '" multiple accept="image/png,image/jpeg,image/gif,image/webp,application/pdf" hidden></label><button type="button" class="x-btn" data-rmsess="' + esc(x.id) + '">Delete page</button>') + '</div>' +
        '<div class="page-host" data-sesspage="' + esc(x.id) + '"></div></div>';
    }).join("") : '<p class="d-note" style="margin:0">No notes yet. Use the button above, or they start automatically when the meeting opens.</p>';
    box.querySelectorAll("[data-sesspage]").forEach(function(h){ renderPage(h, c, h.dataset.sesspage); });
  }
  /* put the cursor on a page: at the end of its last text box, or in a new one at the top */
  function focusPage(c, sid){
    var pg = detailHost.querySelector('.page[data-page="' + (sid || "main") + '"]'); if(!pg || S.readOnly) return;
    var texts = pg.querySelectorAll(".pb-text");
    if(!texts.length){
      var blocks = pageBlocks(c, sid, true); if(!blocks) return;
      var nb = {id:uid(), k:"t", x:16, y:16, w:Math.min(620, Math.max(200, pg.clientWidth - 40)), t:""};
      blocks.push(nb); renderPage(pg.parentNode, c, sid);
      pg = detailHost.querySelector('.page[data-page="' + (sid || "main") + '"]'); texts = pg.querySelectorAll(".pb-text");
    }
    var el = texts[texts.length - 1]; el.focus();
    try{ var r = document.createRange(); r.selectNodeContents(el); r.collapse(false); var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r); }catch(e){}
  }
  function logHist(c, w){
    if(!c) return;
    c.hist.push({at:new Date().toISOString(), w:String(w).slice(0, 300)});
    if(c.hist.length > 300) c.hist.splice(0, c.hist.length - 300);
    if(S.open && S.curId === c.id) renderHist(c);
  }
  var histAll = false;
  function renderHist(c){
    var ol = $("d-hist"); if(!ol) return;
    var items = c.hist.slice().reverse();
    var shown = histAll ? items : items.slice(0, 8);
    ol.innerHTML = shown.length ? shown.map(function(h){
      var d = new Date(h.at);
      var when = isNaN(d) ? "" : d.toLocaleString(undefined, {day:"numeric", month:"short", hour:"2-digit", minute:"2-digit"});
      return '<li><time>' + esc(when) + '</time>' + esc(h.w) + '</li>';
    }).join("") + (items.length > 8 && !histAll ? '<li style="list-style:none"><button type="button" class="text-btn" data-histall="1">Show all ' + items.length + ' changes</button></li>' : "")
      : '<li>No changes recorded yet. Edits, status changes, links and uploads show up here.</li>';
  }
  function syncProgress(c){
    if(c.type !== "project" || !c.check.length) return;
    var done = c.check.filter(function(x){ return x.done; }).length;
    c.f.progress = String(Math.round(done / c.check.length * 100));
    var inp = $("d-f-progress"); if(inp && S.curId === c.id) inp.value = c.f.progress;
  }
  function renderCheck(c){
    var ul = $("d-check"); if(!ul) return;
    var done = c.check.filter(function(x){ return x.done; }).length, n = c.check.length;
    $("d-checksum").textContent = n ? done + " of " + n + " done" + (c.type === "project" ? " · sets the project's progress" : "") : "";
    var bar = $("d-checkbar"); bar.hidden = !n; if(n) bar.firstChild.style.width = (done / n * 100) + "%";
    ul.innerHTML = c.check.map(function(x){
      return '<li class="' + (x.done ? "done" : "") + '"><label><input type="checkbox" data-chk="' + esc(x.id) + '"' + (x.done ? " checked" : "") + (S.readOnly ? " disabled" : "") + '><span>' + esc(x.t) + '</span></label>' +
        (S.readOnly ? "" : '<button type="button" class="x-btn" data-chkdel="' + esc(x.id) + '" aria-label="Remove item">✕</button>') + '</li>';
    }).join("");
  }
  function fieldLabel(c, key){
    if(key === "title") return "Title";
    if(key === "subtitle") return "Subtitle";
    if(key === "status") return "Status";
    if(key.indexOf("f.") === 0){ var k = key.slice(2), fd = td(c.type).fields.filter(function(f){ return f.k === k; })[0]; return fd ? fd.l : k; }
    return key;
  }
  function fieldShow(c, key, v){
    if(!v) return "(empty)";
    if(key.indexOf("f.") === 0){ var k = key.slice(2), fd = td(c.type).fields.filter(function(f){ return f.k === k; })[0]; if(fd && fd.t === "date") return fmtDate(v); }
    return v.length > 60 ? v.slice(0, 57) + "…" : v;
  }
  function rebuildDetail(){ var el = els.get(S.curId); if(el && S.open) buildDetail(el, S.cards.get(S.curId)); }
  function curCard(){ return S.cards.get(S.curId); }

  function renderUpdated(c){
    var u = $("d-updated"); if(!u) return;
    u.textContent = c.updated ? "Edited " + new Date(c.updated).toLocaleString(undefined, {day:"numeric", month:"short", hour:"2-digit", minute:"2-digit"}) : "";
  }
  /* ---- reminders ---- */
  function renderRemind(c){
    var box = $("d-remind"); if(!box) return;
    var ro = S.readOnly ? " disabled" : "";
    box.innerHTML = (c.remind ? '<p class="rm-now"><span class="remind-badge' + (remindDue(c) ? " due" : "") + '"><span aria-hidden="true">🔔</span>' + esc(fmtRemind(c.remind)) + '</span>' + (S.readOnly ? "" : '<button type="button" class="text-btn" data-remind="clear">Clear</button>') + '</p>' : '<p class="d-note rm-now">No reminder set.</p>') +
      '<div class="rm-picks"><button type="button" class="q-btn" data-remind="later"' + ro + '>Later today</button><button type="button" class="q-btn" data-remind="tomorrow"' + ro + '>Tomorrow 9:00</button><button type="button" class="q-btn" data-remind="monday"' + ro + '>Next Monday 9:00</button></div>' +
      '<div class="rm-custom"><input type="datetime-local" id="d-remindat" aria-label="Remind me at" value="' + esc(c.remind) + '"' + ro + '><button type="button" class="btn small" data-remind="custom"' + ro + '>Set</button></div>';
  }
  function setRemind(c, when, w){
    if(!c || S.readOnly || c.remind === when) return;
    c.remind = when;
    logHist(c, w || (when ? "Reminder set for " + fmtRemind(when) : "Reminder cleared"));
    touch(c.id);
    if(S.open && S.curId === c.id) renderRemind(c);
    checkReminders();
  }
  /* browser notifications are extra: ask only from a click, and never let a blocked API (the claude.ai iframe) break anything */
  function askNotify(){
    try{ if(typeof Notification !== "undefined" && Notification.permission === "default"){ var p = Notification.requestPermission(); if(p && p.catch) p.catch(function(){}); } }catch(e){}
  }
  function folderParentOptions(f){
    var exclude = folderDescendants(f.id);
    var out = '<option value=""' + (!f.parent ? " selected" : "") + '>Top level</option>';
    var walk = function(parent, depth){
      folderChildren(parent).forEach(function(x){
        if(exclude.indexOf(x.id) < 0){
          out += '<option value="' + esc(x.id) + '"' + (x.id === (f.parent || "") ? " selected" : "") + '>' + (depth ? "   ".repeat(depth) + "↳ " : "") + esc(x.name) + '</option>';
          walk(x.id, depth + 1);
        }
      });
    };
    walk(null, 0);
    return out;
  }
  function folderOptions(sel){
    var out = '<option value="">Not in a folder</option>';
    var walk = function(parent, depth){
      folderChildren(parent).forEach(function(f){
        out += '<option value="' + esc(f.id) + '"' + (f.id === sel ? " selected" : "") + '>' + (depth ? "\u00a0\u00a0\u00a0".repeat(depth) + "↳ " : "") + esc(f.name) + '</option>';
        walk(f.id, depth + 1);
      });
    };
    walk(null, 0);
    return out;
  }
  function renderRel(c){
    var box = $("d-rel"); if(!box) return;
    var ids = linkedIds(c);
    var fromId = S.back.length ? S.back[S.back.length - 1].id : "";
    if(!ids.length){ box.innerHTML = '<span class="d-note" style="margin:0">Nothing linked yet. Link the servers, people or projects this card relates to.</span>'; return; }
    /* group by the linked card's type, so a card with lots of links is still scannable at a glance */
    var groups = {}, order = [];
    ids.forEach(function(id){
      var o = S.cards.get(id); if(!o) return;
      if(!groups[o.type]){ groups[o.type] = []; order.push(o.type); }
      groups[o.type].push(id);
    });
    order.sort(function(a, b){ return td(a).plural.localeCompare(td(b).plural); });
    box.innerHTML = order.map(function(type){
      var list = groups[type];
      return '<div class="rel-group"><h6 class="rel-group-h">' + esc(td(type).plural) + '<span class="sum">' + list.length + '</span></h6><div class="rel-group-list">' +
        list.map(function(id){
          var o = S.cards.get(id);
          return '<span class="rel-chip' + (id === fromId ? " from" : "") + '" style="' + typeVar(o.type) + '"' + (id === fromId ? ' title="You came from this card"' : "") + '><button type="button" class="go" data-goto="' + esc(id) + '" title="Open ' + esc(o.title) + '"><span class="t-chip">' + esc(td(o.type).short) + '</span><span class="nm">' + esc(o.title) + '</span>' + (id === fromId ? '<span class="from-lbl">came from</span>' : '<span class="pill tone-' + (TONE[o.status] || "muted") + '">' + esc(o.status) + '</span>') + '</button>' +
            (S.readOnly ? "" : '<button type="button" class="x-btn" data-unrel="' + esc(id) + '" aria-label="Unlink ' + esc(o.title) + '">✕</button>') + '</span>';
        }).join("") + '</div></div>';
    }).join("");
  }
  var relSel = 0;
  function renderRelPop(){
    var inp = $("d-relq"), pop = $("d-relpop"), c = curCard();
    if(!inp || !pop || !c) return;
    var q = inp.value.trim();
    if(!q){ pop.hidden = true; return; }
    var pq = parseQuery(q), have = linkedIds(c);
    var res = ranked(Array.from(S.cards.values()).filter(function(o){ return o.id !== c.id && !o.template && have.indexOf(o.id) < 0 && matches(o, pq); }), pq).slice(0, 8);
    relSel = Math.min(relSel, Math.max(0, res.length - 1));
    pop.innerHTML = res.length ? res.map(function(o, i){
      return '<button type="button" class="q-item' + (i === relSel ? " sel" : "") + '" data-addrel="' + esc(o.id) + '" style="' + typeVar(o.type) + '"><span class="t-chip">' + esc(td(o.type).short) + '</span><b>' + highlight(o.title, pq.terms) + '</b><span class="snip">' + snippet(o, pq) + '</span></button>';
    }).join("") : '<div class="q-empty">No other cards match.</div>';
    pop.hidden = false;
  }
  function setRel(a, b, on){
    var ca = S.cards.get(a), cb = S.cards.get(b);
    if(!ca || !cb) return;
    [[ca, b], [cb, a]].forEach(function(p){
      var i = p[0].rel.indexOf(p[1]);
      var other = S.cards.get(p[1]);
      if(on && i < 0 && p[0].rel.length < 100){ p[0].rel.push(p[1]); logHist(p[0], "Linked to " + other.title); touch(p[0].id); }
      if(!on && i >= 0){ p[0].rel.splice(i, 1); logHist(p[0], "Unlinked " + other.title); touch(p[0].id); }
    });
    renderRel(S.cards.get(S.curId) || ca);
  }
  function renderTagEdit(c){
    var box = $("d-tags"); if(!box) return;
    box.innerHTML = c.tags.map(function(t, i){ return '<span class="tag">#' + esc(t) + (S.readOnly ? "" : '<button type="button" data-rmtag="' + i + '" aria-label="Remove tag ' + esc(t) + '">&#10005;</button>') + '</span>'; }).join("") +
      (S.readOnly ? "" : '<input class="inline-input" id="d-tagin" placeholder="Add tag, press Enter" aria-label="Add tag">');
  }
  function copyText(text){
    if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(text).catch(function(){ copyTextFallback(text); }); return; }
    copyTextFallback(text);
  }
  function copyTextFallback(text){
    var ta = document.createElement("textarea");
    ta.value = text; ta.style.position = "fixed"; ta.style.opacity = "0";
    document.body.appendChild(ta); ta.select();
    try{ document.execCommand("copy"); }catch(e){}
    document.body.removeChild(ta);
  }
  /* password managers: Tabwheel never stores a secret, only a link to where it lives */
  function vaultLink(url){
    var u; try{ u = new URL(url); }catch(e){ return null; }
    var h = u.hostname.toLowerCase(), all = u.hash + u.search;
    if(/(^|\.)send\.bitwarden\.(com|eu)$/.test(h) || /#\/send\//.test(u.hash) && /bitwarden/.test(h)) return {kind:"send", label:"Bitwarden Send", short:"Send"};
    if(/bitwarden|vaultwarden/.test(h) || /[?&]itemId=/.test(all) && /#\/vault/.test(u.hash)) return {kind:"bw", label:"Bitwarden", short:"Bitwarden"};
    if(/(^|\.)1password\.(com|eu|ca)$/.test(h)) return {kind:"op", label:"1Password", short:"1Password"};
    return null;
  }
  function renderLinks(c){
    var ul = $("d-links"); if(!ul) return;
    ul.innerHTML = c.links.length ? c.links.map(function(l, i){
      var host = ""; try{ host = new URL(l.url).hostname; }catch(e){}
      var v = vaultLink(l.url);
      return '<li' + (v ? ' class="vault"' : "") + '>' + (v ? '<span class="vault-ico" aria-hidden="true">🔒</span>' : "") + '<a href="' + esc(l.url) + '" target="_blank" rel="noopener noreferrer">' + esc(l.label || (v ? v.label + " item" : host)) + '</a><span class="u">' + esc(v ? "Opens in " + v.label : l.url) + '</span>' + (S.readOnly ? "" : '<button class="x-btn" type="button" data-rmlink="' + i + '">Remove</button>') + '</li>';
    }).join("") : '<li class="d-note" style="border:0;background:none;padding:0">No links yet. For passwords, add a link to the Bitwarden item: open the item in your web vault and copy the address bar.</li>';
  }
  function canUpload(){ return !S.readOnly && (S.mode === "local" || !!S.assets); }
  function renderFiles(c){
    var grid = $("d-files"); if(!grid) return;
    grid.innerHTML = c.files.map(function(x, i){
      var inner = isImage(x)
        ? '<img src="' + esc(fileSrc(x)) + '" alt="' + esc(x.name || "Image") + '" data-zoom="' + i + '" loading="lazy">'
        : '<a class="doc" href="' + esc(fileSrc(x)) + '" target="_blank" rel="noopener"><span><b>PDF</b>' + esc(x.name || "Document") + '</span></a>';
      return '<div class="thumb">' + inner + (S.readOnly ? "" : '<button class="x-btn" type="button" data-rmfile="' + i + '" aria-label="Remove file">&#10005;</button>') + '</div>';
    }).join("") + (canUpload() ? '<label class="file-add" for="d-filein"><b>+</b>Add images<input type="file" id="d-filein" multiple accept="image/png,image/jpeg,image/gif,image/webp,application/pdf"></label>' : "");
    var note = $("d-filenote");
    if(note) note.textContent = !canUpload() ? (S.readOnly ? "" : "Uploads are available to people who can edit this workspace.")
      : S.mode === "online" ? "Drop images or PDFs here. They upload to this workspace's online storage (20 MB each)."
      : "Drop images here. Offline copy: images are kept full size, in this browser only.";
  }

  var detailHost = deckEl;
  /* ---- notes page: click to write, drag to move, corner to resize, paste/drop images where you want them ---- */
  var pgDrag = null, secretWarned = {};
  detailHost.addEventListener("pointerdown", function(e){
    if(!S.open || S.readOnly || e.button > 0) return;
    var ctx = pageCtx(e.target); if(!ctx) return;
    var pt = pagePoint(ctx.pg, e);
    lastPagePoint[ctx.c.id + "/" + (ctx.sid || "main")] = {x:Math.round(pt.x / 8) * 8, y:Math.round(pt.y / 8) * 8};
    var bEl = e.target.closest(".pb");
    if(e.target.closest(".pb-x, .pb-text, a")) return;
    if(bEl){
      var mode = e.target.closest(".pb-rs") ? "size" : (e.target.closest(".pb-grip") || bEl.classList.contains("pb-i")) ? "move" : "";
      if(!mode) return;
      e.preventDefault();
      pgDrag = {ctx:ctx, el:bEl, id:bEl.dataset.b, mode:mode, sx:e.clientX, sy:e.clientY, x:bEl.offsetLeft, y:bEl.offsetTop, w:bEl.offsetWidth, s:ctx.pg._scale || 1, moved:false};
      bEl.classList.add("dragging");
      try{ bEl.setPointerCapture(e.pointerId); }catch(err){}
      return;
    }
    if(e.target === ctx.pg || e.target.classList.contains("page-hint")){
      pgDrag = {ctx:ctx, mode:"new", pt:pt, sx:e.clientX, sy:e.clientY};
    }
  });
  detailHost.addEventListener("pointermove", function(e){
    if(!pgDrag || !pgDrag.el) return;
    var dx = (e.clientX - pgDrag.sx) / pgDrag.s, dy = (e.clientY - pgDrag.sy) / pgDrag.s;
    if(Math.abs(dx) + Math.abs(dy) > 2) pgDrag.moved = true;
    /* snaps to an 8px grid so things line up neatly; hold Alt to place freely */
    var snap = function(v){ return e.altKey ? v : Math.round(v / 8) * 8; };
    if(pgDrag.mode === "move"){
      pgDrag.el.style.left = Math.max(0, snap(pgDrag.x + dx)) + "px";
      pgDrag.el.style.top = Math.max(0, snap(pgDrag.y + dy)) + "px";
    } else pgDrag.el.style.width = Math.max(pgDrag.el.classList.contains("pb-t") ? 120 : 60, snap(pgDrag.w + dx)) + "px";
  });
  function endPageDrag(e){
    if(!pgDrag) return;
    var d = pgDrag; pgDrag = null;
    var c = d.ctx.c, blocks = pageBlocks(c, d.ctx.sid, true);
    if(d.mode === "new"){
      if(Math.abs(e.clientX - d.sx) + Math.abs(e.clientY - d.sy) > 6 || !blocks) return;
      var snapNew = function(v){ return Math.round(v / 8) * 8; };
      var nb = {id:uid(), k:"t", x:snapNew(Math.max(0, d.pt.x - 6)), y:snapNew(Math.max(0, d.pt.y - 12)), w:Math.min(420, Math.max(160, d.ctx.pg.clientWidth - d.pt.x - 16)), t:""};
      blocks.push(nb);
      renderPage(d.ctx.pg.parentNode, c, d.ctx.sid);
      var t = detailHost.querySelector('.pb[data-b="' + nb.id + '"] .pb-text'); if(t) t.focus();
      return;
    }
    d.el.classList.remove("dragging");
    if(!d.moved || !blocks) return;
    var b = findBlock(blocks, d.id); if(!b) return;
    b.x = Math.round(d.el.offsetLeft); b.y = Math.round(d.el.offsetTop); b.w = Math.round(d.el.offsetWidth);
    pageChanged(c, d.ctx.sid);
    sizePage(d.ctx.pg);
  }
  detailHost.addEventListener("pointerup", endPageDrag);
  detailHost.addEventListener("pointercancel", endPageDrag);
  /* typing a space right after something that looks like a URL (starts with http(s):// or
     www.) turns it into a real link — deliberately conservative (no bare "example.com") so
     ordinary prose with periods and abbreviations never gets linkified by accident */
  function autoLinkBeforeCaret(tx){
    var sel = window.getSelection();
    if(!sel.rangeCount) return false;
    var range = sel.getRangeAt(0);
    if(!range.collapsed) return false;
    var node = range.startContainer;
    if(node.nodeType !== 3) return false;
    if(node.parentNode && node.parentNode.closest && node.parentNode.closest("a")) return false;
    var text = node.textContent, end = range.startOffset - 1;
    if(end < 0 || text[end] !== " ") return false;
    var start = end;
    while(start > 0 && !/\s/.test(text[start - 1])) start--;
    var word = text.slice(start, end);
    if(!/^(https?:\/\/|www\.)\S+$/i.test(word)) return false;
    var url = safeUrl(word); if(!url) return false;
    var a = document.createElement("a");
    a.href = url; a.target = "_blank"; a.rel = "noopener"; a.textContent = word;
    var afterNode = document.createTextNode(text.slice(end));
    var parent = node.parentNode;
    parent.insertBefore(document.createTextNode(text.slice(0, start)), node);
    parent.insertBefore(a, node);
    parent.insertBefore(afterNode, node);
    parent.removeChild(node);
    var r = document.createRange(); r.setStart(afterNode, 1); r.collapse(true);
    sel.removeAllRanges(); sel.addRange(r);
    return true;
  }
  detailHost.addEventListener("input", function(e){
    var tx = e.target.closest && e.target.closest(".pb-text"); if(!tx) return;
    var ctx = pageCtx(tx); if(!ctx) return;
    var blocks = pageBlocks(ctx.c, ctx.sid, true), b = blocks && findBlock(blocks, tx.parentNode.dataset.b); if(!b) return;
    if(e.data === " ") autoLinkBeforeCaret(tx);
    fixMarkers(tx);
    b.h = cleanHTML(tx.innerHTML); b.t = richText(tx);
    if(!secretWarned[ctx.c.id] && /\b(password|passwd|pwd|passcode|pin|pw)\s*[:=]\s*\S{4,}/i.test(b.t)){
      secretWarned[ctx.c.id] = true;
      toast("That looks like a password. Notes aren't a safe place for it: keep it in Bitwarden and add the item's link under Web links.");
    }
    if(!b.t.trim() && !/<(ul|ol|li)/.test(b.h)) b.h = "";
    pageChanged(ctx.c, ctx.sid);
    sizePage(ctx.pg);
  });
  detailHost.addEventListener("focusout", function(e){
    var tx = e.target.closest && e.target.closest(".pb-text"); if(!tx) return;
    var ctx = pageCtx(tx); if(!ctx) return;
    var blocks = pageBlocks(ctx.c, ctx.sid, false), id = tx.parentNode.dataset.b;
    var i = blocks ? blocks.findIndex(function(b){ return b.id === id; }) : -1;
    if(i >= 0 && !blocks[i].t.trim()){ blocks.splice(i, 1); pageChanged(ctx.c, ctx.sid); var gone = tx.parentNode, pg = ctx.pg; setTimeout(function(){ if(gone.isConnected) gone.remove(); sizePage(pg); }, 0); }
  });
  detailHost.addEventListener("keydown", function(e){
    if(e.key === "Escape" && e.target.closest && e.target.closest(".pb-text")){ e.stopPropagation(); e.target.blur(); }
  }, true);
  detailHost.addEventListener("click", function(e){
    var x = e.target.closest && e.target.closest("[data-pbdel]"); if(!x) return;
    var ctx = pageCtx(x); if(!ctx) return;
    e.stopPropagation();
    var blocks = pageBlocks(ctx.c, ctx.sid, true), i = blocks.findIndex(function(b){ return b.id === x.dataset.pbdel; }); if(i < 0) return;
    var gone = blocks.splice(i, 1)[0], cid = ctx.c.id, sid = ctx.sid;
    pageChanged(ctx.c, sid, gone.k === "i" ? "Removed an image from the notes" : null);
    renderPage(ctx.pg.parentNode, ctx.c, sid);
    var undoneImg = false;
    toast(gone.k === "i" ? "Removed the image." : "Removed the text.", {label:"Undo", fn:function(){
      undoneImg = true;
      var c = S.cards.get(cid); if(!c) return; var bl = pageBlocks(c, sid, true); if(!bl) return;
      bl.push(gone); pageChanged(c, sid); if(S.curId === cid) redrawPage(c, sid);
    }});
    /* removing an image block only dropped it from the page — the uploaded file itself was
       never cleaned up, leaking storage forever every time someone removed a screenshot */
    if(gone.k === "i" && gone.f && gone.f.id){
      setTimeout(function(){ if(!undoneImg) dropFiles([gone.f.id]); }, 9000);
    }
  }, true);
  detailHost.addEventListener("dblclick", function(e){
    var img = e.target.closest && e.target.closest(".pb-i img"); if(!img) return;
    $("lightboxImg").src = img.src; $("lightbox").hidden = false;
  });
  detailHost.addEventListener("paste", function(e){
    var ctx = pageCtx(e.target) || pageCtx(document.querySelector(".card.open .page:focus-within"));
    if(!ctx || S.readOnly) return;
    var files = Array.from((e.clipboardData && e.clipboardData.files) || []).filter(function(f){ return /^image\//.test(f.type); });
    if(!files.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if(!canUpload()){ toast("Images can't be added in this view."); return; }
    addImagesToPage(ctx, files, nextSpot(ctx));
  }, true);
  detailHost.addEventListener("dragover", function(e){ var pg = e.target.closest && e.target.closest(".page"); if(pg && !S.readOnly && e.dataTransfer && Array.from(e.dataTransfer.types || []).indexOf("Files") >= 0){ e.preventDefault(); pg.classList.add("drop-on"); } }, true);
  detailHost.addEventListener("dragleave", function(e){ var pg = e.target.closest && e.target.closest(".page"); if(pg) pg.classList.remove("drop-on"); }, true);
  detailHost.addEventListener("drop", function(e){
    var ctx = pageCtx(e.target); if(!ctx || S.readOnly) return;
    ctx.pg.classList.remove("drop-on");
    var files = Array.from((e.dataTransfer && e.dataTransfer.files) || []); if(!files.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if(!canUpload()){ toast("Images can't be added in this view."); return; }
    addImagesToPage(ctx, files, pagePoint(ctx.pg, e));
  }, true);

  /* ---- text formatting on notes pages: floating toolbar, shortcuts, markdown-style starts, to-do lists ---- */
  var FMT_COLORS = [["1","Red"],["2","Orange"],["3","Green"],["4","Blue"],["5","Purple"]];
  var HL_COLORS = [["1","Yellow"],["2","Green"],["3","Blue"],["4","Pink"],["5","Orange"]];
  var SZ_SIZES = [["1","Small"],["2","Large"],["3","Extra large"]];
  var fmtBar = document.createElement("div");
  fmtBar.className = "fmt-bar"; fmtBar.hidden = true; fmtBar.setAttribute("role", "toolbar"); fmtBar.setAttribute("aria-label", "Text formatting");
  fmtBar.innerHTML =
    '<button type="button" data-fmt="bold" title="Bold (Ctrl+B)"><b>B</b></button>' +
    '<button type="button" data-fmt="italic" title="Italic (Ctrl+I)"><i>I</i></button>' +
    '<button type="button" data-fmt="underline" title="Underline (Ctrl+U)"><u>U</u></button>' +
    '<button type="button" data-fmt="strikeThrough" title="Strikethrough"><s>S</s></button>' +
    '<span class="fmt-sep"></span>' +
    '<button type="button" data-fmtpop="hl" title="Highlight (Ctrl+Shift+H)" class="fmt-hl"><span>ab</span></button>' +
    '<button type="button" data-fmtpop="fc" title="Text colour" class="fmt-fc"><span>A</span></button>' +
    '<button type="button" data-fmtpop="sz" title="Text size" class="fmt-sz"><span>Aa</span></button>' +
    '<span class="fmt-sep"></span>' +
    '<button type="button" data-block="h1" title="Heading (type # then space)">H1</button>' +
    '<button type="button" data-block="h2" title="Subheading (type ## then space)">H2</button>' +
    '<button type="button" data-block="div" title="Normal text">¶</button>' +
    '<span class="fmt-sep"></span>' +
    '<button type="button" data-fmt="insertUnorderedList" title="Bullets (type - then space)">•≡</button>' +
    '<button type="button" data-fmt="insertOrderedList" title="Numbered list (type 1. then space)">1≡</button>' +
    '<button type="button" data-todo="1" title="To-do list (Ctrl+1, or type [] then space)">☐</button>' +
    '<button type="button" data-fmt="outdent" title="Outdent (Shift+Tab)">⇤</button>' +
    '<button type="button" data-fmt="indent" title="Indent (Tab)">⇥</button>' +
    '<span class="fmt-sep"></span>' +
    '<button type="button" data-linkbtn="1" title="Link (Ctrl+K)">🔗</button>' +
    '<button type="button" data-fmt="removeFormat" title="Clear formatting">⌫</button>' +
    '<a class="fmt-open" hidden target="_blank" rel="noopener noreferrer">Open link ↗</a>' +
    '<div class="fmt-pop" hidden></div>' +
    '<form class="fmt-link" hidden><input type="url" placeholder="https://…" aria-label="Link address"><button type="submit">Add</button><button type="button" data-unlink="1" title="Remove link">Remove</button></form>';
  document.body.appendChild(fmtBar);
  var fmtFor = null, fmtRange = null;
  function fmtText(){ return fmtFor && fmtFor.isConnected ? fmtFor : null; }
  function placeFmtBar(){
    var tx = fmtText(); if(!tx || S.readOnly){ fmtBar.hidden = true; return; }
    var r = tx.parentNode.getBoundingClientRect();
    fmtBar.hidden = false;
    var h = fmtBar.offsetHeight, w = fmtBar.offsetWidth;
    var top = r.top - h - 20; if(top < 8) top = r.bottom + 8;
    fmtBar.style.top = Math.max(8, Math.min(window.innerHeight - h - 8, top)) + "px";
    fmtBar.style.left = Math.max(8, Math.min(window.innerWidth - w - 8, r.left)) + "px";
    updateFmtState();
  }
  function updateFmtState(){
    ["bold","italic","underline","strikeThrough","insertUnorderedList","insertOrderedList"].forEach(function(cmd){
      var b = fmtBar.querySelector('[data-fmt="' + cmd + '"]'); if(!b) return;
      var on = false; try{ on = document.queryCommandState(cmd); }catch(e){}
      b.classList.toggle("on", on);
    });
    var li = selNode(); li = li && li.closest && li.closest("ul.todo");
    fmtBar.querySelector("[data-todo]").classList.toggle("on", !!li);
    var a = selNode(); a = a && a.closest && a.closest(".pb-text a[href]");
    var op = fmtBar.querySelector(".fmt-open"); op.hidden = !a; if(a) op.href = a.getAttribute("href");
  }
  function selNode(){
    var sel = window.getSelection(); if(!sel.rangeCount) return null;
    var n = sel.getRangeAt(0).startContainer; return n.nodeType === 3 ? n.parentNode : n;
  }
  function saveRange(){ var sel = window.getSelection(); fmtRange = sel.rangeCount ? sel.getRangeAt(0).cloneRange() : null; }
  function restoreRange(){ var tx = fmtText(); if(!tx) return; tx.focus(); if(fmtRange){ var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(fmtRange); } }
  function afterFmt(){
    var tx = fmtText(); if(!tx) return;
    /* a list made from a line sits inside that line's <div>: lift it out */
    Array.from(tx.children).forEach(function(d){ if(d.nodeName === "DIV" && d.children.length === 1 && /^(UL|OL)$/.test(d.firstElementChild.nodeName) && !d.textContent.replace(d.firstElementChild.textContent, "").trim()) d.replaceWith(d.firstElementChild); });
    tx.dispatchEvent(new Event("input", {bubbles:true}));
    updateFmtState();
  }
  /* colours are applied with marker colours, then turned into theme classes */
  function fixMarkers(tx){
    tx.querySelectorAll("[style], font[color]").forEach(function(el){
      var cls = rtColorClass(el);
      var st = el.getAttribute("style") || "";
      var cleared = /background(?:-color)?:\s*(transparent|rgba\(0,\s*0,\s*0,\s*0\))/i.test(st);
      var plain = el.nodeName === "SPAN" || el.nodeName === "FONT";
      if(!cls){
        if(plain && (cleared || /color/i.test(st))) el.replaceWith.apply(el, Array.from(el.childNodes));
        else el.removeAttribute("style");
        return;
      }
      /* the colour was put on a <b>, <i>… or a span: keep the element, move the colour into a class wrapper */
      var wrap = document.createElement(/hl-/.test(cls) && !/fc-/.test(cls) ? "mark" : "span");
      wrap.className = cls;
      if(plain){ while(el.firstChild) wrap.appendChild(el.firstChild); el.replaceWith(wrap); }
      else { el.removeAttribute("style"); while(el.firstChild) wrap.appendChild(el.firstChild); el.appendChild(wrap); }
    });
  }
  function execFmt(cmd, val){
    try{ document.execCommand("styleWithCSS", false, cmd === "foreColor" || cmd === "hiliteColor"); }catch(e){}
    try{ document.execCommand(cmd, false, val == null ? null : val); }catch(e){}
    if(cmd === "foreColor" || cmd === "hiliteColor"){ var tx = fmtText(); if(tx) fixMarkers(tx); }
    afterFmt();
  }
  function setHighlight(n){
    if(n === "0"){ execFmt("hiliteColor", "transparent"); var tx = fmtText(); if(tx){ var sel = window.getSelection(); tx.querySelectorAll("mark").forEach(function(m){ if(sel.containsNode(m, true)) m.replaceWith.apply(m, Array.from(m.childNodes)); }); afterFmt(); } return; }
    execFmt("hiliteColor", "rgb(2,2," + n + ")");
  }
  function setColor(n){
    if(n === "0"){ var tx = fmtText(); if(tx){ var sel = window.getSelection(); tx.querySelectorAll("span[class*='fc-']").forEach(function(m){ if(sel.containsNode(m, true)) m.replaceWith.apply(m, Array.from(m.childNodes)); }); afterFmt(); } return; }
    execFmt("foreColor", "rgb(1,1," + n + ")");
  }
  /* size is set the same way as colour: a marker (a legacy <font size>, since execCommand has no arbitrary-size option)
     that's swapped for a real sz-N span right away, so it survives the next cleanHTML pass like fc-/hl- classes do */
  function setSize(n){
    var tx = fmtText(); if(!tx) return;
    if(n === "0"){ var sel = window.getSelection(); tx.querySelectorAll("span[class*='sz-']").forEach(function(m){ if(sel.containsNode(m, true)) m.replaceWith.apply(m, Array.from(m.childNodes)); }); afterFmt(); return; }
    try{ document.execCommand("styleWithCSS", false, false); }catch(e){}
    try{ document.execCommand("fontSize", false, "7"); }catch(e){}
    tx.querySelectorAll("font[size]").forEach(function(el){
      var wrap = document.createElement("span"); wrap.className = "sz-" + n;
      while(el.firstChild) wrap.appendChild(el.firstChild);
      el.replaceWith(wrap);
    });
    afterFmt();
  }
  function toggleTodo(){
    var tx = fmtText(); if(!tx) return;
    var n = selNode(), list = n && n.closest && n.closest("ul, ol");
    if(list && tx.contains(list)){
      if(list.classList.contains("todo")){ list.classList.remove("todo"); if(!list.className) list.removeAttribute("class"); }
      else if(list.nodeName === "UL") list.className = "todo";
      else { var ul = document.createElement("ul"); ul.className = "todo"; while(list.firstChild) ul.appendChild(list.firstChild); list.replaceWith(ul); }
      afterFmt(); return;
    }
    /* turn just this line into a new to-do list (never merge into a list next to it) */
    var line = n && n.closest && n.closest("div:not(.pb-text), h1, h2, blockquote");
    if(!line || !tx.contains(line)){ var lb = lineBefore(tx); line = lb && lb.line; }
    if(!line || line === tx) return;
    var ul2 = document.createElement("ul"), li = document.createElement("li");
    ul2.className = "todo";
    while(line.firstChild) li.appendChild(line.firstChild);
    if(!li.textContent) li.innerHTML = "<br>";
    ul2.appendChild(li); line.replaceWith(ul2);
    var r = document.createRange(); r.selectNodeContents(li); r.collapse(!li.textContent);
    var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
    afterFmt();
  }
  function setBlock(tag){
    var n = selNode(), cur = n && n.closest && n.closest("h1, h2");
    try{ document.execCommand("formatBlock", false, "<" + (cur && cur.nodeName.toLowerCase() === tag ? "div" : tag) + ">"); }catch(e){}
    afterFmt();
  }
  function showPop(kind){
    var pop = fmtBar.querySelector(".fmt-pop");
    var list = kind === "hl" ? HL_COLORS : kind === "sz" ? SZ_SIZES : FMT_COLORS;
    var prefix = kind === "hl" ? "hl-" : kind === "sz" ? "sz-" : "fc-";
    var glyph = kind === "hl" ? "ab" : "A";
    var resetLabel = kind === "hl" ? "No highlight" : kind === "sz" ? "Normal size" : "Default colour";
    pop.innerHTML = list.map(function(c){ return '<button type="button" class="' + prefix + c[0] + '" data-' + kind + '="' + c[0] + '" title="' + c[1] + '">' + glyph + '</button>'; }).join("") +
      '<button type="button" data-' + kind + '="0" title="' + resetLabel + '">✕</button>';
    pop.hidden = !pop.hidden || pop.dataset.kind !== kind ? false : true;
    pop.dataset.kind = kind;
  }
  function openLinkForm(){
    saveRange();
    var f = fmtBar.querySelector(".fmt-link"), inp = f.querySelector("input");
    var a = selNode(); a = a && a.closest && a.closest("a");
    inp.value = a ? a.getAttribute("href") : "https://";
    f.hidden = false; inp.focus(); inp.select();
  }
  fmtBar.addEventListener("mousedown", function(e){ if(!e.target.closest(".fmt-link input")) e.preventDefault(); });
  fmtBar.addEventListener("click", function(e){
    var b = e.target.closest("button"); if(!b) return;
    var d = b.dataset;
    if(d.fmt) execFmt(d.fmt);
    else if(d.block) setBlock(d.block);
    else if(d.todo) toggleTodo();
    else if(d.fmtpop) showPop(d.fmtpop);
    else if(d.hl){ setHighlight(d.hl); fmtBar.querySelector(".fmt-pop").hidden = true; }
    else if(d.fc){ setColor(d.fc); fmtBar.querySelector(".fmt-pop").hidden = true; }
    else if(d.sz){ setSize(d.sz); fmtBar.querySelector(".fmt-pop").hidden = true; }
    else if(d.linkbtn) openLinkForm();
    else if(d.unlink){ fmtBar.querySelector(".fmt-link").hidden = true; restoreRange(); execFmt("unlink"); }
  });
  fmtBar.querySelector(".fmt-link").addEventListener("submit", function(e){
    e.preventDefault();
    var url = e.target.querySelector("input").value.trim();
    e.target.hidden = true;
    restoreRange();
    if(/^www\./i.test(url)) url = "https://" + url;
    if(!/^(https?:\/\/[^\s]+|mailto:[^\s]+)$/i.test(url)){ toast("That doesn't look like a web address."); return; }
    var sel = window.getSelection();
    if(sel.isCollapsed){ try{ document.execCommand("insertHTML", false, '<a href="' + esc(url) + '">' + esc(url) + '</a>'); }catch(err){} afterFmt(); }
    else execFmt("createLink", url);
  });
  fmtBar.querySelector(".fmt-link input").addEventListener("keydown", function(e){ if(e.key === "Escape"){ e.preventDefault(); e.stopPropagation(); e.target.form.hidden = true; restoreRange(); } });
  document.addEventListener("focusin", function(e){
    var tx = e.target.closest && e.target.closest(".pb-text");
    if(tx){ fmtFor = tx; placeFmtBar(); return; }
    if(!fmtBar.contains(e.target)){ fmtFor = null; fmtBar.hidden = true; }
  });
  /* clicking away to a non-focusable spot (e.g. blank page, a heading) reverts focus to <body>
     without firing focusin, so the toolbar would otherwise be left floating; catch that here */
  document.addEventListener("focusout", function(e){
    if(!(e.target.closest && e.target.closest(".pb-text"))) return;
    var to = e.relatedTarget;
    if(!to || (!fmtBar.contains(to) && !(to.closest && to.closest(".pb-text")))){ fmtFor = null; fmtBar.hidden = true; }
  });
  document.addEventListener("selectionchange", function(){ if(fmtText() && !fmtBar.hidden) updateFmtState(); });
  detailHost.addEventListener("scroll", function(){ if(fmtText()) placeFmtBar(); }, true);
  window.addEventListener("resize", function(){ if(fmtText()) placeFmtBar(); });
  detailHost.addEventListener("input", function(e){ if(e.target.closest && e.target.closest(".pb-text") && fmtText()) placeFmtBar(); });

  /* markdown-style starts: "- " "* " bullets, "1. " numbers, "[] " to-do, "# " / "## " headings, "> " quote */
  function lineBefore(tx){
    var sel = window.getSelection(); if(!sel.rangeCount || !sel.isCollapsed) return null;
    var r = sel.getRangeAt(0), n = r.startContainer.nodeType === 3 ? r.startContainer.parentNode : r.startContainer;
    var line = n.closest("div:not(.pb-text), li, h1, h2, blockquote");
    if(!line || !tx.contains(line) || line === tx){
      /* text typed straight into the box: wrap its line in a <div> so block formats apply to that line only */
      var sc = r.startContainer, so = r.startOffset;
      var d = document.createElement("div"), m = tx.firstChild;
      var isBlock = function(x){ return x.nodeType === 1 && /^(DIV|UL|OL|H1|H2|BLOCKQUOTE)$/.test(x.nodeName); };
      if(sc === tx) return null;
      while(m && !isBlock(m)){ var nx = m.nextSibling; d.appendChild(m); m = nx; }
      tx.insertBefore(d, tx.firstChild);
      if(!d.contains(sc)) return null;
      var back = document.createRange(); back.setStart(sc, so); back.collapse(true); sel.removeAllRanges(); sel.addRange(back);
      r = back; line = d;
    }
    var pre = document.createRange(); pre.setStart(line, 0); pre.setEnd(r.startContainer, r.startOffset);
    return {text:pre.toString(), range:pre, line:line};
  }
  detailHost.addEventListener("keydown", function(e){
    var tx = e.target.closest && e.target.closest(".pb-text"); if(!tx || S.readOnly) return;
    var mod = e.ctrlKey || e.metaKey;
    if(mod && !e.shiftKey && e.key === "1"){ e.preventDefault(); toggleTodo(); return; }
    if(mod && e.shiftKey && (e.key === "H" || e.key === "h")){ e.preventDefault(); setHighlight("1"); return; }
    if(mod && (e.key === "k" || e.key === "K")){ e.preventDefault(); openLinkForm(); return; }
    if(mod && e.shiftKey && (e.key === "X" || e.key === "x")){ e.preventDefault(); execFmt("strikeThrough"); return; }
    if(e.key === "Tab"){
      e.preventDefault();
      var inList = selNode() && selNode().closest("li");
      if(inList) execFmt(e.shiftKey ? "outdent" : "indent");
      else if(!e.shiftKey){ try{ document.execCommand("insertText", false, "\t"); }catch(err){} }
      return;
    }
    if(e.key === " " && !mod){
      var lb = lineBefore(tx); if(!lb) return;
      var t = lb.text, act = t === "-" || t === "*" ? "ul" : /^1[.)]$/.test(t) ? "ol" : /^\[ ?\]$/.test(t) ? "todo" : t === "#" ? "h1" : t === "##" ? "h2" : t === ">" ? "quote" : "";
      if(!act) return;
      e.preventDefault();
      lb.range.deleteContents();
      var s0 = window.getSelection(); s0.removeAllRanges(); s0.addRange(lb.range);
      if(!lb.line.textContent && !lb.line.querySelector("br")) lb.line.appendChild(document.createElement("br"));
      if(act === "ul") execFmt("insertUnorderedList");
      else if(act === "ol") execFmt("insertOrderedList");
      else if(act === "todo") toggleTodo();
      else if(act === "quote"){ try{ document.execCommand("formatBlock", false, "<blockquote>"); }catch(err){} afterFmt(); }
      else setBlock(act);
    }
  });
  /* tick a to-do: click its box */
  detailHost.addEventListener("click", function(e){
    var li = e.target.closest && e.target.closest("ul.todo > li"); if(!li) return;
    var r = li.getBoundingClientRect();
    if(e.clientX > r.left + 4) return;
    if(S.readOnly) return;
    e.preventDefault();
    if(li.getAttribute("data-done") === "1") li.removeAttribute("data-done"); else li.setAttribute("data-done", "1");
    var tx = li.closest(".pb-text"); if(tx) tx.dispatchEvent(new Event("input", {bubbles:true}));
  }, true);
  /* links inside notes open with Ctrl/⌘+click (a plain click puts the cursor there) */
  detailHost.addEventListener("click", function(e){
    var a = e.target.closest && e.target.closest(".pb-text a[href]"); if(!a) return;
    if(S.readOnly) return;
    if(e.ctrlKey || e.metaKey){ e.preventDefault(); window.open(a.href, "_blank", "noopener"); }
  });
  /* pasted text keeps simple formatting (bold, lists, links…) but nothing else */
  detailHost.addEventListener("paste", function(e){
    var tx = e.target.closest && e.target.closest(".pb-text"); if(!tx || S.readOnly) return;
    var cd = e.clipboardData; if(!cd || (cd.files && cd.files.length)) return;
    var html = cd.getData("text/html"), text = cd.getData("text/plain");
    if(!html && !text) return;
    e.preventDefault();
    try{
      if(html) document.execCommand("insertHTML", false, cleanHTML(html.replace(/<!--[\s\S]*?-->/g, "")));
      else document.execCommand("insertText", false, text);
    }catch(err){}
  });
  detailHost.addEventListener("input", function(e){
    var t = e.target, key = t.dataset && t.dataset.f;
    if(!key || !S.open) return;
    var c = curCard(); if(!c || S.readOnly) return;
    var v = t.value;
    if(t.tagName === "SELECT" && (key === "status" || key.indexOf("f.") === 0)){
      var was = key === "status" ? c.status : (c.f[key.slice(2)] || "");
      if(was !== v) logHist(c, fieldLabel(c, key) + ": " + fieldShow(c, key, was) + " → " + fieldShow(c, key, v));
    }
    if(key.indexOf("f.") === 0){ var k = key.slice(2); if(v) c.f[k] = v.slice(0, 5000); else delete c.f[k]; }
    else if(key === "title") c.title = v.slice(0, 160);
    else if(key === "subtitle") c.subtitle = v.slice(0, 200);
    else if(key === "status"){
      c.status = v;
      if(CLOSED[v]){
        var roll = rollCard(c);
        if(roll){
          touch(c.id);
          if(roll.rolled) toast("Done — next one is " + fmtDate(roll.next, true) + ".");
          rebuildDetail();
          return;
        }
      }
    }
    else if(key === "notes") c.notes = v.slice(0, 20000);
    else if(key === "folder"){
      var was = c.folder; c.folder = v && folderById(v) ? v : "";
      if(was !== c.folder) logHist(c, c.folder ? "Moved to " + folderPath(c.folder) : "Taken out of its folder");
    }
    else if(key === "type"){
      if(v === c.type) return;
      var oldT = td(c.type).label;
      c.type = v;
      if(td(v).statuses.indexOf(c.status) < 0) c.status = td(v).statuses[0];
      logHist(c, "Type: " + oldT + " → " + td(v).label);
      touch(c.id); rebuildDetail();
      return;
    }
    else if(key === "rpt.every"){
      c.rpt = v ? {every:v, until:(c.rpt && c.rpt.until) || "", times:(c.rpt && c.rpt.times) || 0, n:(c.rpt && c.rpt.n) || 0} : null;
      logHist(c, c.rpt ? "Repeat: " + v : "Repeat turned off");
      touch(c.id); rebuildDetail();
      return;
    }
    else if(key === "rpt.until"){ c.rpt = c.rpt || {every:"", until:"", times:0, n:0}; c.rpt.until = validDate(v) ? v : ""; }
    else if(key === "rpt.times"){ c.rpt = c.rpt || {every:"", until:"", times:0, n:0}; c.rpt.times = Math.max(0, Math.min(999, Math.round(+v) || 0)); }
    touch(c.id);
    renderUpdated(c);
  });
  detailHost.addEventListener("input", function(e){ if(e.target.id === "d-relq"){ relSel = 0; renderRelPop(); } });
  detailHost.addEventListener("change", function(e){
    var sid = e.target.dataset && e.target.dataset.sessfile; if(!sid) return;
    var files = Array.from(e.target.files || []); e.target.value = "";
    var host = detailHost.querySelector('[data-sesspage="' + sid + '"]'), ctx = host && pageCtx(host.firstChild);
    if(ctx && files.length) addImagesToPage(ctx, files, nextSpot(ctx));
  });
  /* paste screenshots straight into meeting notes or a card's notes */
  detailHost.addEventListener("paste", function(e){
    if(!S.open || S.readOnly || !canUpload()) return;
    var items = Array.from((e.clipboardData && e.clipboardData.files) || []).filter(function(f){ return /^image\//.test(f.type); });
    if(!items.length) return;
    var sessEl = e.target.closest && e.target.closest("[data-sess]");
    e.preventDefault();
    var named = items.map(function(f, i){ return new File([f], "Screenshot " + new Date().toLocaleString(undefined, {day:"numeric", month:"short", hour:"2-digit", minute:"2-digit"}) + (items.length > 1 ? " (" + (i + 1) + ")" : "") + "." + (f.type.split("/")[1] || "png"), {type:f.type}); });
    addFiles(named, sessEl ? sessEl.dataset.sess : null);
  });
  detailHost.addEventListener("click", function(e){
    var b = e.target.closest && e.target.closest("[data-remind]"); if(!b) return;
    var c = curCard(); if(!c || S.readOnly) return;
    e.stopPropagation();
    var k = b.dataset.remind, when = "";
    if(k === "later") when = laterStamp(3);
    else if(k === "tomorrow") when = addDays(today(), 1) + "T09:00";
    else if(k === "monday") when = nextMonday(today()) + "T09:00";
    else if(k === "custom"){ var v = ($("d-remindat") || {}).value || ""; if(!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(v)){ toast("Pick a date and time first."); return; } when = v.slice(0, 16); }
    if(k !== "clear") askNotify();
    setRemind(c, when);
    if(k !== "clear" && !remindDue(c)) toast("I'll remind you " + fmtRemind(when).replace(/^(\w)/, function(m){ return m.toLowerCase(); }) + ".");
  });
  detailHost.addEventListener("keydown", function(e){ if(e.target.id === "d-remindat" && e.key === "Enter"){ e.preventDefault(); var s = detailHost.querySelector('[data-remind="custom"]'); if(s) s.click(); } });
  var histBefore = null;
  detailHost.addEventListener("focusin", function(e){
    var key = e.target.dataset && e.target.dataset.f, c = curCard();
    if(!key || !c || key === "folder" || key === "type") return;
    histBefore = {key:key, id:c.id, val:key === "notes" ? c.notes : key.indexOf("f.") === 0 ? (c.f[key.slice(2)] || "") : (c[key] || "")};
  });
  detailHost.addEventListener("change", function(e){
    var key = e.target.dataset && e.target.dataset.f, c = curCard();
    if(e.target.dataset && e.target.dataset.chk){
      var item = c && c.check.filter(function(x){ return x.id === e.target.dataset.chk; })[0];
      if(item){ item.done = e.target.checked; logHist(c, (item.done ? "Ticked: " : "Unticked: ") + item.t); syncProgress(c); touch(c.id); renderCheck(c); }
      return;
    }
    if(!key || !c || e.target.tagName === "SELECT" || !histBefore || histBefore.id !== c.id || histBefore.key !== key) return;
    var now = key === "notes" ? c.notes : key.indexOf("f.") === 0 ? (c.f[key.slice(2)] || "") : (c[key] || "");
    if(now !== histBefore.val){
      logHist(c, key === "notes" ? "Edited notes" : key === "title" ? "Renamed from “" + histBefore.val + "”" : fieldLabel(c, key) + ": " + fieldShow(c, key, histBefore.val) + " → " + fieldShow(c, key, now));
      touch(c.id);
    }
    histBefore = {key:key, id:c.id, val:now};
  });
  detailHost.addEventListener("focusin", function(e){ if(e.target.id === "d-relq") renderRelPop(); });
  detailHost.addEventListener("focusout", function(e){ if(e.target.id === "d-relq") setTimeout(function(){ var p = $("d-relpop"); if(p && document.activeElement !== $("d-relq")) p.hidden = true; }, 150); });
  detailHost.addEventListener("mousedown", function(e){ if(e.target.closest("#d-relpop")) e.preventDefault(); });
  detailHost.addEventListener("change", function(e){
    if(e.target.id === "d-filein"){ addFiles(Array.from(e.target.files || [])); e.target.value = ""; }
    else if(e.target.tagName === "SELECT" && e.target.dataset.f){ e.target.dispatchEvent(new Event("input", {bubbles:true})); }
  });
  detailHost.addEventListener("focusout", function(e){
    if(e.target.id === "d-title" && !e.target.value.trim()){ var c = curCard(); if(c){ c.title = "Untitled " + td(c.type).label.toLowerCase(); e.target.value = c.title; touch(c.id); } }
  });
  detailHost.addEventListener("keydown", function(e){
    if(e.target.id === "d-relq"){
      var items = $("d-relpop") ? $("d-relpop").querySelectorAll("[data-addrel]") : [];
      if(e.key === "ArrowDown" || e.key === "ArrowUp"){ e.preventDefault(); relSel = Math.max(0, Math.min(items.length - 1, relSel + (e.key === "ArrowDown" ? 1 : -1))); renderRelPop(); }
      else if(e.key === "Enter"){ e.preventDefault(); if(items[relSel]) items[relSel].click(); }
      else if(e.key === "Escape"){ var pop = $("d-relpop"); if(e.target.value || (pop && !pop.hidden)){ e.stopPropagation(); e.target.value = ""; renderRelPop(); } else e.target.blur(); }
      return;
    }
    if(e.target.id === "d-checkin" && e.key === "Enter"){
      e.preventDefault();
      var txt = e.target.value.trim().slice(0, 300), cc = curCard();
      if(txt && cc && cc.check.length < 150){ cc.check.push({id:uid(), t:txt, done:false}); logHist(cc, "Added to checklist: " + txt); syncProgress(cc); touch(cc.id); renderCheck(cc); e.target.value = ""; }
      return;
    }
    if(e.target.id === "d-tagin" && (e.key === "Enter" || e.key === ",")){
      e.preventDefault();
      var v = e.target.value.toLowerCase().replace(/^#/, "").replace(/,/g, "").trim().slice(0, 40);
      var c = curCard();
      if(v && c && c.tags.indexOf(v) < 0 && c.tags.length < 20){ c.tags.push(v); touch(c.id); renderTagEdit(c); var inp = $("d-tagin"); if(inp) inp.focus(); }
      else e.target.value = "";
    }
  });
  detailHost.addEventListener("submit", function(e){
    if(e.target.id !== "d-linkform") return;
    e.preventDefault();
    var c = curCard(); if(!c) return;
    var url = safeUrl($("d-linkurl").value);
    if(!url){ toast("That address doesn't look like a web link. Use something like https://example.com."); return; }
    c.links.push({label:$("d-linklabel").value.trim().slice(0, 120), url:url});
    logHist(c, "Added web link: " + ($("d-linklabel").value.trim() || url));
    touch(c.id); renderLinks(c);
    $("d-linkurl").value = ""; $("d-linklabel").value = ""; $("d-linklabel").focus();
  });
  detailHost.addEventListener("click", function(e){
    var t = e.target, c = curCard();
    if(!c || !S.open) return;
    var b;
    if((b = t.closest("[data-trail='back']"))){ goBack(); return; }
    if((b = t.closest("[data-setgo]"))){ jumpTo(b.dataset.setgo, true); return; }
    if((b = t.closest("[data-alltpl]"))){ openTemplates(); return; }
    if((b = t.closest("[data-setall]"))){ S.open = false; S.nav = "t:" + b.dataset.setall; setQuery(""); refresh(); return; }
    if((b = t.closest("[data-style]"))){ openStyle(b.dataset.style); return; }
    if((b = t.closest("[data-addsess]"))){ var sx = ensureSess(c, sessDefaultDate(c)); renderSess(c); focusPage(c, sx.id); return; }
    if((b = t.closest("[data-rmsess]"))){ if(armed(b, "Delete these notes?")){ var ix0 = c.sess.findIndex(function(x){ return x.id === b.dataset.rmsess; }); if(ix0 >= 0){ var gone0 = c.sess.splice(ix0, 1)[0]; logHist(c, "Deleted notes for " + fmtDate(gone0.date)); touch(c.id); renderSess(c);
      var undone0 = false, cid0 = c.id;
      toast("Deleted the notes for " + fmtDate(gone0.date, true) + ".", {label:"Undo", fn:function(){ var cc = cardOf(cid0); if(!cc) return; undone0 = true; cc.sess.push(gone0); logHist(cc, "Restored notes for " + fmtDate(gone0.date)); touch(cid0); if(S.open && S.curId === cid0) renderSess(cc); }});
      setTimeout(function(){ if(!undone0) dropFiles(cardFileIds({files:[], page:null, sess:[gone0]})); }, 9000); } } return; }
    if((b = t.closest("[data-srmfile]"))){ if(armed(b, "Remove?")){ var pr0 = b.dataset.srmfile.split(":"), ss0 = c.sess.filter(function(x){ return x.id === pr0[0]; })[0]; if(ss0){ var gf = ss0.files.splice(+pr0[1], 1)[0]; if(gf && gf.id) dropFiles([gf.id]); touch(c.id); renderSess(c); } } return; }
    if((b = t.closest("[data-szoom]"))){ var pz = b.dataset.szoom.split(":"), sz = c.sess.filter(function(x){ return x.id === pz[0]; })[0], fz = sz && sz.files[+pz[1]]; if(fz){ $("lightboxImg").src = fileSrc(fz); $("lightbox").hidden = false; } return; }
    if((b = t.closest("[data-chkdel]"))){ var ix = c.check.findIndex(function(x){ return x.id === b.dataset.chkdel; }); if(ix >= 0){ logHist(c, "Removed from checklist: " + c.check[ix].t); c.check.splice(ix, 1); syncProgress(c); touch(c.id); renderCheck(c); } }
    else if((b = t.closest("[data-histall]"))){ histAll = true; renderHist(c); }
    else if((b = t.closest("[data-addrel]"))){ setRel(c.id, b.dataset.addrel, true); var q = $("d-relq"); if(q){ q.value = ""; q.focus(); } renderRelPop(); }
    else if((b = t.closest("[data-unrel]"))){ setRel(c.id, b.dataset.unrel, false); }
    else if((b = t.closest("[data-goto]"))){ jumpTo(b.dataset.goto, true); }
    else if((b = t.closest("[data-rmtag]"))){ c.tags.splice(+b.dataset.rmtag, 1); touch(c.id); renderTagEdit(c); }
    else if((b = t.closest("[data-rmlink]"))){ if(armed(b, "Remove?")){ var gone = c.links.splice(+b.dataset.rmlink, 1)[0]; if(gone) logHist(c, "Removed web link: " + (gone.label || gone.url)); touch(c.id); renderLinks(c); } }
    else if((b = t.closest("[data-bwfind]"))){
      var vaultHit = c.links.map(function(l){ return {l:l, v:vaultLink(l.url)}; }).filter(function(x){ return x.v; })[0];
      copyText(c.title);
      window.open(vaultHit ? vaultHit.l.url : "https://vault.bitwarden.com/#/vault", "_blank", "noopener");
      toast("Copied “" + c.title + "”. Paste it into Bitwarden’s search.");
    }
    else if((b = t.closest("[data-rmfile]"))){
      if(armed(b, "Remove?")){
        var x = c.files.splice(+b.dataset.rmfile, 1)[0];
        if(x) logHist(c, "Removed file: " + (x.name || "file"));
        touch(c.id); renderFiles(c);
        if(x && x.id) dropFiles([x.id]);
      }
    }
    else if((b = t.closest("[data-zoom]"))){ var f = c.files[+b.dataset.zoom]; if(f){ $("lightboxImg").src = fileSrc(f); $("lightboxImg").alt = f.name || ""; $("lightbox").hidden = false; } }
    else if(t.id === "d-archive"){
      if(c.archived) unarchiveCard(c); else archiveCard(c);
    }
    else if(t.id === "d-dup") duplicateCard(c);
    else if(t.id === "d-savetpl") saveAsTemplate(c);
    else if(t.id === "d-usetpl") createFromTemplate(c.id);
    else if(t.id === "d-delete"){
      if(armed(t, "Click again to delete")) deleteCard(c);
    }
  });
  ["dragover", "dragenter"].forEach(function(ev){
    detailHost.addEventListener(ev, function(e){ var sec = e.target.closest && e.target.closest("#d-filesec"); if(sec && canUpload()){ e.preventDefault(); sec.classList.add("drop-on"); } });
  });
  detailHost.addEventListener("dragleave", function(e){ var sec = e.target.closest && e.target.closest("#d-filesec"); if(sec) sec.classList.remove("drop-on"); });
  detailHost.addEventListener("dragover", function(e){ var se = e.target.closest && e.target.closest("[data-sess]"); if(se && canUpload()){ e.preventDefault(); se.classList.add("drop-on"); } });
  detailHost.addEventListener("dragleave", function(e){ var se = e.target.closest && e.target.closest("[data-sess]"); if(se && !se.contains(e.relatedTarget)) se.classList.remove("drop-on"); });
  detailHost.addEventListener("drop", function(e){
    var se = e.target.closest && e.target.closest("[data-sess]");
    if(se){ e.preventDefault(); se.classList.remove("drop-on"); if(canUpload()) addFiles(Array.from(e.dataTransfer.files || []), se.dataset.sess); return; }
    var sec = e.target.closest && e.target.closest("#d-filesec");
    if(!sec) return;
    e.preventDefault(); sec.classList.remove("drop-on");
    if(canUpload()) addFiles(Array.from(e.dataTransfer.files || []));
  });

  function addFiles(files, sessId){
    var c = curCard(); if(!c || !files.length) return;
    if(sessId){
      /* meeting pages place images on the page itself */
      var host = detailHost.querySelector('[data-sesspage="' + sessId + '"]'), pctx = host && pageCtx(host.firstChild);
      if(pctx) addImagesToPage(pctx, files, nextSpot(pctx));
      return;
    }
    var ok = /^(image\/(png|jpeg|gif|webp)|application\/pdf)$/;
    files = files.filter(function(f){ return ok.test(f.type); });
    if(!files.length){ toast("Only PNG, JPEG, GIF, WebP images and PDFs can be added."); return; }
    var note = $("d-filenote"), done = 0, id = c.id;
    var next = function(){
      if(done >= files.length){ if(note && S.curId === id && !sessId) renderFiles(curCard()); if(sessId) toast(files.length === 1 ? "Screenshot added." : files.length + " files added."); return; }
      var f = files[done];
      if(note && !sessId) note.textContent = "Adding " + (done + 1) + " of " + files.length + "…";
      if(sessId) toast("Adding " + (done + 1) + " of " + files.length + "…");
      var p = S.mode === "online" ? S.assets.upload(f).then(function(r){ return {id:r.id, name:f.name, type:r.contentType}; })
                                 : localFile(f);
      p.then(function(rec){
        var card = S.cards.get(id);
        if(card && rec && sessId){
          var ss = card.sess.filter(function(x){ return x.id === sessId; })[0];
          if(ss){ ss.files.push(rec); logHist(card, "Added screenshot to " + fmtDate(ss.date) + " notes"); touch(id); if(S.curId === id) renderSess(card); }
        }
        else if(card && rec){ card.files.push(rec); logHist(card, (isImage(rec) ? "Added image: " : "Added file: ") + (rec.name || "file")); touch(id); if(S.curId === id) renderFiles(card); }
      }, function(err){
        var code = err && err.code;
        toast(code === "too_large" ? f.name + " is over 20 MB, so it wasn't added."
          : code === "quota_or_state" ? "This workspace's file storage is full. Remove some files first."
          : code === "unsupported_type" ? f.name + " isn't a supported file type."
          : (err && err.message) || ("Couldn't add " + f.name + ". Try again."));
      }).then(function(){ done++; next(); });
    };
    next();
  }
  function localFile(f){
    return new Promise(function(resolve, reject){
      var r = new FileReader();
      r.onload = function(){ resolve({data:r.result, name:f.name, type:f.type}); };
      r.onerror = function(){ reject({message:"Couldn't read " + f.name + "."}); };
      r.readAsDataURL(f);
    });
  }
  /* upload a list of files one by one; resolves with the stored file records (failures are reported and skipped) */
  function uploadFiles(files){
    var ok = /^(image\/(png|jpeg|gif|webp)|application\/pdf)$/;
    files = files.filter(function(f){ return ok.test(f.type); });
    if(!files.length){ toast("Only PNG, JPEG, GIF, WebP images and PDFs can be added."); return Promise.resolve([]); }
    var out = [];
    return files.reduce(function(p, f, i){
      return p.then(function(){
        if(files.length > 1) toast("Adding " + (i + 1) + " of " + files.length + "…");
        var up = S.mode === "online" ? S.assets.upload(f).then(function(r){ return {id:r.id, name:f.name, type:r.contentType}; }) : localFile(f);
        return up.then(function(rec){ out.push(rec); }, function(err){
          var code = err && err.code;
          toast(code === "too_large" ? f.name + " is over 20 MB, so it wasn't added."
            : code === "quota_or_state" ? "This workspace's file storage is full. Remove some files first."
            : code === "unsupported_type" ? f.name + " isn't a supported file type."
            : (err && err.message) || ("Couldn't add " + f.name + ". Try again."));
        });
      });
    }, Promise.resolve()).then(function(){ return out; });
  }

  /* ================= notes pages: place text and screenshots anywhere, like a OneNote page ================= */
  function pageText(blocks){
    return blocks.filter(function(b){ return b.k === "t" && b.t.trim(); }).sort(function(a, b){ return a.y - b.y || a.x - b.x; }).map(function(b){ return b.t.trim(); }).join("\n\n");
  }
  function blocksFrom(text, files){
    var out = [], y = 16;
    if(text && text.trim()){ out.push({id:uid(), k:"t", x:16, y:16, w:620, t:text}); y = 16 + Math.max(1, text.split("\n").length + Math.floor(text.length / 80)) * 23 + 40; }
    (files || []).forEach(function(f, i){ out.push({id:uid(), k:"i", x:16 + (i % 3) * 262, y:y + Math.floor(i / 3) * 210, w:246, f:f}); });
    return out;
  }
  /* the blocks behind a page element: the card's own page, or one meeting date's page */
  function pageBlocks(c, sid, create){
    if(sid){
      var ss = c.sess.filter(function(x){ return x.id === sid; })[0]; if(!ss) return null;
      if(!ss.blocks){ if(!create) return blocksFrom(ss.text, ss.files); ss.blocks = blocksFrom(ss.text, ss.files); }
      return ss.blocks;
    }
    if(!c.page){ if(!create) return blocksFrom(c.notes, []); c.page = blocksFrom(c.notes, []); }
    return c.page;
  }
  /* keep the plain-text copies (search, Ask, card face) in step with the page */
  function pageChanged(c, sid, hist){
    if(sid){
      var ss = c.sess.filter(function(x){ return x.id === sid; })[0];
      if(ss && ss.blocks){ ss.text = pageText(ss.blocks); ss.files = ss.blocks.filter(function(b){ return b.k === "i"; }).map(function(b){ return b.f; }); }
    } else if(c.page) c.notes = pageText(c.page);
    if(hist) logHist(c, hist);
    touch(c.id);
  }
  function blockHTML(b){
    var ro = S.readOnly;
    var tools = ro ? "" : '<span class="pb-grip" title="Drag to move" aria-hidden="true"></span><button type="button" class="pb-x" data-pbdel="' + esc(b.id) + '" aria-label="Remove">✕</button><span class="pb-rs" title="Drag to resize" aria-hidden="true"></span>';
    var style = 'left:' + b.x + 'px; top:' + b.y + 'px; width:' + b.w + 'px';
    if(b.k === "t") return '<div class="pb pb-t" data-b="' + esc(b.id) + '" style="' + style + '">' + tools + '<div class="pb-text rt"' + (ro ? "" : ' contenteditable="true"') + ' spellcheck="true">' + (b.h ? cleanHTML(b.h) : plainLines(b.t)) + '</div></div>';
    var f = b.f;
    var inner = isImage(f) ? '<img src="' + esc(fileSrc(f)) + '" alt="' + esc(f.name || "Image") + '" draggable="false" loading="lazy">'
      : '<a class="doc" href="' + esc(fileSrc(f)) + '" target="_blank" rel="noopener"><span><b>PDF</b>' + esc(f.name || "Document") + '</span></a>';
    return '<div class="pb pb-i" data-b="' + esc(b.id) + '" style="' + style + '">' + tools + inner + '</div>';
  }
  function plainLines(t){ return String(t || "").split("\n").map(function(l){ return "<div>" + (l ? esc(l) : "<br>") + "</div>"; }).join(""); }
  function renderPage(host, c, sid){
    var blocks = pageBlocks(c, sid, false) || [];
    host.innerHTML = '<div class="page' + (S.readOnly ? " ro" : "") + '" data-page="' + esc(sid || "main") + '" tabindex="-1">' + blocks.map(blockHTML).join("") +
      (blocks.length || S.readOnly ? "" : '<p class="page-hint">Click anywhere to write. Paste or drop screenshots and they stay where you put them. Drag the dotted handle to move things.</p>') + '</div>';
    sizePage(host.firstChild);
    host.querySelectorAll(".pb-i img").forEach(function(img){ img.addEventListener("load", function(){ sizePage(host.firstChild); }); });
  }
  /* on a narrow screen, a page wider than the panel shrinks to fit (transform: scale) instead of scrolling sideways;
     _scale is read back by pagePoint() and the drag handlers so pointer math still lands on the right block */
  var PAGE_SCALE_BP = 700;
  function sizePage(pg){
    if(!pg) return;
    var h = 0, right = 0;
    pg.querySelectorAll(".pb").forEach(function(el){ h = Math.max(h, el.offsetTop + el.offsetHeight); right = Math.max(right, el.offsetLeft + el.offsetWidth); });
    var natH = pg.dataset.page === "main" ? Math.max(380, h + 160) : Math.max(150, h + 70);
    var host = pg.parentNode;
    pg.style.width = ""; pg.style.transform = ""; pg.style.transformOrigin = ""; pg._scale = 1;
    if(host) host.style.height = "";
    var avail = host ? host.clientWidth : 0;
    var scale = 1;
    if(host && window.innerWidth <= PAGE_SCALE_BP && avail && right + 16 > avail) scale = Math.max(.15, avail / (right + 16));
    pg.style.height = natH + "px";
    if(scale < 1){
      pg.style.width = (right + 16) + "px";
      pg.style.transform = "scale(" + scale + ")";
      pg.style.transformOrigin = "0 0";
      pg._scale = scale;
      // use the real rendered height (respects .page's CSS min-height), not natH alone —
      // otherwise a short session page can be taller than natH*scale and overflow its host,
      // overlapping the next session block below it.
      host.style.height = Math.ceil(pg.offsetHeight * scale) + "px";
    }
  }
  function pageCtx(el){
    var pg = el && el.closest && el.closest(".page"); if(!pg) return null;
    var c = curCard(); if(!c) return null;
    var sid = pg.dataset.page === "main" ? null : pg.dataset.page;
    return {pg:pg, c:c, sid:sid};
  }
  function findBlock(blocks, id){ return blocks.filter(function(b){ return b.id === id; })[0]; }
  function pagePoint(pg, e){
    var r = pg.getBoundingClientRect(), s = pg._scale || 1;
    return {x:Math.max(0, Math.round((e.clientX - r.left) / s + pg.scrollLeft)), y:Math.max(0, Math.round((e.clientY - r.top) / s + pg.scrollTop))};
  }
  /* where the next pasted thing goes: the last place clicked on this page, or under everything */
  var lastPagePoint = {};
  function nextSpot(ctx){
    var key = ctx.c.id + "/" + (ctx.sid || "main");
    if(lastPagePoint[key]){ var p = lastPagePoint[key]; lastPagePoint[key] = {x:p.x + 24, y:p.y + 24}; return p; }
    var h = 0; ctx.pg.querySelectorAll(".pb").forEach(function(el){ h = Math.max(h, el.offsetTop + el.offsetHeight); });
    return {x:16, y:h ? h + 16 : 16};
  }
  function addImagesToPage(ctx, files, at){
    var cid = ctx.c.id, sid = ctx.sid;
    var named = files.map(function(f, i){ return f.name && f.name !== "image.png" ? f : new File([f], "Screenshot " + new Date().toLocaleString(undefined, {day:"numeric", month:"short", hour:"2-digit", minute:"2-digit"}) + (files.length > 1 ? " (" + (i + 1) + ")" : "") + "." + (f.type.split("/")[1] || "png"), {type:f.type}); });
    uploadFiles(named).then(function(recs){
      var c = S.cards.get(cid); if(!c || !recs.length) return;
      var blocks = pageBlocks(c, sid, true); if(!blocks) return;
      recs.forEach(function(rec, i){ blocks.push({id:uid(), k:"i", x:at.x + i * 28, y:at.y + i * 28, w:Math.min(520, Math.max(160, (ctx.pg.clientWidth || 800) - at.x - 24)), f:rec}); });
      pageChanged(c, sid, recs.length === 1 ? "Added a screenshot to the notes" : "Added " + recs.length + " images to the notes");
      toast(recs.length === 1 ? "Screenshot added. Drag it anywhere on the page." : recs.length + " images added.");
      if(S.curId === cid) redrawPage(c, sid);
    });
  }
  function redrawPage(c, sid){
    var pg = detailHost.querySelector('.page[data-page="' + (sid || "main") + '"]');
    if(pg) renderPage(pg.parentNode, c, sid);
  }

  /* ---- Trash: deleting only marks the card; it can be restored for 30 days ---- */
  var TRASH_DAYS = 30;
  function deleteCard(c){
    trashCards([c.id]);
    S.open = false;
    toast("Moved “" + c.title + "” to the Trash.", {label:"Undo", fn:function(){ restoreCards([c.id]); }});
    refresh();
  }
  /* ---- Archive: tucked out of every view except an active search, kept forever until unarchived ---- */
  function archiveCard(c){
    c.archived = new Date().toISOString(); logHist(c, "Archived"); touch(c.id);
    S.open = false;
    toast("Archived “" + c.title + "”.", {label:"Undo", fn:function(){ unarchiveCard(c, true); }});
    refresh();
  }
  function unarchiveCard(c, quiet){
    c.archived = ""; logHist(c, "Restored from Archive"); touch(c.id);
    if(!quiet) toast("“" + c.title + "” is no longer archived.");
    refresh();
  }
  function trashCards(ids){
    var now = new Date().toISOString(), n = 0;
    ids.forEach(function(id){
      var c = S.cards.get(id); if(!c) return;
      c.deleted = now; logHist(c, "Moved to the Trash");
      putCard(c); touch(id); n++;
    });
    return n;
  }
  function restoreCards(ids){
    var n = 0;
    ids.forEach(function(id){
      var c = S.trash.get(id); if(!c) return;
      c.deleted = ""; logHist(c, "Restored from the Trash");
      putCard(c); touch(id); n++;
    });
    if(n){ toast(n === 1 ? "Restored “" + S.cards.get(ids[0]).title + "”." : "Restored " + n + " cards."); refresh(); }
    if(modalKind === "trash") renderTrash();
    return n;
  }
  /* permanent: removes the card, its links from other cards, its notes pages and its files */
  function purgeCards(ids){
    var gone = {}, files = [];
    ids.forEach(function(id){
      var c = cardOf(id); if(!c) return;
      gone[id] = 1;
      files = files.concat(cardFileIds(c));
      dropCard(id); S.dirty.add(id); clearTimeout(saveTimers[id]); flush(id);
    });
    dropFiles(files);
    S.cards.forEach(function(o){
      var keep = o.rel.filter(function(r){ return !gone[r]; });
      if(keep.length !== o.rel.length){ o.rel = keep; touch(o.id); }
    });
    if(S.mode === "local") saveLocal();
  }
  function removeCards(ids){ purgeCards(ids); S.open = false; }
  function purgeOldTrash(){
    if(S.readOnly) return;
    var cut = Date.now() - TRASH_DAYS * 864e5;
    var old = Array.from(S.trash.values()).filter(function(c){ var t = Date.parse(c.deleted); return !isNaN(t) && t < cut; }).map(function(c){ return c.id; });
    if(old.length) purgeCards(old);
  }
  function renderTrash(){
    var list = Array.from(S.trash.values()).sort(function(a, b){ return b.deleted.localeCompare(a.deleted); });
    var head = '<div class="modal-head"><h2 id="modalTitle">Trash</h2><button type="button" class="btn small" data-mclose="1">Close</button></div>';
    var body = list.length ? '<p class="d-note" style="margin-top:0">Deleted cards stay here for ' + TRASH_DAYS + ' days, then they and their images are removed for good.</p><div class="trash-list">' + list.map(function(c){
      var left = Math.max(0, TRASH_DAYS - Math.floor((Date.now() - Date.parse(c.deleted)) / 864e5));
      return '<div class="trash-row" style="' + typeVar(c.type) + '"><span class="t-chip">' + esc(td(c.type).label) + '</span><span class="t"><b>' + esc(c.title) + '</b><small>' + (c.template ? "Template · " : "") + 'Deleted ' + esc(ago(c.deleted)) + ' · ' + left + (left === 1 ? " day" : " days") + ' left</small></span>' +
        (S.readOnly ? "" : '<button type="button" class="btn small" data-restore="' + esc(c.id) + '">Restore</button><button type="button" class="btn small danger" data-purge="' + esc(c.id) + '">Delete forever</button>') + '</div>';
    }).join("") + '</div>' : '<p class="d-note" style="margin-top:0">The Trash is empty. Cards you delete wait here for ' + TRASH_DAYS + ' days, so you can bring them back.</p>';
    var foot = list.length && !S.readOnly ? '<button type="button" class="btn" data-restoreall="1">Restore all</button><button type="button" class="btn danger" data-emptytrash="1">Empty the Trash</button>' : "";
    $("modalBox").innerHTML = head + '<div class="modal-body">' + body + '</div>' + (foot ? '<div class="modal-foot">' + foot + '</div>' : "");
  }
  function openTrash(){ openModal("trash"); renderTrash(); }

  /* every file id any card (including trashed-but-not-yet-purged ones) still points to —
     across the Files gallery, the notes canvas, meeting screenshots and meeting canvases */
  /* every uploaded file id one card points to (gallery, notes canvas, meeting screenshots and canvases) */
  function cardFileIds(c){
    var out = [], add = function(f){ if(f && f.id) out.push(f.id); };
    c.files.forEach(add);
    (c.page || []).forEach(function(b){ if(b.k === "i") add(b.f); });
    c.sess.forEach(function(s){ s.files.forEach(add); (s.blocks || []).forEach(function(b){ if(b.k === "i") add(b.f); }); });
    return out;
  }
  /* a duplicate or a card made from a template shares its files with the original, so a file is only
     deleted from storage once no card (live, template or in the Trash) points to it any more */
  function dropFiles(ids){
    if(!S.assets || !ids.length) return;
    var used = referencedFileIds();
    ids.forEach(function(id){ if(id && !used[id]){ used[id] = 1; S.assets.delete(id).catch(function(){}); } });
  }
  function referencedFileIds(){
    var ids = {};
    var add = function(f){ if(f && f.id) ids[f.id] = 1; };
    Array.from(S.cards.values()).concat(Array.from(S.trash.values())).forEach(function(c){
      c.files.forEach(add);
      (c.page || []).forEach(function(b){ if(b.k === "i") add(b.f); });
      c.sess.forEach(function(s){
        s.files.forEach(add);
        (s.blocks || []).forEach(function(b){ if(b.k === "i") add(b.f); });
      });
    });
    return ids;
  }
  function fmtBytes(n){
    if(n < 1024) return n + " B";
    if(n < 1024 * 1024) return Math.round(n / 1024) + " KB";
    var u = n < Math.pow(1024, 3) ? ["MB", 2] : n < Math.pow(1024, 4) ? ["GB", 3] : ["TB", 4];
    return (n / Math.pow(1024, u[1])).toFixed(1).replace(/\.0$/, "") + " " + u[0];
  }
  var cleanupState = null; // null = not scanned yet, {orphans, scanning, done}
  function renderCleanup(){
    var head = '<div class="modal-head"><h2 id="modalTitle">Clean up unused files</h2><button type="button" class="btn small" data-mclose="1">Close</button></div>';
    var body;
    if(!cleanupState || cleanupState.scanning){
      body = '<p class="d-note" style="margin-top:0">Scanning your workspace’s online storage for files no card or note points to any more (e.g. from images removed before this feature existed)…</p>';
    } else if(cleanupState.error){
      body = '<p class="d-note" style="margin-top:0">Couldn’t scan storage: ' + esc(cleanupState.error) + '</p>';
    } else if(!cleanupState.orphans.length){
      body = '<p class="d-note" style="margin-top:0">Nothing to clean up — every file in storage is still used by a card or note.</p>';
    } else {
      var total = cleanupState.orphans.reduce(function(n, f){ return n + (f.size || 0); }, 0);
      body = '<p class="d-note" style="margin-top:0">Found ' + cleanupState.orphans.length + ' unused file' + (cleanupState.orphans.length === 1 ? "" : "s") + ' (' + fmtBytes(total) + ') — uploaded once, but no longer attached to any card or note (usually from an image that was later removed). Deleting them frees storage and can’t be undone.</p>';
    }
    var foot = cleanupState && !cleanupState.scanning && !cleanupState.error && cleanupState.orphans.length
      ? '<button type="button" class="btn danger" data-cleanupdel="1">Delete ' + cleanupState.orphans.length + ' unused file' + (cleanupState.orphans.length === 1 ? "" : "s") + '</button>' : "";
    $("modalBox").innerHTML = head + '<div class="modal-body">' + body + '</div>' + (foot ? '<div class="modal-foot">' + foot + '</div>' : "");
  }
  function scanCleanup(){
    cleanupState = {scanning:true, orphans:[]};
    renderCleanup();
    S.assets.list().then(function(objs){
      var used = referencedFileIds();
      cleanupState = {scanning:false, orphans:objs.filter(function(o){ return !used[o.id]; })};
      if(modalKind === "cleanup") renderCleanup();
    }, function(e){
      cleanupState = {scanning:false, orphans:[], error:(e && e.message) || "unknown error"};
      if(modalKind === "cleanup") renderCleanup();
    });
  }
  function openCleanup(){
    if(S.readOnly || !(S.assets && typeof S.assets.list === "function")) return;
    openModal("cleanup"); cleanupState = null; renderCleanup(); scanCleanup();
  }

  /* ---- Duplicate and templates: a fresh card built from another one ---- */
  /* copies the content (fields, tags, folder, web links, checklist unticked, notes page, files) under new ids;
     never the meeting sessions, history, favourite, links to other cards or import source */
  function copyCard(src, title, template){
    var T = td(src.type), nb = function(b){ var o = JSON.parse(JSON.stringify(b)); o.id = uid(); return o; };
    var c = norm({id:uid(), type:src.type, title:title, subtitle:src.subtitle, status:T.statuses[0], f:JSON.parse(JSON.stringify(src.f)), tags:src.tags.slice(),
      folder:src.folder, home:src.home, links:JSON.parse(JSON.stringify(src.links)), files:JSON.parse(JSON.stringify(src.files)), notes:src.notes,
      check:src.check.map(function(x){ return {id:uid(), t:x.t, done:false}; }), page:src.page ? src.page.map(nb) : null, template:!!template,
      /* a fresh copy of the same repeat schedule, but a brand new count of completions */
      rpt:src.rpt ? {every:src.rpt.every, until:src.rpt.until, times:src.rpt.times, n:0} : null});
    return c;
  }
  function addCopy(c, w){
    logHist(c, w);
    S.cards.set(c.id, c);
    touch(c.id);
    return c;
  }
  function openCopy(c){
    toggleNew(false);
    if(!navMatch(c)) S.nav = c.template ? "templates" : "all";
    setQuery("");
    computeDeck();
    jumpTo(c.id, true);
  }
  function duplicateCard(c){
    if(S.readOnly) return;
    var n = addCopy(copyCard(c, c.title.slice(0, 153) + " (copy)", c.template), "Duplicated from " + c.title);
    toast("Duplicated “" + c.title + "”.");
    openCopy(n);
  }
  function saveAsTemplate(c){
    if(S.readOnly) return;
    var n = addCopy(copyCard(c, c.title, true), "Saved as a template from " + c.title);
    toast("Saved “" + c.title + "” as a template.", {label:"Open it", fn:function(){ if(S.cards.has(n.id)) jumpTo(n.id, true); }});
    refresh();
  }
  function createFromTemplate(id){
    var t = S.cards.get(id);
    if(!t || S.readOnly){ if(S.readOnly) toast("You have view-only access to this workspace."); return; }
    var n = addCopy(copyCard(t, t.title, false), "Created from the template " + t.title);
    if(S.nav.indexOf("f:") === 0 && !t.folder){ n.folder = S.nav.slice(2); }
    openCopy(n);
    setTimeout(function(){ var el = $("d-title"); if(el && S.curId === n.id){ el.focus(); el.select(); } }, 700);
  }
  function templatesInSpace(){
    return Array.from(S.cards.values()).filter(function(c){ return c.template && !!c.home === (S.space === "home"); })
      .sort(function(a, b){ return a.title.localeCompare(b.title, undefined, {numeric:true, sensitivity:"base"}); });
  }
  function renderTemplates(){
    var list = templatesInSpace(), by = {};
    list.forEach(function(c){ (by[c.type] = by[c.type] || []).push(c); });
    var keys = TYPE_ORDER.filter(function(k){ return by[k]; }).concat(Object.keys(by).filter(function(k){ return TYPE_ORDER.indexOf(k) < 0; }));
    var head = '<div class="modal-head"><h2 id="modalTitle">Templates</h2><button type="button" class="btn small" data-mclose="1">Close</button></div>';
    var body = list.length ? '<p class="d-note" style="margin-top:0">Pick one from <b>+ New card</b> to start a card from it. Templates stay out of the wheel, search and dashboards.</p>' + keys.map(function(k){
      return '<div class="tpl-group" style="' + typeVar(k) + '"><h3 class="tpl-h"><span class="dot"></span>' + esc(td(k).plural) + '</h3><div class="trash-list">' + by[k].map(function(c){
        return '<div class="trash-row tpl-row" style="' + typeVar(c.type) + '"><span class="t-chip">' + esc(td(c.type).label) + '</span><span class="t"><b>' + esc(c.title) + '</b><small>' + esc(c.subtitle || (c.check.length ? c.check.length + (c.check.length === 1 ? " checklist item" : " checklist items") : "Edited " + ago(c.updated))) + '</small></span>' +
          (S.readOnly ? "" : '<button type="button" class="btn small" data-tuse="' + esc(c.id) + '">Use</button><button type="button" class="btn small" data-tedit="' + esc(c.id) + '">Edit</button><button type="button" class="btn small danger" data-tdel="' + esc(c.id) + '">Delete</button>') + '</div>';
      }).join("") + '</div></div>';
    }).join("") : '<p class="d-note" style="margin-top:0">No templates yet. Open any card and choose <b>Save as template</b> to reuse it as a starting point.</p>';
    $("modalBox").innerHTML = head + '<div class="modal-body">' + body + '</div>';
  }
  function openTemplates(){ openModal("templates"); renderTemplates(); }

  function createCard(type, date){
    if(S.readOnly){ toast("You have view-only access to this workspace."); return; }
    var T = td(type), f = {};
    var dk = validDate(date) ? dateKey(type) : "";
    if(dk) f[dk] = date;
    var folder = S.nav.indexOf("f:") === 0 ? S.nav.slice(2) : "";
    var c = norm({id:uid(), type:type, title:"New " + T.label.toLowerCase(), status:T.statuses[0], folder:folder, fav:S.nav === "fav", home:S.space === "home", f:f});
    c.hist.push({at:new Date().toISOString(), w:"Created" + (dk ? " for " + fmtDate(date, true) : "")});
    S.calAdd = false;
    S.cards.set(c.id, c);
    touch(c.id);
    /* discard it on close if it's never edited — see isBlankNewCard()/refresh() */
    S.pendingBlank = c.id;
    if(!navMatch(c)) S.nav = "all";
    setQuery("");
    S.curId = c.id; S.open = true;
    if(S.view !== "rolodex") setView("rolodex"); else refresh();
    /* a meeting added from a calendar day already has its date, so the next thing to fill in is when it starts */
    var focusId = dk && type === "meeting" ? "d-f-time" : "d-title";
    setTimeout(function(){ var t = $(focusId) || $("d-title"); if(t){ t.focus(); if(t.id === "d-title") t.select(); } }, 420);
  }
  /* true if a card createCard() made is still exactly as it was left, with nothing typed into it —
     the pre-filled date from a calendar "+ Add" doesn't count as an edit. */
  function isBlankNewCard(id){
    var c = S.cards.get(id); if(!c) return false;
    var T = td(c.type);
    if(c.title !== "New " + T.label.toLowerCase()) return false;
    if(c.subtitle || c.notes || (c.page && c.page.length) || c.sess.length) return false;
    if(c.tags.length || c.links.length || c.files.length || c.check.length || c.rel.length) return false;
    if(c.status !== T.statuses[0]) return false;
    var dk = dateKey(c.type);
    return Object.keys(c.f).every(function(k){ return k === dk; });
  }

  /* ================= calendar ================= */
  function occurrences(){
    var out = [];
    S.deck.forEach(function(c){ cardDates(c).forEach(function(d){ out.push(d); }); });
    return out;
  }
  var calByDay = {};
  /* the start time shown on a calendar chip: "09:30" from a meeting's time field, or a best effort at
     free text like "2pm" / "14.30" on other types; "" when there's none (all-day items sort first) */
  function occTime(o){
    var t = o.kind === "due" && o.card.f.time ? String(o.card.f.time).trim() : "";
    var m = /^(\d{1,2})(?:[:.](\d{2}))?\s*(am|pm|a\.m\.|p\.m\.|a|p)?(?![\w])/i.exec(t);
    if(!m || (!m[2] && !m[3]) || +m[1] > 23 || (m[2] && +m[2] > 59)) return "";
    var h = +m[1], ap = (m[3] || "").toLowerCase().charAt(0);
    if(ap === "p" && h < 12) h += 12; if(ap === "a" && h === 12) h = 0;
    return (h < 10 ? "0" : "") + h + ":" + (m[2] || "00");
  }
  function calSort(a, b){ var x = occTime(a), y = occTime(b); return x < y ? -1 : x > y ? 1 : a.card.title.localeCompare(b.card.title); }
  function calWeekStart(ds){ return addDays(ds, -((parseISO(ds).getDay() + 6) % 7)); }
  function calChip(o){
    var tm = occTime(o), dr = !S.readOnly;
    var repIcon = (o.rep || (o.card.rpt && o.card.rpt.every)) ? '<i class="cal-rep" aria-hidden="true">↻</i>' : "";
    return '<span class="cal-chip' + (o.ghost ? " ghost" : "") + '" role="button" tabindex="0" style="' + typeVar(o.card.type) + '" data-open="' + esc(o.card.id) + '"' +
      (dr ? ' draggable="true" data-drag="' + esc(o.card.id) + '" data-key="' + esc(o.key || "") + '" data-from="' + esc(o.date) + '"' + (o.rep ? ' data-rep="1"' : "") + (o.ghost ? ' data-ghost="1"' : "") : "") +
      ' title="' + esc(o.what + ": " + o.card.title) + '">' + (tm ? '<b class="cal-time">' + tm + '</b>' : "") + repIcon + esc(o.card.title) + '</span>';
  }
  function renderCalendar(){
    var box = $("v-calendar");
    if(!S.calMonth){ var n = new Date(); S.calMonth = new Date(n.getFullYear(), n.getMonth(), 1); }
    var m = S.calMonth, t = today(), week = S.calView === "week";
    var start, cells;
    if(week){ start = parseISO(calWeekStart(S.calDay || t)); cells = 7; }
    else {
      var first = new Date(m.getFullYear(), m.getMonth(), 1);
      var offset = (first.getDay() + 6) % 7;
      start = new Date(first); start.setDate(1 - offset);
      var daysInMonth = new Date(m.getFullYear(), m.getMonth() + 1, 0).getDate();
      cells = Math.ceil((offset + daysInMonth) / 7) * 7;
    }
    var gridFrom = iso(start), gridTo = addDays(gridFrom, cells - 1);
    var byDay = {};
    occurrences().forEach(function(o){ if(o.card.type === "meeting" && o.card.f.repeat) return; (byDay[o.date] = byDay[o.date] || []).push(o); });
    S.deck.forEach(function(c){
      if(c.type !== "meeting" || !c.f.repeat || c.status === "Cancelled") return;
      meetingDates(c, gridFrom, gridTo).forEach(function(d){ (byDay[d] = byDay[d] || []).push({date:d, kind:"due", what:"Meeting" + (c.f.time ? " at " + c.f.time : ""), card:c, key:"due", rep:true}); });
    });
    /* future occurrences of a repeating task/other card: faded "ghost" chips, calendar preview only */
    S.deck.forEach(function(c){
      if(c.type === "meeting" || !c.rpt || !c.rpt.every) return;
      var key = dateKey(c.type); if(!key) return;
      taskRepeatDates(c, gridFrom, gridTo).forEach(function(d){ (byDay[d] = byDay[d] || []).push({date:d, kind:"due", what:mainDateWhat(c), card:c, key:key, ghost:true}); });
    });
    Object.keys(byDay).forEach(function(k){ byDay[k].sort(calSort); });
    calByDay = byDay;
    var unit = week ? "week" : "month";
    var title = week ? start.toLocaleDateString(undefined, {month:"short", day:"numeric"}) + " – " + parseISO(gridTo).toLocaleDateString(undefined, {month:"short", day:"numeric", year:"numeric"})
      : m.toLocaleDateString(undefined, {month:"long", year:"numeric"});
    var html = '<div class="panel"><div class="panel-head"><h2 class="panel-title">' + esc(title) + '</h2>' +
      '<div class="seg" role="group" aria-label="Calendar view">' + [["month","Month"],["week","Week"]].map(function(v){ var on = v[0] === S.calView || (v[0] === "month" && !week); return '<button type="button" data-calview="' + v[0] + '"' + (on ? ' class="on"' : "") + ' aria-pressed="' + (on ? "true" : "false") + '">' + v[1] + '</button>'; }).join("") + '</div>' +
      '<button class="btn small" type="button" data-cal="-1" aria-label="Previous ' + unit + '">&#8592;</button><button class="btn small" type="button" data-cal="0">Today</button><button class="btn small" type="button" data-cal="1" aria-label="Next ' + unit + '">&#8594;</button></div>';
    html += '<div class="cal' + (week ? " week" : "") + '">' + ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"].map(function(d){ return '<div class="cal-wd">' + d + '</div>'; }).join("");
    for(var i = 0; i < cells; i++){
      var d = new Date(start); d.setDate(start.getDate() + i);
      var ds = iso(d), items = byDay[ds] || [];
      var cls = "cal-day" + (!week && d.getMonth() !== m.getMonth() ? " out" : "") + (ds === t ? " today" : "") + (ds === S.calDay ? " sel" : "");
      html += '<div class="' + cls + '" data-day="' + ds + '" role="button" tabindex="0" aria-label="' + esc(fmtDate(ds, true)) + ', ' + items.length + ' items"><span class="cal-num">' + (week ? '<span class="cal-wdn">' + esc(d.toLocaleDateString(undefined, {weekday:"short"})) + ' </span>' : "") + d.getDate() + '</span>';
      (week ? items : items.slice(0, 3)).forEach(function(o){ html += calChip(o); });
      if(!week && items.length > 3) html += '<span class="cal-more">+' + (items.length - 3) + ' more</span>';
      if(!week && items.length) html += '<span class="cal-dots">' + items.slice(0, 6).map(function(o){ return '<i style="' + typeVar(o.card.type) + '"></i>'; }).join("") + '</span>';
      html += '</div>';
    }
    html += '</div>';
    html += '<div class="day-panel" id="calDayPanel">' + calDayPanel() + '</div></div>';
    box.innerHTML = html;
  }
  /* the selected day's agenda, with "+ Add" (a row of the dated types in this space, Meeting first) */
  function calDayPanel(){
    var t = today(), sel = S.calDay || t, list = calByDay[sel] || [];
    var types = spaceTypes().filter(dateKey).sort(function(a, b){ return (b === "meeting") - (a === "meeting"); });
    var canAdd = !S.readOnly && types.length;
    return '<div class="day-head"><h4>' + esc(fmtDate(sel, true)) + (sel === t ? " · Today" : "") + '</h4>' +
      (canAdd ? '<button class="btn small" type="button" data-caladd="1" aria-expanded="' + (S.calAdd ? "true" : "false") + '">+ Add</button>' : "") + '</div>' +
      (canAdd && S.calAdd ? '<div class="cal-add" role="group" aria-label="Add to ' + esc(fmtDate(sel, true)) + '">' + newTypeBtns(types, sel) + '</div>' : "") +
      (list.length ? '<div class="agenda">' + list.map(agendaItem).join("") + '</div>' : '<p class="d-note">Nothing on this day.</p>');
  }
  /* select a day without rebuilding the grid (so a double-click lands on the same cell), optionally opening "+ Add" */
  function selectCalDay(ds, add){
    var box = $("v-calendar");
    S.calDay = ds; S.calAdd = !!add;
    box.querySelectorAll(".cal-day.sel").forEach(function(x){ x.classList.remove("sel"); });
    var cell = box.querySelector('.cal-day[data-day="' + ds + '"]'), p = $("calDayPanel");
    if(!cell || !p){ renderCalendar(); return; }
    cell.classList.add("sel"); p.innerHTML = calDayPanel();
    if(add){ var b = p.querySelector(".cal-add button"); if(b) b.focus(); }
  }
  /* drag a chip to another day: move the date field that put it there */
  function moveCalDate(id, key, from, to){
    var c = S.cards.get(id); if(!c || S.readOnly || !key || !validDate(to) || from === to || c.f[key] !== from) return;
    var fd = td(c.type).fields.filter(function(x){ return x.k === key; })[0], lbl = fd ? fd.l : "Date";
    c.f[key] = to; S.calDay = to; S.calAdd = false;
    logHist(c, lbl + ": " + fmtDate(from) + " → " + fmtDate(to)); touch(id);
    toast("Moved “" + c.title + "” to " + fmtDate(to, true) + ".", {label:"Undo", fn:function(){ if(c.f[key] !== to) return; c.f[key] = from; S.calDay = from; logHist(c, lbl + ": moved back to " + fmtDate(from)); touch(id); refresh(); }});
    refresh();
  }
  function agendaItem(o){
    /* meetings: always say Repeats <rule> or One-off, since that's the common "is this worth
       moving?" question on a day's meeting list. Other repeating cards (rpt) still get the same
       ↻ <rule> tag calChip() shows on the month grid; an ordinary one-off non-meeting item (most
       of the list, most days) gets no tag at all rather than a "One-off" label on everything. */
    var rule = o.card.type === "meeting" ? o.card.f.repeat : ((o.card.rpt && o.card.rpt.every) || "");
    var repTag = rule ? '<span class="ag-rep" title="' + esc(rule) + '"><i class="cal-rep" aria-hidden="true">↻</i>' + esc(rule) + '</span>'
      : (o.card.type === "meeting" ? '<span class="ag-rep one-off">One-off</span>' : "");
    return '<button type="button" class="ag-item" data-open="' + esc(o.card.id) + '" style="' + typeVar(o.card.type) + '"><span class="ag-date"><b>' + esc(fmtDate(o.date)) + '</b> ' + esc(parseISO(o.date).toLocaleDateString(undefined, {weekday:"short"})) + '</span>' +
      '<span class="t-chip">' + esc(td(o.card.type).label) + '</span><span class="ag-title">' + esc(o.card.title) + '</span><span class="ag-what">' + esc(o.what) + (o.card.f.time && o.kind === "due" && o.what.indexOf(o.card.f.time) < 0 ? " · " + esc(o.card.f.time) : "") + '</span>' + repTag + '</button>';
  }

  /* ================= today ================= */
  function isOverdue(o){
    return dayDiff(today(), o.date) < 0 && !CLOSED[o.card.status] && o.kind !== "start" && (o.card.type === "issue" || o.card.type === "project" || (!BUILTIN[o.card.type] && o.kind === "due"));
  }
  function storagePct(c){
    if(c.type !== "storage" || !c.f.used || !c.f.capacity) return 0;
    var u = /([\d.]+)\s*([a-z]+)/i.exec(c.f.used), cap = /([\d.]+)\s*([a-z]+)/i.exec(c.f.capacity);
    return (u && cap && u[2].toLowerCase() === cap[2].toLowerCase() && +cap[1] > 0) ? +u[1] / +cap[1] * 100 : 0;
  }
  function attentionReason(c){
    if(c.type === "server" && c.status !== "Online") return c.status;
    if(c.type === "storage" && (c.status === "Near capacity" || c.status === "Degraded")) return c.status + (storagePct(c) ? " · " + Math.round(storagePct(c)) + "% used" : "");
    if(c.type === "storage" && storagePct(c) >= 85) return Math.round(storagePct(c)) + "% used";
    if(c.type === "issue" && !CLOSED[c.status] && (c.status === "Blocked" || c.f.severity === "Critical" || c.f.severity === "High")) return c.status === "Blocked" ? "Blocked" : c.f.severity + " severity";
    if(c.type === "project" && c.status === "At risk") return "At risk";
    return "";
  }
  function dRow(c, right, sub){
    return '<button type="button" class="d-row" data-open="' + esc(c.id) + '" style="' + typeVar(c.type) + '"><span class="dot"></span><span class="t">' + esc(c.title) + (c.fav ? ' <span style="color:var(--warn)">★</span>' : "") + (c.remind ? ' <span class="bell" title="Reminder: ' + esc(fmtRemind(c.remind)) + '">🔔</span>' : "") + '</span><span class="s">' + esc(sub || c.subtitle || td(c.type).label) + '</span><span class="r">' + (right || "") + '</span></button>';
  }
  /* "Gone quiet": open work (issues, projects, custom types that can be closed) nobody has touched in 14 days */
  var STALE_DAYS = 14;
  function staleType(k){ return k === "issue" || k === "project" || (!BUILTIN[k] && td(k).statuses.some(function(st){ return CLOSED[st]; })); }
  function isStale(c){
    if(!staleType(c.type) || CLOSED[c.status] || c.archived || c.deleted || c.example || c.template || !c.updated) return false;
    var t = Date.parse(c.updated);
    return isFinite(t) && Date.now() - t > STALE_DAYS * 864e5;
  }
  function renderToday(){
    var box = $("v-today"), t = today(), deck = S.deck;
    var occ = occurrences();
    var overdue = occ.filter(isOverdue).sort(function(a, b){ return a.date.localeCompare(b.date); });
    var dueToday = occ.filter(function(o){ return o.card.type !== "meeting" && dayDiff(t, o.date) === 0 && !CLOSED[o.card.status]; }).sort(function(a, b){ return a.date.localeCompare(b.date); });
    var meetToday = occ.filter(function(o){ return o.card.type === "meeting" && dayDiff(t, o.date) === 0 && !CLOSED[o.card.status]; });
    var upcoming = occ.filter(function(o){ var d = dayDiff(t, o.date); return d >= 0 && d <= 6 && !CLOSED[o.card.status]; });
    var openIssues = deck.filter(function(c){ return c.type === "issue" && !CLOSED[c.status]; });
    var hot = openIssues.filter(function(c){ return c.f.severity === "Critical" || c.f.severity === "High"; }).length;
    var attn = deck.filter(function(c){ return attentionReason(c); });
    var recent = deck.slice().sort(function(a, b){ return (b.updated || "").localeCompare(a.updated || ""); }).slice(0, 6);
    var tile = function(n, label, sub, tone, act){ return '<' + (act ? 'button type="button" data-tile="' + esc(act) + '"' : "div") + ' class="tile ' + (n ? tone : "") + '"><span class="num">' + n + '</span><span class="lbl">' + label + '</span><span class="sub">' + sub + '</span></' + (act ? "button" : "div") + '>'; };
    var html = '<div class="panel"><div class="panel-head"><h2 class="panel-title">Today</h2><span class="dash-date">' + esc(new Date().toLocaleDateString(undefined, {weekday:"long", day:"numeric", month:"long", year:"numeric"})) + (S.nav !== "all" || (S.pq && !S.pq.empty) ? " · showing " + esc(navLabel()) + (S.pq && !S.pq.empty ? " matching your search" : "") : "") + '</span></div>';
    html += '<div class="dash-tiles">' +
      tile(overdue.length, "Overdue", overdue.length ? "Past their due or end date" : "Nothing overdue", "bad", "q:is:overdue") +
      tile(dueToday.length, "Due today", dueToday.length ? "Due by end of day" : "Nothing due today", "warn", "q:is:today") +
      tile(meetToday.length, "Meetings today", meetToday.length ? "On your calendar today" : "No meetings today", "warn", "q:type:meeting is:today") +
      tile(openIssues.length, "Open issues", hot ? hot + " high or critical" : "None high or critical", "warn", "board:issue") +
      tile(upcoming.length, "Upcoming", "Due within the next 7 days", "", "q:is:week") + '</div>';
    var sec = function(title, n, body, cls){ return '<section class="dash-card' + (cls ? " " + cls : "") + '"><h3>' + title + (n !== null ? ' <span class="n">' + n + '</span>' : "") + '</h3>' + body + '</section>'; };
    var qa = function(o, row){
      var T = td(o.card.type), done = T.statuses.filter(function(st){ return CLOSED[st]; })[0];
      var rec = o.card.type === "meeting" && o.card.f.repeat;
      if(S.readOnly || (!done && rec)) return row;
      return '<div class="q-row">' + row + '<span class="q-acts">' + (done ? '<button type="button" class="q-btn" data-qdone="' + esc(o.card.id) + '" title="Mark ' + esc(done.toLowerCase()) + '">✓</button>' : "") +
        (rec ? "" : '<button type="button" class="q-btn" data-qsnooze="' + esc(o.card.id) + '" data-qdate="' + esc(o.date) + '" title="Move this date later" aria-haspopup="true">Snooze</button>') + '</span></div>';
    };
    /* NEXT MEETING: the single soonest upcoming meeting, with a Join link if it has one */
    var nm = occ.filter(function(o){ return o.card.type === "meeting" && !CLOSED[o.card.status] && o.date >= t; }).sort(function(a, b){ return a.date.localeCompare(b.date); })[0];
    var nmBody;
    if(nm){
      var join = joinInfo(nm.card.f.join);
      var when = relDate(nm.date) + (nm.card.f.time ? " · " + nm.card.f.time : "") + (nm.card.f.where ? " · " + nm.card.f.where : "");
      nmBody = '<div class="nm-row">' + dRow(nm.card, "", when) + (join ? '<span class="q-acts"><a class="btn small" href="' + esc(join.url) + '" target="_blank" rel="noopener">' + esc(join.label) + '</a></span>' : "") + '</div>';
    } else nmBody = '<p class="dash-empty">No meetings scheduled.</p>';
    /* NEEDS ATTENTION: overdue + due-today items, plus cards flagged by attentionReason not already covered above */
    var attnOnly = attn.filter(function(c){ return !overdue.some(function(o){ return o.card.id === c.id; }) && !dueToday.some(function(o){ return o.card.id === c.id; }); });
    var needsRows = overdue.map(function(o){ return qa(o, dRow(o.card, '<span class="due tone-bad">' + esc("Overdue " + (-dayDiff(t, o.date)) + "d") + '</span>', o.what + " " + fmtDate(o.date))); })
      .concat(dueToday.map(function(o){ return qa(o, dRow(o.card, '<span class="due tone-warn">Today</span>', o.what + (o.card.f.time ? " · " + o.card.f.time : ""))); }))
      .concat(attnOnly.map(function(c){ return dRow(c, '<span class="pill tone-' + (TONE[c.status] || "muted") + '">' + esc(c.status) + '</span>', attentionReason(c)); }));
    var needsCount = overdue.length + dueToday.length + attnOnly.length;
    html += sec("Next meeting", null, nmBody, "nm-card");
    /* REMINDERS: every pending reminder, due ones first (they're also in the reminder bar) */
    var rems = deck.filter(function(c){ return c.remind; }).sort(function(a, b){ return a.remind.localeCompare(b.remind); });
    if(rems.length){
      var remActs = function(c){ return S.readOnly ? "" : '<span class="q-acts"><button type="button" class="q-btn q-txt" data-rsnooze="' + esc(c.id) + '" aria-haspopup="true" title="Remind me later">Snooze</button><button type="button" class="q-btn q-txt" data-rdone="' + esc(c.id) + '" title="Clear this reminder">Done</button></span>'; };
      html += sec("Reminders", rems.length, rems.map(function(c){
        var due = remindDue(c);
        return '<div class="q-row q-wrap">' + dRow(c, due ? '<span class="due tone-warn">Due</span>' : '<span class="ag-what">' + esc(c.remind.split("T")[1]) + '</span>', "Reminder " + fmtRemind(c.remind)) + remActs(c) + '</div>';
      }).join(""), "rem-card");
    }
    /* GONE QUIET: oldest first; the rest are one search away */
    var stale = deck.filter(isStale).sort(function(a, b){ return (a.updated || "").localeCompare(b.updated || ""); });
    var staleRows = stale.slice(0, 6).map(function(c){
      var done = td(c.type).statuses.filter(function(st){ return CLOSED[st]; })[0];
      return '<div class="q-row q-wrap">' + dRow(c, '<span class="ag-what">' + esc(ago(c.updated)) + '</span>', c.status + " · no changes for " + dayDiff(iso(new Date(c.updated)), today()) + " days") +
        (S.readOnly ? "" : '<span class="q-acts"><button type="button" class="q-btn q-txt" data-qstill="' + esc(c.id) + '" title="Log a check-in so it stops showing here">Still on it</button>' +
          (done ? '<button type="button" class="q-btn q-txt" data-qdone="' + esc(c.id) + '" title="Mark ' + esc(done.toLowerCase()) + '">Close</button>' : "") + '</span>') + '</div>';
    });
    var staleBody = staleRows.length ? staleRows.join("") + (stale.length > 6 ? '<button type="button" class="stale-more" data-tile="w:is:stale">+' + (stale.length - 6) + ' more</button>' : "") : '<p class="dash-empty">Nothing has gone quiet.</p>';
    html += '<div class="dash-grid">' +
      sec("Needs attention", needsCount, needsRows.length ? needsRows.join("") : '<p class="dash-empty">Everything looks healthy.</p>') +
      sec("Recently updated", null, recent.length ? recent.map(function(c){ return dRow(c, '<span class="ag-what">' + esc(c.updated ? ago(c.updated) : "") + '</span>'); }).join("") : '<p class="dash-empty">No cards yet.</p>') +
      sec("Gone quiet", stale.length, staleBody, "stale-card") +
      '</div></div>';
    box.innerHTML = html;
  }

  /* ================= board ================= */
  function renderBoard(){
    var box = $("v-board");
    var types = TYPE_ORDER.filter(function(k){ return td(k).statuses.length > 1; });
    if(types.indexOf(S.boardType) < 0) S.boardType = types.indexOf("issue") >= 0 ? "issue" : types[0];
    var T = td(S.boardType), k = S.boardType;
    var cards = S.deck.filter(function(c){ return c.type === k; });
    var html = '<div class="panel"><div class="panel-head"><h2 class="panel-title">Board</h2>' +
      '<label class="hint" for="boardType">Show</label><select id="boardType" class="btn small" style="padding:5px 8px">' + types.map(function(t){ return '<option value="' + esc(t) + '"' + (t === k ? " selected" : "") + '>' + esc(td(t).plural) + '</option>'; }).join("") + '</select>' +
      '<span class="hint">Drag a card to another column to change its status.</span></div><div class="board-scroll"><div class="board">';
    T.statuses.forEach(function(st){
      var col = cards.filter(function(c){ return c.status === st; });
      html += '<div class="b-col" data-status="' + esc(st) + '"><div class="b-col-head"><span class="pill tone-' + (TONE[st] || "muted") + '">' + esc(st) + '</span><span class="n">' + col.length + '</span></div>' +
        (col.length ? col.map(function(c){
          var who = c.f.assignee || c.f.owner || c.f.with || "";
          var cd = c.check.filter(function(x){ return x.done; }).length;
          return '<div class="b-tile" draggable="' + (S.readOnly ? "false" : "true") + '" data-open="' + esc(c.id) + '" data-id="' + esc(c.id) + '" role="button" tabindex="0" style="' + typeVar(c.type) + '">' +
            '<span class="tt">' + esc(c.title) + '</span>' + (c.subtitle ? '<span class="ts">' + esc(c.subtitle) + '</span>' : "") +
            '<span class="tm">' + dueBadge(c) + (c.f.severity ? '<span class="tag">' + esc(c.f.severity) + '</span>' : "") + (who ? '<span>' + esc(who) + '</span>' : "") +
            (c.check.length ? '<span class="check-sum">☑ <b>' + cd + '</b>/' + c.check.length + '</span>' : "") + (c.fav ? '<span class="fav">★</span>' : "") + '</span></div>';
        }).join("") : '<div class="b-empty">Nothing ' + esc(st.toLowerCase()) + '</div>') + '</div>';
    });
    html += '</div></div></div>';
    box.innerHTML = html;
  }
  function setStatus2(id, st){
    var c = S.cards.get(id); if(!c || c.status === st || S.readOnly) return;
    logHist(c, "Status: " + c.status + " → " + st);
    c.status = st;
    var roll = CLOSED[st] ? rollCard(c) : null;
    touch(id);
    if(roll && S.open && S.curId === id) rebuildDetail();
    if(roll && roll.rolled) toast("Done — next one is " + fmtDate(roll.next, true) + ".");
    else toast("“" + c.title + "” is now " + st + ".");
  }
  var boardDrag = "";
  $("v-board").addEventListener("dragstart", function(e){ var t = e.target.closest && e.target.closest(".b-tile"); if(!t) return; boardDrag = t.dataset.id; t.classList.add("dragging"); e.dataTransfer.effectAllowed = "move"; try{ e.dataTransfer.setData("text/plain", t.dataset.id); }catch(err){} });
  $("v-board").addEventListener("dragend", function(){ boardDrag = ""; $("v-board").querySelectorAll(".dragging, .drop").forEach(function(x){ x.classList.remove("dragging", "drop"); }); });
  $("v-board").addEventListener("dragover", function(e){ var col = boardDrag && e.target.closest && e.target.closest(".b-col"); if(!col) return; e.preventDefault(); $("v-board").querySelectorAll(".b-col.drop").forEach(function(x){ if(x !== col) x.classList.remove("drop"); }); col.classList.add("drop"); });
  $("v-board").addEventListener("drop", function(e){ var col = e.target.closest && e.target.closest(".b-col"); if(!col || !boardDrag) return; e.preventDefault(); setStatus2(boardDrag, col.dataset.status); boardDrag = ""; });
  var calDrag = null, vCal = $("v-calendar");
  vCal.addEventListener("dragstart", function(e){
    var ch = e.target.closest && e.target.closest(".cal-chip[data-drag]"); if(!ch) return;
    if(ch.dataset.rep){ e.preventDefault(); toast("This meeting repeats, so it can’t be dragged to one day. Open it to change the series."); return; }
    if(ch.dataset.ghost){ e.preventDefault(); toast("That’s a future occurrence — open the card to change its repeat."); return; }
    calDrag = {id:ch.dataset.drag, key:ch.dataset.key, from:ch.dataset.from}; ch.classList.add("dragging");
    e.dataTransfer.effectAllowed = "move"; try{ e.dataTransfer.setData("text/plain", ch.dataset.drag); }catch(err){}
  });
  vCal.addEventListener("dragend", function(){ calDrag = null; vCal.querySelectorAll(".dragging, .drop").forEach(function(x){ x.classList.remove("dragging", "drop"); }); });
  vCal.addEventListener("dragover", function(e){ var day = calDrag && e.target.closest && e.target.closest(".cal-day"); if(!day) return; e.preventDefault(); e.dataTransfer.dropEffect = "move"; vCal.querySelectorAll(".cal-day.drop").forEach(function(x){ if(x !== day) x.classList.remove("drop"); }); day.classList.add("drop"); });
  vCal.addEventListener("drop", function(e){ var day = e.target.closest && e.target.closest(".cal-day"); if(!day || !calDrag) return; e.preventDefault(); var d = calDrag; calDrag = null; moveCalDate(d.id, d.key, d.from, day.dataset.day); });
  vCal.addEventListener("dblclick", function(e){ var day = e.target.closest && e.target.closest(".cal-day"); if(!day || e.target.closest(".cal-chip") || S.readOnly) return; selectCalDay(day.dataset.day, true); });
  $("v-board").addEventListener("change", function(e){ if(e.target.id === "boardType"){ S.boardType = e.target.value; savePrefs(); renderBoard(); } });
  $("v-board").addEventListener("keydown", function(e){ var t = e.target.closest && e.target.closest(".b-tile"); if(t && (e.key === "Enter" || e.key === " ")){ e.preventDefault(); jumpTo(t.dataset.id, true); } });
  $("v-today").addEventListener("click", function(e){
    var b = e.target.closest("[data-tile]"); if(!b) return;
    var a = b.dataset.tile;
    if(a.indexOf("q:") === 0){ setQuery(a.slice(2)); setView("upcoming"); }
    else if(a.indexOf("w:") === 0){ setQuery(a.slice(2)); setView("rolodex"); }
    else if(a.indexOf("board:") === 0){ S.boardType = a.slice(6); setView("board"); }
  });

  /* ================= upcoming ================= */
  function renderUpcoming(){
    var box = $("v-upcoming"), t = today();
    var groups = [["Overdue", []], ["Today", []], ["Next 7 days", []], ["Next 30 days", []], ["Later", []]];
    occurrences().forEach(function(o){
      var diff = dayDiff(t, o.date), closed = CLOSED[o.card.status];
      if(diff < 0){ if(!closed && (o.kind === "due" || o.kind === "end") && o.card.type !== "person" && o.card.type !== "event" && o.card.type !== "storage") groups[0][1].push(o); return; }
      if(closed && o.card.type !== "storage") return;
      if(diff === 0) groups[1][1].push(o);
      else if(diff <= 7) groups[2][1].push(o);
      else if(diff <= 30) groups[3][1].push(o);
      else if(diff <= 365) groups[4][1].push(o);
    });
    var html = '<div class="panel"><div class="panel-head"><h2 class="panel-title">Coming up</h2><span class="hint">Dates from every card: due dates, events, maintenance windows, project milestones and warranties.</span></div>';
    var any = false;
    groups.forEach(function(g, gi){
      if(!g[1].length) return;
      any = true;
      g[1].sort(function(a, b){ return a.date.localeCompare(b.date); });
      html += '<h3 class="ag-group' + (gi === 0 ? " bad" : "") + '">' + g[0] + ' <span class="n">' + g[1].length + '</span></h3><div class="agenda">' + g[1].map(agendaItem).join("") + '</div>';
    });
    if(!any) html += '<div class="empty"><h3>Nothing coming up</h3><p>Add dates to cards (due dates, events, project start and end) and they appear here.</p></div>';
    box.innerHTML = html + '</div>';
  }

  /* ================= timeline (gantt) ================= */
  function renderTimeline(){
    var box = $("v-timeline"), t = today();
    var bars = [], marks = [];
    S.deck.forEach(function(c){
      var s = c.f.start, e = c.f.end;
      if(validDate(s) && validDate(e) && e >= s) bars.push(c);
      else if(validDate(c.f.due) && c.type !== "person") marks.push(c);
    });
    var lo = addDays(t, -14), hi = addDays(t, 60);
    bars.forEach(function(c){ if(c.f.start < lo) lo = c.f.start; if(c.f.end > hi) hi = c.f.end; });
    marks.forEach(function(c){ if(c.f.due < lo) lo = c.f.due; if(c.f.due > hi) hi = c.f.due; });
    if(dayDiff(t, lo) < -120) lo = addDays(t, -120);
    if(dayDiff(t, hi) > 240) hi = addDays(t, 240);
    var lod = parseISO(lo); lod.setDate(lod.getDate() - ((lod.getDay() + 6) % 7)); lo = iso(lod);
    var days = dayDiff(lo, hi) + 8, DW = 20, W = days * DW;
    var x = function(s){ return Math.max(0, Math.min(W, dayDiff(lo, s) * DW)); };

    var head = '<div class="g-row g-head"><div class="g-label"><span class="t-chip" style="--tc:var(--muted)">' + (bars.length + marks.length) + ' dated cards</span></div><div class="g-track" style="width:' + W + 'px">';
    for(var i = 0; i < days; i++){
      var d = addDays(lo, i), dd = parseISO(d);
      if(dd.getDate() === 1 || i === 0) head += '<span class="g-month" style="left:' + (i * DW) + 'px">' + esc(dd.toLocaleDateString(undefined, {month:"short", year:dd.getMonth() === 0 || i === 0 ? "numeric" : undefined})) + '</span>';
      if(dd.getDay() === 1) head += '<span class="g-wk" style="left:' + (i * DW + DW / 2) + 'px">' + dd.getDate() + '</span>';
    }
    head += '</div></div>';
    var grid = "background:repeating-linear-gradient(to right, transparent 0 " + (7 * DW - 1) + "px, var(--line) " + (7 * DW - 1) + "px " + (7 * DW) + "px) " + ((((dayDiff(lo, lo)) % 7) * DW)) + "px 0";
    var rows = "";
    TYPE_ORDER.forEach(function(k){
      var bs = bars.filter(function(c){ return c.type === k; }).sort(function(a, b){ return a.f.start.localeCompare(b.f.start); });
      var ms = marks.filter(function(c){ return c.type === k; }).sort(function(a, b){ return a.f.due.localeCompare(b.f.due); });
      if(!bs.length && !ms.length) return;
      rows += '<div class="g-row g-group" style="' + typeVar(k) + '"><div class="g-label">' + esc(td(k).plural) + '</div><div class="g-track" style="width:' + W + 'px;' + grid + '"></div></div>';
      bs.forEach(function(c){
        var x0 = x(c.f.start), x1 = x(addDays(c.f.end, 1)), prog = c.type === "project" ? Math.max(0, Math.min(100, parseFloat(c.f.progress) || 0)) : 0;
        rows += '<div class="g-row" style="' + typeVar(k) + '"><div class="g-label"><button type="button" data-open="' + esc(c.id) + '">' + esc(c.title) + '</button><small>' + esc(fmtDate(c.f.start)) + ' – ' + esc(fmtDate(c.f.end)) + ' · ' + esc(c.status) + '</small></div>' +
          '<div class="g-track" style="width:' + W + 'px;' + grid + '"><button type="button" class="g-bar" data-open="' + esc(c.id) + '" style="left:' + x0 + 'px;width:' + Math.max(6, x1 - x0) + 'px" title="' + esc(c.title + ": " + fmtDate(c.f.start) + " – " + fmtDate(c.f.end)) + '"><i style="width:' + prog + '%"></i><span>' + (prog ? prog + "%" : "") + '</span></button></div></div>';
      });
      if(ms.length){
        rows += '<div class="g-row" style="' + typeVar(k) + '"><div class="g-label"><small>' + ms.length + ' ' + esc(ms.length === 1 ? "date" : "dates") + ' (' + esc(((td(k).fields.filter(function(f){ return f.k === "due"; })[0]) || {l:"date"}).l.toLowerCase()) + ')</small></div><div class="g-track" style="width:' + W + 'px;' + grid + '">' +
          ms.map(function(c){ return '<button type="button" class="g-ms" data-open="' + esc(c.id) + '" style="left:' + (x(c.f.due) + DW / 2) + 'px" title="' + esc(c.title + ": " + fmtDate(c.f.due)) + '" aria-label="' + esc(c.title + ", " + fmtDate(c.f.due)) + '"></button>'; }).join("") + '</div></div>';
      }
    });
    var todayX = 210 + x(t) + DW / 2;
    var html = '<div class="panel"><div class="panel-head"><h2 class="panel-title">Timeline</h2><span class="hint">Cards with a start and end date show as bars. Single dates show as diamonds.</span></div>';
    if(!bars.length && !marks.length) html += '<div class="empty"><h3>No dates to chart yet</h3><p>Give a project a start and end date, or a server a maintenance window, and it appears here.</p></div>';
    else html += '<div class="gantt-scroll" id="ganttScroll"><div class="gantt">' + head + rows + '<div class="g-today" style="left:' + todayX + 'px"><span>Today</span></div></div></div>' +
      '<div class="legend">' + TYPE_ORDER.map(function(k){ return '<span style="' + typeVar(k) + '"><span class="dot"></span>' + esc(td(k).plural) + '</span>'; }).join("") + '</div>';
    box.innerHTML = html + '</div>';
    var sc = $("ganttScroll");
    if(sc){
      var lbl = sc.querySelector(".g-label"); var lw = lbl ? lbl.offsetWidth : 210;
      sc.querySelector(".g-today").style.left = (lw + x(t) + DW / 2) + "px";
      sc.scrollLeft = Math.max(0, x(t) - 7 * DW);
    }
  }

  /* ================= views ================= */
  var VIEWS = ["rolodex", "today", "board", "calendar", "timeline", "upcoming"];
  function setView(v){
    if(VIEWS.indexOf(v) < 0) v = "rolodex";
    if(v !== "rolodex" && S.nav === "templates") S.nav = "all";
    S.view = v;
    VIEWS.forEach(function(n){ $("v-" + n).hidden = n !== v; });
    $("views").querySelectorAll("button").forEach(function(b){ b.setAttribute("aria-selected", b.dataset.view === v ? "true" : "false"); });
    savePrefs();
    try{ if(location.hash !== "#" + v) history.replaceState(null, "", "#" + v); }catch(e){}
    refresh();
  }
  function savePrefs(){ lsSet(PREF_KEY, JSON.stringify({view:S.view, sort:S.sort, collapsed:S.collapsed, boardType:S.boardType, autoMeet:S.autoMeet, wheelSound:!!S.wheelSound, wsName:S.wsName, space:S.space, calView:S.calView})); }

  /* ================= search box ================= */
  var qEl = $("q"), qPop = $("qPop"), qSel = 0;
  var FILTER_CHIPS_QUICK = [["Overdue","is:overdue"],["Today","is:today"],["Tomorrow","is:tomorrow"],["This week","is:week"],["Next week","is:nextweek"]];
  var FILTER_CHIPS_CONTENT = [["Has notes","has:notes"],["Has file","has:file"],["Has link","has:link"],["Has checklist","has:checklist"]];
  var FILTER_CHIPS = FILTER_CHIPS_QUICK.concat(FILTER_CHIPS_CONTENT);
  function setQuery(v){
    S.query = v; S.pq = parseQuery(v);
    if(qEl.value !== v) qEl.value = v;
    $("qClear").hidden = !v; $("qKbd").hidden = !!v;
  }
  function renderSearchCount(){
    $("qCount").textContent = S.pq && !S.pq.empty ? S.deck.length + (S.deck.length === 1 ? " match" : " matches") : "";
  }
  function renderPop(){
    if(document.activeElement !== qEl){ qPop.hidden = true; return; }
    if(!S.pq || S.pq.empty){
      var chipRow = function(list){ return list.map(function(f){ return '<button type="button" class="q-tip" data-tip="' + f[1] + '">' + f[0] + '</button>'; }).join(""); };
      qPop.innerHTML = '<div class="q-tips"><div>Search every field, note, link and file name.</div>' +
        '<div class="q-group" id="qFilterChips">' +
        '<div class="ws-lbl">Quick filters</div><div class="q-tips-row">' + chipRow(FILTER_CHIPS_QUICK) + '</div>' +
        '<div class="ws-lbl">Content</div><div class="q-tips-row">' + chipRow(FILTER_CHIPS_CONTENT) + '</div>' +
        '</div>' +
        '<div class="q-group" id="qAdvancedChips">' +
        '<div class="ws-lbl">Advanced</div><div class="q-tips-row">' +
        ['type:server', 'type:people', 'is:open', '#prod', 'is:blocked', 'type:issue is:open'].map(function(s){ return '<button type="button" class="q-tip" data-tip="' + s + '">' + s + '</button>'; }).join("") +
        '</div></div>' +
        '<div>Press <kbd>Enter</kbd> to open the first match, <kbd>↑</kbd> <kbd>↓</kbd> to choose.</div></div>';
      qPop.hidden = false; return;
    }
    var askItem = S.sample ? '<button type="button" class="q-item" data-ask="1"><span class="t-chip" style="--tc:var(--accent)">Ask</span><b>Ask Claude: “' + esc(S.query.trim()) + '”</b><span class="snip">Get an answer from all your cards</span></button>' : "";
    var res = ranked(S.deck, S.pq).slice(0, 8);
    qSel = Math.min(qSel, Math.max(0, res.length - 1));
    qPop.innerHTML = (/\?\s*$/.test(S.query) ? askItem : "") + (res.length ? res.map(function(c, i){
      return '<button type="button" class="q-item' + (i === qSel ? " sel" : "") + '" data-open="' + esc(c.id) + '" style="' + typeVar(c.type) + '"><span class="t-chip">' + esc(td(c.type).short) + '</span><b>' + highlight(c.title, S.pq.terms) + '</b><span class="snip">' + snippet(c, S.pq) + '</span></button>';
    }).join("") + (S.deck.length > 8 ? '<div class="q-empty">' + (S.deck.length - 8) + ' more in the list on the left.</div>' : "")
      : '<div class="q-empty">No cards match “' + esc(S.query) + '”.</div>' + (/\?\s*$/.test(S.query) ? "" : askItem));
    qPop.hidden = false;
  }
  qEl.addEventListener("input", function(){ setQuery(qEl.value); qSel = 0; refresh(); renderPop(); });
  qEl.addEventListener("focus", renderPop);
  qEl.addEventListener("blur", function(){ setTimeout(function(){ if(document.activeElement !== qEl) qPop.hidden = true; }, 150); });
  qEl.addEventListener("keydown", function(e){
    if(e.key === "ArrowDown" || e.key === "ArrowUp"){ e.preventDefault(); qSel = Math.max(0, Math.min(Math.min(7, S.deck.length - 1), qSel + (e.key === "ArrowDown" ? 1 : -1))); renderPop(); }
    else if(e.key === "Enter" && S.sample && /\?\s*$/.test(S.query)){ var qq = S.query.trim(); qEl.blur(); qPop.hidden = true; openAsk(qq); }
    else if(e.key === "Enter"){ var c = S.pq && !S.pq.empty ? ranked(S.deck, S.pq)[qSel] : null; if(c){ qEl.blur(); qPop.hidden = true; jumpTo(c.id, true); } }
    else if(e.key === "Escape"){ if(qEl.value){ setQuery(""); refresh(); renderPop(); } else qEl.blur(); }
  });
  qPop.addEventListener("mousedown", function(e){ e.preventDefault(); });
  qPop.addEventListener("click", function(e){
    var b = e.target.closest("[data-tip]");
    if(b){ setQuery(b.dataset.tip + " "); qEl.focus(); refresh(); renderPop(); return; }
    if(e.target.closest("[data-ask]")){ var q = S.query.trim(); qEl.blur(); qPop.hidden = true; openAsk(q); return; }
    b = e.target.closest("[data-open]");
    if(b){ qEl.blur(); qPop.hidden = true; jumpTo(b.dataset.open, true); }
  });
  $("qClear").addEventListener("click", function(){ setQuery(""); refresh(); qEl.focus(); });

  /* ================= global events ================= */
  document.addEventListener("keydown", function(e){
    var a = document.activeElement, tag = a && a.tagName;
    var typing = a && (a.isContentEditable || tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT");
    if(e.defaultPrevented) return;
    if((e.key === "k" || e.key === "K") && (e.metaKey || e.ctrlKey)){ e.preventDefault(); qEl.focus(); qEl.select(); return; }
    if(e.altKey && !typing && (e.key === "ArrowLeft" || e.key === "ArrowRight")){ e.preventDefault(); if(e.key === "ArrowLeft") goBack(); else goForward(); return; }
    if(e.key === "Escape"){
      if(!$("snoozeMenu").hidden){ closeSnooze(); return; }
      if(!$("lightbox").hidden){ $("lightbox").hidden = true; return; }
      if(!$("modal").hidden){ closeModal(); return; }
      if(helpOpen){ closeHelp(); return; }
      if(!$("newMenu").hidden){ toggleNew(false); return; }
      if(!$("wsMenu").hidden){ toggleWs(false); return; }
      if(S.open && S.view === "rolodex"){ if(typing) a.blur(); closeCard(); return; }
    }
    if(e.key === "Tab" && !$("modal").hidden){
      var box = $("modalBox"), items = focusablesIn(box);
      if(!items.length){ e.preventDefault(); box.focus(); return; }
      var idx = items.indexOf(a);
      if(e.shiftKey){ if(idx <= 0){ e.preventDefault(); items[items.length - 1].focus(); } }
      else{ if(idx === -1 || idx === items.length - 1){ e.preventDefault(); items[0].focus(); } }
      return;
    }
    if(typing) return;
    if(e.key === "/"){ e.preventDefault(); qEl.focus(); return; }
    if(e.key === "?"){ e.preventDefault(); toggleHelp(); return; }
    if(S.view !== "rolodex") return;
    if(S.open && e.key !== "Escape") return;
    if(e.key === "ArrowDown" || e.key === "ArrowRight"){ e.preventDefault(); step(1); }
    else if(e.key === "ArrowUp" || e.key === "ArrowLeft"){ e.preventDefault(); step(-1); }
    else if(e.key === "PageDown"){ e.preventDefault(); step(10); }
    else if(e.key === "PageUp"){ e.preventDefault(); step(-10); }
    else if(e.key === "Home"){ e.preventDefault(); step(-1e6, true); }
    else if(e.key === "End"){ e.preventDefault(); step(1e6, true); }
    else if((e.key === "Enter" || e.key === " ") && tag !== "BUTTON"){ e.preventDefault(); openCard(); }
  });

  document.addEventListener("click", function(e){
    if(!S.open || S.view !== "rolodex") return;
    var t = e.target;
    if(!t || !t.isConnected) return;
    if(t.closest(".card.front, #lightbox, #toast, #deckList, #modal, #meetBar, #remindBar, #snoozeMenu, .fmt-bar")) return;
    closeCard();
  }, true);

  $("trail").addEventListener("click", function(e){
    var b = e.target.closest("button"); if(!b) return;
    if(b.dataset.trail === "back") goBack();
    else if(b.dataset.trail === "fwd") goForward();
    else if(b.dataset.trail === "clear"){ S.back = []; S.fwd = []; renderTrail(); if(S.open) rebuildDetail(); }
    else if(b.dataset.crumb !== undefined) goCrumb(+b.dataset.crumb);
  });

  $("prevBtn").addEventListener("click", function(){ step(-1); });
  $("nextBtn").addEventListener("click", function(){ step(1); });
  $("az").addEventListener("click", function(e){
    var b = e.target.closest("button[data-l]"); if(!b || b.disabled) return;
    var L = b.dataset.l;
    var i = S.deck.findIndex(function(c){ var ch = c.title.charAt(0).toUpperCase(); return L === "#" ? !/[A-Z]/.test(ch) : ch === L; });
    if(i >= 0) jumpTo(S.deck[i].id);
  });
  var nav = $("nav");
  nav.addEventListener("click", function(e){
    var b;
    if((b = e.target.closest("[data-collapse]"))){ var k = b.dataset.collapse; S.collapsed[k] = !S.collapsed[k]; savePrefs(); renderNav(); return; }
    if((b = e.target.closest("[data-caret]"))){ var ck = "f:" + b.dataset.caret; S.collapsed[ck] = !S.collapsed[ck]; savePrefs(); renderNav(); return; }
    if((b = e.target.closest("[data-edittypes]"))){ openTypes(); return; }
    if((b = e.target.closest("[data-editfolders]"))){ S.editFolders = !S.editFolders; if(S.editFolders) S.collapsed.folders = false; renderNav(); return; }
    if((b = e.target.closest("[data-addfolder]"))){ addFolder(b.dataset.addfolder); return; }
    if((b = e.target.closest("[data-delfolder]"))){ if(armed(b, "Delete?")) deleteFolder(b.dataset.delfolder); return; }
    if((b = e.target.closest("[data-nav]"))){ if(b.dataset.nav === "trash"){ openTrash(); return; } S.nav = b.dataset.nav; S.open = false; refresh(); }
  });
  nav.addEventListener("input", function(e){
    var id = e.target.dataset && e.target.dataset.rename; if(!id) return;
    var f = folderById(id); if(!f) return;
    f.name = e.target.value.slice(0, 80) || "Untitled folder";
    saveFolders();
  });
  nav.addEventListener("change", function(e){
    var id = e.target.dataset && e.target.dataset.reparent; if(!id) return;
    moveFolder(id, e.target.value || null);
  });
  nav.addEventListener("keydown", function(e){ if(e.target.classList.contains("folder-edit") && e.key === "Enter"){ e.preventDefault(); e.target.blur(); } });
  nav.addEventListener("focusout", function(e){ if(e.target.classList.contains("folder-edit")) setTimeout(function(){ nav._html = ""; refresh(); }, 0); });

  /* drag cards from the list onto folders, and folders onto folders */
  var dragKind = "", dragId = "";
  $("deckList").addEventListener("dragstart", function(e){
    var b = e.target.closest("button[data-id]"); if(!b) return;
    dragKind = "card"; dragId = b.dataset.id;
    e.dataTransfer.effectAllowed = "move";
    try{ e.dataTransfer.setData("text/plain", S.cards.get(dragId).title); }catch(err){}
  });
  nav.addEventListener("dragstart", function(e){
    var row = e.target.closest && e.target.closest(".folder-row.editing"); if(!row) return;
    dragKind = "folder"; dragId = row.dataset.folder;
    e.dataTransfer.effectAllowed = "move";
    try{ e.dataTransfer.setData("text/plain", folderById(dragId).name); }catch(err){}
  });
  document.addEventListener("dragend", function(){ dragKind = ""; dragId = ""; nav.querySelectorAll(".drop").forEach(function(x){ x.classList.remove("drop"); }); });
  function dropTarget(e){
    if(!dragKind || S.readOnly) return null;
    var t = e.target.closest && e.target.closest(".folder-row, [data-droproot], [data-nav='all'], [data-nav='unfiled']");
    if(!t) return null;
    if(dragKind === "folder" && (t.dataset.nav === "all" || t.dataset.nav === "unfiled")) return null;
    if(dragKind === "card" && t.hasAttribute("data-droproot")) return null;
    return t;
  }
  nav.addEventListener("dragover", function(e){
    var t = dropTarget(e); if(!t) return;
    e.preventDefault(); e.dataTransfer.dropEffect = "move";
    nav.querySelectorAll(".drop").forEach(function(x){ if(x !== t) x.classList.remove("drop"); });
    t.classList.add("drop");
  });
  nav.addEventListener("dragleave", function(e){ var t = e.target.closest && e.target.closest(".drop"); if(t && !t.contains(e.relatedTarget)) t.classList.remove("drop"); });
  nav.addEventListener("drop", function(e){
    var t = dropTarget(e); if(!t) return;
    e.preventDefault(); t.classList.remove("drop");
    var folder = t.dataset.folder || "";
    if(dragKind === "card") fileCard(dragId, folder);
    else if(dragKind === "folder") moveFolder(dragId, folder || null);
    dragKind = ""; dragId = "";
  });
  $("deckList").addEventListener("click", function(e){
    var b = e.target.closest("button[data-id]"); if(b){ jumpTo(b.dataset.id, S.view === "rolodex" && b.dataset.id === S.curId ? !S.open : false); return; }
    var act = e.target.closest("[data-act]"); if(!act) return;
    if(act.dataset.act === "clear-filters"){ S.nav = "all"; setQuery(""); refresh(); }
    else if(act.dataset.act === "load-examples") loadSamples();
    else if(act.dataset.act === "open-import") openImport();
  });
  $("sortSel").addEventListener("change", function(e){ S.sort = e.target.value; savePrefs(); refresh(); });
  $("views").addEventListener("click", function(e){ var b = e.target.closest("button[data-view]"); if(b) setView(b.dataset.view); });
  function updateSpaceToggle(){
    $("spaceToggle").querySelectorAll("button[data-space]").forEach(function(b){
      var on = b.dataset.space === S.space;
      b.classList.toggle("on", on);
      b.setAttribute("aria-selected", on ? "true" : "false");
    });
  }
  $("spaceToggle").addEventListener("click", function(e){
    var b = e.target.closest("button[data-space]"); if(!b) return;
    var sp = b.dataset.space; if(sp === S.space) return;
    S.space = sp;
    if(sp === "home") ensureHomeStarter();
    S.nav = "all";
    if(S.open) S.open = false;
    updateSpaceToggle();
    savePrefs();
    refresh();
  });
  window.addEventListener("hashchange", function(){ var v = location.hash.slice(1); if(v && v !== S.view && VIEWS.indexOf(v) >= 0) setView(v); });
  $("main").addEventListener("click", function(e){
    var q = e.target.closest("[data-qdone], [data-qsnooze], [data-qstill], [data-rsnooze], [data-rdone]");
    if(q){
      e.stopPropagation();
      var qc = S.cards.get(q.dataset.qdone || q.dataset.qsnooze || q.dataset.qstill || q.dataset.rsnooze || q.dataset.rdone); if(!qc || S.readOnly) return;
      if(q.dataset.qdone){
        var done = td(qc.type).statuses.filter(function(st){ return CLOSED[st]; })[0], was = qc.status;
        qc.status = done; logHist(qc, "Status: " + was + " → " + done);
        var roll = rollCard(qc);
        touch(qc.id);
        if(S.open && S.curId === qc.id) rebuildDetail();
        if(roll && roll.rolled) toast("Done — next one is " + fmtDate(roll.next, true) + ".");
        else toast("Marked “" + qc.title + "” " + done.toLowerCase() + ".", {label:"Undo", fn:function(){ qc.status = was; logHist(qc, "Status: " + done + " → " + was); touch(qc.id); refresh(); }});
      } else if(q.dataset.qsnooze){ openDateSnooze(q, qc, q.dataset.qdate); return; }
      else if(q.dataset.rsnooze){ openRemindSnooze(q, qc); return; }
      else if(q.dataset.rdone) remindDone(qc);
      else if(q.dataset.qstill){ logHist(qc, "Checked in: still on it"); touch(qc.id); toast("Checked in on “" + qc.title + "”."); }
      refresh(); return;
    }
    var b = e.target.closest("[data-open]");
    if(b && !b.closest(".card")){ e.stopPropagation(); jumpTo(b.dataset.open, true); return; }
    var n = e.target.closest("[data-cal]");
    if(n){
      var d = +n.dataset.cal, m = S.calMonth; S.calAdd = false;
      if(d === 0){ S.calDay = today(); S.calMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1); }
      else if(S.calView === "week"){ S.calDay = addDays(S.calDay || today(), 7 * d); var wd = parseISO(S.calDay); S.calMonth = new Date(wd.getFullYear(), wd.getMonth(), 1); }
      else S.calMonth = new Date(m.getFullYear(), m.getMonth() + d, 1);
      renderCalendar(); return;
    }
    var cv = e.target.closest("[data-calview]");
    if(cv){
      S.calView = cv.dataset.calview === "week" ? "week" : "month";
      if(S.calView === "month" && S.calDay){ var sd = parseISO(S.calDay); S.calMonth = new Date(sd.getFullYear(), sd.getMonth(), 1); }
      savePrefs(); renderCalendar(); return;
    }
    if(e.target.closest("[data-caladd]")){ selectCalDay(S.calDay || today(), !S.calAdd); return; }
    var day = e.target.closest("[data-day]");
    if(day){ selectCalDay(day.dataset.day, S.calAdd && day.dataset.day === S.calDay); return; }
    var nb = e.target.closest("[data-new]");
    if(nb){ createCard(nb.dataset.new, nb.dataset.date); return; }
    var act = e.target.closest("[data-act]");
    if(act && act.dataset.act === "clear-filters"){ S.nav = "all"; setQuery(""); refresh(); }
    if(act && act.dataset.act === "load-examples") loadSamples();
    if(act && act.dataset.act === "open-import") openImport();
  });
  $("main").addEventListener("keydown", function(e){
    var day = e.target.closest && e.target.closest("[data-day]");
    if(day && e.target === day && (e.key === "Enter" || e.key === " ")){ e.preventDefault(); selectCalDay(day.dataset.day); }
    var chip = e.target.classList && e.target.classList.contains("cal-chip") ? e.target : null;
    if(chip && (e.key === "Enter" || e.key === " ")){ e.preventDefault(); jumpTo(chip.dataset.open, true); }
  });
  $("lightbox").addEventListener("click", function(){ $("lightbox").hidden = true; });

  function toggleNew(show){
    var m = $("newMenu"); m.hidden = !show; $("newBtn").setAttribute("aria-expanded", show ? "true" : "false");
  }
  function renderNewMenu(){
    var tpl = {};
    templatesInSpace().forEach(function(c){ (tpl[c.type] = tpl[c.type] || []).push(c); });
    var html = spaceTypes().map(function(k){ return '<button type="button" data-new="' + k + '" style="' + typeVar(k) + '"><span class="dot"></span>' + esc(td(k).label) + '</button>' +
      (tpl[k] || []).map(function(c){ return '<button type="button" class="tpl-item" data-newtpl="' + esc(c.id) + '" style="' + typeVar(k) + '"><span class="tpl-from">from template</span><span class="tpl-name">' + esc(c.title) + '</span></button>'; }).join(""); }).join("");
    var m = $("newMenu"); if(m._html !== html){ m.innerHTML = html; m._html = html; }
  }
  renderNewMenu();
  $("newBtn").addEventListener("click", function(e){ e.stopPropagation(); toggleNew($("newMenu").hidden); });
  $("newMenu").addEventListener("click", function(e){ var t = e.target.closest("[data-newtpl]"); if(t){ toggleNew(false); createFromTemplate(t.dataset.newtpl); return; } var b = e.target.closest("[data-new]"); if(b){ toggleNew(false); createCard(b.dataset.new); } });
  document.addEventListener("click", function(e){ if(!e.target.closest(".new-wrap")) toggleNew(false); });

  function removeCards(ids){
    var gone = {}, files = [];
    ids.forEach(function(id){
      var c = S.cards.get(id); if(!c) return;
      gone[id] = 1; files = files.concat(cardFileIds(c));
      S.cards.delete(id); S.dirty.add(id); clearTimeout(saveTimers[id]); flush(id);
    });
    dropFiles(files);
    S.cards.forEach(function(o){
      var keep = o.rel.filter(function(r){ return !gone[r]; });
      if(keep.length !== o.rel.length){ o.rel = keep; touch(o.id); }
    });
    if(S.mode === "local") saveLocal();
    S.open = false;
  }
  function loadSamples(){
    if(S.readOnly){ toast("You have view-only access to this workspace."); return; }
    /* sample cards are always Work data — switch there so a click from the workspace
       menu (or the sidebar's empty-list prompt) while viewing Home doesn't silently
       load cards into a space the user can't currently see */
    var switched = S.space === "home";
    if(switched){ S.space = "work"; S.nav = "all"; if(S.open) S.open = false; updateSpaceToggle(); savePrefs(); }
    sampleFolders().forEach(function(f){ if(!folderById(f.id)) S.folders.push(f); });
    var list = examples();
    list.forEach(function(c){ S.cards.set(c.id, c); touch(c.id); });
    S.collapsed.folders = false;
    foldersChanged();
    toast("Loaded " + list.length + " sample cards and " + sampleFolders().length + " sample folders." + (switched ? " Switched to Work." : "") + " Clear them any time from Data.");
    refresh();
  }
  /* Home space starter types: pre-seeded card types only, no cards, per the product plan's "Personal life admin" pack. */
  function ensureHomeStarter(){
    if(typeCfg.custom.some(function(x){ return x.home; })) return;
    var mk = function(key, label, plural, short, color, statuses, fields){
      return {key:key, label:label, plural:plural, short:short, color:color, statuses:statuses, fields:fields, home:true};
    };
    var starters = [
      mk("hs_contacts", "Contact", "Contacts", "CON", "c1", ["Active", "Inactive"], [{k:"phone", l:"Phone", t:"tel"}, {k:"email", l:"Email", t:"email"}]),
      mk("hs_house", "Home", "Home", "HOM", "c2", ["Active", "Inactive"], [{k:"address", l:"Address", t:"text"}, {k:"notes", l:"Notes", t:"text"}]),
      mk("hs_car", "Car", "Cars", "CAR", "c3", ["Active", "Inactive"], [{k:"make", l:"Make", t:"text"}, {k:"model", l:"Model", t:"text"}, {k:"reg", l:"Registration", t:"text"}, {k:"renewal", l:"Insurance renewal", t:"date"}]),
      mk("hs_insurance", "Insurance & policy", "Insurance & policies", "INS", "c4", ["Active", "Expired"], [{k:"provider", l:"Provider", t:"text"}, {k:"policy", l:"Policy number", t:"text"}, {k:"renewal", l:"Renewal date", t:"date"}]),
      mk("hs_documents", "Document", "Documents", "DOC", "c5", ["Current", "Expired"], [{k:"kind", l:"Type", t:"text"}, {k:"expiry", l:"Expiry date", t:"date"}]),
      mk("hs_reminders", "Reminder", "Reminders", "REM", "c6", ["Open", "Done"], [{k:"due", l:"Due date", t:"date"}, {k:"notes", l:"Notes", t:"text"}])
    ];
    starters.forEach(function(s){ typeCfg.custom.push(s); });
    typeCfg = normTypeCfg(typeCfg);
    rebuildTypes();
    saveTypes();
  }
  $("loadSample").addEventListener("click", loadSamples);
  $("clearSample").addEventListener("click", function(){
    var btn = $("clearSample");
    if(!armed(btn, "Click again to clear")) return;
    var ids = Array.from(S.cards.values()).filter(function(c){ return c.example; }).map(function(c){ return c.id; });
    removeCards(ids);
    /* drop sample folders that no longer hold anything of yours */
    var used = {};
    S.cards.forEach(function(c){ if(c.folder) used[c.folder] = 1; });
    S.folders.forEach(function(f){ if(!f.example) used[f.id] = 1; });
    var removed = 0, changed = true;
    while(changed){
      changed = false;
      S.folders = S.folders.filter(function(f){
        if(!f.example) return true;
        var busy = used[f.id] || S.folders.some(function(x){ return x.parent === f.id; });
        if(busy) return true;
        removed++; changed = true; return false;
      });
    }
    foldersChanged();
    toast("Cleared " + ids.length + " sample cards" + (removed ? " and " + removed + " sample folders" : "") + ".");
    refresh();
  });
  $("clearAll").addEventListener("click", function(){
    var btn = $("clearAll");
    if(!armed(btn, "Click again to move every card to the Trash")) return;
    var ids = Array.from(S.cards.values()).filter(function(c){ return !c.template; }).map(function(c){ return c.id; });
    trashCards(ids); S.open = false;
    toast("Moved all " + ids.length + " cards to the Trash. Your folders are still there.", {label:"Undo", fn:function(){ restoreCards(ids); }});
    refresh();
  });

  /* ================= workspace menu ================= */
  function renderBackupNote(){
    var el = $("backupNote"); if(!el) return;
    var t = lsGet(LASTBACKUP_KEY);
    var d = t && fmtDate(t.slice(0, 10));
    var days = d ? (Date.now() - new Date(t).getTime()) / 864e5 : Infinity;
    var stale = !(days <= 14);
    var when = !d ? "" : days < 45 ? Math.round(days / 7) + " weeks ago" : days < 365 ? Math.round(days / 30) + " months ago" : "over a year ago";
    el.textContent = !d ? "No backup made yet — export one now" : stale ? "Last backup: " + when + " — export one now" : "Last backup: " + d;
    el.classList.toggle("warn", stale);
  }
  /* ---------- storage use (workspace menu, Data & safety) ----------
     Works out what can be known about storage in the current mode and draws it into #storageUse:
     the hosted app's assets.usage() (files + database vs. the free plan), claude.ai's record count
     (one doc per card, meeting page and notes page, plus meta/folders and meta/types, vs. ~5,000),
     or this browser's quota (navigator.storage.estimate()). Refreshed each time the menu opens. */
  var RECORD_LIMIT = 5000, usageTick = 0;
  function countFiles(){
    var ids = {}, n = 0;
    var add = function(f){ if(!f) return; if(f.id){ if(!ids[f.id]){ ids[f.id] = 1; n++; } } else if(f.data) n++; };
    Array.from(S.cards.values()).concat(Array.from(S.trash.values())).forEach(function(c){
      (c.files || []).forEach(add);
      (c.page || []).forEach(function(b){ if(b.k === "i") add(b.f); });
      (c.sess || []).forEach(function(s){ (s.files || []).forEach(add); (s.blocks || []).forEach(function(b){ if(b.k === "i") add(b.f); }); });
    });
    return n;
  }
  /* docs online: the server's copy of each card's meeting pages and notes page, joined with what's
     in memory (a trashed card's pages may only be known from the server snapshot) */
  function countRecords(){
    var n = 2, docs = {}; /* 2 = meta/folders and meta/types */
    serverSess.forEach(function(v, k){ docs["s:" + k] = 1; });
    serverPage.forEach(function(v, k){ docs["p:" + k] = 1; });
    Array.from(S.cards.values()).concat(Array.from(S.trash.values())).forEach(function(c){
      n++;
      (c.sess || []).forEach(function(s){ docs["s:" + sessDocId(c.id, s.id)] = 1; });
      if(c.page) docs["p:" + c.id] = 1;
    });
    return n + Object.keys(docs).length;
  }
  function storageUsage(){
    var num = function(x){ return typeof x === "number" && isFinite(x) && x >= 0; };
    var plural = function(n, w){ return Number(n).toLocaleString() + " " + w + (n === 1 ? "" : "s"); };
    var row = function(text, used, limit){ return {text:text, pct:num(used) && num(limit) && limit > 0 ? Math.min(100, used / limit * 100) : null}; };
    var trashed = S.trash.size, cards = S.cards.size + trashed;
    var cardLine = plural(cards, "card") + (trashed ? " (" + Number(trashed).toLocaleString() + " in the Trash)" : "") + ", " + plural(countFiles(), "file");
    if(S.mode === "loading") return Promise.resolve({rows:[], caption:"Storage use shows once your workspace has loaded."});
    if(S.mode === "online" && S.assets && typeof S.assets.usage === "function"){
      var p;
      try{ p = Promise.resolve(S.assets.usage()); }catch(e){ p = Promise.reject(e); }
      return p.then(function(u){
        u = u || {};
        var rows = [];
        if(num(u.fileBytes)) rows.push(row("Files: " + fmtBytes(u.fileBytes) + (num(u.fileLimit) ? " of " + fmtBytes(u.fileLimit) : "") + (num(u.fileCount) ? " (" + plural(u.fileCount, "file") + ")" : ""), u.fileBytes, u.fileLimit));
        if(num(u.dbBytes)) rows.push(row("Database: " + fmtBytes(u.dbBytes) + (num(u.dbLimit) ? " of " + fmtBytes(u.dbLimit) : ""), u.dbBytes, u.dbLimit));
        if(!rows.length) return {rows:[], caption:cardLine + "."};
        return {rows:rows, caption:"Free plan limits." + (num(u.dbBytes) ? " The database figure covers the whole project, not just this workspace." : "")};
      }, function(){ return {rows:[], caption:"Couldn't read storage use right now."}; });
    }
    if(S.mode === "online"){
      var recs = countRecords(), files = countFiles();
      return Promise.resolve({rows:[row("Records: " + Number(recs).toLocaleString() + " of " + Number(RECORD_LIMIT).toLocaleString(), recs, RECORD_LIMIT), {text:plural(files, "file") + " uploaded", pct:null}],
        caption:"Each card, meeting page and notes page is one record (up to 256 KB each). Cards in the Trash still count."});
    }
    var est = null;
    try{ if(navigator.storage && typeof navigator.storage.estimate === "function") est = navigator.storage.estimate(); }catch(e){ est = null; }
    return Promise.resolve(est).then(function(e){
      if(!e || !num(e.usage)) return {rows:[], caption:cardLine + ", saved in this browser."};
      return {rows:[row("This browser: " + fmtBytes(e.usage) + " used" + (num(e.quota) && e.quota > 0 ? " of about " + fmtBytes(e.quota) + " available" : ""), e.usage, e.quota)], caption:cardLine + "."};
    }, function(){ return {rows:[], caption:cardLine + ", saved in this browser."}; });
  }
  function renderStorageUse(){
    var el = $("storageUse"); if(!el) return;
    var tick = ++usageTick;
    if(!el.innerHTML) el.innerHTML = '<p class="usage-cap">Checking storage use…</p>';
    storageUsage().then(function(r){
      if(tick !== usageTick) return;
      el.innerHTML = r.rows.map(function(x){
        var meter = x.pct === null ? "" : '<div class="meter"><div class="meter-track"><div class="meter-fill' + (x.pct >= 85 ? " hot" : "") + '" style="width:' + x.pct.toFixed(1) + '%"></div></div><span class="mono">' + (x.pct > 0 && x.pct < 1 ? "&lt;1" : Math.round(x.pct)) + '%</span></div>';
        return '<div class="usage-row"><span class="usage-lbl">' + esc(x.text) + '</span>' + meter + '</div>';
      }).join("") + (r.caption ? '<p class="usage-cap">' + esc(r.caption) + '</p>' : "");
    }, function(){ if(tick === usageTick) el.innerHTML = '<p class="usage-cap">Couldn\'t read storage use right now.</p>'; });
  }
  function toggleWs(show){ $("wsMenu").hidden = !show; $("wsBtn").setAttribute("aria-expanded", show ? "true" : "false"); if(show){ $("wsNameIn").value = S.wsName; $("autoMeet").checked = S.autoMeet !== false; $("wheelSound").checked = !!S.wheelSound; renderBackupNote(); renderStorageUse(); $("cleanupBtn").hidden = S.readOnly || !(S.assets && typeof S.assets.list === "function"); } }
  $("wsBtn").addEventListener("click", function(e){ e.stopPropagation(); toggleWs($("wsMenu").hidden); });
  document.addEventListener("click", function(e){ if(!e.target.closest(".ws-wrap")) toggleWs(false); });

  /* ================= save-state popover ================= */
  $("saveState").addEventListener("click", function(e){ e.stopPropagation(); toggleSaveInfo($("savePop").hidden); });
  document.addEventListener("click", function(e){ if(!e.target.closest(".save-wrap")) toggleSaveInfo(false); });
  $("wsMenu").addEventListener("click", function(e){
    var b = e.target.closest("button"); if(!b) return;
    if(b.id === "wsTypes" || b.id === "importSheet" || b.id === "exportBtn" || b.id === "loadSample" || b.id === "trashBtn" || b.id === "cleanupBtn" || b.id === "tipsBtn" || b.id === "templatesBtn") toggleWs(false);
  });
  $("wsTypes").addEventListener("click", openTypes);
  $("templatesBtn").addEventListener("click", openTemplates);
  $("modalBox").addEventListener("click", function(e){
    if(modalKind !== "templates") return;
    var b = e.target.closest("button"); if(!b) return;
    if(b.dataset.tuse){ var u = b.dataset.tuse; closeModal(); createFromTemplate(u); }
    else if(b.dataset.tedit){ var ed = b.dataset.tedit; closeModal(); jumpTo(ed, true); }
    else if(b.dataset.tdel){ if(armed(b, "Click again")){ var dc = S.cards.get(b.dataset.tdel); if(dc){ if(S.open && S.curId === dc.id) S.open = false; trashCards([dc.id]); toast("Moved the template “" + dc.title + "” to the Trash.", {label:"Undo", fn:function(){ restoreCards([dc.id]); if(modalKind === "templates") renderTemplates(); }}); renderTemplates(); refresh(); } } }
  });
  $("trashBtn").addEventListener("click", openTrash);
  $("cleanupBtn").addEventListener("click", openCleanup);
  $("toast").addEventListener("click", function(e){
    if(!e.target.closest(".toast-btn") || !toastAction) return;
    var a = toastAction; toastAction = null; $("toast").hidden = true; a.fn();
  });
  $("modalBox").addEventListener("click", function(e){
    if(modalKind !== "trash") return;
    var b = e.target.closest("button"); if(!b) return;
    if(b.dataset.restore) restoreCards([b.dataset.restore]);
    else if(b.dataset.restoreall) restoreCards(Array.from(S.trash.keys()));
    else if(b.dataset.purge){ if(armed(b, "Click again")){ purgeCards([b.dataset.purge]); renderTrash(); } }
    else if(b.dataset.emptytrash){ if(armed(b, "Click again to empty")){ var n = S.trash.size; purgeCards(Array.from(S.trash.keys())); renderTrash(); toast("Removed " + n + " cards for good."); } }
  });
  $("modalBox").addEventListener("click", function(e){
    if(modalKind !== "cleanup") return;
    var b = e.target.closest("[data-cleanupdel]"); if(!b || !cleanupState || cleanupState.scanning) return;
    if(!armed(b, "Click again to delete")) return;
    var orphans = cleanupState.orphans;
    b.disabled = true; b.textContent = "Deleting…";
    Promise.all(orphans.map(function(o){ return S.assets.delete(o.id).catch(function(){}); })).then(function(){
      toast("Removed " + orphans.length + " unused file" + (orphans.length === 1 ? "" : "s") + ".");
      cleanupState = {scanning:false, orphans:[]};
      if(modalKind === "cleanup") renderCleanup();
    });
  });
  $("wsNameIn").addEventListener("input", function(e){ S.wsName = e.target.value.trim().slice(0, 60) || "My workspace"; $("wsName").textContent = S.wsName; savePrefs(); });
  $("wsNameIn").addEventListener("keydown", function(e){ if(e.key === "Enter"){ e.preventDefault(); toggleWs(false); } });
  $("wheelSound").addEventListener("change", function(e){ S.wheelSound = e.target.checked; savePrefs(); if(S.wheelSound) tick(); });
  $("autoMeet").addEventListener("change", function(e){ S.autoMeet = e.target.checked; savePrefs(); toast(S.autoMeet ? "Meeting notes will open when a meeting is about to start." : "Meetings won't open by themselves. You'll still see a reminder bar."); });

  /* ================= tips ================= */
  var TIPS = [
    "Press / to search from anywhere. End a search with ? to ask Claude instead.",
    "Scroll, drag or use the arrow keys to turn the wheel. It goes all the way round.",
    "Click the front card to open it; click anywhere outside it or press Esc to close it.",
    "Paste a screenshot straight into meeting notes with Ctrl+V or ⌘V.",
    "Alt+← and Alt+→ take you back and forward through the cards you've visited.",
    "Drag a card from the list onto a folder to file it.",
    "Star a card to pin it to Favourites and the Today page.",
    "Import your Outlook calendar (File › Save Calendar) to get a card for every meeting, with its Join link.",
    "Type #tag, type:meeting or is:open in the search box to narrow things down.",
    "Link cards together, then follow the links and use Back to return.",
    "On the Board, drag a card to another column to change its status.",
    "Notes are pages: click anywhere to write, and paste a screenshot where you clicked. Drag the dotted handle to move text.",
    "Import a spreadsheet as a new set: every row becomes a tab, and Style all changes the look of every row at once.",
    "Deleted something by mistake? Click Undo, or open Trash in the workspace menu within 30 days."
  ];
  var tipIx = Math.floor(Math.random() * TIPS.length);
  function showTip(){ $("tipText").textContent = "Tip: " + TIPS[tipIx % TIPS.length]; }
  $("tipNext").addEventListener("click", function(){ tipIx++; showTip(); });
  showTip();
  function openTips(){
    openModal("tips");
    var k = function(x){ return '<kbd>' + x + '</kbd>'; };
    $("modalBox").innerHTML = '<div class="modal-head"><h2 id="modalTitle">Tips and shortcuts</h2><button type="button" class="btn small" data-mclose="1">Close</button></div>' +
      '<div class="modal-body"><div class="tips-grid">' +
        '<section><h3>Keyboard</h3><dl>' +
          '<dt>' + k("/") + ' or ' + k("⌘K") + '</dt><dd>Search everything</dd>' +
          '<dt>' + k("?") + '</dt><dd>Open Help</dd>' +
          '<dt>' + k("↑") + ' ' + k("↓") + '</dt><dd>Turn the wheel</dd>' +
          '<dt>' + k("Enter") + '</dt><dd>Open the front card</dd>' +
          '<dt>' + k("Esc") + '</dt><dd>Close the card, pop-up or search</dd>' +
          '<dt>' + k("Alt") + ' + ' + k("←") + ' / ' + k("→") + '</dt><dd>Back and forward through visited cards</dd>' +
          '<dt>' + k("Home") + ' ' + k("End") + '</dt><dd>First and last card</dd>' +
        '</dl></section>' +
        '<section><h3>Search</h3><dl>' +
          '<dt><code>#prod</code></dt><dd>Cards with a tag</dd>' +
          '<dt><code>type:meeting</code></dt><dd>One card type</dd>' +
          '<dt><code>is:open</code></dt><dd>Cards with that status</dd>' +
          '<dt><code>is:fav</code></dt><dd>Your favourites</dd>' +
          '<dt>ends with <code>?</code></dt><dd>Ask Claude instead of searching</dd>' +
        '</dl></section>' +
        '<section><h3>Meetings</h3><ul>' +
          '<li>Save your Outlook calendar as .ics (File › Save Calendar) and import it from the workspace menu.</li>' +
          '<li>A reminder bar appears 15 minutes before a meeting, with a Join button.</li>' +
          '<li>Five minutes before, the meeting card opens with a fresh page of notes for today.</li>' +
          '<li>Paste or drop screenshots into the notes.</li>' +
        '</ul></section>' +
        '<section><h3>Staying tidy</h3><ul>' +
          '<li>Use folders for places or clients, and card types for kinds of thing.</li>' +
          '<li>Link related cards rather than repeating details.</li>' +
          '<li>Checklists on a project set its progress automatically.</li>' +
          '<li>Export a backup now and then from the workspace menu.</li>' +
        '</ul></section>' +
      '</div></div>';
  }
  $("tipsBtn").addEventListener("click", openTips);
  /* ---- Help topics (in-app Help drawer) ----
       Copied verbatim from app/site/help-topics.js, which is the source of truth — when a topic
       changes there, copy the change here and into app/src/app.js too (search for HELP_TOPICS).
       Original file's own header: */
    /* Help topics, shared by the public /help page and the in-app Help panel.
     Each topic: {id, title, code, body (trusted HTML, written here), keywords (extra search words)}.
     Keep the wording plain British English, short sentences, and true to what the app does today.
     Facts come from docs/guide.html and the app itself; update both when a feature changes.
     THIS FILE IS THE SOURCE OF TRUTH: work-rolodex.html and app/src/app.js each keep an inline copy
     of this same HELP_TOPICS array (they can't import a module) — when you change a topic here, copy
     the change into both of those too. Search them for "HELP_TOPICS" to find the copies. */
  var HELP_TOPICS = [
    {
      id: "getting-started",
      code: "GO",
      title: "Getting started",
      keywords: "start begin first sign in google account workspace new sample data welcome",
      body:
        "<p>Tabwheel keeps your work on cards, like an old desk rolodex. Each customer, job, quote, supplier or meeting gets its own card.</p>" +
        "<ol>" +
          "<li>Sign in with your Google account. You get your own private workspace.</li>" +
          "<li>Click <b>+ New card</b> at the top and pick a type. Give it a name and fill in what you know.</li>" +
          "<li>Spin the wheel to find cards. Click the front card to open it and write notes.</li>" +
          "<li>Check <b>Today</b> each morning for what's overdue, due today and coming up.</li>" +
        "</ol>" +
        "<p>Setting up a brand-new workspace? Pick a starter set (Trades &amp; services, Office &amp; agency, Shop &amp; hospitality, Property &amp; lettings, or IT &amp; infrastructure) and it adds matching card types and a few example cards — or choose <b>Start blank</b>. You can add another starter set, or hide types you don't use, later from <b>Card types…</b>.</p>" +
        "<p>Want to look around first? Open the workspace menu (click the Tabwheel name, top left) and choose <b>Load sample data</b>. <b>Clear sample data</b> removes it again.</p>" +
        "<p class=\"tip\">Tabwheel is invite-only for now. If you sign in and see “You're on the way in”, you're signed in but not let in yet. <a href=\"/welcome#join\">Join the waiting list</a> and we'll email you.</p>"
    },
    {
      id: "wheel",
      code: "WHL",
      title: "The wheel",
      keywords: "spin turn rotate scroll drag flick arrow keys rolodex tab letter a-z back forward open close",
      body:
        "<p>The wheel shows your cards one behind the other, with their tabs peeking over the top. The card at the front is the one you're on.</p>" +
        "<ul>" +
          "<li><b>Turn it:</b> scroll, drag, or use the <kbd>Up</kbd> and <kbd>Down</kbd> arrow keys. It goes all the way round.</li>" +
          "<li><b>Jump:</b> click any tab behind the front card, or a letter in the A–Z strip. <kbd>Home</kbd> and <kbd>End</kbd> go to the first and last card. <kbd>Page Up</kbd> and <kbd>Page Down</kbd> jump ten.</li>" +
          "<li><b>Open a card:</b> click the front card, or press <kbd>Enter</kbd>. It fills the window so there's room to write.</li>" +
          "<li><b>Close it:</b> click outside the card or press <kbd>Esc</kbd>.</li>" +
          "<li><b>Go back:</b> <kbd>Alt</kbd> + <kbd>Left</kbd> and <kbd>Alt</kbd> + <kbd>Right</kbd> arrow move back and forward through the cards you've visited.</li>" +
        "</ul>" +
        "<p>If your device is set to reduce motion, the wheel jumps straight to each card instead of turning.</p>"
    },
    {
      id: "cards",
      code: "CRD",
      title: "Cards and card types",
      keywords: "card type custom fields status colour color tab style paper link favourite star tag checklist archive trash delete undo",
      body:
        "<p>Every card has a type, such as Customer, Job or Meeting. The type decides the card's fields, its statuses and its colour.</p>" +
        "<ul>" +
          "<li><b>Your own types:</b> workspace menu → <b>Card types…</b>. Give it a name, add the fields you need, then choose statuses and a colour. Drag types to change their order.</li>" +
          "<li><b>Style:</b> a type's colour, tab label, tab position, paper (plain, lined or grid) and front-of-card fields apply to every card of that type.</li>" +
          "<li><b>Links:</b> link related cards, such as a customer and their jobs. Click a link to jump there, then use Back to return.</li>" +
          "<li><b>Favourites:</b> star a card to pin it to Favourites and the Today page.</li>" +
          "<li><b>Tags and checklists:</b> add <code>#tags</code> to group cards across types. A checklist on a project sets its progress.</li>" +
          "<li><b>Archive:</b> hides a finished card from every view. Search still finds it.</li>" +
          "<li><b>Delete:</b> moves the card to Trash for 30 days. Click <b>Undo</b> straight away, or restore it from <b>Trash</b>.</li>" +
        "</ul>"
    },
    {
      id: "search",
      code: "SRC",
      title: "Search",
      keywords: "find search filter query is: has: type: tag overdue stale reminder repeating quick filters shortcut slash",
      body:
        "<p>Press <kbd>/</kbd> (or <kbd>Ctrl</kbd> + <kbd>K</kbd>, <kbd>⌘</kbd> + <kbd>K</kbd> on a Mac) and start typing. Search reads names, fields, notes, tags, links and history. Pick a result and the wheel spins to it.</p>" +
        "<p>Click into the empty search box to see quick filters, or type these yourself:</p>" +
        "<ul>" +
          "<li><code>#boiler</code>: cards with that tag</li>" +
          "<li><code>type:quote</code>: one card type</li>" +
          "<li><code>is:open</code>: cards with that status. <code>is:fav</code>: your favourites</li>" +
          "<li><code>is:overdue</code>, <code>is:today</code>, <code>is:tomorrow</code>, <code>is:week</code>, <code>is:nextweek</code>: by date</li>" +
          "<li><code>is:stale</code>: open work nobody has touched for two weeks (“gone quiet”)</li>" +
          "<li><code>is:reminder</code>: cards with a reminder set</li>" +
          "<li><code>is:repeating</code>: cards that repeat</li>" +
          "<li><code>has:notes</code>, <code>has:file</code>, <code>has:link</code>, <code>has:checklist</code></li>" +
        "</ul>" +
        "<p>Mix them with words: <code>is:overdue #boiler</code> finds overdue boiler work.</p>"
    },
    {
      id: "calendar",
      code: "CAL",
      title: "Calendar",
      keywords: "calendar month week add double-click drag reschedule move day date meeting times",
      body:
        "<p>The <b>Calendar</b> view shows every card with a date. Meeting chips show their start time.</p>" +
        "<ul>" +
          "<li><b>Add:</b> click <b>+ Add</b> under the calendar, or double-click a day, then pick what to add. The date is filled in for you.</li>" +
          "<li><b>Move:</b> drag a chip to another day. You'll see an <b>Undo</b> button in case it was a slip.</li>" +
          "<li><b>Week view:</b> switch between <b>Month</b> and <b>Week</b> at the top. Tabwheel remembers your choice.</li>" +
        "</ul>" +
        "<p class=\"tip\">Dragging needs a mouse for now. On a phone, open the card and change its date instead. A repeating meeting can't be dragged to one day: open it to change the series.</p>"
    },
    {
      id: "reminders",
      code: "REM",
      title: "Reminders and snooze",
      keywords: "reminder remind me notification alert snooze later tomorrow next week bell done",
      body:
        "<p>Open any card and click <b>Remind me</b>. Choose later today, tomorrow at 9:00, next Monday at 9:00, or a time of your own. <b>Clear</b> removes it.</p>" +
        "<p>When it's due, a bar pops up with <b>Open</b>, <b>Snooze</b> and <b>Done</b>. If you allow notifications, you'll get one from your browser too. Cards with a reminder show a small bell, and the Today page lists them.</p>" +
        "<p><b>Snooze</b> asks when: tomorrow, in 3 days, next Monday, next week, or a date you pick. Every snooze has an Undo.</p>" +
        "<p class=\"tip\">Reminders only go off while Tabwheel is open in a browser tab. Email reminders are planned.</p>"
    },
    {
      id: "repeating",
      code: "RPT",
      title: "Repeating tasks",
      keywords: "repeat repeating recurring every week month year until times service renewal done next date",
      body:
        "<p>Some jobs come round again: a boiler service, an insurance renewal, monthly invoicing. Set a card with a date to repeat, and choose how often.</p>" +
        "<ul>" +
          "<li>When you tick it <b>Done</b>, the card moves on to its next date. There's no copy to tidy up.</li>" +
          "<li>To stop it, set an <b>until</b> date, or a <b>number of times</b>. After the last one it's simply done.</li>" +
          "<li>Search <code>is:repeating</code> to see everything that repeats.</li>" +
        "</ul>" +
        "<p>Meetings repeat in the same way, and each meeting date gets its own page of notes.</p>"
    },
    {
      id: "starter-sets",
      code: "SET",
      title: "Starter sets",
      keywords: "starter set pack chooser trades office shop property it infrastructure blank card types manager add",
      body:
        "<p>A starter set gives a new workspace matching card types and a few example cards, so it's useful straight away instead of empty.</p>" +
        "<ul>" +
          "<li><b>Trades &amp; services:</b> Customer, Job, Quote, Invoice, Supplier, Van &amp; kit.</li>" +
          "<li><b>Office &amp; agency:</b> Client, Project, Task, Meeting, Invoice.</li>" +
          "<li><b>Shop &amp; hospitality:</b> Stock, Order, Booking, Check, Supplier.</li>" +
          "<li><b>Property &amp; lettings:</b> Property, Tenancy, Certificate, Repair, Viewing, Landlord.</li>" +
          "<li><b>IT &amp; infrastructure:</b> Server, Storage, Issue, Person, Meeting, Project — the original set.</li>" +
        "</ul>" +
        "<p>Built-in types the set doesn't need are hidden from + New, the sidebar and the calendar (they come back on their own if you ever put a card on one). Add another set later, or turn a hidden type back on, from the workspace menu → <b>Card types…</b>.</p>"
    },
    {
      id: "templates",
      code: "TPL",
      title: "Templates and duplicate",
      keywords: "template duplicate copy save as template job sheet new from template",
      body:
        "<p>On an open card, <b>Duplicate</b> makes a copy and <b>Save as template</b> keeps it as a starting point.</p>" +
        "<ul>" +
          "<li>Templates appear under their type in <b>+ New card</b>.</li>" +
          "<li>Copies start fresh: the checklist is unticked, and there's no history, reminder or favourite.</li>" +
          "<li>Manage templates from the workspace menu → <b>Templates…</b>.</li>" +
        "</ul>" +
        "<p>Templates stay out of the wheel, search and the calendar, so they never get in the way.</p>"
    },
    {
      id: "notes",
      code: "NTS",
      title: "Notes pages and files",
      keywords: "notes page write paste screenshot photo image pdf file drop drag resize formatting meeting notes",
      body:
        "<p>Each card has a notes page. Click anywhere on it to start writing there.</p>" +
        "<ul>" +
          "<li><b>Photos and screenshots:</b> paste with <kbd>Ctrl</kbd> + <kbd>V</kbd> (<kbd>⌘</kbd> + <kbd>V</kbd> on a Mac), or drop a file. It lands where you last clicked.</li>" +
          "<li><b>Move and resize:</b> drag the dotted handle to move a block, and its edge to resize it.</li>" +
          "<li><b>Formatting:</b> select text for the toolbar. Start a line with <code>- </code> for a list or <code>[] </code> for a to-do.</li>" +
          "<li><b>Meetings:</b> a meeting card has a fresh page for each date, so one card builds up the whole history.</li>" +
        "</ul>" +
        "<p>Files are private to your workspace. A copied image link stops working after a day.</p>" +
        "<p class=\"tip\">Please don't keep passwords in notes. Link to your password manager instead.</p>"
    },
    {
      id: "folders",
      code: "FLD",
      title: "Folders",
      keywords: "folder subfolder organise file move drag sidebar place client",
      body:
        "<p>Folders sit in the sidebar. Use them for places, clients or projects, and use card types for kinds of thing.</p>" +
        "<ul>" +
          "<li>Drag a card from the list onto a folder to file it, or pick the folder on the open card.</li>" +
          "<li>Folders can hold other folders. A card belongs to one folder at a time.</li>" +
          "<li>Click a folder to show just its cards on the wheel.</li>" +
        "</ul>"
    },
    {
      id: "work-home",
      code: "W/H",
      title: "Work and Home",
      keywords: "work home personal space switch toggle separate",
      body:
        "<p>The <b>Work/Home</b> switch at the top keeps your personal cards separate from the business. Each side has its own cards, folders and card types.</p>" +
        "<p>The first time you switch to Home, Tabwheel adds some starter types: Contacts, Home, Car, Insurance and policies, Documents and Reminders. Work gets its own starter-set chooser the first time there's nothing in it (see <b>Starter sets</b>). Tabwheel remembers which side you were on.</p>"
    },
    {
      id: "import",
      code: "IMP",
      title: "Importing",
      keywords: "import spreadsheet csv excel xlsx contacts vcard vcf calendar ics outlook set",
      body:
        "<p>Workspace menu → <b>Import spreadsheets, contacts or calendars…</b>. You'll see a preview before anything is added.</p>" +
        "<ul>" +
          "<li><b>Spreadsheets</b> (CSV or Excel): each row becomes a card. Match the columns to fields, or import it as <b>a new set</b> with its own card type and folder.</li>" +
          "<li><b>Contacts</b> (.vcf): each contact becomes a person card.</li>" +
          "<li><b>Calendars</b> (.ics, for example from Outlook: File › Save Calendar): each meeting becomes a card with its Join link. Importing again updates them rather than adding copies.</li>" +
        "</ul>"
    },
    {
      id: "backups",
      code: "BAK",
      title: "Backups and restore",
      keywords: "backup export restore download json safety nightly lost recover trash",
      body:
        "<p>Your workspace is backed up every night, and each copy is kept for 30 days. That copy covers cards, notes, card types and folders, but not uploaded photos or PDFs.</p>" +
        "<p>You can make your own backup any time: workspace menu → <b>Export a backup</b>. The menu reminds you in amber if it's been more than two weeks.</p>" +
        "<p>To bring one back: workspace menu → <b>Restore from a backup…</b>. Tabwheel shows what's in the file and asks before it changes anything.</p>" +
        "<p class=\"tip\">Deleted a card by mistake? Look in <b>Trash</b> first. Cards stay there for 30 days.</p>"
    },
    {
      id: "storage",
      code: "LIM",
      title: "Storage and limits",
      keywords: "storage limit space size full quota gb mb files database usage",
      body:
        "<p>Tabwheel doesn't limit how many cards, notes or files you have. The limits come from the service underneath.</p>" +
        "<ul>" +
          "<li><b>Files:</b> 1 GB of photos, screenshots and PDFs per workspace during early access.</li>" +
          "<li><b>Cards and notes:</b> text is tiny, so there's room for a very large number.</li>" +
        "</ul>" +
        "<p>To see how much you're using, open the workspace menu and look under <b>Data &amp; safety</b>. The bars turn red when you're close to a limit.</p>"
    },
    {
      id: "privacy",
      code: "PRV",
      title: "Privacy and your data",
      keywords: "privacy data gdpr where stored eu ireland supabase google sign in delete account export trackers",
      body:
        "<p>Your cards and files are stored with Supabase in the EU (Ireland). Only people in your workspace can see them. You sign in with Google, so Tabwheel never sees your password.</p>" +
        "<ul>" +
          "<li>We don't sell your data, show ads or use tracking scripts.</li>" +
          "<li>You can export everything at any time.</li>" +
          "<li>To have your account and workspace deleted, email us.</li>" +
        "</ul>" +
        "<p>The full details are in the <a href=\"/privacy\">privacy notice</a>.</p>"
    }
  ];
  
  /* plain text of a topic, for searching (and for anything that can't render HTML) */
  function topicText(t){
    return (t.title + " " + t.keywords + " " + String(t.body).replace(/<[^>]+>/g, " ").replace(/&amp;/g, "&").replace(/&[a-z]+;/g, " ")).replace(/\s+/g, " ");
  }
  
  /* topics matching a free-text query: every word must appear somewhere, title hits first */
  function searchHelpTopics(query, topics){
    topics = topics || HELP_TOPICS;
    var words = String(query || "").toLowerCase().split(/\s+/).filter(Boolean);
    if(!words.length) return topics.slice();
    return topics.map(function(t, i){
      var hay = topicText(t).toLowerCase(), title = t.title.toLowerCase(), score = 0;
      for(var w = 0; w < words.length; w++){
        if(hay.indexOf(words[w]) < 0) return null;
        if(title.indexOf(words[w]) >= 0) score += 3;
        if(t.keywords.toLowerCase().indexOf(words[w]) >= 0) score += 1;
      }
      return {t: t, s: score, i: i};
    }).filter(Boolean).sort(function(a, b){ return b.s - a.s || a.i - b.i; }).map(function(x){ return x.t; });
  }


  /* ================= in-app Help ================= */
  var HELP_URL = "/help";
  var helpOpen = false;
  function openHelp(){
    if(!$("modal").hidden) closeModal();
    helpOpen = true;
    $("helpBack").hidden = false;
    $("helpDrawer").hidden = false;
    $("helpBtn").setAttribute("aria-expanded", "true");
    renderHelp("");
    setTimeout(function(){ var i = $("helpSearch"); if(i) i.focus(); }, 0);
  }
  function closeHelp(){
    if(!helpOpen) return;
    helpOpen = false;
    $("helpBack").hidden = true;
    $("helpDrawer").hidden = true;
    $("helpDrawer").innerHTML = "";
    $("helpBtn").setAttribute("aria-expanded", "false");
    if($("helpBtn").offsetParent !== null) $("helpBtn").focus();
  }
  function toggleHelp(){ if(helpOpen) closeHelp(); else openHelp(); }
  function renderHelp(q){
    var topics = q ? searchHelpTopics(q) : HELP_TOPICS;
    var actions = '<div class="help-actions">' +
      '<button type="button" class="btn small" data-help="tour">Replay the welcome tour</button>' +
      '<button type="button" class="btn small" data-help="tips">Tips and shortcuts</button>' +
      '<a class="btn small" href="' + HELP_URL + '" target="_blank" rel="noopener noreferrer">Full help online ↗</a>' +
      '</div>';
    var list = topics.length ? topics.map(function(t, i){
      return '<details class="help-topic"' + (q && i === 0 ? " open" : "") + '><summary>' + esc(t.title) + '</summary><div class="help-topic-body">' + t.body + '</div></details>';
    }).join("") : '<p class="help-empty">No topics match “' + esc(q) + '”.</p>';
    $("helpDrawer").innerHTML = '<div class="help-head"><h2 id="helpTitle">Help</h2><button type="button" class="btn small" id="helpClose" aria-label="Close help">Close</button></div>' +
      '<div class="help-body"><label class="sr-only" for="helpSearch">Search help topics</label><input id="helpSearch" class="help-search" type="search" placeholder="Search help" value="' + esc(q) + '">' + actions + list + '</div>';
    var i2 = $("helpSearch"); if(i2){ i2.setSelectionRange(i2.value.length, i2.value.length); }
  }
  $("helpBtn").addEventListener("click", toggleHelp);
  $("helpBack").addEventListener("click", closeHelp);
  $("helpDrawer").addEventListener("input", function(e){ if(e.target.id === "helpSearch") renderHelp(e.target.value); });
  $("helpDrawer").addEventListener("click", function(e){
    if(e.target.id === "helpClose"){ closeHelp(); return; }
    var b = e.target.closest("[data-help]"); if(!b) return;
    if(b.dataset.help === "tour"){ closeHelp(); startTour(); }
    else if(b.dataset.help === "tips"){ closeHelp(); openTips(); }
  });

  /* ================= welcome tour (spotlight) ================= */
  var TOUR_STEPS = [
    {sel:"#deck", t:"Spin the wheel", b:"Drag it, scroll over it, or use the ↑ and ↓ arrow keys — it goes all the way round."},
    {sel:"#deck", t:"Open a card", b:"Click the card at the front, or press Enter, to open it and start writing notes."},
    {sel:"#newBtn", t:"Add a card", b:"Click + New card, pick a type, and give it a name."},
    {sel:"#search", t:"Search everything", b:"Press / any time. Try is:overdue or is:repeating, or just type a word."},
    {sel:"[data-view=\"today\"]", t:"Today", b:"Today gathers what's overdue, due today and coming up next."},
    {sel:"[data-view=\"calendar\"]", t:"Calendar", b:"See every dated card by month or week. Double-click a day to add one."},
    {sel:"#nav", t:"Folders and card types", b:"Folders organise by place or client; card types group cards by kind — both live here in the sidebar."},
    {sel:"#wsBtn", t:"Work, Home and the workspace menu", b:"Switch between Work and Home here, or open this menu for card types, import and backups."},
    {sel:"#helpBtn", t:"Replay this tour any time", b:"Come back here whenever you like — Help also has tips, shortcuts and searchable topics.", last:true}
  ];
  var tourIx = -1, tourActive = false;
  function tourSeen(){
    try{ if(localStorage.getItem("work-rolodex/tour")) return true; }catch(e){}
    return !!(typeCfg && typeCfg.tour);
  }
  function markTourSeen(){
    try{ localStorage.setItem("work-rolodex/tour", "1"); }catch(e){}
    if(!typeCfg.tour){ typeCfg.tour = true; if(!S.readOnly) saveTypes(); }
  }
  function tourTarget(sel){
    var el = document.querySelector(sel);
    if(!el || el.hidden || el.offsetParent === null) return null;
    var r = el.getBoundingClientRect();
    return (r.width || r.height) ? el : null;
  }
  function startTour(){
    if(S.readOnly || !$("modal").hidden) return;
    tourActive = true; tourIx = -1;
    document.body.classList.add("tour-on");
    stepTour(1);
  }
  function endTour(markSeen){
    if(!tourActive){ if(markSeen) markTourSeen(); return; }
    tourActive = false;
    $("tourDim").hidden = true; $("tourRing").hidden = true; $("tourPop").hidden = true;
    document.body.classList.remove("tour-on");
    if(markSeen) markTourSeen();
    var hb = $("helpBtn"); if(hb.offsetParent !== null) hb.focus();
  }
  function stepTour(dir){
    var ix = tourIx;
    do{ ix += dir; } while(ix >= 0 && ix < TOUR_STEPS.length && !tourTarget(TOUR_STEPS[ix].sel));
    if(ix < 0) return;
    if(ix >= TOUR_STEPS.length){ endTour(true); return; }
    tourIx = ix;
    renderTourStep();
  }
  function placeTourStep(){
    if(!tourActive) return;
    var step = TOUR_STEPS[tourIx], el = tourTarget(step.sel);
    if(!el) return;
    var r = el.getBoundingClientRect(), pad = 6;
    var ring = $("tourRing");
    ring.style.top = (r.top - pad) + "px"; ring.style.left = (r.left - pad) + "px";
    ring.style.width = (r.width + pad * 2) + "px"; ring.style.height = (r.height + pad * 2) + "px";
    var pop = $("tourPop");
    if(window.innerWidth > 560){
      var pr = pop.getBoundingClientRect();
      var top = r.bottom + 14, left = r.left + r.width / 2 - pr.width / 2;
      if(top + pr.height > window.innerHeight - 12) top = Math.max(12, r.top - pr.height - 14);
      left = Math.max(12, Math.min(left, window.innerWidth - pr.width - 12));
      pop.style.top = top + "px"; pop.style.left = left + "px"; pop.style.right = "auto"; pop.style.bottom = "auto";
    } else { pop.style.top = ""; pop.style.left = ""; pop.style.right = ""; pop.style.bottom = ""; }
  }
  function renderTourStep(){
    var step = TOUR_STEPS[tourIx], el = tourTarget(step.sel);
    if(!el){ stepTour(1); return; }
    var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
    el.scrollIntoView({block:"center", inline:"center", behavior:reduce ? "auto" : "smooth"});
    $("tourDim").hidden = false;
    var pop = $("tourPop");
    pop.innerHTML = '<span class="tour-step-n">' + (tourIx + 1) + ' of ' + TOUR_STEPS.length + '</span><h3>' + esc(step.t) + '</h3><p>' + esc(step.b) + '</p>' +
      '<div class="tour-pop-foot"><button type="button" class="tour-skip" data-tour="skip">Skip tour</button><div class="tour-pop-nav">' +
      (tourIx > 0 ? '<button type="button" class="btn small" data-tour="back">Back</button>' : "") +
      '<button type="button" class="btn small primary" data-tour="next">' + (step.last ? "Done" : "Next") + '</button></div></div>';
    pop.hidden = false; $("tourRing").hidden = false;
    placeTourStep();
    setTimeout(placeTourStep, reduce ? 0 : 280);
    pop.focus();
  }
  window.addEventListener("resize", function(){ if(tourActive) placeTourStep(); });
  $("tourPop").addEventListener("click", function(e){
    var b = e.target.closest("[data-tour]"); if(!b) return;
    if(b.dataset.tour === "skip") endTour(true);
    else if(b.dataset.tour === "back") stepTour(-1);
    else if(b.dataset.tour === "next") stepTour(1);
  });
  document.addEventListener("keydown", function(e){
    if(!tourActive) return;
    if(e.key === "Escape"){ e.preventDefault(); endTour(true); }
    else if(e.key === "ArrowRight"){ e.preventDefault(); stepTour(1); }
    else if(e.key === "ArrowLeft"){ e.preventDefault(); stepTour(-1); }
  });
  /* offered once per account/device: a small "watch the tour?" prompt after setup, or on first load
     for anyone who's never been offered it (never in read-only mode, never over another modal) */
  function maybeOfferTour(){
    if(S.readOnly || tourActive || !$("modal").hidden || tourSeen()) return;
    if(/[?&]notour(=|&|$)/.test(location.search)) return;
    $("tourOffer").hidden = false;
    $("tourOffer").innerHTML = '<span>New here? Take a 1-minute tour.</span><button type="button" class="btn small primary" data-offer="watch">Watch</button><button type="button" class="btn small" data-offer="no">No thanks</button>';
  }
  $("tourOffer").addEventListener("click", function(e){
    var b = e.target.closest("button"); if(!b) return;
    $("tourOffer").hidden = true;
    markTourSeen();
    if(b.dataset.offer === "watch") startTour();
  });




  /* ================= modal ================= */
  var modalKind = "", modalTrigger = null;
  function focusablesIn(root){
    return Array.from(root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function(el){ return el.offsetParent !== null; });
  }
  function focusModalFirst(){
    var box = $("modalBox"); if(!box) return;
    var items = focusablesIn(box);
    (items[0] || box).focus();
  }
  function openModal(kind){ modalKind = kind; modalTrigger = document.activeElement; $("modal").hidden = false; setTimeout(focusModalFirst, 0); }
  function closeModal(){
    if(askCtl){ askCtl.abort(); askCtl = null; }
    if(modalKind === "restore") pendingRestore = null;
    if(modalKind === "chooser") chooserDismissed();
    modalKind = ""; $("modal").hidden = true; $("modalBox").innerHTML = "";
    var t = modalTrigger; modalTrigger = null;
    if(t && document.contains(t) && typeof t.focus === "function" && t.offsetParent !== null) t.focus();
    else{ var wb = $("wsBtn"); if(wb && wb.offsetParent !== null) wb.focus(); }
    refresh();
  }
  $("modal").addEventListener("mousedown", function(e){ if(e.target === $("modal")) closeModal(); });

  /* ================= card types editor ================= */
  var tdraft = null, tsel = "server";
  /* ---- Style: one look per card type, so every card of that type (e.g. every row of a sheet) follows it ---- */
  var sdraft = null;
  function openStyle(key){
    if(S.readOnly){ toast("You have view-only access to this workspace."); return; }
    if(!TYPES[key]){ toast("Give this card a type first, then style it."); return; }
    sdraft = {key:key, st:JSON.parse(JSON.stringify((typeCfg.style || {})[key] || {}))};
    openModal("style"); renderStyle();
  }
  function styleColorKey(key){
    var st = sdraft.st; if(st.color) return st.color;
    if(BUILTIN[key]) return key;
    var ct = typeCfg.custom.filter(function(x){ return x.key === key; })[0]; return ct ? ct.color : "c1";
  }
  function renderStyle(){
    var key = sdraft.key, st = sdraft.st, T = td(key);
    var base = BUILTIN[key] || typeCfg.custom.filter(function(x){ return x.key === key; })[0] || {};
    var n = Array.from(S.cards.values()).filter(function(c){ return c.type === key; }).length;
    var col = styleColorKey(key), short = st.short || base.short || T.short;
    var face = st.face || null;
    var swatches = BUILTIN_ORDER.concat(PALETTE).map(function(k){
      return '<button type="button" class="swatch' + (k === col ? " on" : "") + '" data-scolor="' + k + '" style="--tc:var(--t-' + k + ')" aria-label="Colour ' + k + '"' + (k === col ? ' aria-pressed="true"' : "") + '></button>';
    }).join("");
    var seg = function(name, opts, cur){ return '<div class="seg" role="group">' + opts.map(function(o){ return '<button type="button" data-s' + name + '="' + o[0] + '"' + (o[0] === cur ? ' class="on" aria-pressed="true"' : "") + '>' + o[1] + '</button>'; }).join("") + '</div>'; };
    var fieldsHtml = T.fields.map(function(fd){
      var on = face ? face.indexOf(fd.k) >= 0 : false;
      return '<label class="pick"><input type="checkbox" data-sface="' + esc(fd.k) + '"' + (on ? " checked" : "") + '> ' + esc(fd.l) + '</label>';
    }).join("");
    var sample = Array.from(S.cards.values()).filter(function(c){ return c.type === key; })[0];
    var pf = (face ? face.map(function(k){ return T.fields.filter(function(fd){ return fd.k === k; })[0]; }).filter(Boolean) : T.fields.slice(0, 4)).slice(0, 4);
    var preview = '<div class="style-prev paper-' + (st.paper || "lined") + '" style="--tc:var(--t-' + col + '); --tab-x:' + (st.tab ? TAB_POS[st.tab] : "3%") + '">' +
      '<span class="sp-tab"><b>' + esc(short) + '</b> ' + esc(sample ? sample.title : T.label) + '</span>' +
      '<div class="sp-body"><b class="sp-title">' + esc(sample ? sample.title : "Example " + T.label.toLowerCase()) + '</b><div class="sp-rule"></div>' +
      '<dl>' + pf.map(function(fd){ return '<div><dt>' + esc(fd.l) + '</dt><dd>' + esc(sample && sample.f[fd.k] ? (fd.t === "date" ? fmtDate(sample.f[fd.k]) : sample.f[fd.k]) : "…") + '</dd></div>'; }).join("") + '</dl></div></div>';
    $("modalBox").innerHTML = '<div class="modal-head"><h2 id="modalTitle">Style: ' + esc(T.plural) + '</h2><button type="button" class="btn small" data-mclose="1">Cancel</button></div>' +
      '<div class="modal-body style-grid"><div class="style-form">' +
        '<p class="d-note" style="margin-top:0">Changes apply to all <b>' + n + '</b> ' + esc(n === 1 ? T.label.toLowerCase() : T.plural.toLowerCase()) + ' cards' + (T.custom ? ", including any added later from the same sheet" : "") + '.</p>' +
        '<div class="fld"><label>Colour</label><div class="swatches">' + swatches + '</div></div>' +
        '<div class="fld"><label for="s-short">Tab label (up to 4 letters)</label><input id="s-short" maxlength="4" value="' + esc(short) + '" style="max-width:120px; text-transform:uppercase"></div>' +
        '<div class="fld"><label>Tab position</label>' + seg("tab", [["", "Staggered"], ["left", "Left"], ["centre", "Centre"], ["right", "Right"]], st.tab || "") + '</div>' +
        '<div class="fld"><label>Card paper</label>' + seg("paper", [["lined", "Lined"], ["plain", "Plain"], ["grid", "Squared"]], st.paper || "lined") + '</div>' +
        '<div class="fld"><label>Show on the front of the card</label><p class="d-note" style="margin:0 0 4px">Tick up to 8 fields, in the order you want. Leave all unticked to show whatever is filled in.</p><div class="face-picks">' + (fieldsHtml || '<span class="d-note">No fields on this card type.</span>') + '</div></div>' +
      '</div><div class="style-side"><span class="ws-lbl">Preview</span>' + preview + '</div></div>' +
      '<div class="modal-foot"><button type="button" class="btn" data-sreset="1">Back to default</button><button type="button" class="btn primary" data-ssave="1">Apply to all ' + n + '</button></div>';
  }
  $("modalBox").addEventListener("click", function(e){
    if(modalKind !== "style") return;
    var b = e.target.closest("button"); if(!b) return;
    var st = sdraft.st;
    if(b.dataset.scolor){ st.color = b.dataset.scolor; renderStyle(); }
    else if(b.dataset.stab !== undefined){ if(b.dataset.stab) st.tab = b.dataset.stab; else delete st.tab; renderStyle(); }
    else if(b.dataset.spaper){ if(b.dataset.spaper === "lined") delete st.paper; else st.paper = b.dataset.spaper; renderStyle(); }
    else if(b.dataset.sreset){ sdraft.st = {}; renderStyle(); }
    else if(b.dataset.ssave){
      var key = sdraft.key;
      typeCfg.style = typeCfg.style || {};
      if(Object.keys(st).length) typeCfg.style[key] = st; else delete typeCfg.style[key];
      typeCfg = normTypeCfg(typeCfg); rebuildTypes(); saveTypes();
      S.cards.forEach(function(c){ if(c.type === key) bump(c.id); });
      var n = Array.from(S.cards.values()).filter(function(c){ return c.type === key; }).length;
      closeModal(); rebuildDetail();
      toast("Updated the style of " + n + " " + (n === 1 ? td(key).label.toLowerCase() : td(key).plural.toLowerCase()) + " cards.");
    }
  });
  $("modalBox").addEventListener("change", function(e){
    if(modalKind !== "style") return;
    var t = e.target, st = sdraft.st;
    if(t.dataset.sface !== undefined){
      var f = st.face ? st.face.slice() : [], k = t.dataset.sface, i = f.indexOf(k);
      if(t.checked && i < 0){ if(f.length >= 8){ t.checked = false; toast("Up to 8 fields fit on the front of a card."); return; } f.push(k); }
      if(!t.checked && i >= 0) f.splice(i, 1);
      if(f.length) st.face = f; else delete st.face;
      renderStyle();
    }
  });
  $("modalBox").addEventListener("input", function(e){
    if(modalKind !== "style" || e.target.id !== "s-short") return;
    var v = e.target.value.trim().toUpperCase().slice(0, 4);
    if(v) sdraft.st.short = v; else delete sdraft.st.short;
    var tab = $("modalBox").querySelector(".sp-tab b"); if(tab) tab.textContent = v || td(sdraft.key).short;
  });

  var packExOpt = {};
  function openTypes(){
    if(S.readOnly){ toast("You have view-only access to this workspace."); return; }
    tdraft = JSON.parse(JSON.stringify(typeCfg));
    packExOpt = {};
    if(!TYPES[tsel]) tsel = TYPE_ORDER[0];
    openModal("types"); renderTypesModal();
  }
  function draftType(key){ return BUILTIN[key] ? null : tdraft.custom.filter(function(c){ return c.key === key; })[0]; }
  function fieldRow(fd, i, locked){
    if(locked) return '<div class="f-row locked"><span>' + esc(fd.l) + '</span><span>' + esc(FIELD_KINDS[fd.t || "text"] || "Text") + '</span><span>' + (fd.opts ? esc(fd.opts.join(", ")) : "Built in") + '</span><span></span></div>';
    return '<div class="f-row"><input id="tf-l-' + i + '" data-ff="l" data-fi="' + i + '" value="' + esc(fd.l) + '" placeholder="Field name" aria-label="Field name">' +
      '<select id="tf-t-' + i + '" data-ff="t" data-fi="' + i + '" aria-label="Field kind">' + Object.keys(FIELD_KINDS).map(function(k){ return '<option value="' + k + '"' + (fd.t === k ? " selected" : "") + '>' + FIELD_KINDS[k] + '</option>'; }).join("") + '</select>' +
      (fd.t === "select" ? '<input class="opts" id="tf-o-' + i + '" data-ff="opts" data-fi="' + i + '" value="' + esc((fd.opts || []).join(", ")) + '" placeholder="Choices, separated by commas" aria-label="Choices">' : '<span></span>') +
      '<button type="button" class="icon-btn" data-fdel="' + i + '" aria-label="Remove field">✕</button></div>';
  }
  function renderTypesModal(){
    var builtinOrder = tdraft.builtinOrder || BUILTIN_ORDER;
    var keys = builtinOrder.concat(tdraft.custom.map(function(c){ return c.key; }));
    if(keys.indexOf(tsel) < 0) tsel = keys[0];
    var typeRow = function(key, group, sel, label, style){
      return '<button type="button" class="nav-item t-drag' + (sel ? " on" : "") + '" draggable="true" data-tsel="' + esc(key) + '" data-tdrag="' + esc(key) + '" data-tgroup="' + group + '" style="' + style + '"><span class="drag-grip" aria-hidden="true">⠿</span><span class="dot"></span><span class="nm">' + esc(label) + '</span></button>';
    };
    var list = '<div class="types-list"><h4 class="side-h">Built in</h4>' + builtinOrder.map(function(k){
      return typeRow(k, "builtin", tsel === k, BUILTIN[k].plural, typeVar(k));
    }).join("") + '<h4 class="side-h">Your types</h4>' + tdraft.custom.map(function(c){
      return typeRow(c.key, "custom", tsel === c.key, c.plural || c.label, "--tc:var(--t-" + c.color + ")");
    }).join("") + '<button type="button" class="nav-item" data-tnew="1"><span class="icon-btn" style="width:9px">+</span><span class="nm">New card type</span></button></div>';
    var form, ct = draftType(tsel);
    if(!ct){
      var b = BUILTIN[tsel], extra = tdraft.extra[tsel] || [];
      form = '<div class="types-form"><h3 style="' + typeVar(tsel) + '"><span class="dot" style="width:12px;height:12px"></span>' + esc(b.plural) + '</h3>' +
        '<label class="ws-check"><input type="checkbox" data-toffkey="' + esc(tsel) + '"' + (tdraft.off.indexOf(tsel) < 0 ? " checked" : "") + '> Show in menus</label>' +
        (tdraft.off.indexOf(tsel) >= 0 ? '<p class="d-note" style="margin-top:0">Hidden from + New, the sidebar and calendar. It\'ll come back automatically if a card of this type exists.</p>' : "") +
        '<div><h4 class="side-h">Statuses</h4><div class="status-chips">' + b.statuses.map(function(st){ return '<span class="pill tone-' + (TONE[st] || "muted") + '">' + esc(st) + '</span>'; }).join("") + '</div></div>' +
        '<div><h4 class="side-h">Fields</h4><div class="f-list">' + (b.fields.length + extra.length ? '<div class="f-row f-head"><span>Field name</span><span>Type</span><span>Choices</span><span></span></div>' : "") + b.fields.map(function(fd){ return fieldRow(fd, 0, true); }).join("") + extra.map(function(fd, i){ return fieldRow(fd, i, false); }).join("") + '</div></div>' +
        '<div><button type="button" class="btn small" data-fadd="1">+ Add a field</button></div></div>';
    } else {
      var inUse = Array.from(S.cards.values()).filter(function(c){ return c.type === ct.key; }).length;
      form = '<div class="types-form"><h3 style="--tc:var(--t-' + ct.color + ')"><span class="dot" style="width:12px;height:12px"></span>' + esc(ct.label || "New type") + '</h3>' +
        '<div class="fld"><label for="tt-label">Name</label><input id="tt-label" data-tf="label" value="' + esc(ct.label) + '" placeholder="e.g. Software licence"></div>' +
        '<div><h4 class="side-h">Fields</h4><div class="f-list">' + (ct.fields.length ? '<div class="f-row f-head"><span>Field name</span><span>Type</span><span>Choices</span><span></span></div>' + ct.fields.map(function(fd, i){ return fieldRow(fd, i, false); }).join("") : '<p class="d-note">No fields yet.</p>') + '</div><button type="button" class="btn small" data-fadd="1" style="margin-top:6px">+ Add a field</button></div>' +
        '<div class="fld"><label for="tt-statuses">Statuses, one per line (the first is the default)</label><textarea id="tt-statuses" data-tf="statuses">' + esc(ct.statuses.join("\n")) + '</textarea></div>' +
        '<div class="fld"><label>Colour</label><div class="swatches">' + PALETTE.map(function(c){ return '<button type="button" class="swatch' + (ct.color === c ? " on" : "") + '" data-tcolor="' + c + '" style="--tc:var(--t-' + c + ')" aria-label="Colour ' + c + '"></button>'; }).join("") + '</div></div>' +
        '<details class="d-fold"><summary>Advanced options</summary><div class="form-grid">' +
          '<div class="fld"><label for="tt-plural">Name (many)</label><input id="tt-plural" data-tf="plural" value="' + esc(ct.plural) + '" placeholder="e.g. Software licences"></div>' +
          '<div class="fld"><label for="tt-short">Tab code</label><input id="tt-short" data-tf="short" maxlength="4" value="' + esc(ct.short) + '" placeholder="LIC"></div>' +
        '</div></details>' +
        '<div style="display:flex; gap:8px; flex-wrap:wrap; align-items:center"><button type="button" class="btn small danger" data-tdel="1"' + (inUse ? " disabled title=\"" + inUse + " cards use this type\"" : "") + '>Delete this type</button>' + (inUse ? '<span class="d-note" style="margin:0">' + inUse + ' cards use this type, so it can\'t be deleted.</span>' : "") + '</div></div>';
    }
    var packRow = function(p){
      var added = (typeCfg.packs || []).indexOf(p.id) >= 0;
      return '<div class="starter-row"><span class="sr-name">' + esc(p.name) + '</span><span class="sr-blurb">' + esc(p.blurb) + '</span>' +
        (added ? '<span class="setup-added">Added</span>' :
          '<label class="ws-check" style="margin:0"><input type="checkbox" data-packex="' + p.id + '"' + (packExOpt[p.id] ? " checked" : "") + '> Examples too</label><button type="button" class="btn small" data-packadd="' + p.id + '">Add</button>') +
        '</div>';
    };
    var starterSection = '<details class="d-fold" style="margin-top:16px"><summary>Add a starter set</summary><div class="starter-list">' + STARTER_PACKS.map(packRow).join("") + '</div></details>';
    $("modalBox").innerHTML = '<div class="modal-head"><h2 id="modalTitle">Card types</h2><button type="button" class="btn small" data-mclose="1">Cancel</button></div>' +
      '<div class="modal-body"><p class="d-note" style="margin:0 0 14px">A card’s <b>type</b> is what it is (a server, a contact, a project); a <b>folder</b> is where you keep it. Types set fields, statuses and look; folders are just for organising.</p><div class="types-grid">' + list + form + '</div>' + starterSection + '</div>' +
      '<div class="modal-foot"><span class="note">Built-in types keep their own fields and statuses. You can add extra fields to them.</span><button type="button" class="btn" data-mclose="1">Cancel</button><button type="button" class="btn primary" data-tsave="1">Save card types</button></div>';
  }
  function draftFields(){
    var ct = draftType(tsel);
    if(ct) return ct.fields;
    return (tdraft.extra[tsel] = tdraft.extra[tsel] || []);
  }
  $("modalBox").addEventListener("input", function(e){
    if(modalKind !== "types") return;
    var t = e.target, ct = draftType(tsel);
    if(t.dataset.tf && ct){
      if(t.dataset.tf === "statuses") ct.statuses = t.value.split("\n").map(function(x){ return x.trim(); }).filter(Boolean);
      else ct[t.dataset.tf] = t.value;
    }
    if(t.dataset.ff){
      var fd = draftFields()[+t.dataset.fi]; if(!fd) return;
      if(t.dataset.ff === "opts") fd.opts = t.value.split(",").map(function(x){ return x.trim(); }).filter(Boolean);
      else fd[t.dataset.ff] = t.value;
      if(t.dataset.ff === "t") renderTypesModal();
    }
  });
  var typeDrag = null;
  $("modalBox").addEventListener("dragstart", function(e){
    if(modalKind !== "types") return;
    var b = e.target.closest(".t-drag"); if(!b) return;
    typeDrag = {key:b.dataset.tdrag, group:b.dataset.tgroup};
    b.classList.add("dragging");
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", b.dataset.tdrag);
  });
  $("modalBox").addEventListener("dragend", function(e){
    if(modalKind !== "types") return;
    var b = e.target.closest(".t-drag"); if(b) b.classList.remove("dragging");
    $("modalBox").querySelectorAll(".t-drag.drag-over").forEach(function(x){ x.classList.remove("drag-over"); });
    typeDrag = null;
  });
  $("modalBox").addEventListener("dragover", function(e){
    if(modalKind !== "types" || !typeDrag) return;
    var b = e.target.closest(".t-drag"); if(!b || b.dataset.tgroup !== typeDrag.group) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    b.classList.add("drag-over");
  });
  $("modalBox").addEventListener("dragleave", function(e){
    var b = e.target.closest(".t-drag"); if(b) b.classList.remove("drag-over");
  });
  $("modalBox").addEventListener("drop", function(e){
    if(modalKind !== "types" || !typeDrag) return;
    var b = e.target.closest(".t-drag"); if(!b || b.dataset.tgroup !== typeDrag.group) return;
    e.preventDefault();
    var targetKey = b.dataset.tdrag, dragKey = typeDrag.key;
    if(targetKey === dragKey) return;
    var arr, keyOf;
    if(typeDrag.group === "builtin"){
      arr = tdraft.builtinOrder = (tdraft.builtinOrder || BUILTIN_ORDER.slice()).slice();
      keyOf = function(x){ return x; };
    } else { arr = tdraft.custom; keyOf = function(x){ return x.key; }; }
    var from = arr.findIndex(function(x){ return keyOf(x) === dragKey; });
    var to = arr.findIndex(function(x){ return keyOf(x) === targetKey; });
    if(from < 0 || to < 0) return;
    arr.splice(to, 0, arr.splice(from, 1)[0]);
    renderTypesModal();
  });
  $("modalBox").addEventListener("change", function(e){
    if(modalKind !== "types") return;
    var t = e.target;
    if(t.dataset.toffkey !== undefined){
      var off = tdraft.off || (tdraft.off = []), k = t.dataset.toffkey, i = off.indexOf(k);
      if(t.checked && i >= 0) off.splice(i, 1);
      else if(!t.checked && i < 0) off.push(k);
      renderTypesModal();
    } else if(t.dataset.packex !== undefined){ packExOpt[t.dataset.packex] = t.checked; }
  });
  $("modalBox").addEventListener("click", function(e){
    var b = e.target.closest("button"); if(!b) return;
    if(b.dataset.mclose){ closeModal(); return; }
    if(modalKind !== "types") return;
    if(b.dataset.tsel){ tsel = b.dataset.tsel; renderTypesModal(); }
    else if(b.dataset.tnew){
      var key = "t" + uid().replace(/[^a-z0-9]/g, "");
      tdraft.custom.push({key:key, label:"New type", plural:"New types", short:"NEW", color:PALETTE[tdraft.custom.length % PALETTE.length], statuses:["Active","Inactive"], fields:[{k:"x_" + uid().slice(-6), l:"Owner", t:"text"}], home:S.space === "home"});
      tsel = key; renderTypesModal();
      setTimeout(function(){ var i = $("tt-label"); if(i){ i.focus(); i.select(); } }, 20);
    }
    else if(b.dataset.fadd){
      draftFields().push({k:"x_" + uid().slice(-7).replace(/[^a-z0-9]/g, "0"), l:"", t:"text"});
      renderTypesModal();
      var n = draftFields().length - 1; setTimeout(function(){ var i = $("tf-l-" + n); if(i) i.focus(); }, 20);
    }
    else if(b.dataset.fdel !== undefined){ if(armed(b, "Remove?")){ draftFields().splice(+b.dataset.fdel, 1); renderTypesModal(); } }
    else if(b.dataset.tcolor){ var ct = draftType(tsel); if(ct){ ct.color = b.dataset.tcolor; renderTypesModal(); } }
    else if(b.dataset.tdel){ if(armed(b, "Click again to delete")){ tdraft.custom = tdraft.custom.filter(function(c){ return c.key !== tsel; }); tsel = "server"; renderTypesModal(); } }
    else if(b.dataset.packadd){
      applyStarterPack(b.dataset.packadd, !!packExOpt[b.dataset.packadd]);
      tdraft = JSON.parse(JSON.stringify(typeCfg));
      renderTypesModal();
      toast("Added the " + (starterPack(b.dataset.packadd) || {}).name + " starter set.");
    }
    else if(b.dataset.tsave){
      Object.keys(tdraft.extra).forEach(function(k){ tdraft.extra[k] = tdraft.extra[k].filter(function(f){ return (f.l || "").trim(); }); });
      tdraft.custom.forEach(function(c){ c.fields = c.fields.filter(function(f){ return (f.l || "").trim(); }); });
      typeCfg = normTypeCfg(tdraft);
      rebuildTypes(); saveTypes();
      Array.from(S.cards.keys()).forEach(bump);
      closeModal();
      toast("Card types saved.");
    }
  });

  /* ================= import spreadsheets & contacts ================= */
  var imp = null;
  var SYN = {
    title:["name","title","hostname","servername","fullname","displayname","assetname","device","devicename","subject","summary","item"],
    subtitle:["description","desc","subtitle","purpose","details"],
    status:["status","state"],
    tags:["tags","labels","label","category","categories"],
    notes:["notes","note","comments","comment","remarks"],
    host:["ip","ipaddress","host","hostip","address4","ipv4"], os:["os","operatingsystem","platform"],
    email:["email","emailaddress","mail","e-mail"], phone:["phone","mobile","tel","telephone","phonenumber","cell"],
    company:["company","organisation","organization","team","department","org"], role:["role","jobtitle","position"],
    location:["location","site","office","city","room","rack"], serial:["serial","serialnumber","assettag","sn"],
    capacity:["capacity","size","total"], used:["used","usage"], kind:["kind","type","model"],
    assignee:["assignee","assignedto","owner"], owner:["owner","lead","manager"], severity:["severity","priority"],
    ticket:["ticket","ticketno","ticketnumber","ref","reference","id"], due:["due","duedate","deadline","date","warranty","warrantyends","expiry","expires"],
    start:["start","startdate","begin"], end:["end","enddate","finish"], where:["where","venue"], "with":["with","attendees","people"], time:["time"], progress:["progress","percent","complete"]
  };
  function normH(h){ return String(h || "").toLowerCase().replace(/[^a-z0-9]/g, ""); }
  /* "a new set": the sheet becomes its own card type, every column a field, every row a card */
  function slugKey(name){
    var base = String(name || "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "").replace(/^[^a-z]+/, "").slice(0, 30) || "set";
    var k = base, i = 2;
    while(TYPES[k] || BUILTIN[k] || k === "other") k = base + "_" + (i++);
    return k;
  }
  function setName(){
    var sheet = imp.sheet && !/^sheet\s*\d*$/i.test(imp.sheet) ? imp.sheet : "";
    var n = imp.setName || sheet || String(imp.name || "Imported").replace(/\.[a-z0-9]+$/i, "").replace(/[_-]+/g, " ").trim() || "Imported";
    return n.charAt(0).toUpperCase() + n.slice(1);
  }
  function fieldKind(vals){
    var v = vals.filter(function(x){ return x instanceof Date || String(x).trim(); }).slice(0, 200);
    if(!v.length) return "text";
    var share = function(fn){ return v.filter(fn).length / v.length; };
    if(share(function(x){ return x instanceof Date || (/^\d{1,4}[\/.\-]\d{1,2}[\/.\-]\d{1,4}/.test(String(x).trim()) && toISODate(x)); }) > .8) return "date";
    if(share(function(x){ return /^https?:\/\//i.test(String(x).trim()); }) > .8) return "url";
    if(share(function(x){ return /^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(String(x).trim()); }) > .8) return "email";
    if(share(function(x){ return /^[+()\d][\d\s()+\-]{6,}$/.test(String(x).trim()); }) > .8 && v.some(function(x){ return /\s|^\+|^0/.test(String(x).trim()); })) return "tel";
    if(share(function(x){ return /^-?[\d,]*\.?\d+$/.test(String(x).trim()); }) > .9) return "number";
    return "text";
  }
  function buildSetType(){
    var used = {}, fields = [], statusCol = -1, titleCol = -1;
    var hs = imp.headers.map(normH);
    titleCol = hs.findIndex(function(h){ return ["name","title","fullname","company","item","description","subject"].indexOf(h) >= 0; });
    if(titleCol < 0) titleCol = 0;
    statusCol = hs.findIndex(function(h, i){ return i !== titleCol && ["status","state","stage"].indexOf(h) >= 0; });
    var notesCol = hs.findIndex(function(h, i){ return i !== titleCol && i !== statusCol && ["notes","note","comments","comment","remarks"].indexOf(h) >= 0; });
    var statuses = [];
    if(statusCol >= 0) imp.rows.forEach(function(r){ var v = String(r[statusCol] || "").trim(); if(v && statuses.indexOf(v) < 0 && statuses.length < 12) statuses.push(v); });
    var colKey = imp.headers.map(function(h, i){
      if(i === titleCol || i === statusCol || i === notesCol) return "";
      var k = normH(h).replace(/^[^a-z]+/, "").slice(0, 36) || "field"; var kk = k, n = 2;
      while(used[kk]) kk = k + n++;
      used[kk] = 1;
      var kind = fieldKind(imp.rows.map(function(r){ return r[i]; }));
      var fd = {k:kk, l:h.slice(0, 60), t:kind}; if(kind === "number" || kind === "tel" || kind === "email") fd.mono = 1;
      fields.push(fd);
      return kk;
    });
    var name = setName();
    var taken = typeCfg.custom.map(function(c){ return c.color; });
    var color = PALETTE.filter(function(p){ return taken.indexOf(p) < 0; })[0] || PALETTE[typeCfg.custom.length % PALETTE.length];
    imp.setType = {key:imp.setKey || slugKey(name), label:name, plural:name, short:name.replace(/[^A-Za-z0-9]/g, "").slice(0, 3).toUpperCase() || "SET", color:color,
      statuses:statuses.length ? statuses : ["Active","Inactive"], fields:fields, sheet:(imp.name || "") + (imp.sheet ? " › " + imp.sheet : ""), home:S.space === "home"};
    imp.setKey = imp.setType.key;
    imp.map = imp.headers.map(function(h, i){ return i === titleCol ? "title" : i === statusCol ? "status" : i === notesCol ? "notes" : "f." + colKey[i]; });
  }
  function impType(){
    if(imp.type !== "__set") return td(imp.type);
    var st = imp.setType;
    return {label:st.label, plural:st.plural, short:st.short, statuses:st.statuses, fields:st.fields, color:"var(--t-" + st.color + ")", custom:true};
  }
  function impTargets(type){
    var T = type === "__set" ? impType() : td(type);
    return [["", "Don't import"], ["title", "Title"], ["subtitle", "Subtitle"], ["status", "Status"], ["tags", "Tags"], ["notes", "Notes"]]
      .concat(T.fields.map(function(fd){ return ["f." + fd.k, fd.l]; }));
  }
  function guessType(headers){
    var h = headers.map(normH).join(" ");
    var has = function(list){ return list.some(function(w){ return h.indexOf(w) >= 0; }); };
    if(has(["email","phone","mobile","jobtitle"])) return "person";
    if(has(["severity","ticket","priority"])) return "issue";
    if(has(["ipaddress","hostname","operatingsystem","servername"]) || headers.map(normH).some(function(x){ return x === "ip" || x === "os"; })) return "server";
    if(has(["capacity","used","serial","warranty"])) return "storage";
    if(has(["startdate","enddate","progress"])) return "project";
    if(S.nav.indexOf("t:") === 0) return S.nav.slice(2);
    return "server";
  }
  function guessMap(headers, type){
    var targets = impTargets(type), used = {};
    var map = headers.map(function(h){
      var n = normH(h); if(!n) return "";
      var hit = "";
      targets.forEach(function(t){
        if(hit || !t[0] || used[t[0]]) return;
        var key = t[0].indexOf("f.") === 0 ? t[0].slice(2) : t[0];
        var syn = SYN[key] || [];
        if(normH(t[1]) === n || syn.indexOf(n) >= 0) hit = t[0];
      });
      if(!hit) targets.forEach(function(t){ if(!hit && t[0] && !used[t[0]] && normH(t[1]).length > 2 && (n.indexOf(normH(t[1])) >= 0 || normH(t[1]).indexOf(n) === 0)) hit = t[0]; });
      if(hit) used[hit] = 1;
      return hit;
    });
    if(map.indexOf("title") < 0){ var i = map.findIndex(function(m){ return !m; }); if(i >= 0) map[i] = "title"; }
    return map;
  }
  function toISODate(v){
    if(v instanceof Date && !isNaN(v)) return iso(v);
    var s = String(v || "").trim(), m;
    if(!s) return "";
    if((m = /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(s))) return m[1] + "-" + pad(+m[2]) + "-" + pad(+m[3]);
    if((m = /^(\d{1,2})[\/.\-](\d{1,2})[\/.\-](\d{2,4})$/.exec(s))){
      var a = +m[1], b = +m[2], y = +m[3]; if(y < 100) y += 2000;
      var d = a, mo = b; if(b > 12 && a <= 12){ d = b; mo = a; }
      if(mo >= 1 && mo <= 12 && d >= 1 && d <= 31) return y + "-" + pad(mo) + "-" + pad(d);
    }
    var t = Date.parse(s); return isNaN(t) ? "" : iso(new Date(t));
  }
  function parseCSV(text){
    text = text.replace(/^﻿/, "");
    var first = text.split(/\r?\n/)[0] || "";
    var delim = (first.split("\t").length > first.split(",").length) ? "\t" : (first.split(";").length > first.split(",").length ? ";" : ",");
    var rows = [], row = [], cell = "", q = false;
    for(var i = 0; i < text.length; i++){
      var ch = text[i];
      if(q){
        if(ch === '"'){ if(text[i + 1] === '"'){ cell += '"'; i++; } else q = false; }
        else cell += ch;
      } else if(ch === '"') q = true;
      else if(ch === delim){ row.push(cell); cell = ""; }
      else if(ch === "\n" || ch === "\r"){ if(ch === "\r" && text[i + 1] === "\n") i++; row.push(cell); rows.push(row); row = []; cell = ""; }
      else cell += ch;
    }
    if(cell || row.length){ row.push(cell); rows.push(row); }
    return rows.filter(function(r){ return r.some(function(x){ return String(x).trim(); }); });
  }
  function parseVCF(text){
    text = text.replace(/\r\n[ \t]/g, "").replace(/\n[ \t]/g, "");
    var out = [];
    text.split(/BEGIN:VCARD/i).slice(1).forEach(function(block){
      var p = {emails:[], phones:[], urls:[]};
      block.split(/\r?\n/).forEach(function(line){
        var i = line.indexOf(":"); if(i < 0) return;
        var name = line.slice(0, i).split(";")[0].replace(/^[^.]+\./, "").toUpperCase();
        var val = line.slice(i + 1).replace(/\\n/gi, "\n").replace(/\\([,;\\])/g, "$1").trim();
        if(name === "FN") p.fn = val;
        else if(name === "N" && !p.n){ var parts = val.split(";"); p.n = [parts[1], parts[0]].filter(Boolean).join(" "); }
        else if(name === "ORG") p.org = val.split(";").filter(Boolean).join(", ");
        else if(name === "TITLE") p.title = val;
        else if(name === "EMAIL") p.emails.push(val);
        else if(name === "TEL") p.phones.push(val);
        else if(name === "ADR"){ var a = val.split(";"); p.city = a[3] || a[4] || a[2] || ""; }
        else if(name === "NOTE") p.note = val;
        else if(name === "URL") p.urls.push(val);
      });
      if(p.fn || p.n) out.push(p);
    });
    return out;
  }
  /* Outlook / Google calendar export (.ics) -> meetings */
  function icsDate(v, params){
    var m = /^(\d{4})(\d{2})(\d{2})(?:T(\d{2})(\d{2})(\d{2})?(Z)?)?/.exec(v || "");
    if(!m) return null;
    if(!m[4]) return {date:m[1] + "-" + m[2] + "-" + m[3], time:""};
    var d = m[7] ? new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5])) : new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    return {date:iso(d), time:pad(d.getHours()) + ":" + pad(d.getMinutes())};
  }
  function parseICS(text){
    text = text.replace(/\r\n[ \t]/g, "").replace(/\n[ \t]/g, "");
    var out = [];
    text.split(/BEGIN:VEVENT/i).slice(1).forEach(function(block){
      block = block.split(/END:VEVENT/i)[0];
      var ev = {attendees:[]};
      block.split(/\r?\n/).forEach(function(line){
        var i = line.indexOf(":"); if(i < 0) return;
        var head = line.slice(0, i), val = line.slice(i + 1);
        var name = head.split(";")[0].toUpperCase();
        var un = function(x){ return x.replace(/\\n/gi, "\n").replace(/\\([,;\\])/g, "$1").trim(); };
        var cn = /CN="?([^";:]+)"?/i.exec(head);
        if(name === "SUMMARY") ev.title = un(val);
        else if(name === "UID") ev.uid = val.trim();
        else if(name === "RECURRENCE-ID") ev.exception = true;
        else if(name === "DTSTART") ev.start = icsDate(val);
        else if(name === "DTEND") ev.end = icsDate(val);
        else if(name === "RRULE") ev.rrule = val.toUpperCase();
        else if(name === "LOCATION") ev.location = un(val);
        else if(name === "DESCRIPTION") ev.desc = un(val);
        else if(name === "X-MICROSOFT-SKYPETEAMSMEETINGURL" || name === "X-GOOGLE-CONFERENCE") ev.join = val.trim();
        else if(name === "ORGANIZER") ev.organiser = cn ? cn[1] : val.replace(/^mailto:/i, "");
        else if(name === "ATTENDEE"){ if(ev.attendees.length < 12) ev.attendees.push(cn ? cn[1] : val.replace(/^mailto:/i, "")); }
        else if(name === "STATUS" && /CANCEL/i.test(val)) ev.cancelled = true;
      });
      if(!ev.title || !ev.start) return;
      if(!ev.join){
        var m = /(https:\/\/[^\s"<>]*(?:teams\.microsoft\.com|teams\.live\.com|zoom\.us|meet\.google\.com|webex\.com)[^\s"<>]*)/i.exec((ev.location || "") + " " + (ev.desc || ""));
        if(m) ev.join = m[1].replace(/[>)\].,]+$/, "");
      }
      var r = ev.rrule || "", repeat = "";
      if(r){
        var freq = (/FREQ=(\w+)/.exec(r) || [])[1], interval = +((/INTERVAL=(\d+)/.exec(r) || [])[1] || 1), byday = (/BYDAY=([^;]+)/.exec(r) || [])[1] || "";
        if(freq === "DAILY") repeat = "Every day";
        else if(freq === "WEEKLY" && interval === 1 && byday.split(",").length >= 5 && !/SA|SU/.test(byday)) repeat = "Every weekday";
        else if(freq === "WEEKLY" && interval === 2) repeat = "Every 2 weeks";
        else if(freq === "WEEKLY") repeat = "Every week";
        else if(freq === "MONTHLY") repeat = "Every month";
        var until = (/UNTIL=(\d{8})/.exec(r) || [])[1];
        if(until){ var u = icsDate(until); if(u && u.date < today()) repeat = "ended"; }
        ev.oddRule = !repeat;
      }
      ev.repeat = repeat;
      out.push(ev);
    });
    /* RECURRENCE-ID marks a one-off change to a single occurrence of a recurring series — skip it
       only when the file also has that series' master (a same-UID event with no RECURRENCE-ID),
       which carries the RRULE and is what the calendar actually repeats. Saving/forwarding just one
       occurrence from Outlook (Web or desktop) exports ONLY the RECURRENCE-ID instance, no master —
       drop it too and every meeting in that common case silently disappears, which is the file the
       owner hit this on. Without a master to fall back to, treat it as a normal one-off meeting. */
    var masterUids = {};
    out.forEach(function(ev){ if(!ev.exception && ev.uid) masterUids[ev.uid] = true; });
    out = out.filter(function(ev){ return !ev.exception || !masterUids[ev.uid]; });
    var t = today();
    /* keep meetings that are still coming up: future one-offs and live repeating series */
    return out.filter(function(ev){ return ev.repeat === "ended" ? false : ev.repeat ? true : ev.start.date >= addDays(t, -1); })
      .sort(function(a, b){ return (a.repeat ? "0" : "1").localeCompare(b.repeat ? "0" : "1") || a.start.date.localeCompare(b.start.date); });
  }
  /* a best-effort read of an invite pasted as plain text (copied from an email or a calendar app,
     rather than saved as an .ics file). Returns the same shape as parseICS()'s events, 0 or 1 of
     them — this is a guess, so the caller always shows a preview before anything is created. */
  var MONTHS = {jan:0, feb:1, mar:2, apr:3, may:4, jun:5, jul:6, aug:7, sep:8, oct:9, nov:10, dec:11};
  function parseInviteDate(text){
    var m = /(\d{1,2})(?:st|nd|rd|th)?\s+(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\.?,?\s+(\d{4})/i.exec(text);
    if(m) return new Date(+m[3], MONTHS[m[2].toLowerCase()], +m[1]);
    m = /(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\.?\s+(\d{1,2})(?:st|nd|rd|th)?,?\s+(\d{4})/i.exec(text);
    if(m) return new Date(+m[3], MONTHS[m[1].toLowerCase()], +m[2]);
    m = /\b(\d{4})-(\d{2})-(\d{2})\b/.exec(text);
    if(m) return new Date(+m[1], +m[2] - 1, +m[3]);
    m = /\b(\d{1,2})[\/.](\d{1,2})[\/.](\d{4})\b/.exec(text);
    if(m) return new Date(+m[3], +m[2] - 1, +m[1]);
    return null;
  }
  function parseInviteTimeRange(text){
    var m = /(\d{1,2})(?:[:.](\d{2}))?\s*(am|pm)?\s*[-–—to]+\s*(\d{1,2})(?:[:.](\d{2}))?\s*(am|pm)?/i.exec(text);
    if(!m) return null;
    var ap1 = m[3], ap2 = m[6] || ap1;
    var to24 = function(h, ap){ h = +h; if(ap && /pm/i.test(ap) && h < 12) h += 12; if(ap && /am/i.test(ap) && h === 12) h = 0; return h; };
    var h1 = to24(m[1], ap1 || ap2), h2 = to24(m[4], ap2);
    if(h1 > 23 || h2 > 23) return null;
    return {time:pad(h1) + ":" + pad(+(m[2] || 0)), endtime:pad(h2) + ":" + pad(+(m[5] || 0))};
  }
  function parseInviteText(text){
    if(/BEGIN:VEVENT/i.test(text)) return parseICS(text);
    var lines = text.split(/\r?\n/).map(function(l){ return l.trim(); }).filter(Boolean);
    if(!lines.length) return [];
    var field = function(re){ var l = lines.filter(function(x){ return re.test(x); })[0]; return l ? l.replace(re, "").trim() : ""; };
    var dateLine = lines.filter(function(l){ return parseInviteDate(l); })[0];
    var d = dateLine ? parseInviteDate(dateLine) : parseInviteDate(text);
    if(!d) return [];
    var tr = parseInviteTimeRange(dateLine || text) || {};
    var title = field(/^subject\s*:/i) || lines[0];
    var where = field(/^(where|location)\s*:/i);
    var organiser = field(/^organi[sz]er\s*:/i);
    var attendeeLine = field(/^(required\s+)?attendees\s*:/i) || field(/^invitees\s*:/i);
    var attendees = attendeeLine ? attendeeLine.split(/[,;]/).map(function(x){ return x.trim(); }).filter(Boolean).slice(0, 12) : [];
    var m = /(https:\/\/[^\s"<>]*(?:teams\.microsoft\.com|teams\.live\.com|zoom\.us|meet\.google\.com|webex\.com)[^\s"<>]*)/i.exec(text);
    var join = m ? m[1].replace(/[>)\].,]+$/, "") : "";
    if(!where && /Microsoft Teams Meeting/i.test(text)) where = "Microsoft Teams Meeting";
    return [{title:str(title, 160) || "Meeting", start:{date:iso(d), time:tr.time || ""}, end:tr.endtime ? {date:iso(d), time:tr.endtime} : null,
      location:where, organiser:organiser, attendees:attendees, join:join, repeat:""}];
  }
  function loadXLSX(){
    if(window.XLSX) return Promise.resolve(window.XLSX);
    return new Promise(function(res, rej){
      var sc = document.createElement("script");
      sc.src = "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
      sc.onload = function(){ window.XLSX ? res(window.XLSX) : rej(); };
      sc.onerror = rej;
      document.head.appendChild(sc);
    });
  }
  function openImport(){
    if(S.readOnly){ toast("You have view-only access to this workspace."); return; }
    imp = {step:"pick", folder:S.nav.indexOf("f:") === 0 ? S.nav.slice(2) : ""};
    openModal("import"); renderImport();
  }
  function useTable(rows, name, extra){
    var hi = 0; while(hi < rows.length && !rows[hi].some(function(x){ return String(x).trim(); })) hi++;
    var headers = (rows[hi] || []).map(function(h, i){ return String(h).trim() || "Column " + (i + 1); });
    var body = rows.slice(hi + 1).map(function(r){ return headers.map(function(_, i){ var v = r[i]; return v instanceof Date ? v : (v == null ? "" : String(v)); }); });
    if(body.length > 20000){ toast("Only the first 20,000 rows will be imported."); body = body.slice(0, 20000); }
    var type = guessType(headers);
    Object.assign(imp, {step:"map", kind:"table", name:name, headers:headers, rows:body, type:type, map:guessMap(headers, type)}, extra || {});
    if(imp.wantSet !== false){ imp.type = "__set"; imp.setKey = ""; if(!imp.folder) imp.folder = "__new"; buildSetType(); }
    renderImport();
  }
  function readImportFile(f){
    if(!f) return;
    var ext = (f.name.split(".").pop() || "").toLowerCase();
    var r = new FileReader();
    if(ext === "xlsx" || ext === "xls" || ext === "ods"){
      imp.step = "loading"; renderImport();
      r.onload = function(){
        loadXLSX().then(function(X){
          var wb = X.read(new Uint8Array(r.result), {type:"array", cellDates:true});
          var sheetOf = function(n){ return X.utils.sheet_to_json(wb.Sheets[n], {header:1, raw:true, defval:""}); };
          imp.wb = wb; imp.sheetOf = sheetOf;
          useTable(sheetOf(wb.SheetNames[0]), f.name, {sheets:wb.SheetNames, sheet:wb.SheetNames[0]});
        }, function(){ imp.step = "pick"; renderImport(); toast("Couldn't load the Excel reader. Save the sheet as CSV and import that instead."); });
      };
      r.readAsArrayBuffer(f);
      return;
    }
    /* a read error, or a parser throwing on something unexpected in the file, used to leave the
       dialog silently sitting on "Choose a file" with nothing else happening — always land back
       on a state the user can see and act on. */
    r.onerror = function(){ imp.step = "pick"; renderImport(); toast("Couldn't read that file. Try again, or save it again from the app you exported it from."); };
    r.onload = function(){
      try{
        var text = String(r.result || "");
        if(ext === "ics" || /^BEGIN:VCALENDAR/im.test(text.slice(0, 200))){
          var evs = parseICS(text);
          if(!evs.length){ toast("No upcoming meetings found in that calendar file."); return; }
          Object.assign(imp, {step:"ics", kind:"ics", name:f.name, events:evs});
          renderImport();
          return;
        }
        if(ext === "vcf" || /^BEGIN:VCARD/im.test(text.slice(0, 200))){
          var people = parseVCF(text);
          if(!people.length){ toast("No contacts found in that file."); return; }
          Object.assign(imp, {step:"vcf", kind:"vcf", name:f.name, people:people});
          renderImport();
        } else {
          var rows = parseCSV(text);
          if(rows.length < 2){ toast("That file needs a header row and at least one row of data."); return; }
          useTable(rows, f.name);
        }
      }catch(e){
        imp.step = "pick"; renderImport();
        toast("Couldn't read that file — it may not be in the format it claims to be.");
      }
    };
    r.readAsText(f);
  }
  function impFolderSelect(){
    return '<div class="fld"><label for="imp-folder">Put them in</label><select id="imp-folder">' + (imp.kind === "table" && imp.type === "__set" ? '<option value="__new"' + (imp.folder === "__new" ? " selected" : "") + '>A new folder: ' + esc(setName()) + '</option>' : "") + folderOptions(imp.folder).replace("Not in a folder", "No folder") + '</select></div>';
  }
  function impBuildCards(){
    var now = new Date().toISOString(), out = [];
    if(imp.kind === "ics"){
      imp.events.forEach(function(ev){
        var f = {due:ev.start.date};
        if(ev.start.time) f.time = ev.start.time;
        if(ev.end && ev.end.time && ev.end.date === ev.start.date) f.endtime = ev.end.time;
        if(ev.repeat) f.repeat = ev.repeat;
        if(ev.join && safeUrl(ev.join)) f.join = safeUrl(ev.join);
        if(ev.organiser) f.organiser = ev.organiser;
        if(ev.location && !/^https?:/i.test(ev.location) && !/Microsoft Teams Meeting/i.test(ev.location)) f.where = ev.location;
        if(ev.attendees.length) f["with"] = ev.attendees.join(", ");
        out.push({id:uid(), type:"meeting", title:ev.title, subtitle:ev.repeat || "", status:ev.cancelled ? "Cancelled" : "Scheduled", f:f, folder:imp.folder, src:"ics:" + (ev.uid || ev.title + ev.start.date),
          notes:ev.oddRule ? "This meeting has a repeat pattern Tabwheel can't copy exactly. Check the dates in Outlook." : "", hist:[{at:now, w:"Imported from " + imp.name}]});
      });
      return out;
    }
    if(imp.kind === "vcf"){
      imp.people.forEach(function(p){
        var f = {};
        if(p.title) f.role = p.title; if(p.org) f.company = p.org; if(p.emails[0]) f.email = p.emails[0]; if(p.phones[0]) f.phone = p.phones[0]; if(p.city) f.location = p.city;
        var extra = p.emails.slice(1).concat(p.phones.slice(1));
        out.push({id:uid(), type:"person", title:p.fn || p.n, subtitle:[p.title, p.org].filter(Boolean).join(", "), status:"Active", f:f, folder:imp.folder,
          notes:[p.note, extra.length ? "Also: " + extra.join(", ") : ""].filter(Boolean).join("\n"), links:p.urls.map(function(u){ return {label:"", url:u}; }),
          hist:[{at:now, w:"Imported from " + imp.name}]});
      });
    } else {
      var T = impType(), tkey = imp.type === "__set" ? imp.setType.key : imp.type;
      imp.rows.forEach(function(r){
        var c = {id:uid(), type:tkey, title:"", subtitle:"", status:T.statuses[0], f:{}, tags:[], notes:"", folder:imp.folder, hist:[{at:now, w:"Imported from " + imp.name}]}, extraNotes = [];
        imp.map.forEach(function(target, i){
          var raw = r[i], v = raw instanceof Date ? iso(raw) : String(raw == null ? "" : raw).trim();
          if(!target || !v) return;
          if(target === "status"){ var m = T.statuses.filter(function(st){ return st.toLowerCase() === v.toLowerCase(); })[0]; if(m) c.status = m; else extraNotes.push("Status: " + v); }
          else if(target === "tags") c.tags = c.tags.concat(v.split(/[,;|]/).map(function(x){ return x.trim(); }).filter(Boolean));
          else if(target === "notes") c.notes = c.notes ? c.notes + "\n" + v : v;
          else if(target.indexOf("f.") === 0){
            var k = target.slice(2), fd = T.fields.filter(function(x){ return x.k === k; })[0];
            if(fd && fd.t === "date"){ var d = toISODate(raw); if(d) c.f[k] = d; else extraNotes.push(fd.l + ": " + v); }
            else if(fd && fd.t === "select"){ var o = (fd.opts || []).filter(function(x){ return x.toLowerCase() === v.toLowerCase(); })[0]; if(o) c.f[k] = o; else extraNotes.push(fd.l + ": " + v); }
            else c.f[k] = v;
          }
          else c[target] = v;
        });
        if(extraNotes.length) c.notes = (c.notes ? c.notes + "\n" : "") + extraNotes.join("\n");
        if(!c.title && Object.keys(c.f).length) c.title = c.f[Object.keys(c.f)[0]];
        if(c.title) out.push(c);
      });
    }
    return out;
  }
  function impStepBar(){
    /* legible wizard steps: choose file -> preview -> map fields (tables only) -> import. Purely presentational; doesn't affect imp.step or when data is written. */
    var labels, cur;
    if(imp.kind === "table"){
      labels = ["Choose file", "Preview", "Map fields", "Import"];
      cur = imp.step === "map" ? [1, 2] : [0];
    } else {
      labels = ["Choose file", "Preview", "Import"];
      cur = (imp.step === "ics" || imp.step === "vcf") ? [1] : [0];
    }
    var minCur = Math.min.apply(null, cur);
    return '<div class="imp-steps">' + labels.map(function(l, i){
      var cls = cur.indexOf(i) > -1 ? "cur" : (i < minCur ? "done" : "");
      return '<span class="step ' + cls + '">' + (i + 1) + '. ' + esc(l) + '</span>';
    }).join('<span class="sep">›</span>') + '</div>';
  }
  function renderImport(){
    var head = '<div class="modal-head"><h2 id="modalTitle">Import spreadsheets, contacts or calendars</h2><button type="button" class="btn small" data-mclose="1">Cancel</button></div>' + impStepBar();
    var body = "", foot = "";
    if(imp.step === "pick" || imp.step === "loading"){
      body = '<label class="drop-zone" id="imp-drop" for="imp-file"><b style="font-size:16px">' + (imp.step === "loading" ? "Reading the file…" : "Choose a file, or drop it here") + '</b><span>CSV or Excel (.xlsx) with a header row, contacts exported as .vcf, or an Outlook or Google calendar saved as .ics</span><input type="file" id="imp-file" accept=".csv,.tsv,.txt,.xlsx,.xls,.ods,.vcf,.ics,text/csv,text/vcard,text/calendar"></label>' +
        '<p class="d-note">Nothing is saved until you check the preview and click Import. You can match each column to a field on the next step.</p>' +
        '<p class="d-note"><b>Outlook meetings:</b> in Outlook for Windows choose File › Save Calendar, pick a date range, and drop the .ics file here. Import again any time; meetings you already have are updated, and their notes are kept.</p>' +
        '<button type="button" class="btn small" data-imppaste="1" style="margin-top:6px">Or paste a meeting invite…</button>';
    } else if(imp.step === "paste"){
      body = (imp.pastedCount ? '<p class="d-note" style="margin-top:0"><b>' + imp.pastedCount + '</b> added so far. Paste the next one, or Cancel when you\'re done.</p>' : "") +
        '<p class="d-note"' + (imp.pastedCount ? "" : ' style="margin-top:0"') + '>Paste the invite text — select-all and copy it from the email or calendar item, including a line with the date (and time, if it has one).</p>' +
        '<textarea id="imp-paste-text" rows="10" style="width:100%; font:inherit" placeholder="Paste the invite here…"></textarea>' +
        '<p class="d-note" id="imp-paste-err" hidden>Couldn\'t find a date in that text. Check it includes a line like “Monday, 28 September 2026, 10:00–10:45”, then try again.</p>';
      foot = '<button type="button" class="btn" data-impback="1">Back</button><button type="button" class="btn primary" data-imppastego="1">Read invite</button>';
    } else if(imp.step === "ics"){
      var rep0 = imp.events.filter(function(e){ return e.repeat; }).length, links0 = imp.events.filter(function(e){ return e.join; }).length;
      var repCell = function(e, i){
        /* a rule we already recognise can be changed here before it's even created; one .ics
           couldn't map exactly to (oddRule) is left as a read-only note rather than risk quietly
           replacing a real pattern with the nearest guess — open the card afterward to fix that one. */
        if(e.oddRule) return '<span title="This meeting has a repeat pattern Tabwheel can\'t copy exactly. Check the dates in Outlook.">Custom</span>';
        return '<select class="imp-rep-sel" data-evrep="' + i + '"><option value=""' + (e.repeat ? "" : " selected") + '>Doesn\'t repeat</option>' +
          REPEATS.map(function(r){ return '<option value="' + esc(r) + '"' + (e.repeat === r ? " selected" : "") + '>' + esc(r) + '</option>'; }).join("") + '</select>';
      };
      body = '<div class="form-grid" style="margin-bottom:14px">' + impFolderSelect() + '</div>' +
        '<p><b>' + imp.events.length + '</b> upcoming meetings in ' + esc(imp.name) + ': ' + rep0 + ' repeating, ' + links0 + ' with a Teams or Zoom link. Meetings you imported before are updated, and their notes are kept.</p>' +
        '<h4 class="side-h">Preview</h4>' +
        '<div class="table-wrap"><table class="map-table"><thead><tr><th>Meeting</th><th>When</th><th>Repeats</th><th>Join link</th></tr></thead><tbody>' +
        imp.events.slice(0, 10).map(function(e, i){ return '<tr><td><b>' + esc(e.title) + '</b></td><td class="sample">' + esc(fmtDate(e.start.date, true) + (e.start.time ? " " + e.start.time : "")) + '</td><td>' + repCell(e, i) + '</td><td>' + (e.join ? esc(joinInfo(e.join) ? joinInfo(e.join).label.replace("Join ", "") : "Yes") : "—") + '</td></tr>'; }).join("") + '</tbody></table></div>' +
        (imp.events.length > 10 ? '<p class="d-note">…and ' + (imp.events.length - 10) + ' more.</p>' : "") +
        '<p class="d-note">Times are shown in this computer\'s time zone.</p>';
      foot = '<button type="button" class="btn" data-impback="1">' + (imp.pastedFlow ? "Paste another" : "Choose another file") + '</button><button type="button" class="btn primary" data-impgo="1">Import ' + imp.events.length + ' meetings</button>';
    } else if(imp.step === "vcf"){
      body = '<div class="form-grid" style="margin-bottom:14px">' + impFolderSelect() + '</div>' +
        '<p><b>' + imp.people.length + '</b> contacts found in ' + esc(imp.name) + '. They will become People cards.</p>' +
        '<h4 class="side-h">Preview</h4>' +
        '<div class="table-wrap"><table class="map-table"><thead><tr><th>Name</th><th>Company</th><th>Email</th><th>Phone</th></tr></thead><tbody>' +
        imp.people.slice(0, 8).map(function(p){ return '<tr><td>' + esc(p.fn || p.n) + '</td><td>' + esc(p.org || "") + '</td><td class="sample">' + esc(p.emails[0] || "") + '</td><td class="sample">' + esc(p.phones[0] || "") + '</td></tr>'; }).join("") + '</tbody></table></div>' +
        (imp.people.length > 8 ? '<p class="d-note">…and ' + (imp.people.length - 8) + ' more.</p>' : "");
      foot = '<button type="button" class="btn" data-impback="1">Choose another file</button><button type="button" class="btn primary" data-impgo="1">Import ' + imp.people.length + ' contacts</button>';
    } else {
      var targets = impTargets(imp.type);
      var preview = impBuildCards().slice(0, 5);
      body = '<div class="form-grid" style="margin-bottom:14px">' +
        '<div class="fld"><label for="imp-type">Import as</label><select id="imp-type"><option value="__set"' + (imp.type === "__set" ? " selected" : "") + '>A new set: one tab per row</option><optgroup label="Or add to an existing type">' + TYPE_ORDER.map(function(k){ return '<option value="' + esc(k) + '"' + (k === imp.type ? " selected" : "") + '>' + esc(td(k).plural) + '</option>'; }).join("") + '</optgroup></select></div>' +
        (imp.type === "__set" ? '<div class="fld"><label for="imp-setname">Name of the set</label><input id="imp-setname" maxlength="40" value="' + esc(setName()) + '"></div>' : "") +
        impFolderSelect() +
        (imp.sheets && imp.sheets.length > 1 ? '<div class="fld"><label for="imp-sheet">Sheet</label><select id="imp-sheet">' + imp.sheets.map(function(n){ return '<option' + (n === imp.sheet ? " selected" : "") + '>' + esc(n) + '</option>'; }).join("") + '</select></div>' : "") +
        '</div>' + '<h4 class="side-h">Map fields</h4>' + (imp.type === "__set" ? '<p class="set-note">Each of the <b>' + imp.rows.length + '</b> rows becomes a card with its own tab. They share one card type, <b>' + esc(setName()) + '</b>, so they sit together in the menu, link to each other with Previous and Next, and <b>restyling one restyles them all</b>. Each column becomes a field.</p>' : '<p><b>' + imp.rows.length + '</b> rows in ' + esc(imp.name) + '. Match each column to a field:</p>') +
        '<div class="table-wrap"><table class="map-table"><thead><tr><th>Column</th><th>First value</th><th>Goes into</th></tr></thead><tbody>' +
        imp.headers.map(function(h, i){
          var ex = ""; for(var j = 0; j < imp.rows.length && !ex; j++){ var v = imp.rows[j][i]; ex = v instanceof Date ? iso(v) : String(v || "").trim(); }
          return '<tr><td><b>' + esc(h) + '</b></td><td class="sample">' + esc(ex) + '</td><td><select data-impmap="' + i + '" aria-label="Field for ' + esc(h) + '">' + targets.map(function(t){ return '<option value="' + esc(t[0]) + '"' + (imp.map[i] === t[0] ? " selected" : "") + '>' + esc(t[1]) + '</option>'; }).join("") + '</select></td></tr>';
        }).join("") + '</tbody></table></div>' +
        '<h4 class="side-h" style="margin-top:16px">Preview</h4>' + (preview.length ? '<div class="agenda">' + preview.map(function(c){ return '<div class="d-row" style="' + typeVar(c.type) + '"><span class="dot"></span><span class="t">' + esc(c.title) + '</span><span class="s">' + esc(c.subtitle || Object.keys(c.f).slice(0, 3).map(function(k){ return c.f[k]; }).join(" · ")) + '</span><span class="r"><span class="pill tone-' + (TONE[c.status] || "muted") + '">' + esc(c.status) + '</span></span></div>'; }).join("") + '</div>' : '<p class="d-note">No rows have a title yet. Pick which column holds the name or title.</p>');
      var n = impBuildCards().length;
      foot = '<span class="note">Values that don\'t fit a field (like an unknown status) are kept in the card\'s notes.</span><button type="button" class="btn" data-impback="1">Choose another file</button><button type="button" class="btn primary" data-impgo="1"' + (n ? "" : " disabled") + '>Import ' + n + ' cards</button>';
    }
    $("modalBox").innerHTML = head + '<div class="modal-body">' + body + '</div>' + (foot ? '<div class="modal-foot">' + foot + '</div>' : "");
  }
  $("importSheet").addEventListener("click", openImport);
  $("modalBox").addEventListener("change", function(e){
    if(modalKind !== "import") return;
    var t = e.target;
    if(t.id === "imp-file"){ readImportFile(t.files && t.files[0]); }
    else if(t.id === "imp-type"){
      imp.type = t.value; imp.wantSet = t.value === "__set";
      if(imp.type === "__set"){ imp.setKey = ""; if(!imp.folder) imp.folder = "__new"; buildSetType(); }
      else { if(imp.folder === "__new") imp.folder = ""; imp.map = guessMap(imp.headers, imp.type); }
      renderImport();
    }
    else if(t.id === "imp-setname"){ imp.setName = t.value.trim().slice(0, 40); imp.setKey = ""; var mp = imp.map.slice(); buildSetType(); imp.map = mp; renderImport(); }
    else if(t.id === "imp-folder"){ imp.folder = t.value; }
    else if(t.id === "imp-sheet"){ imp.sheet = t.value; imp.setName = ""; var keep = {sheets:imp.sheets, sheet:t.value}; useTable(imp.sheetOf(t.value), imp.name, keep); }
    else if(t.dataset.impmap !== undefined){ imp.map[+t.dataset.impmap] = t.value; renderImport(); }
    else if(t.dataset.evrep !== undefined){ var ev = imp.events[+t.dataset.evrep]; if(ev) ev.repeat = t.value; }
  });
  $("modalBox").addEventListener("dragover", function(e){ var z = e.target.closest && e.target.closest("#imp-drop"); if(z){ e.preventDefault(); z.classList.add("on"); } });
  $("modalBox").addEventListener("dragleave", function(e){ var z = e.target.closest && e.target.closest("#imp-drop"); if(z) z.classList.remove("on"); });
  $("modalBox").addEventListener("drop", function(e){ var z = e.target.closest && e.target.closest("#imp-drop"); if(!z) return; e.preventDefault(); readImportFile(e.dataTransfer.files && e.dataTransfer.files[0]); });
  $("modalBox").addEventListener("click", function(e){
    if(modalKind !== "import") return;
    var b = e.target.closest("button"); if(!b) return;
    if(b.dataset.imppaste){ imp.step = "paste"; imp.pastedFlow = true; renderImport(); setTimeout(function(){ var t = $("imp-paste-text"); if(t) t.focus(); }, 0); }
    else if(b.dataset.imppastego){
      var text = ($("imp-paste-text") || {}).value || "";
      var evs;
      try{ evs = parseInviteText(text); }catch(e){ evs = []; }
      if(!evs.length){ $("imp-paste-err").hidden = false; return; }
      Object.assign(imp, {step:"ics", kind:"ics", name:"the pasted invite", events:evs});
      renderImport();
    }
    else if(b.dataset.impback){
      if(imp.step === "ics" && imp.pastedFlow) imp = {step:"paste", pastedFlow:true, folder:imp.folder};
      else imp = {step:"pick", folder:imp.folder};
      renderImport();
      if(imp.step === "paste") setTimeout(function(){ var t = $("imp-paste-text"); if(t) t.focus(); }, 0);
    }
    else if(b.dataset.impgo){
      if(imp.kind === "table" && imp.type === "__set"){
        var st = imp.setType;
        typeCfg.custom.push({key:st.key, label:st.label, plural:st.plural, short:st.short, color:st.color, statuses:st.statuses, fields:st.fields, sheet:st.sheet, home:!!st.home});
        typeCfg = normTypeCfg(typeCfg); rebuildTypes(); saveTypes();
      }
      if(imp.folder === "__new"){
        var nf = {id:"f" + uid(), name:setName(), parent:null, home:S.space === "home"};
        S.folders.push(nf); S.folders = normFolders(S.folders); foldersChanged(); imp.folder = nf.id;
      }
      var isHome = S.space === "home";
      var cards = impBuildCards().map(function(c){ c.home = isHome; return norm(c); }), updated = 0;
      var bySrc = {};
      S.cards.forEach(function(c){ if(c.src) bySrc[c.src] = c; });
      cards.forEach(function(c){
        var old = c.src && bySrc[c.src];
        if(old){
          /* keep the notes, links, files and history; refresh the calendar details */
          old.title = c.title; old.subtitle = c.subtitle; old.status = c.status;
          Object.assign(old.f, c.f);
          logHist(old, "Updated from " + imp.name); touch(old.id); updated++;
        } else { S.cards.set(c.id, c); touch(c.id); }
      });
      /* pasting is often several meetings in a row — stay in the dialog, ready for the next
         paste, instead of closing and making them reopen Import every time. */
      var backToPaste = imp.kind === "ics" && imp.pastedFlow, pastedSoFar = (imp.pastedCount || 0) + cards.length;
      if(!backToPaste) closeModal();
      if(imp.kind === "table" && imp.type === "__set") S.nav = "t:" + imp.setType.key;
      else if(imp.folder){ S.nav = "f:" + imp.folder; }
      toast("Imported " + (cards.length - updated) + " new" + (updated ? " and updated " + updated : "") + (imp.kind === "ics" ? " meetings" : " cards") + (imp.folder ? " into " + folderPath(imp.folder) : "") + ".");
      refresh();
      if(backToPaste){
        imp = {step:"paste", pastedFlow:true, folder:imp.folder, pastedCount:pastedSoFar};
        renderImport();
        setTimeout(function(){ var t = $("imp-paste-text"); if(t) t.focus(); }, 0);
      }
    }
  });

  /* ================= ask the rolodex ================= */
  var askThread = [], askCtl = null;
  function cardLine(c){
    var T = td(c.type), o = {id:c.id, type:T.label, title:c.title};
    if(c.subtitle) o.subtitle = c.subtitle;
    o.status = c.status;
    T.fields.forEach(function(fd){ if(c.f[fd.k]) o[fd.l] = c.f[fd.k]; });
    if(c.fav) o.favourite = true;
    if(c.tags.length) o.tags = c.tags.join(", ");
    if(c.folder && folderById(c.folder)) o.folder = folderPath(c.folder);
    var rel = linkedIds(c); if(rel.length) o.linked = rel.map(function(id){ return S.cards.get(id).title; });
    if(c.check.length){ o.checklist = c.check.filter(function(x){ return x.done; }).length + "/" + c.check.length + " done"; var open = c.check.filter(function(x){ return !x.done; }).slice(0, 5).map(function(x){ return x.t; }); if(open.length) o.open_items = open; }
    if(c.notes) o.notes = c.notes.slice(0, 300);
    if(c.updated) o.edited = c.updated.slice(0, 10);
    return JSON.stringify(o);
  }
  function openAsk(q){
    if(!S.sample){ toast("Asking Claude works on the online version of this page."); return; }
    openModal("ask"); renderAsk();
    var inp = $("ask-in"); if(inp){ inp.value = q || ""; inp.focus(); }
    if(q) askNow(q);
  }
  function mdLite(text){
    var lines = esc(text).split(/\n/), html = "", list = "";
    var inline = function(t){
      return t.replace(/\*\*([^*]+)\*\*/g, "<b>$1</b>").replace(/\[\[([A-Za-z0-9_.~:@+-]{1,60})\]\]/g, function(m, id){
        var c = S.cards.get(id); return c ? '<button type="button" class="cite" data-cite="' + esc(id) + '" style="' + typeVar(c.type) + '"><span class="dot"></span>' + esc(c.title) + '</button>' : "";
      });
    };
    lines.forEach(function(l){
      var m = /^\s*(?:[-*•]|\d+[.)])\s+(.*)$/.exec(l);
      if(m){ if(!list){ list = /^\s*\d/.test(l) ? "ol" : "ul"; html += "<" + list + ">"; } html += "<li>" + inline(m[1]) + "</li>"; return; }
      if(list){ html += "</" + list + ">"; list = ""; }
      if(l.trim()) html += "<p>" + inline(l.replace(/^#+\s*/, "")) + "</p>";
    });
    if(list) html += "</" + list + ">";
    return html;
  }
  function renderAsk(){
    var tips = ["What's overdue?", "Which servers have open issues?", "What is Maya Chen linked to?", "Summarise the Q4 plans folder", "What storage is nearly full?"];
    $("modalBox").innerHTML = '<div class="modal-head"><h2 id="modalTitle">Ask Tabwheel</h2><button type="button" class="btn small" data-mclose="1">Close</button></div>' +
      '<div class="modal-body"><form class="ask-form" id="ask-form"><input id="ask-in" autocomplete="off" placeholder="Ask about your servers, issues, people, dates…" aria-label="Your question"><button class="btn primary" type="submit" id="ask-go">Ask</button><button class="btn" type="button" id="ask-stop" hidden>Stop</button></form>' +
      '<div class="ask-tips">' + tips.map(function(t){ return '<button type="button" class="q-tip" data-asktip="' + esc(t) + '">' + esc(t) + '</button>'; }).join("") + '</div>' +
      '<div class="ask-thread" id="ask-thread"></div></div>' +
      '<div class="modal-foot"><span class="note">Claude answers from the cards in this workspace only. Each question uses your Claude account.</span></div>';
    renderThread();
  }
  function renderThread(){
    var box = $("ask-thread"); if(!box) return;
    box.innerHTML = askThread.slice().reverse().map(function(t){
      return '<div><div class="ask-q">' + esc(t.q) + '</div><div class="ask-a">' + (t.err ? '<p class="err">' + esc(t.err) + '</p>' : "") + (t.a ? mdLite(t.a) : (t.err ? "" : '<p class="thinking">Thinking…</p>')) + '</div></div>';
    }).join("");
  }
  var ASK_ERR = {
    not_granted:"Claude wasn't given permission to answer. Reload the page and choose Allow when asked.",
    rate_limited:"Too many questions at once. Wait a moment, then ask again.",
    prompt_too_large:"There's too much in this workspace to send in one question. Narrow it down with a folder or search first.",
    cancelled:"Stopped.", refused:"Claude couldn't answer that one.", session_expired:"Your session has expired. Reload the page to keep asking.",
    sampling_disabled:"Asking Claude isn't available here.", capability_disabled:"Asking Claude isn't available here.", not_declared:"Asking Claude isn't available here.",
    empty_completion:"Claude didn't return an answer. Try rewording the question."
  };
  function askNow(q){
    q = String(q || "").trim(); if(!q || !S.sample) return;
    if(askCtl) askCtl.abort();
    var ctl = askCtl = new AbortController();
    var entry = {q:q, a:"", err:""};
    askThread.push(entry); if(askThread.length > 6) askThread.shift();
    renderThread();
    $("ask-stop").hidden = false; $("ask-go").disabled = true;
    var cards = Array.from(S.cards.values()).filter(function(c){ return !c.template; }).sort(function(a, b){ return (b.fav - a.fav) || (b.updated || "").localeCompare(a.updated || ""); });
    var lines = [], size = 0, cut = false;
    cards.forEach(function(c){ var l = cardLine(c); if(size + l.length > 46000){ cut = true; return; } lines.push(l); size += l.length + 1; });
    var prior = askThread.slice(0, -1).slice(-3).filter(function(t){ return t.a; }).map(function(t){ return "Q: " + t.q + "\nA: " + t.a.slice(0, 1200); }).join("\n\n");
    var prompt = "You are the assistant inside Tabwheel, the user's card index of their work (servers, storage and assets, issues, people, meetings, upcoming events, projects, and their own card types). Today is " + today() + ".\n" +
      "Answer the question using only the cards below. Be brief and practical: one or two sentences, then a short bulleted list if you are listing things. " +
      "Whenever you mention a card, put its id in double square brackets right after the name, like Maya Chen [[ex10]]. Don't invent cards, dates or facts; if the cards don't answer the question, say so plainly and suggest what to add.\n\n" +
      (cut ? "Only some cards are listed below (favourites and most recently edited first). Use the search_cards and get_card tools to look up anything else.\n\n" : "") +
      "CARDS (" + lines.length + " of " + cards.length + ", one JSON object per line):\n" + lines.join("\n") + "\n\n" +
      (prior ? "EARLIER IN THIS CONVERSATION:\n" + prior + "\n\n" : "") + "QUESTION: " + q;
    var opts = {signal:ctl.signal, onText:function(u){ entry.a = u.text; renderThread(); }};
    if(cut) opts.tools = [
      {name:"search_cards", description:"Search every card in the workspace by words, IPs, names, #tags, type:server or is:open. Returns up to 15 matching cards as JSON lines.", inputSchema:{type:"object", properties:{query:{type:"string"}}, required:["query"]},
        execute:function(input){ var pq = parseQuery(String(input && input.query || "")); return ranked(Array.from(S.cards.values()).filter(function(c){ return !c.template && matches(c, pq); }), pq).slice(0, 15).map(cardLine).join("\n") || "No matches."; }},
      {name:"get_card", description:"Get one card's full details by id, including notes, checklist and recent history.", inputSchema:{type:"object", properties:{id:{type:"string"}}, required:["id"]},
        execute:function(input){ var c = S.cards.get(String(input && input.id || "")); if(!c) return "No card with that id."; return JSON.stringify({card:JSON.parse(cardLine(c)), notes:c.notes.slice(0, 4000), checklist:c.check, history:c.hist.slice(-10)}); }}
    ];
    S.sample(prompt, opts).then(function(r){ entry.a = r.text; }, function(e){
      entry.a = (e && e.text) || entry.a || "";
      entry.err = ASK_ERR[e && e.code] || "Something went wrong getting an answer. Try again.";
      if(e && e.code === "not_granted"){ S.sample = null; $("askBtn").hidden = true; }
    }).then(function(){
      if(askCtl === ctl) askCtl = null;
      renderThread();
      var st = $("ask-stop"), go = $("ask-go"); if(st) st.hidden = true; if(go) go.disabled = false;
    });
  }
  $("askBtn").addEventListener("click", function(){ openAsk(""); });
  $("modalBox").addEventListener("submit", function(e){
    if(modalKind !== "ask" || e.target.id !== "ask-form") return;
    e.preventDefault();
    var inp = $("ask-in"); askNow(inp.value); inp.value = "";
  });
  $("modalBox").addEventListener("click", function(e){
    if(modalKind !== "ask") return;
    var b = e.target.closest("button"); if(!b) return;
    if(b.id === "ask-stop"){ if(askCtl) askCtl.abort(); }
    else if(b.dataset.asktip){ askNow(b.dataset.asktip); }
    else if(b.dataset.cite){ var id = b.dataset.cite; closeModal(); jumpTo(id, true); }
  });

  /* ================= backup ================= */
  function recordBackup(){ lsSet(LASTBACKUP_KEY, new Date().toISOString()); if(!$("wsMenu").hidden) renderBackupNote(); }
  $("exportBtn").addEventListener("click", function(){
    var data = JSON.stringify({app:"tabwheel", version:2, exported:new Date().toISOString(), cards:Array.from(S.cards.values()), trash:Array.from(S.trash.values()), folders:S.folders, types:typeCfg}, null, 2);
    var name = "tabwheel-" + today() + ".json";
    var fallback = function(){
      try{
        var a = document.createElement("a"); a.href = URL.createObjectURL(new Blob([data], {type:"application/json"})); a.download = name;
        document.body.appendChild(a); a.click(); a.remove();
        recordBackup();
      }catch(e){ toast("This view can't save files."); }
    };
    if(window.claude && typeof window.claude.use === "function" && S.mode === "online"){
      window.claude.use("downloads").then(function(dl){
        if(!dl){ toast("Saving files isn't available in this view."); return; }
        dl.save({filename:name, data:data}).then(function(){ recordBackup(); }).catch(function(e){ if(e && e.code !== "declined") toast("The backup couldn't be saved here."); });
      });
    } else fallback();
  });
  /* Restore is a two-step flow: the file is read and parsed immediately (as before), but the merge
     itself waits behind a confirmation modal so a wrong file pick can't silently rewrite the workspace.
     pendingRestore holds the parsed backup across that gap; it's plain JS data, not a live file handle. */
  var pendingRestore = null;
  function renderRestoreConfirm(){
    if(!pendingRestore) return;
    var n = pendingRestore.list.length;
    var whenTxt = "";
    var exported = pendingRestore.parsed && pendingRestore.parsed.exported;
    if(typeof exported === "string" && /^\d{4}-\d{2}-\d{2}/.test(exported)){
      var d = fmtDate(exported.slice(0, 10), true);
      if(d) whenTxt = " from a backup dated " + d;
    }
    var head = '<div class="modal-head"><h2 id="modalTitle">Restore backup?</h2><button type="button" class="btn small" data-mclose="1">Cancel</button></div>';
    var body = '<p class="d-note" style="margin-top:0">This will add or update ' + n + ' card' + (n === 1 ? "" : "s") + whenTxt + '. Existing cards won’t be removed.</p>';
    var foot = '<button type="button" class="btn" data-mclose="1">Cancel</button><button type="button" class="btn primary" data-restoreconfirm="1">Restore ' + n + ' card' + (n === 1 ? "" : "s") + '</button>';
    $("modalBox").innerHTML = head + '<div class="modal-body">' + body + '</div><div class="modal-foot">' + foot + '</div>';
  }
  function applyRestore(){
    if(!pendingRestore) return;
    var parsed = pendingRestore.parsed, list = pendingRestore.list;
    pendingRestore = null;
    var n = 0;
    if(parsed && parsed.types && typeof parsed.types === "object"){
      var incoming = normTypeCfg(parsed.types);
      incoming.custom.forEach(function(ct){ if(!typeCfg.custom.some(function(x){ return x.key === ct.key; })) typeCfg.custom.push(ct); });
      Object.keys(incoming.extra).forEach(function(k){ if(!typeCfg.extra[k]) typeCfg.extra[k] = incoming.extra[k]; });
      Object.keys(incoming.style || {}).forEach(function(k){ if(!typeCfg.style[k]) typeCfg.style[k] = incoming.style[k]; });
      typeCfg = normTypeCfg(typeCfg); rebuildTypes(); saveTypes();
    }
    list.concat(parsed && Array.isArray(parsed.trash) ? parsed.trash : []).forEach(function(raw){
      var c = norm(raw); if(!c.id || !/^[A-Za-z0-9_.~:@+-]{1,60}$/.test(c.id)) c.id = uid();
      putCard(c); touch(c.id); if(!c.deleted) n++;
    });
    if(parsed && Array.isArray(parsed.folders)){
      normFolders(parsed.folders).forEach(function(f){ var old = folderById(f.id); if(old){ old.name = f.name; old.parent = f.parent; } else S.folders.push(f); });
      S.folders = normFolders(S.folders);
      foldersChanged();
    }
    closeModal();
    toast("Imported " + n + " cards.");
  }
  $("modalBox").addEventListener("click", function(e){
    if(modalKind !== "restore") return;
    if(e.target.closest("[data-restoreconfirm]")) applyRestore();
  });
  $("importInput").addEventListener("change", function(e){
    var f = e.target.files && e.target.files[0]; e.target.value = "";
    if(!f) return;
    if(S.readOnly){ toast("You have view-only access to this workspace."); return; }
    var r = new FileReader();
    r.onload = function(){
      var parsed; try{ parsed = JSON.parse(r.result); }catch(err){ toast("That file isn't a Tabwheel backup."); return; }
      var list = Array.isArray(parsed) ? parsed : parsed && Array.isArray(parsed.cards) ? parsed.cards : null;
      if(!list){ toast("That file isn't a Tabwheel backup."); return; }
      pendingRestore = {parsed:parsed, list:list};
      openModal("restore"); renderRestoreConfirm();
    };
    r.readAsText(f);
  });

  /* ================= sample data banner ================= */
  var sampleBarDismissed = false;
  try{ sampleBarDismissed = sessionStorage.getItem("tabwheel/sample-bar-dismissed") === "1"; }catch(e){}
  function renderSampleBar(hasSample){
    var bar = $("sampleBar");
    if(!hasSample || sampleBarDismissed){ bar.hidden = true; return; }
    if(bar.hidden) bar.innerHTML = '<span>Sample data loaded. You can clear it from the workspace menu.</span><button type="button" data-sample="dismiss" aria-label="Dismiss">✕</button>';
    bar.hidden = false;
  }
  $("sampleBar").addEventListener("click", function(e){
    if(!e.target.closest('[data-sample="dismiss"]')) return;
    sampleBarDismissed = true;
    $("sampleBar").hidden = true;
    try{ sessionStorage.setItem("tabwheel/sample-bar-dismissed", "1"); }catch(err){}
  });

  /* ================= meetings coming up ================= */
  var meetShown = {};
  try{ meetShown = JSON.parse(sessionStorage.getItem("tabwheel/meet-shown") || "{}"); }catch(e){}
  function minutesOf(hhmm){ var m = /^(\d{1,2})[:.](\d{2})/.exec(hhmm || ""); return m ? (+m[1]) * 60 + (+m[2]) : null; }
  function checkMeetings(){
    if(S.mode === "loading" || S.autoMeet === false) return;
    var t = today(), now = new Date(), nowMin = now.getHours() * 60 + now.getMinutes();
    var soon = null;
    S.cards.forEach(function(c){
      if(c.type !== "meeting" || c.status === "Cancelled" || c.template) return;
      var d = c.f.repeat ? nextMeeting(c, t) : c.f.due;
      var st = minutesOf(c.f.time);
      if(d !== t || st === null) return;
      var diff = st - nowMin;
      if(diff <= 15 && diff >= -20 && (!soon || diff < soon.diff)) soon = {c:c, diff:diff};
    });
    var bar = $("meetBar");
    if(!soon){ bar.hidden = true; return; }
    var c = soon.c, key = c.id + ":" + t, ji = joinInfo(c.f.join);
    if(meetShown[key] === "dismissed"){ bar.hidden = true; return; }
    bar.innerHTML = '<span><b>' + esc(c.title) + '</b> ' + (soon.diff > 0 ? "starts in " + soon.diff + " min" : soon.diff === 0 ? "is starting now" : "started " + (-soon.diff) + " min ago") + ' · ' + esc(c.f.time) + '</span>' +
      (ji ? '<a class="join-btn" href="' + esc(ji.url) + '" target="_blank" rel="noopener noreferrer">' + esc(ji.label) + '</a>' : "") +
      '<button type="button" data-meet="open">Open notes</button><button type="button" data-meet="dismiss" aria-label="Dismiss">✕</button>';
    bar.dataset.id = c.id;
    bar.hidden = false;
    /* open the notes automatically once, a few minutes before it starts, unless you're busy typing */
    if(soon.diff <= 5 && !meetShown[key]){
      var a = document.activeElement, busy = a && (a.tagName === "INPUT" || a.tagName === "TEXTAREA" || a.isContentEditable) && !(S.open && S.curId === c.id);
      if(!busy && $("modal").hidden){
        meetShown[key] = "opened";
        try{ sessionStorage.setItem("tabwheel/meet-shown", JSON.stringify(meetShown)); }catch(e){}
        openMeeting(c.id);
      }
    }
  }
  function openMeeting(id){
    var c = S.cards.get(id); if(!c) return;
    if(!S.readOnly) ensureSess(c, today());
    jumpTo(id, true);
    setTimeout(function(){ var cc = S.cards.get(id), x = cc && cc.sess.filter(function(q){ return q.date === today(); })[0]; if(x && S.open && S.curId === id) focusPage(cc, x.id); }, 900);
  }
  $("meetBar").addEventListener("click", function(e){
    var b = e.target.closest("button"); if(!b) return;
    var id = $("meetBar").dataset.id, key = id + ":" + today();
    if(b.dataset.meet === "open"){ meetShown[key] = "opened"; openMeeting(id); }
    else if(b.dataset.meet === "dismiss"){ meetShown[key] = "dismissed"; $("meetBar").hidden = true; checkReminders(); }
    try{ sessionStorage.setItem("tabwheel/meet-shown", JSON.stringify(meetShown)); }catch(err){}
  });
  setInterval(checkMeetings, 20000);
  window.__checkMeetings = checkMeetings;

  /* ================= snooze menu (dates and reminders) ================= */
  var snoozeItems = null, snoozePick = null, snoozeFrom = null;
  function openSnooze(anchor, title, items, pick){
    var m = $("snoozeMenu");
    if(!m.hidden && snoozeFrom === anchor){ closeSnooze(); return; }
    snoozeItems = items; snoozePick = pick || null; snoozeFrom = anchor;
    m.innerHTML = '<div class="sn-h">' + esc(title) + '</div>' + items.map(function(it, i){ return '<button type="button" role="menuitem" data-si="' + i + '"><span>' + esc(it.label) + '</span><span class="sn-d">' + esc(it.sub || "") + '</span></button>'; }).join("") +
      (pick ? '<form class="sn-pick" id="snPick"><input type="date" id="snDate" aria-label="Pick a date" min="' + today() + '" value="' + esc(pick.value || "") + '" required><button type="submit" class="btn small">Move</button></form>' : "");
    m.hidden = false;
    placeSnooze();
    var f = m.querySelector("button"); if(f) f.focus({preventScroll:true});
  }
  /* sits under its button (or above it near the bottom of the screen), kept inside the viewport */
  function placeSnooze(){
    var m = $("snoozeMenu"); if(m.hidden || !snoozeFrom) return;
    if(!snoozeFrom.isConnected){ closeSnooze(); return; }
    var r = snoozeFrom.getBoundingClientRect(), w = m.offsetWidth, h = m.offsetHeight;
    if(r.bottom < 0 || r.top > innerHeight){ closeSnooze(); return; }
    var top = r.bottom + 4;
    if(top + h > innerHeight - 8) top = Math.max(8, r.top - h - 4);
    m.style.left = Math.max(8, Math.min(r.right - w, innerWidth - w - 8)) + "px"; m.style.top = top + "px";
  }
  function closeSnooze(){
    var m = $("snoozeMenu"); if(m.hidden) return;
    var back = m.contains(document.activeElement) && snoozeFrom && snoozeFrom.isConnected ? snoozeFrom : null;
    m.hidden = true; snoozeItems = snoozePick = snoozeFrom = null;
    if(back) back.focus({preventScroll:true});
  }
  $("snoozeMenu").addEventListener("click", function(e){
    e.stopPropagation();
    var b = e.target.closest("[data-si]"); if(!b || !snoozeItems) return;
    var it = snoozeItems[+b.dataset.si]; closeSnooze(); if(it) it.fn();
  });
  $("snoozeMenu").addEventListener("submit", function(e){
    e.preventDefault();
    var v = $("snDate").value, p = snoozePick; if(!validDate(v) || !p) return;
    closeSnooze(); p.fn(v);
  });
  document.addEventListener("click", function(e){ if(!e.target.closest("#snoozeMenu")) closeSnooze(); });
  window.addEventListener("resize", closeSnooze);
  document.addEventListener("scroll", placeSnooze, true);
  /* move every date field that holds `from` to `to` (the old one-click Snooze, now with a choice of day) */
  function snoozeDate(qc, from, to){
    if(!qc || S.readOnly || !validDate(to) || to === from) return;
    var keys = [];
    td(qc.type).fields.forEach(function(fd){ if(fd.t === "date" && qc.f[fd.k] === from){ qc.f[fd.k] = to; keys.push(fd.k); } });
    if(!keys.length) return;
    logHist(qc, "Snoozed to " + fmtDate(to)); touch(qc.id);
    toast("Moved “" + qc.title + "” to " + fmtDate(to, true) + ".", {label:"Undo", fn:function(){ keys.forEach(function(k){ qc.f[k] = from; }); logHist(qc, "Snooze undone"); touch(qc.id); refresh(); }});
    refresh();
  }
  function openDateSnooze(anchor, c, from){
    var t = today(), base = from > t ? from : t, later = base !== t;
    var mk = function(label, to){ return {label:label, sub:fmtDate(to, true), fn:function(){ snoozeDate(c, from, to); }}; };
    openSnooze(anchor, "Move to", [mk(later ? "1 day later" : "Tomorrow", addDays(base, 1)), mk(later ? "3 days later" : "In 3 days", addDays(base, 3)),
      mk(later ? "Monday after" : "Next Monday", nextMonday(base)), mk(later ? "1 week later" : "Next week", addDays(base, 7))],
      {value:addDays(base, 1), fn:function(v){ snoozeDate(c, from, v); }});
  }
  function openRemindSnooze(anchor, c){
    var mk = function(label, when){ return {label:label, sub:fmtRemind(when), fn:function(){ snoozeRemind(c, when); }}; };
    openSnooze(anchor, "Remind me again", [mk("In 1 hour", laterStamp(1)), mk("In 3 hours", laterStamp(3)),
      mk("Tomorrow 9:00", addDays(today(), 1) + "T09:00"), mk("Next Monday 9:00", nextMonday(today()) + "T09:00")]);
  }
  function snoozeRemind(c, when){
    var was = c.remind;
    setRemind(c, when, "Reminder snoozed to " + fmtRemind(when));
    toast("I'll remind you again " + fmtRemind(when).replace(/^\w/, function(m){ return m.toLowerCase(); }) + ".", {label:"Undo", fn:function(){ setRemind(c, was, "Reminder snooze undone"); refresh(); }});
    refresh();
  }
  function remindDone(c){
    var was = c.remind; if(!was) return;
    setRemind(c, "", "Reminder done");
    toast("Cleared the reminder on “" + c.title + "”.", {label:"Undo", fn:function(){ setRemind(c, was, "Reminder restored"); refresh(); }});
  }

  /* ================= reminders coming due ================= */
  var remindFired = {};
  try{ remindFired = JSON.parse(sessionStorage.getItem("tabwheel/remind-fired") || "{}") || {}; }catch(e){}
  function notifyRemind(c){
    try{
      if(typeof Notification === "undefined" || Notification.permission !== "granted") return;
      var n = new Notification("Reminder: " + c.title, {body:(c.subtitle || td(c.type).label) + " · " + fmtRemind(c.remind), tag:"tabwheel-remind-" + c.id});
      n.onclick = function(){ try{ window.focus(); n.close(); }catch(e){} openRemindCard(c.id); };
    }catch(e){}
  }
  function openRemindCard(id){
    var c = S.cards.get(id); if(!c) return;
    if(!!c.home !== (S.space === "home")){ S.space = c.home ? "home" : "work"; updateSpaceToggle(); savePrefs(); }
    if(c.archived && S.nav !== "archived") S.nav = "archived";
    jumpTo(id, true);
  }
  function checkReminders(){
    var bar = $("remindBar"), mb = $("meetBar");
    if(S.mode === "loading"){ bar.hidden = true; return; }
    var now = nowStamp(), due = [], fired = false;
    S.cards.forEach(function(c){ if(c.remind && !c.template && c.remind <= now) due.push(c); });
    due.sort(function(a, b){ return a.remind.localeCompare(b.remind); });
    due.forEach(function(c){ if(remindFired[c.id] !== c.remind){ remindFired[c.id] = c.remind; fired = true; notifyRemind(c); } });
    if(fired){ try{ sessionStorage.setItem("tabwheel/remind-fired", JSON.stringify(remindFired)); }catch(e){} }
    bar.style.setProperty("--rb-off", mb.hidden ? "0px" : (mb.offsetHeight + 8) + "px");
    if(!due.length){ bar.hidden = true; return; }
    var c = due[0];
    var html = '<span class="rb-txt"><span aria-hidden="true">🔔 </span><b>' + esc(c.title) + '</b> · ' + esc(fmtRemind(c.remind)) + (due.length > 1 ? ' <span class="rb-more">+' + (due.length - 1) + ' more</span>' : "") + '</span>' +
      '<span class="rb-acts"><button type="button" data-rbar="open">Open</button>' + (S.readOnly ? "" : '<button type="button" data-rbar="snooze" aria-haspopup="true">Snooze</button><button type="button" data-rbar="done">Done</button>') + '</span>';
    if(bar._html !== html || bar.dataset.id !== c.id){ bar.innerHTML = html; bar._html = html; bar.dataset.id = c.id; }
    bar.hidden = false;
  }
  $("remindBar").addEventListener("click", function(e){
    var b = e.target.closest("button[data-rbar]"); if(!b) return;
    e.stopPropagation();
    var c = S.cards.get($("remindBar").dataset.id); if(!c) return;
    if(b.dataset.rbar === "open"){ closeSnooze(); openRemindCard(c.id); }
    else if(b.dataset.rbar === "snooze") openRemindSnooze(b, c);
    else if(b.dataset.rbar === "done"){ closeSnooze(); remindDone(c); refresh(); }
  });
  setInterval(checkReminders, 30000);
  document.addEventListener("visibilitychange", function(){ if(document.visibilityState === "visible") checkReminders(); });
  window.__checkReminders = checkReminders;

  /* save anything still waiting on its debounce when the page is hidden or closed */
  function flushPending(){
    Object.keys(saveTimers).forEach(function(id){ if(S.dirty.has(id) && !writing[id]){ clearTimeout(saveTimers[id]); flush(id); } });
    if(S.mode === "local" && (localTimer || localSaving)){ clearTimeout(localTimer); localTimer = null; saveLocalNow(); }
    if(folderTimer){ clearTimeout(folderTimer); folderTimer = null; if(S.mode === "online" && S.foldersDirty) writeFolders(); }
  }
  window.addEventListener("pagehide", flushPending);
  document.addEventListener("visibilitychange", function(){ if(document.visibilityState === "hidden") flushPending(); });

  /* ================= boot ================= */
  try{ var pr = JSON.parse(lsGet(PREF_KEY) || "{}"); if(pr.sort) S.sort = pr.sort; if(pr.view) S.view = pr.view; if(pr.collapsed && typeof pr.collapsed === "object") S.collapsed = pr.collapsed; if(typeof pr.boardType === "string") S.boardType = pr.boardType; if(pr.autoMeet === false) S.autoMeet = false; if(pr.wheelSound === true) S.wheelSound = true; if(typeof pr.wsName === "string" && pr.wsName) S.wsName = pr.wsName.slice(0, 60); if(pr.space === "home") S.space = "home"; if(pr.calView === "week") S.calView = "week"; }catch(e){}
  S.wsName = S.wsName || "My workspace"; $("wsName").textContent = S.wsName;
  updateSpaceToggle();
  if(["az","fav","type","recent","date"].indexOf(S.sort) < 0) S.sort = "az";
  $("sortSel").value = S.sort;
  var hv = location.hash.slice(1);
  setQuery("");
  setView(VIEWS.indexOf(hv) >= 0 ? hv : S.view);
  connect();
}
